webpackJsonp(["app"],{

/***/ "./$$_gendir lazy recursive":
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		throw new Error("Cannot find module '" + req + "'.");
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_gendir lazy recursive";

/***/ }),

/***/ "./node_modules/moment/locale recursive ^\\.\\/.*$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "./node_modules/moment/locale/af.js",
	"./af.js": "./node_modules/moment/locale/af.js",
	"./ar": "./node_modules/moment/locale/ar.js",
	"./ar-dz": "./node_modules/moment/locale/ar-dz.js",
	"./ar-dz.js": "./node_modules/moment/locale/ar-dz.js",
	"./ar-kw": "./node_modules/moment/locale/ar-kw.js",
	"./ar-kw.js": "./node_modules/moment/locale/ar-kw.js",
	"./ar-ly": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ly.js": "./node_modules/moment/locale/ar-ly.js",
	"./ar-ma": "./node_modules/moment/locale/ar-ma.js",
	"./ar-ma.js": "./node_modules/moment/locale/ar-ma.js",
	"./ar-sa": "./node_modules/moment/locale/ar-sa.js",
	"./ar-sa.js": "./node_modules/moment/locale/ar-sa.js",
	"./ar-tn": "./node_modules/moment/locale/ar-tn.js",
	"./ar-tn.js": "./node_modules/moment/locale/ar-tn.js",
	"./ar.js": "./node_modules/moment/locale/ar.js",
	"./az": "./node_modules/moment/locale/az.js",
	"./az.js": "./node_modules/moment/locale/az.js",
	"./be": "./node_modules/moment/locale/be.js",
	"./be.js": "./node_modules/moment/locale/be.js",
	"./bg": "./node_modules/moment/locale/bg.js",
	"./bg.js": "./node_modules/moment/locale/bg.js",
	"./bm": "./node_modules/moment/locale/bm.js",
	"./bm.js": "./node_modules/moment/locale/bm.js",
	"./bn": "./node_modules/moment/locale/bn.js",
	"./bn.js": "./node_modules/moment/locale/bn.js",
	"./bo": "./node_modules/moment/locale/bo.js",
	"./bo.js": "./node_modules/moment/locale/bo.js",
	"./br": "./node_modules/moment/locale/br.js",
	"./br.js": "./node_modules/moment/locale/br.js",
	"./bs": "./node_modules/moment/locale/bs.js",
	"./bs.js": "./node_modules/moment/locale/bs.js",
	"./ca": "./node_modules/moment/locale/ca.js",
	"./ca.js": "./node_modules/moment/locale/ca.js",
	"./cs": "./node_modules/moment/locale/cs.js",
	"./cs.js": "./node_modules/moment/locale/cs.js",
	"./cv": "./node_modules/moment/locale/cv.js",
	"./cv.js": "./node_modules/moment/locale/cv.js",
	"./cy": "./node_modules/moment/locale/cy.js",
	"./cy.js": "./node_modules/moment/locale/cy.js",
	"./da": "./node_modules/moment/locale/da.js",
	"./da.js": "./node_modules/moment/locale/da.js",
	"./de": "./node_modules/moment/locale/de.js",
	"./de-at": "./node_modules/moment/locale/de-at.js",
	"./de-at.js": "./node_modules/moment/locale/de-at.js",
	"./de-ch": "./node_modules/moment/locale/de-ch.js",
	"./de-ch.js": "./node_modules/moment/locale/de-ch.js",
	"./de.js": "./node_modules/moment/locale/de.js",
	"./dv": "./node_modules/moment/locale/dv.js",
	"./dv.js": "./node_modules/moment/locale/dv.js",
	"./el": "./node_modules/moment/locale/el.js",
	"./el.js": "./node_modules/moment/locale/el.js",
	"./en-au": "./node_modules/moment/locale/en-au.js",
	"./en-au.js": "./node_modules/moment/locale/en-au.js",
	"./en-ca": "./node_modules/moment/locale/en-ca.js",
	"./en-ca.js": "./node_modules/moment/locale/en-ca.js",
	"./en-gb": "./node_modules/moment/locale/en-gb.js",
	"./en-gb.js": "./node_modules/moment/locale/en-gb.js",
	"./en-ie": "./node_modules/moment/locale/en-ie.js",
	"./en-ie.js": "./node_modules/moment/locale/en-ie.js",
	"./en-nz": "./node_modules/moment/locale/en-nz.js",
	"./en-nz.js": "./node_modules/moment/locale/en-nz.js",
	"./eo": "./node_modules/moment/locale/eo.js",
	"./eo.js": "./node_modules/moment/locale/eo.js",
	"./es": "./node_modules/moment/locale/es.js",
	"./es-do": "./node_modules/moment/locale/es-do.js",
	"./es-do.js": "./node_modules/moment/locale/es-do.js",
	"./es-us": "./node_modules/moment/locale/es-us.js",
	"./es-us.js": "./node_modules/moment/locale/es-us.js",
	"./es.js": "./node_modules/moment/locale/es.js",
	"./et": "./node_modules/moment/locale/et.js",
	"./et.js": "./node_modules/moment/locale/et.js",
	"./eu": "./node_modules/moment/locale/eu.js",
	"./eu.js": "./node_modules/moment/locale/eu.js",
	"./fa": "./node_modules/moment/locale/fa.js",
	"./fa.js": "./node_modules/moment/locale/fa.js",
	"./fi": "./node_modules/moment/locale/fi.js",
	"./fi.js": "./node_modules/moment/locale/fi.js",
	"./fo": "./node_modules/moment/locale/fo.js",
	"./fo.js": "./node_modules/moment/locale/fo.js",
	"./fr": "./node_modules/moment/locale/fr.js",
	"./fr-ca": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ca.js": "./node_modules/moment/locale/fr-ca.js",
	"./fr-ch": "./node_modules/moment/locale/fr-ch.js",
	"./fr-ch.js": "./node_modules/moment/locale/fr-ch.js",
	"./fr.js": "./node_modules/moment/locale/fr.js",
	"./fy": "./node_modules/moment/locale/fy.js",
	"./fy.js": "./node_modules/moment/locale/fy.js",
	"./gd": "./node_modules/moment/locale/gd.js",
	"./gd.js": "./node_modules/moment/locale/gd.js",
	"./gl": "./node_modules/moment/locale/gl.js",
	"./gl.js": "./node_modules/moment/locale/gl.js",
	"./gom-latn": "./node_modules/moment/locale/gom-latn.js",
	"./gom-latn.js": "./node_modules/moment/locale/gom-latn.js",
	"./gu": "./node_modules/moment/locale/gu.js",
	"./gu.js": "./node_modules/moment/locale/gu.js",
	"./he": "./node_modules/moment/locale/he.js",
	"./he.js": "./node_modules/moment/locale/he.js",
	"./hi": "./node_modules/moment/locale/hi.js",
	"./hi.js": "./node_modules/moment/locale/hi.js",
	"./hr": "./node_modules/moment/locale/hr.js",
	"./hr.js": "./node_modules/moment/locale/hr.js",
	"./hu": "./node_modules/moment/locale/hu.js",
	"./hu.js": "./node_modules/moment/locale/hu.js",
	"./hy-am": "./node_modules/moment/locale/hy-am.js",
	"./hy-am.js": "./node_modules/moment/locale/hy-am.js",
	"./id": "./node_modules/moment/locale/id.js",
	"./id.js": "./node_modules/moment/locale/id.js",
	"./is": "./node_modules/moment/locale/is.js",
	"./is.js": "./node_modules/moment/locale/is.js",
	"./it": "./node_modules/moment/locale/it.js",
	"./it.js": "./node_modules/moment/locale/it.js",
	"./ja": "./node_modules/moment/locale/ja.js",
	"./ja.js": "./node_modules/moment/locale/ja.js",
	"./jv": "./node_modules/moment/locale/jv.js",
	"./jv.js": "./node_modules/moment/locale/jv.js",
	"./ka": "./node_modules/moment/locale/ka.js",
	"./ka.js": "./node_modules/moment/locale/ka.js",
	"./kk": "./node_modules/moment/locale/kk.js",
	"./kk.js": "./node_modules/moment/locale/kk.js",
	"./km": "./node_modules/moment/locale/km.js",
	"./km.js": "./node_modules/moment/locale/km.js",
	"./kn": "./node_modules/moment/locale/kn.js",
	"./kn.js": "./node_modules/moment/locale/kn.js",
	"./ko": "./node_modules/moment/locale/ko.js",
	"./ko.js": "./node_modules/moment/locale/ko.js",
	"./ky": "./node_modules/moment/locale/ky.js",
	"./ky.js": "./node_modules/moment/locale/ky.js",
	"./lb": "./node_modules/moment/locale/lb.js",
	"./lb.js": "./node_modules/moment/locale/lb.js",
	"./lo": "./node_modules/moment/locale/lo.js",
	"./lo.js": "./node_modules/moment/locale/lo.js",
	"./lt": "./node_modules/moment/locale/lt.js",
	"./lt.js": "./node_modules/moment/locale/lt.js",
	"./lv": "./node_modules/moment/locale/lv.js",
	"./lv.js": "./node_modules/moment/locale/lv.js",
	"./me": "./node_modules/moment/locale/me.js",
	"./me.js": "./node_modules/moment/locale/me.js",
	"./mi": "./node_modules/moment/locale/mi.js",
	"./mi.js": "./node_modules/moment/locale/mi.js",
	"./mk": "./node_modules/moment/locale/mk.js",
	"./mk.js": "./node_modules/moment/locale/mk.js",
	"./ml": "./node_modules/moment/locale/ml.js",
	"./ml.js": "./node_modules/moment/locale/ml.js",
	"./mr": "./node_modules/moment/locale/mr.js",
	"./mr.js": "./node_modules/moment/locale/mr.js",
	"./ms": "./node_modules/moment/locale/ms.js",
	"./ms-my": "./node_modules/moment/locale/ms-my.js",
	"./ms-my.js": "./node_modules/moment/locale/ms-my.js",
	"./ms.js": "./node_modules/moment/locale/ms.js",
	"./my": "./node_modules/moment/locale/my.js",
	"./my.js": "./node_modules/moment/locale/my.js",
	"./nb": "./node_modules/moment/locale/nb.js",
	"./nb.js": "./node_modules/moment/locale/nb.js",
	"./ne": "./node_modules/moment/locale/ne.js",
	"./ne.js": "./node_modules/moment/locale/ne.js",
	"./nl": "./node_modules/moment/locale/nl.js",
	"./nl-be": "./node_modules/moment/locale/nl-be.js",
	"./nl-be.js": "./node_modules/moment/locale/nl-be.js",
	"./nl.js": "./node_modules/moment/locale/nl.js",
	"./nn": "./node_modules/moment/locale/nn.js",
	"./nn.js": "./node_modules/moment/locale/nn.js",
	"./pa-in": "./node_modules/moment/locale/pa-in.js",
	"./pa-in.js": "./node_modules/moment/locale/pa-in.js",
	"./pl": "./node_modules/moment/locale/pl.js",
	"./pl.js": "./node_modules/moment/locale/pl.js",
	"./pt": "./node_modules/moment/locale/pt.js",
	"./pt-br": "./node_modules/moment/locale/pt-br.js",
	"./pt-br.js": "./node_modules/moment/locale/pt-br.js",
	"./pt.js": "./node_modules/moment/locale/pt.js",
	"./ro": "./node_modules/moment/locale/ro.js",
	"./ro.js": "./node_modules/moment/locale/ro.js",
	"./ru": "./node_modules/moment/locale/ru.js",
	"./ru.js": "./node_modules/moment/locale/ru.js",
	"./sd": "./node_modules/moment/locale/sd.js",
	"./sd.js": "./node_modules/moment/locale/sd.js",
	"./se": "./node_modules/moment/locale/se.js",
	"./se.js": "./node_modules/moment/locale/se.js",
	"./si": "./node_modules/moment/locale/si.js",
	"./si.js": "./node_modules/moment/locale/si.js",
	"./sk": "./node_modules/moment/locale/sk.js",
	"./sk.js": "./node_modules/moment/locale/sk.js",
	"./sl": "./node_modules/moment/locale/sl.js",
	"./sl.js": "./node_modules/moment/locale/sl.js",
	"./sq": "./node_modules/moment/locale/sq.js",
	"./sq.js": "./node_modules/moment/locale/sq.js",
	"./sr": "./node_modules/moment/locale/sr.js",
	"./sr-cyrl": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr-cyrl.js": "./node_modules/moment/locale/sr-cyrl.js",
	"./sr.js": "./node_modules/moment/locale/sr.js",
	"./ss": "./node_modules/moment/locale/ss.js",
	"./ss.js": "./node_modules/moment/locale/ss.js",
	"./sv": "./node_modules/moment/locale/sv.js",
	"./sv.js": "./node_modules/moment/locale/sv.js",
	"./sw": "./node_modules/moment/locale/sw.js",
	"./sw.js": "./node_modules/moment/locale/sw.js",
	"./ta": "./node_modules/moment/locale/ta.js",
	"./ta.js": "./node_modules/moment/locale/ta.js",
	"./te": "./node_modules/moment/locale/te.js",
	"./te.js": "./node_modules/moment/locale/te.js",
	"./tet": "./node_modules/moment/locale/tet.js",
	"./tet.js": "./node_modules/moment/locale/tet.js",
	"./th": "./node_modules/moment/locale/th.js",
	"./th.js": "./node_modules/moment/locale/th.js",
	"./tl-ph": "./node_modules/moment/locale/tl-ph.js",
	"./tl-ph.js": "./node_modules/moment/locale/tl-ph.js",
	"./tlh": "./node_modules/moment/locale/tlh.js",
	"./tlh.js": "./node_modules/moment/locale/tlh.js",
	"./tr": "./node_modules/moment/locale/tr.js",
	"./tr.js": "./node_modules/moment/locale/tr.js",
	"./tzl": "./node_modules/moment/locale/tzl.js",
	"./tzl.js": "./node_modules/moment/locale/tzl.js",
	"./tzm": "./node_modules/moment/locale/tzm.js",
	"./tzm-latn": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm-latn.js": "./node_modules/moment/locale/tzm-latn.js",
	"./tzm.js": "./node_modules/moment/locale/tzm.js",
	"./uk": "./node_modules/moment/locale/uk.js",
	"./uk.js": "./node_modules/moment/locale/uk.js",
	"./ur": "./node_modules/moment/locale/ur.js",
	"./ur.js": "./node_modules/moment/locale/ur.js",
	"./uz": "./node_modules/moment/locale/uz.js",
	"./uz-latn": "./node_modules/moment/locale/uz-latn.js",
	"./uz-latn.js": "./node_modules/moment/locale/uz-latn.js",
	"./uz.js": "./node_modules/moment/locale/uz.js",
	"./vi": "./node_modules/moment/locale/vi.js",
	"./vi.js": "./node_modules/moment/locale/vi.js",
	"./x-pseudo": "./node_modules/moment/locale/x-pseudo.js",
	"./x-pseudo.js": "./node_modules/moment/locale/x-pseudo.js",
	"./yo": "./node_modules/moment/locale/yo.js",
	"./yo.js": "./node_modules/moment/locale/yo.js",
	"./zh-cn": "./node_modules/moment/locale/zh-cn.js",
	"./zh-cn.js": "./node_modules/moment/locale/zh-cn.js",
	"./zh-hk": "./node_modules/moment/locale/zh-hk.js",
	"./zh-hk.js": "./node_modules/moment/locale/zh-hk.js",
	"./zh-tw": "./node_modules/moment/locale/zh-tw.js",
	"./zh-tw.js": "./node_modules/moment/locale/zh-tw.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/moment/locale recursive ^\\.\\/.*$";

/***/ }),

/***/ "./src/app/app.component.html":
/***/ (function(module, exports) {

module.exports = "<div>\r\n  <div id=\"screen-disable\"></div>\r\n  <div id=\"loader\"></div>\r\n  <router-outlet></router-outlet>\r\n  <div (click)=\"showTeamEasterEgg()\" style=\"height: 10px; width: 10px;\"></div>\r\n</div>\r\n";

/***/ }),

/***/ "./src/app/app.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.min.css"), "");
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/themes/default.min.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}:root{font-size:75%}body{background-color:beige;font-family:Verdana,Arial,Tahoma;font-size:1rem}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/app.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var popupHelper_1 = __webpack_require__("./src/models/popupHelper.ts");
var AppComponent = (function () {
    function AppComponent() {
        this.title = 'CRIM Web Application';
    }
    AppComponent.prototype.showTeamEasterEgg = function () {
        popupHelper_1.default.developerEasterEgg();
    };
    AppComponent = __decorate([
        core_1.Component({
            selector: 'app-root',
            template: __webpack_require__("./src/app/app.component.html"),
            styles: [__webpack_require__("./node_modules/normalize.css/normalize.css"), __webpack_require__("./src/app/app.component.scss")],
            encapsulation: core_1.ViewEncapsulation.None,
        })
    ], AppComponent);
    return AppComponent;
}());
exports.AppComponent = AppComponent;
//# sourceMappingURL=app.component.js.map

/***/ }),

/***/ "./src/app/app.module.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var http_1 = __webpack_require__("./node_modules/@angular/http/esm5/http.js");
var platform_browser_1 = __webpack_require__("./node_modules/@angular/platform-browser/esm5/platform-browser.js");
var app_component_1 = __webpack_require__("./src/app/app.component.ts");
var app_routing_1 = __webpack_require__("./src/app/app.routing.ts");
var helloWorld_component_1 = __webpack_require__("./src/app/helloWorld/helloWorld.component.ts");
var navigation_component_1 = __webpack_require__("./src/app/navigation/navigation.component.ts");
var navigationWorkOrders_component_1 = __webpack_require__("./src/app/navigationWorkOrders/navigationWorkOrders.component.ts");
var navigationInternal_component_1 = __webpack_require__("./src/app/navigationInternal/navigationInternal.component.ts");
var login_component_1 = __webpack_require__("./src/app/login/login.component.ts");
var loginHeader_component_1 = __webpack_require__("./src/app/loginHeader/loginHeader.component.ts");
var footer_component_1 = __webpack_require__("./src/app/footer/footer.component.ts");
var changePassword_component_1 = __webpack_require__("./src/app/changePassword/changePassword.component.ts");
var forgotPassword_component_1 = __webpack_require__("./src/app/forgotPassword/forgotPassword.component.ts");
var exit_component_1 = __webpack_require__("./src/app/exit/exit.component.ts");
var specialAdmitted_component_1 = __webpack_require__("./src/app/specialAdmitted/specialAdmitted.component.ts");
var specialInstruction_component_1 = __webpack_require__("./src/app/specialInstruction/specialInstruction.component.ts");
var specialResearch_component_1 = __webpack_require__("./src/app/specialResearch/specialResearch.component.ts");
var sortTaskList_component_1 = __webpack_require__("./src/app/sortTaskList/sortTaskList.component.ts");
var sortTaskListHelp_component_1 = __webpack_require__("./src/app/sortTaskListHelp/sortTaskListHelp.component.ts");
var offense_component_1 = __webpack_require__("./src/app/offense/offense.component.ts");
var offenseCounts_component_1 = __webpack_require__("./src/app/offenseCounts/offenseCounts.component.ts");
var offenseRecord_component_1 = __webpack_require__("./src/app/offenseRecord/offenseRecord.component.ts");
var offenseSearch_component_1 = __webpack_require__("./src/app/offenseSearch/offenseSearch.component.ts");
var offenseHelp_component_1 = __webpack_require__("./src/app/offenseHelp/offenseHelp.component.ts");
var registration_component_1 = __webpack_require__("./src/app/registration/registration.component.ts");
var researcherTaskComment_component_1 = __webpack_require__("./src/app/researcherTaskComment/researcherTaskComment.component.ts");
var researcherTaskList_component_1 = __webpack_require__("./src/app/researcherTaskList/researcherTaskList.component.ts");
var researcherTaskListHelp_component_1 = __webpack_require__("./src/app/researcherTaskListHelp/researcherTaskListHelp.component.ts");
var workOrderReport_component_1 = __webpack_require__("./src/app/workOrderReport/workOrderReport.component.ts");
var workOrderIdentifiers_component_1 = __webpack_require__("./src/app/workOrderIdentifiers/workOrderIdentifiers.component.ts");
var workOrderAdmissions_component_1 = __webpack_require__("./src/app/workOrderAdmissions/workOrderAdmissions.component.ts");
var workOrderSpecialInstructions_component_1 = __webpack_require__("./src/app/workOrderSpecialInstructions/workOrderSpecialInstructions.component.ts");
var confirmation_component_1 = __webpack_require__("./src/app/confirmation/confirmation.component.ts");
var reports_component_1 = __webpack_require__("./src/app/reports/reports.component.ts");
var invoiceReport_component_1 = __webpack_require__("./src/app/invoiceReport/invoiceReport.component.ts");
var orderBy_1 = __webpack_require__("./src/models/orderBy.ts");
// providers
var index_1 = __webpack_require__("./src/services/index.ts");
var environmentService_1 = __webpack_require__("./src/services/environmentService.ts");
var messageService_1 = __webpack_require__("./src/services/messageService.ts");
var browserWindowObjectService_1 = __webpack_require__("./src/services/browserWindowObjectService.ts");
var complianceAuditLogService_1 = __webpack_require__("./src/services/complianceAuditLogService.ts");
// guards
var authenticationGuard_1 = __webpack_require__("./src/guards/authenticationGuard.ts");
// custom directives
var validateOnblur_directive_1 = __webpack_require__("./src/directives/validateOnblur.directive.ts");
var AppModule = (function () {
    function AppModule() {
    }
    AppModule = __decorate([
        core_1.NgModule({
            declarations: [
                app_component_1.AppComponent,
                helloWorld_component_1.default,
                login_component_1.LoginComponent,
                loginHeader_component_1.LoginHeaderComponent,
                footer_component_1.FooterComponent,
                changePassword_component_1.ChangePasswordComponent,
                forgotPassword_component_1.ForgotPasswordComponent,
                exit_component_1.ExitComponent,
                researcherTaskList_component_1.ResearcherTaskListComponent,
                researcherTaskComment_component_1.ResearcherTaskCommentComponent,
                specialInstruction_component_1.SpecialInstructionComponent,
                specialAdmitted_component_1.SpecialAdmittedComponent,
                specialResearch_component_1.SpecialResearchComponent,
                sortTaskList_component_1.SortTaskListComponent,
                sortTaskListHelp_component_1.SortTaskListHelpComponent,
                workOrderReport_component_1.WorkOrderReportComponent,
                workOrderIdentifiers_component_1.WorkOrderIdentifiersComponent,
                workOrderAdmissions_component_1.WorkOrderAdmissionsComponent,
                workOrderSpecialInstructions_component_1.WorkOrderSpecialInstructionsComponent,
                offense_component_1.default,
                offenseSearch_component_1.default,
                offenseRecord_component_1.default,
                offenseCounts_component_1.default,
                offenseHelp_component_1.default,
                navigation_component_1.default,
                navigationWorkOrders_component_1.default,
                navigationInternal_component_1.NavigationInternalComponent,
                login_component_1.LoginComponent,
                registration_component_1.default,
                confirmation_component_1.default,
                validateOnblur_directive_1.default,
                researcherTaskListHelp_component_1.ResearcherTaskListHelpComponent,
                reports_component_1.default,
                invoiceReport_component_1.default,
                validateOnblur_directive_1.default,
                orderBy_1.OrderBy
            ],
            imports: [
                platform_browser_1.BrowserModule,
                http_1.HttpModule,
                app_routing_1.routing,
                forms_1.FormsModule,
                forms_1.ReactiveFormsModule,
            ],
            providers: [authenticationGuard_1.default,
                index_1.AuthenticationService,
                messageService_1.default, environmentService_1.default,
                browserWindowObjectService_1.default,
                complianceAuditLogService_1.default
            ],
            bootstrap: [app_component_1.AppComponent]
        })
    ], AppModule);
    return AppModule;
}());
exports.AppModule = AppModule;
//# sourceMappingURL=app.module.js.map

/***/ }),

/***/ "./src/app/app.routing.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var login_component_1 = __webpack_require__("./src/app/login/login.component.ts");
var exit_component_1 = __webpack_require__("./src/app/exit/exit.component.ts");
var researcherTaskComment_component_1 = __webpack_require__("./src/app/researcherTaskComment/researcherTaskComment.component.ts");
var researcherTaskList_component_1 = __webpack_require__("./src/app/researcherTaskList/researcherTaskList.component.ts");
var researcherTaskListHelp_component_1 = __webpack_require__("./src/app/researcherTaskListHelp/researcherTaskListHelp.component.ts");
var specialInstruction_component_1 = __webpack_require__("./src/app/specialInstruction/specialInstruction.component.ts");
var sortTaskList_component_1 = __webpack_require__("./src/app/sortTaskList/sortTaskList.component.ts");
var sortTaskListHelp_component_1 = __webpack_require__("./src/app/sortTaskListHelp/sortTaskListHelp.component.ts");
var workOrderReport_component_1 = __webpack_require__("./src/app/workOrderReport/workOrderReport.component.ts");
var offense_component_1 = __webpack_require__("./src/app/offense/offense.component.ts");
var offenseHelp_component_1 = __webpack_require__("./src/app/offenseHelp/offenseHelp.component.ts");
var helloWorld_component_1 = __webpack_require__("./src/app/helloWorld/helloWorld.component.ts");
var navigation_component_1 = __webpack_require__("./src/app/navigation/navigation.component.ts");
var registration_component_1 = __webpack_require__("./src/app/registration/registration.component.ts");
var authenticationGuard_1 = __webpack_require__("./src/guards/authenticationGuard.ts");
var confirmation_component_1 = __webpack_require__("./src/app/confirmation/confirmation.component.ts");
var reports_component_1 = __webpack_require__("./src/app/reports/reports.component.ts");
var invoiceReport_component_1 = __webpack_require__("./src/app/invoiceReport/invoiceReport.component.ts");
var appRoutes = [
    { path: '', component: login_component_1.LoginComponent },
    { path: 'login', component: login_component_1.LoginComponent },
    { path: 'comment', component: researcherTaskComment_component_1.ResearcherTaskCommentComponent, canActivate: [authenticationGuard_1.default] },
    { path: 'specialInstruction', component: specialInstruction_component_1.SpecialInstructionComponent, canActivate: [authenticationGuard_1.default] },
    { path: 'sortTaskList/:status', component: sortTaskList_component_1.SortTaskListComponent, canActivate: [authenticationGuard_1.default] },
    { path: 'sortTaskListHelp', component: sortTaskListHelp_component_1.SortTaskListHelpComponent, canActivate: [authenticationGuard_1.default] },
    { path: 'workOrderReport', component: workOrderReport_component_1.WorkOrderReportComponent, canActivate: [authenticationGuard_1.default] },
    { path: 'exit', component: exit_component_1.ExitComponent },
    { path: 'registration', component: registration_component_1.default },
    { path: 'confirmation', component: confirmation_component_1.default },
    { path: 'researcherHelp', component: researcherTaskListHelp_component_1.ResearcherTaskListHelpComponent },
    { path: 'researcherTaskList/:status', component: researcherTaskList_component_1.ResearcherTaskListComponent, canActivate: [authenticationGuard_1.default] },
    { path: 'researcherTaskList/:status/:jurisdictionId', component: researcherTaskList_component_1.ResearcherTaskListComponent, canActivate: [authenticationGuard_1.default] },
    { path: 'offense/:requestNumber', component: offense_component_1.default, canActivate: [authenticationGuard_1.default] },
    { path: 'offenseHelp', component: offenseHelp_component_1.default, canActivate: [authenticationGuard_1.default] },
    { path: 'helloworld', component: helloWorld_component_1.default, canActivate: [authenticationGuard_1.default] },
    { path: 'navigation', component: navigation_component_1.default, canActivate: [authenticationGuard_1.default] },
    { path: 'reports', component: reports_component_1.default, canActivate: [authenticationGuard_1.default] },
    { path: 'invoiceReport/:startDate/:endDate/:invoiceNumber', component: invoiceReport_component_1.default, canActivate: [authenticationGuard_1.default] },
    { path: 'invoiceReport/:startDate/:endDate', component: invoiceReport_component_1.default, canActivate: [authenticationGuard_1.default] },
];
exports.routing = router_1.RouterModule.forRoot(appRoutes, { useHash: true });
//# sourceMappingURL=app.routing.js.map

/***/ }),

/***/ "./src/app/changePassword/changePassword.component.html":
/***/ (function(module, exports) {

module.exports = "<form [formGroup]=\"changePasswordForm\" (ngSubmit)=\"onSubmit()\" novalidate autocomplete=\"off\">\r\n  <div id=\"changePasswrd\" *ngIf='showChangePassword()'>\r\n    <div id='spacerxsm'></div>\r\n    <app-login-header></app-login-header>\r\n    <h1 >CRIM System - Change Password</h1>\r\n    <div class=\"form-group\" align='center'>\r\n      <label class= 'lbl_headerTxt'>Enter new password information.\r\n    </label>\r\n    </div>\r\n    <div id=\"username-group\" formGroupName=\"change\" align='center'>\r\n      <label for=\"userName\" >Username:</label>\r\n        <input id=\"userName\" type=\"text\" formControlName=\"userName\" app-validateOnBlur\r\n          (focus)=\"setFocusById('username-sidebar')\"\r\n          (blur)=\"setBlurById('username-sidebar')\"><mark>*</mark>\r\n    <div id=\"username-sidebar\" class=\"username-sidebar sidebar hide-sidebar\">\r\n      <p > Username used to login into the CRIM system.</p>\r\n    </div>\r\n    <div class=\"validation\"  *ngIf=\"userName.invalid && (userName.dirty || userName.touched)\">\r\n      <span *ngIf=\"userName.hasError('required')\">Username is required. </span>\r\n      <span *ngIf=\"userName.hasError('minlength')\">Username must be a minimum of 4 characters.</span>\r\n      <span *ngIf=\"userName.hasError('maxlength')\">Username can only be a maximum of 30 characters.</span>\r\n      <span *ngIf=\"userName.hasError('locked')\">Account locked. Please contact GIS Vendor Relations.</span>\r\n      <span *ngIf=\"userName.hasError('notexists')\"> Username or password does not exist.</span>\r\n    </div>\r\n    </div>\r\n    <div id='spacerxsm'></div>\r\n    <div id=\"password-group\" formGroupName=\"change\" align='center'>\r\n      <label for=\"currentPassword\">Current Password:</label>\r\n      <input id=\"currentPassword\" type=\"password\" formControlName=\"currentPassword\" app-validateOnBlur\r\n        (focus)=\"setFocusById('password-sidebar')\"\r\n        (blur)=\"setBlurById('password-sidebar')\"\r\n        (keyup)=\"passwordKeyup($event, 0)\"><mark>*</mark> <br/>\r\n\r\n      <div id='spacerxxsm'></div>\r\n      <div id=\"password-sidebar\" class=\"password-sidebar sidebar hide-sidebar\">\r\n        <ul>\r\n          <li id=\"password-lower-case-letter\" class=\"rule-not-met\">At least <strong>1 lower case letter</strong></li>\r\n          <li id=\"password-upper-case-letter\" class=\"rule-not-met\">At least <strong>1 capital case letter</strong></li>\r\n          <li id=\"password-number-rule\" class=\"rule-not-met\">At least <strong>1 number</strong></li>\r\n          <li id=\"password-symbol-rule\" class=\"rule-not-met\">At least <strong>1 symbol</strong></li>\r\n          <li id=\"password-length-rule\"  class=\"rule-not-met\">At least <strong>8 characters minimum</strong></li>\r\n        </ul>\r\n      </div>\r\n      <div class=\"validation\" *ngIf=\"currentPassword.invalid && (currentPassword.dirty || currentPassword.touched)\">\r\n        <span *ngIf=\"currentPassword.hasError('required')\">Password is required. </span>\r\n        <span *ngIf=\"currentPassword.hasError('maxlength')\">Password can only be a maximum of 60 characters.</span>\r\n        <span *ngIf=\"currentPassword.hasError('passwordRules')\">Password does not meet validation rules.</span>\r\n        <span *ngIf=\"currentPassword.hasError('invalid')\">Password is invalid.</span>\r\n        <span *ngIf=\"currentPassword.hasError('notexists')\"> Username or password does not exist.</span>\r\n      </div>\r\n    </div>\r\n    <div id='spacerxsm'></div>\r\n    <div id=\"new-password-group\" formGroupName=\"change\" align='center'>\r\n      <label for=\"new-password\">New Password:</label>\r\n      <input id=\"new-password\" type=\"password\" formControlName=\"newPassword\" app-validateOnBlur\r\n        (focus)=\"setFocusById('new-password-sidebar')\"\r\n        (blur)=\"setBlurById('new-password-sidebar')\"\r\n        (keyup)=\"passwordKeyup($event, 1)\"><mark>*</mark><br/>\r\n        <div id='spacerxxsm'></div>\r\n        <div id=\"new-password-sidebar\" class=\"new-password-sidebar sidebar hide-sidebar\">\r\n          <ul>\r\n            <li id=\"newPassword-lower-case-letter\" class=\"rule-not-met\">At least <strong>1 lower case letter</strong></li>\r\n            <li id=\"newPassword-upper-case-letter\" class=\"rule-not-met\">At least <strong>1 capital case letter</strong></li>\r\n            <li id=\"newPassword-number-rule\" class=\"rule-not-met\">At least <strong>1 number</strong></li>\r\n            <li id=\"newPassword-symbol-rule\" class=\"rule-not-met\">At least <strong>1 symbol</strong></li>\r\n            <li id=\"newPassword-length-rule\"  class=\"rule-not-met\">At least <strong>8 characters minimum</strong></li>\r\n          </ul>\r\n        </div>\r\n        <div class=\"validation\" *ngIf=\"newPassword.invalid && (newPassword.dirty || newPassword.touched)\">\r\n          <span *ngIf=\"newPassword.hasError('required')\">New password is required. </span>\r\n          <span *ngIf=\"newPassword.hasError('maxlength')\">Password maximum 60 characters.</span>\r\n          <span *ngIf=\"newPassword.hasError('passwordRules')\">Password does not meet validation rules.</span>\r\n          <span *ngIf=\"newPassword.hasError('compareTwoInputs')\">Cannot match current password.</span>\r\n          <span *ngIf=\"newPassword.hasError('exists')\">Password already exists.</span>\r\n        </div>\r\n    </div>\r\n    <div id='spacerxsm'></div>\r\n    <div id=\"confirm-password-group\" formGroupName=\"change\" align='center'>\r\n      <label for=\"confirm-password\">Confirm Password:</label>\r\n      <input id=\"confirm-password\" type=\"password\" formControlName=\"confirmPassword\" app-validateOnBlur\r\n        (focus)=\"setFocusById('confirm-password-sidebar')\"\r\n        (blur)=\"setBlurById('confirm-password-sidebar')\"><mark>*</mark>\r\n\r\n        <div id=\"confirm-password-sidebar\" class=\"confirm-password-sidebar sidebar hide-sidebar\">\r\n          <p>Must match New Password entered.</p>\r\n        </div>\r\n        <div class=\"validation\" *ngIf=\"confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)\">\r\n          <span *ngIf=\"confirmPassword.hasError('required')\">Confirm Password is required.</span>\r\n          <span *ngIf=\"confirmPassword.hasError('maxlength')\">Confirm Password maximum 60 characters.</span>\r\n          <span *ngIf=\"confirmPassword.hasError('MatchPassword')\">Confirm Password must match New Password.</span>\r\n\r\n        </div>\r\n    </div>\r\n      <div id='spacer'></div>\r\n      <div id=\"changePassword-group\" align='center'>\r\n        <button class=\"Button button_pwd\" type=\"submit\" [disabled]=\"changePasswordForm.invalid\">Change Password</button>\r\n        <button class=\"Button button_cancel\" type=\"button\" (click)=\"home()\">Cancel</button>\r\n      </div>\r\n      <app-footer></app-footer>\r\n  </div>\r\n</form>\r\n";

/***/ }),

/***/ "./src/app/changePassword/changePassword.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}h1{text-align:center}.hdr{border:\"0\";background-color:#ccf;width:149.5rem;margin-left:4.5rem;-ms-flex-line-pack:center;align-content:center;height:1.5rem}.hdrTxt{font-weight:700;color:#000}.col1{float:left}.errMsg{font-weight:400;color:red;margin-top:.5rem;margin-left:3rem;display:block}p{text-align:left}Button{font-family:Verdana,Tahoma,Arial;background-color:#ccf;font-size:9pt}.button_pwd{width:11rem;height:2rem}.button_cancel{width:6rem;height:2rem}label{font-weight:bolder;font-size:9pt;font-family:Verdana,Tahoma,Arial;display:inline-block;width:11rem;text-align:left;padding-left:5em}.lbl_headerTxt{font-weight:400;width:48rem;padding-left:34rem;text-align:left;font-size:14px}input{font-size:11pt;font-family:Verdana,Tahoma,Arial;margin:.2rem;height:1.35rem;width:20rem}#spacer{padding-top:2.5rem}#spacerxsm{padding-top:.5rem}#spacerxxsm{padding-top:.1rem}#spacersm{padding-top:1.5rem}hr{width:45rem;size:1;color:#a5a29b}.footer{font-family:Arial Narrow\\,Arial;font-size:2}.requiredTag{margin-left:50.5rem}header{-ms-flex-line-pack:center;align-content:center;text-align:center;margin-bottom:3rem}mark{color:red;background-color:inherit}small{font-size:smaller;font-weight:400;margin-left:11.1rem;display:inline-block}#username-group{margin-top:3rem}#new-password-group,#password-group{position:relative}.validation span{font-weight:400;color:red;text-align:left;display:block;font-size:8pt;padding-left:20.5rem;height:1.35rem;width:25rem}div.username-sidebar{margin-top:-1rem;margin-left:1.7rem}div.password-sidebar,div.username-sidebar{font-size:1rem;width:auto;text-align:left;display:inline-block}div.password-sidebar{margin-top:-6rem;margin-left:20rem}div.new-password-sidebar{margin-top:-7rem;margin-left:20rem}div.confirm-password-sidebar,div.new-password-sidebar{font-size:1rem;width:auto;text-align:left;display:inline-block}div.confirm-password-sidebar{margin-top:-1rem;margin-left:1rem}.show-sidebar{visibility:visible;opacity:1}.hide-sidebar{visibility:hidden;opacity:0}.sidebar:before{content:\"\\25C1\";color:#dede8d;position:absolute;top:40%;left:-.6rem}.sidebar{border:.1rem solid #dede8d;padding:.3rem;background-color:lighter(beige,10%);position:absolute;margin:0}.sidebar ul{list-style-position:inside;margin:0;padding:.9rem .7rem;font-size:87%}.sidebar li:nth-of-type(n+1):nth-of-type(-n+4){margin-bottom:1.3rem}.sidebar li{list-style-type:none}.rule-not-met{color:red;padding-left:1.1rem;line-height:.8rem;background:url(\"data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg width='100%' height='100%' viewBox='0 0 31 30' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;'%3E%3Cpath d='M11.115,15.288l-10.169,-10.003c-1.097,-1.08 -1.199,-2.815 -0.236,-4.016c0.025,-0.032 0.051,-0.064 0.077,-0.096c0.53,-0.662 1.317,-1.068 2.164,-1.118c0.847,-0.05 1.675,0.261 2.28,0.856l10.315,10.147l9.282,-8.863c0.613,-0.586 1.446,-0.885 2.292,-0.822c0.846,0.062 1.626,0.48 2.147,1.149c0.027,0.035 0.054,0.07 0.081,0.105c0.946,1.215 0.818,2.949 -0.295,4.012l-9.134,8.721l7.703,7.577c1.097,1.08 1.199,2.815 0.236,4.016c-0.025,0.032 -0.051,0.064 -0.077,0.096c-0.531,0.662 -1.317,1.068 -2.164,1.118c-0.847,0.05 -1.675,-0.261 -2.28,-0.856l-7.848,-7.72l-9.112,8.7c-0.613,0.585 -1.446,0.884 -2.292,0.822c-0.846,-0.062 -1.626,-0.48 -2.147,-1.149c-0.027,-0.035 -0.054,-0.07 -0.081,-0.105c-0.946,-1.215 -0.818,-2.949 0.295,-4.012l8.963,-8.559Z' style='fill:%23e03030;stroke:%23404040;stroke-width:0.1px;'/%3E%3C/svg%3E\") no-repeat 0 50%}.rule-met{color:green;padding-left:1.1rem;line-height:.9rem;background:url(\"data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg width='100%' height='100%' viewBox='0 0 23 34' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;'%3E%3Cpath d='M0.662,23.279c-0.369,0.394 -0.359,1.009 0.022,1.391c1.655,1.654 5.881,5.881 7.872,7.871c0.237,0.237 0.577,0.34 0.906,0.273c0.328,-0.067 0.602,-0.294 0.728,-0.605c2.156,-5.322 9.812,-24.219 11.498,-28.381c0.188,-0.465 0.002,-0.999 -0.436,-1.246c-0.626,-0.353 -1.545,-0.872 -2.395,-1.351c-0.53,-0.299 -1.166,-0.341 -1.731,-0.113c-0.564,0.227 -0.994,0.699 -1.168,1.282c-1.623,5.43 -5.549,18.562 -6.993,23.393c-0.075,0.251 -0.304,0.425 -0.566,0.428c-0.262,0.004 -0.496,-0.162 -0.578,-0.411c-0.262,-0.788 -0.582,-1.752 -0.904,-2.725c-0.334,-1.004 -1.171,-1.758 -2.204,-1.985c-1.034,-0.227 -2.11,0.107 -2.833,0.879c-0.462,0.492 -0.888,0.948 -1.218,1.3Z' style='fill:%232be926;'/%3E%3C/svg%3E\") no-repeat 0 50%}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/changePassword/changePassword.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var index_1 = __webpack_require__("./src/services/index.ts");
var compareTwoInputsValidator_1 = __webpack_require__("./src/validators/compareTwoInputsValidator.ts");
var passwordRulesValidator_1 = __webpack_require__("./src/validators/passwordRulesValidator.ts");
var passwordValidation_1 = __webpack_require__("./src/validators/passwordValidation.ts");
var index_2 = __webpack_require__("./src/models/index.ts");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var ChangePasswordComponent = (function () {
    function ChangePasswordComponent(formBuilder, msgSvc, authenticationService) {
        this.formBuilder = formBuilder;
        this.msgSvc = msgSvc;
        this.authenticationService = authenticationService;
        this.showChange = false;
    }
    ChangePasswordComponent.prototype.ngOnInit = function () {
        this.msgSvc.setControlKey();
        this.changePasswordForm = this.formBuilder.group({
            change: this.formBuilder.group({
                userName: ['', forms_1.Validators.compose([
                        forms_1.Validators.required,
                        forms_1.Validators.maxLength(30),
                        forms_1.Validators.minLength(4)
                    ])
                ],
                currentPassword: ['', forms_1.Validators.compose([
                        forms_1.Validators.required,
                        forms_1.Validators.maxLength(60),
                        passwordRulesValidator_1.default()
                    ])
                ],
                newPassword: ['', forms_1.Validators.compose([
                        forms_1.Validators.required,
                        forms_1.Validators.maxLength(60),
                        passwordRulesValidator_1.default(),
                        compareTwoInputsValidator_1.default('currentPassword', false)
                    ])
                ],
                confirmPassword: ['', forms_1.Validators.compose([
                        forms_1.Validators.required,
                        forms_1.Validators.maxLength(60)
                    ])
                ],
            }, { validator: passwordValidation_1.PasswordValidation.MatchPassword })
        });
    };
    ChangePasswordComponent.prototype.home = function () {
        this.showChange = false;
        this.changePasswordForm.reset();
    };
    // this is called from login
    ChangePasswordComponent.prototype.passwordChange = function (isVisible) {
        this.showChange = isVisible;
    };
    ChangePasswordComponent.prototype.showChangePassword = function () {
        if (this.showChange) {
            return true;
        }
        else {
            return false;
        }
    };
    ChangePasswordComponent.prototype.onSubmit = function () {
        var _this = this;
        var form = this.changePasswordForm.value;
        var changes = Object.assign({}, form.change, { confirmPassword: undefined });
        this.authenticationService.changePassword(changes.userName, changes.currentPassword, changes.newPassword)
            .subscribe(function (codes) {
            var code = codes.find(function (rc) { return rc === index_2.Codes.ok; });
            if (code === index_2.Codes.ok) {
                _this.home();
            }
            else {
                for (var _i = 0, codes_1 = codes; _i < codes_1.length; _i++) {
                    var errorCode = codes_1[_i];
                    switch (errorCode) {
                        case index_2.Codes.requireUsername:
                            _this.setValidationErrorByControlName('change.userName', 'required');
                            break;
                        case index_2.Codes.requirePassword:
                            _this.setValidationErrorByControlName('change.currentPassword', 'required');
                            break;
                        case index_2.Codes.requiredNewPassword:
                            _this.setValidationErrorByControlName('change.newPassword', 'required');
                            break;
                        case index_2.Codes.invalidPassword:
                            _this.setValidationErrorByControlName('change.currentPassword', 'invalid');
                            break;
                        case index_2.Codes.userNamePasswordNotExist:
                            _this.setValidationErrorByControlName('change.userName', 'notexists');
                            _this.setValidationErrorByControlName('change.currentPassword', 'notexists');
                            break;
                        case index_2.Codes.passwordAlreadyExist:
                            _this.setValidationErrorByControlName('change.newPassword', 'exists');
                            break;
                        case index_2.Codes.accountLocked:
                            _this.setValidationErrorByControlName('change.userName', 'locked');
                            break;
                        case index_2.Codes.passwordMatch:
                            _this.setValidationErrorByControlName('change.newPassword', 'compareTwoInputs');
                            break;
                        default:
                            break;
                    }
                }
            }
        });
    };
    ChangePasswordComponent.prototype.setBlurById = function (id) {
        var classListPasswordSidebar = document.getElementById(id).classList;
        classListPasswordSidebar.remove('show-sidebar');
        classListPasswordSidebar.add('hide-sidebar');
    };
    ChangePasswordComponent.prototype.setFocusById = function (id) {
        var classListPasswordSidebar = document.getElementById(id).classList;
        classListPasswordSidebar.remove('hide-sidebar');
        classListPasswordSidebar.add('show-sidebar');
    };
    ChangePasswordComponent.prototype.passwordKeyup = function (event, order) {
        var password = event.target.value;
        this.checkLength(password, order);
        if (order === 0) {
            this.checkRegEx(password, /[!@#$%^&*(){}[\]?~<>]/, 'password-symbol-rule');
            this.checkRegEx(password, /[A-Z]/, 'password-upper-case-letter');
            this.checkRegEx(password, /[a-z]/, 'password-lower-case-letter');
            this.checkRegEx(password, /\d/, 'password-number-rule');
        }
        else {
            this.checkRegEx(password, /[!@#$%^&*(){}[\]?~<>]/, 'newPassword-symbol-rule');
            this.checkRegEx(password, /[A-Z]/, 'newPassword-upper-case-letter');
            this.checkRegEx(password, /[a-z]/, 'newPassword-lower-case-letter');
            this.checkRegEx(password, /\d/, 'newPassword-number-rule');
        }
    };
    ChangePasswordComponent.prototype.checkRegEx = function (s, pattern, id) {
        if (s.match !== null) {
            var isMatch = s.match(pattern);
            if (!isMatch) {
                this.showRuleNotMet(id);
            }
            else {
                this.showRuleMet(id);
            }
        }
    };
    ChangePasswordComponent.prototype.setValidationErrorByControlName = function (controlName, validatorType) {
        var control = this.changePasswordForm.get(controlName);
        var validator = {};
        validator[validatorType] = true;
        control.setErrors(validator);
        control.markAsTouched();
    };
    ChangePasswordComponent.prototype.checkLength = function (password, order) {
        var id = '';
        if (order === 0) {
            id = 'password-length-rule';
        }
        else {
            id = 'newPassword-length-rule';
        }
        if (password.length < 8) {
            this.showRuleNotMet(id);
        }
        else {
            this.showRuleMet(id);
        }
    };
    ChangePasswordComponent.prototype.showRuleMet = function (id) {
        var passwordLength = document.getElementById(id).classList;
        passwordLength.remove('rule-not-met');
        passwordLength.add('rule-met');
    };
    ChangePasswordComponent.prototype.showRuleNotMet = function (id) {
        var passwordLength = document.getElementById(id).classList;
        passwordLength.remove('rule-met');
        passwordLength.add('rule-not-met');
    };
    Object.defineProperty(ChangePasswordComponent.prototype, "userName", {
        get: function () { return this.changePasswordForm.get('change.userName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChangePasswordComponent.prototype, "currentPassword", {
        get: function () { return this.changePasswordForm.get('change.currentPassword'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChangePasswordComponent.prototype, "newPassword", {
        get: function () { return this.changePasswordForm.get('change.newPassword'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChangePasswordComponent.prototype, "confirmPassword", {
        get: function () { return this.changePasswordForm.get('change.confirmPassword'); },
        enumerable: true,
        configurable: true
    });
    ChangePasswordComponent = __decorate([
        core_1.Component({
            selector: 'app-changepassword',
            template: __webpack_require__("./src/app/changePassword/changePassword.component.html"),
            styles: [__webpack_require__("./src/app/changePassword/changePassword.component.scss")],
            providers: [index_1.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof forms_1.FormBuilder !== "undefined" && forms_1.FormBuilder) === "function" && _a || Object, typeof (_b = typeof index_1.MessageQueService !== "undefined" && index_1.MessageQueService) === "function" && _b || Object, typeof (_c = typeof index_1.AuthenticationService !== "undefined" && index_1.AuthenticationService) === "function" && _c || Object])
    ], ChangePasswordComponent);
    return ChangePasswordComponent;
    var _a, _b, _c;
}());
exports.ChangePasswordComponent = ChangePasswordComponent;
//# sourceMappingURL=changePassword.component.js.map

/***/ }),

/***/ "./src/app/confirmation/confirmation.component.html":
/***/ (function(module, exports) {

module.exports = "<main>\r\n  <h1>Congratulations on Creating Your Crim Account</h1>\r\n  <h3>Please visit <a routerLink=\"/\">here</a> to sign in.</h3>\r\n</main>\r\n";

/***/ }),

/***/ "./src/app/confirmation/confirmation.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}*{-webkit-box-sizing:border-box;box-sizing:border-box}main{-ms-flex-line-pack:center;align-content:center;text-align:center}h1{margin-top:5rem}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/confirmation/confirmation.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ConfirmationComponent = (function () {
    function ConfirmationComponent() {
    }
    ConfirmationComponent = __decorate([
        core_1.Component({
            selector: 'app-confirmation',
            template: __webpack_require__("./src/app/confirmation/confirmation.component.html"),
            styles: [__webpack_require__("./src/app/confirmation/confirmation.component.scss")],
        })
    ], ConfirmationComponent);
    return ConfirmationComponent;
}());
exports.default = ConfirmationComponent;
//# sourceMappingURL=confirmation.component.js.map

/***/ }),

/***/ "./src/app/exit/exit.component.html":
/***/ (function(module, exports) {

module.exports = "\r\n<br />\r\n<br />\r\n<br />\r\n<div align='center'>\r\n  <b>You have selected to exit the System.</b><br/>\r\n    System session ended...\r\n  <br />\r\n  <br />\r\n  <br/>\r\n  <br />\r\n    <strong>Click <a routerLink='/' routerLinkActive='active' href >here</a> to sign on again.</strong>\r\n</div>\r\n";

/***/ }),

/***/ "./src/app/exit/exit.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var index_1 = __webpack_require__("./src/services/index.ts");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var ExitComponent = (function () {
    function ExitComponent(authenticationService, router) {
        this.authenticationService = authenticationService;
        this.router = router;
    }
    ExitComponent.prototype.ngOnInit = function () {
        this.authenticationService.logout()
            .subscribe();
    };
    ExitComponent.prototype.logon = function () {
        this.router.navigate(['login']);
    };
    ExitComponent = __decorate([
        core_1.Component({
            template: __webpack_require__("./src/app/exit/exit.component.html")
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof index_1.AuthenticationService !== "undefined" && index_1.AuthenticationService) === "function" && _a || Object, typeof (_b = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _b || Object])
    ], ExitComponent);
    return ExitComponent;
    var _a, _b;
}());
exports.ExitComponent = ExitComponent;
//# sourceMappingURL=exit.component.js.map

/***/ }),

/***/ "./src/app/footer/footer.component.html":
/***/ (function(module, exports) {

module.exports = "<div id='spacersm'></div>\r\n<div align='center' >\r\n<hr>\r\n<span class='footer'> © 2017 General Information Services, Inc. - All rights reserved.</span>\r\n</div>\r\n";

/***/ }),

/***/ "./src/app/footer/footer.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".footer{font-family:Arial Narrow\\,Arial;font-size:2}#spacersm{padding-top:2.5rem}hr{width:30rem;size:1;color:#a5a29b}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/footer/footer.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var FooterComponent = (function () {
    function FooterComponent() {
    }
    FooterComponent = __decorate([
        core_1.Component({
            selector: 'app-footer',
            template: __webpack_require__("./src/app/footer/footer.component.html"),
            styles: [__webpack_require__("./src/app/footer/footer.component.scss")],
        })
    ], FooterComponent);
    return FooterComponent;
}());
exports.FooterComponent = FooterComponent;
//# sourceMappingURL=footer.component.js.map

/***/ }),

/***/ "./src/app/forgotPassword/forgotPassword.component.html":
/***/ (function(module, exports) {

module.exports = "<form [formGroup]=\"retrievePasswordForm\" (ngSubmit)=\"requestPassword()\" novalidate autocomplete=\"off\">\r\n  <div id=\"retrieveP\" *ngIf='showForgotPassword()'>\r\n    <div id='spacerxsm'></div>\r\n    <app-login-header></app-login-header>\r\n    <div id='spacerxsm'></div>\r\n    <h1 >CRIM System - Reset Password</h1>\r\n    <div class=\"form-group\" align='center'>\r\n      <label class= 'lbl_headerTxt'>Enter user verification information. </label>\r\n    </div>\r\n      <div id=\"username-group\" formGroupName=\"retrieve\" align='center'>\r\n        <label for=\"userName\">Username:</label>\r\n        <input id='userName' formControlName=\"userName\" type=\"text\" tabindex=\"1\" app-validateOnBlur\r\n          (focus)=\"setFocusById('username-sidebar')\"\r\n          (blur)=\"setBlurById('username-sidebar')\"><mark>*</mark>\r\n        <div id=\"username-sidebar\" class=\"username-sidebar sidebar hide-sidebar\">\r\n          <p > Username to login into the CRIM system.</p>\r\n        </div>\r\n        <div class=\"validation\"  *ngIf=\"userName.invalid && (userName.dirty || userName.touched)\">\r\n          <span *ngIf=\"userName.hasError('required')\">Username is required. </span>\r\n          <span *ngIf=\"userName.hasError('minlength')\">Username must be a minimum of 4 characters.</span>\r\n          <span *ngIf=\"userName.hasError('maxlength')\">Username can only be a maximum of 30 characters.</span>\r\n        </div>\r\n      </div>\r\n      <div id=\"email-group\" formGroupName=\"retrieve\" align='center'>\r\n        <label for=\"email\" >Email Address:</label>\r\n        <input id=\"email\" type=\"email\" formControlName=\"email\" app-validateOnBlur\r\n          (focus)=\"setFocusById('email-sidebar')\"\r\n          (blur)=\"setBlurById('email-sidebar')\"><mark>*</mark><br/>\r\n          <div id='spacerxxsm'></div>\r\n          <div id=\"email-sidebar\" class=\"email-sidebar sidebar hide-sidebar\">\r\n            <p > Email address used for CRIM system registration.</p>\r\n          </div>\r\n          <div class=\"validation\" *ngIf=\"email.invalid && (email.dirty || email.touched)\">\r\n            <span *ngIf=\"email.hasError('required')\">Email address is required. </span>\r\n            <span *ngIf=\"email.hasError('pattern')\">Email address is invalid. </span>\r\n          </div>\r\n      </div>\r\n      <div id='spacersm'></div>\r\n      <div id=\"retrieve-group\" formGroupName=\"retrieve\" align='center'>\r\n        <button class=\"Button button_pwd\" [disabled]=\"retrievePasswordForm.invalid\">Request Password</button>\r\n        <button class=\"Button button_sign\" (click)=\"home()\">Cancel</button>\r\n      </div>\r\n      <div id='spacerxsm'></div>\r\n      <app-footer></app-footer>\r\n  </div>\r\n</form>\r\n";

/***/ }),

/***/ "./src/app/forgotPassword/forgotPassword.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}h1{text-align:center}.hdr{border:\"0\";background-color:#ccf;width:149.5rem;margin-left:4.5rem;-ms-flex-line-pack:center;align-content:center;height:1.5rem}.hdrTxt{font-weight:700;color:#000}.lbl_header{width:88rem;text-align:center;font-size:24px}.lbl_headerTxt{font-weight:400;width:48rem;padding-left:30rem;text-align:left;font-size:14px}input{margin:.2rem;height:1.35rem;width:20rem}input,label{font-size:9pt;font-family:Verdana,Tahoma,Arial}label{font-weight:bolder;display:inline-block;width:11.5rem;text-align:left}Button{font-family:Verdana,Tahoma,Arial;background-color:#ccf}.button_sign{width:6rem;height:2rem}.button_pwd{width:11rem;height:2rem}.footer{font-family:Arial Narrow\\,Arial;font-size:2}#spacersm{padding-top:2.5rem}#spacerxsm{padding-top:.5rem}#spacer{padding-top:1.5rem}hr{width:30rem;size:1;color:#a5a29b}mark{color:red;background-color:inherit}small{font-size:smaller;font-weight:400;margin-left:10.5rem;display:inline-block}#username-group{margin-top:3rem}.validation span{font-weight:400;color:red;text-align:left;display:block;font-size:8pt;padding-left:15.7rem;height:1.35rem;width:25rem}div.username-sidebar{margin-top:-1rem;margin-left:1.7rem}div.email-sidebar,div.username-sidebar{font-size:1rem;width:auto;text-align:left;display:inline-block}div.email-sidebar{margin-top:-3.5rem;margin-left:19rem}.show-sidebar{visibility:visible;opacity:1}.hide-sidebar{visibility:hidden;opacity:0}.sidebar:before{content:\"\\25C1\";color:#dede8d;position:absolute;top:40%;left:-.6rem}.sidebar{border:.1rem solid #dede8d;padding:.3rem;background-color:lighter(beige,10%);position:absolute;margin:0}.sidebar ul{list-style-position:inside;margin:0;padding:.9rem .7rem;font-size:87%}.sidebar li:nth-of-type(n+1):nth-of-type(-n+4){margin-bottom:1.3rem}.sidebar li{list-style-type:none}.rule-not-met{color:red;padding-left:1.1rem;line-height:.8rem;background:url(\"data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg width='100%' height='100%' viewBox='0 0 31 30' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;'%3E%3Cpath d='M11.115,15.288l-10.169,-10.003c-1.097,-1.08 -1.199,-2.815 -0.236,-4.016c0.025,-0.032 0.051,-0.064 0.077,-0.096c0.53,-0.662 1.317,-1.068 2.164,-1.118c0.847,-0.05 1.675,0.261 2.28,0.856l10.315,10.147l9.282,-8.863c0.613,-0.586 1.446,-0.885 2.292,-0.822c0.846,0.062 1.626,0.48 2.147,1.149c0.027,0.035 0.054,0.07 0.081,0.105c0.946,1.215 0.818,2.949 -0.295,4.012l-9.134,8.721l7.703,7.577c1.097,1.08 1.199,2.815 0.236,4.016c-0.025,0.032 -0.051,0.064 -0.077,0.096c-0.531,0.662 -1.317,1.068 -2.164,1.118c-0.847,0.05 -1.675,-0.261 -2.28,-0.856l-7.848,-7.72l-9.112,8.7c-0.613,0.585 -1.446,0.884 -2.292,0.822c-0.846,-0.062 -1.626,-0.48 -2.147,-1.149c-0.027,-0.035 -0.054,-0.07 -0.081,-0.105c-0.946,-1.215 -0.818,-2.949 0.295,-4.012l8.963,-8.559Z' style='fill:%23e03030;stroke:%23404040;stroke-width:0.1px;'/%3E%3C/svg%3E\") no-repeat 0 50%}.rule-met{color:green;padding-left:1.1rem;line-height:.9rem;background:url(\"data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg width='100%' height='100%' viewBox='0 0 23 34' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;'%3E%3Cpath d='M0.662,23.279c-0.369,0.394 -0.359,1.009 0.022,1.391c1.655,1.654 5.881,5.881 7.872,7.871c0.237,0.237 0.577,0.34 0.906,0.273c0.328,-0.067 0.602,-0.294 0.728,-0.605c2.156,-5.322 9.812,-24.219 11.498,-28.381c0.188,-0.465 0.002,-0.999 -0.436,-1.246c-0.626,-0.353 -1.545,-0.872 -2.395,-1.351c-0.53,-0.299 -1.166,-0.341 -1.731,-0.113c-0.564,0.227 -0.994,0.699 -1.168,1.282c-1.623,5.43 -5.549,18.562 -6.993,23.393c-0.075,0.251 -0.304,0.425 -0.566,0.428c-0.262,0.004 -0.496,-0.162 -0.578,-0.411c-0.262,-0.788 -0.582,-1.752 -0.904,-2.725c-0.334,-1.004 -1.171,-1.758 -2.204,-1.985c-1.034,-0.227 -2.11,0.107 -2.833,0.879c-0.462,0.492 -0.888,0.948 -1.218,1.3Z' style='fill:%232be926;'/%3E%3C/svg%3E\") no-repeat 0 50%}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/forgotPassword/forgotPassword.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var index_1 = __webpack_require__("./src/services/index.ts");
var index_2 = __webpack_require__("./src/models/index.ts");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var popupHelper_1 = __webpack_require__("./src/models/popupHelper.ts");
var alertifyPromise_1 = __webpack_require__("./src/models/alertifyPromise.ts");
var ForgotPasswordComponent = (function () {
    function ForgotPasswordComponent(formBuilder, msgSvc, authenticationService) {
        this.formBuilder = formBuilder;
        this.msgSvc = msgSvc;
        this.authenticationService = authenticationService;
        this.show = false;
    }
    ForgotPasswordComponent.prototype.ngOnInit = function () {
        this.msgSvc.setControlKey();
        this.retrievePasswordForm = this.formBuilder.group({
            retrieve: this.formBuilder.group({
                userName: ['', forms_1.Validators.compose([
                        forms_1.Validators.required,
                        forms_1.Validators.maxLength(30),
                        forms_1.Validators.minLength(4)
                    ])
                ],
                email: ['', forms_1.Validators.compose([
                        forms_1.Validators.required,
                        forms_1.Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}'),
                        forms_1.Validators.maxLength(100)
                    ])
                ],
            })
        });
    };
    ForgotPasswordComponent.prototype.requestPassword = function () {
        var _this = this;
        var form = this.retrievePasswordForm.value;
        var retrieve = Object.assign({}, form.retrieve, { confirmPassword: undefined });
        this.authenticationService.resetPassword(retrieve.userName, retrieve.email)
            .subscribe(function (codes) {
            var code = codes.find(function (rc) { return rc === index_2.Codes.ok; });
            if (code === index_2.Codes.ok) {
                if (_this.authenticationService.isStatusInvalid === 400) {
                    var message = 'Email message not sent.  Please try again.';
                    _this.forgotPasswordRequest(message, 'error');
                }
                else if (_this.authenticationService.isStatusInvalid === 200) {
                    var message = 'Email sent, to provided email address, with additional instructions';
                    _this.forgotPasswordRequest(message, 'success');
                }
                else if (_this.authenticationService.isStatusInvalid === 401) {
                    var message = 'Invalid user and/or password.  Please try again.  Access denied';
                    _this.forgotPasswordRequest(message, 'error');
                }
            }
            else {
                for (var _i = 0, codes_1 = codes; _i < codes_1.length; _i++) {
                    var errorCode = codes_1[_i];
                    switch (errorCode) {
                        case index_2.Codes.requireUsername:
                            _this.setValidationErrorByControlName('retrieve.userName', 'required');
                            break;
                        case index_2.Codes.requiredEmail:
                            _this.setValidationErrorByControlName('retrieve.email', 'required');
                            break;
                        default:
                            break;
                    }
                }
            }
        });
    };
    ForgotPasswordComponent.prototype.setValidationErrorByControlName = function (controlName, validatorType) {
        var control = this.retrievePasswordForm.get(controlName);
        var validator = {};
        validator[validatorType] = true;
        control.setErrors(validator);
        control.markAsTouched();
    };
    ForgotPasswordComponent.prototype.setBlurById = function (id) {
        var classListPasswordSidebar = document.getElementById(id).classList;
        classListPasswordSidebar.remove('show-sidebar');
        classListPasswordSidebar.add('hide-sidebar');
    };
    ForgotPasswordComponent.prototype.setFocusById = function (id) {
        var classListPasswordSidebar = document.getElementById(id).classList;
        classListPasswordSidebar.remove('hide-sidebar');
        classListPasswordSidebar.add('show-sidebar');
    };
    ForgotPasswordComponent.prototype.home = function () {
        this.show = false;
        this.retrievePasswordForm.reset();
    };
    ForgotPasswordComponent.prototype.forgotPassword = function (isVisible) {
        this.show = isVisible;
    };
    ForgotPasswordComponent.prototype.showForgotPassword = function () {
        if (this.show) {
            return true;
        }
        else {
            return false;
        }
    };
    ForgotPasswordComponent.prototype.forgotPasswordRequest = function (message, type) {
        return __awaiter(this, void 0, void 0, function () {
            var alertResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popupHelper_1.default.userHelper(message, type)];
                    case 1:
                        alertResult = _a.sent();
                        if (alertResult === alertifyPromise_1.AlertResult.Ok) {
                            if (type === 'error') {
                                this.retrievePasswordForm.reset();
                            }
                            else {
                                this.home();
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ForgotPasswordComponent.prototype, "userName", {
        get: function () { return this.retrievePasswordForm.get('retrieve.userName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ForgotPasswordComponent.prototype, "email", {
        get: function () { return this.retrievePasswordForm.get('retrieve.email'); },
        enumerable: true,
        configurable: true
    });
    ForgotPasswordComponent = __decorate([
        core_1.Component({
            selector: 'app-forgotpassword',
            template: __webpack_require__("./src/app/forgotPassword/forgotPassword.component.html"),
            styles: [__webpack_require__("./src/app/forgotPassword/forgotPassword.component.scss")],
            providers: [index_1.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof forms_1.FormBuilder !== "undefined" && forms_1.FormBuilder) === "function" && _a || Object, typeof (_b = typeof index_1.MessageQueService !== "undefined" && index_1.MessageQueService) === "function" && _b || Object, typeof (_c = typeof index_1.AuthenticationService !== "undefined" && index_1.AuthenticationService) === "function" && _c || Object])
    ], ForgotPasswordComponent);
    return ForgotPasswordComponent;
    var _a, _b, _c;
}());
exports.ForgotPasswordComponent = ForgotPasswordComponent;
//# sourceMappingURL=forgotPassword.component.js.map

/***/ }),

/***/ "./src/app/helloWorld/helloWorld.component.html":
/***/ (function(module, exports) {

module.exports = "<h3>Message coming from service</h3>\r\n<h4>title: {{title}}</h4>\r\n<h4>description: {{description}}</h4>\r\n<h4>webApiHostName: {{webApiHostName}}</h4>\r\n<h4>dataApiHostName: {{dataApiHostName}}</h4>\r\n<button (click)=\"getMessage()\">Get Message</button>\r\n<p>{{error}}</p>\r\n";

/***/ }),

/***/ "./src/app/helloWorld/helloWorld.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}h3{color:#0064ff}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/helloWorld/helloWorld.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var messageService_1 = __webpack_require__("./src/services/messageService.ts");
var environmentService_1 = __webpack_require__("./src/services/environmentService.ts");
var HelloWorldComponent = (function () {
    function HelloWorldComponent(messageService) {
        this.messageService = messageService;
    }
    HelloWorldComponent.prototype.getMessage = function () {
        var _this = this;
        this.messageService.getMessage()
            .then(function (message) {
            _this.title = message.title;
            _this.description = message.description;
            _this.webApiHostName = message.webApiHostName;
            _this.dataApiHostName = message.dataApiHostName;
        })
            .catch(function (e) {
            _this.handleError(e);
        });
    };
    HelloWorldComponent.prototype.handleError = function (error) {
        this.error = "Server Error: Status: " + error.status + " StatusText: " + error.statusText + " Url: " + error.url;
    };
    HelloWorldComponent = __decorate([
        core_1.Component({
            selector: 'app-hello-world',
            template: __webpack_require__("./src/app/helloWorld/helloWorld.component.html"),
            styles: [__webpack_require__("./src/app/helloWorld/helloWorld.component.scss")],
            providers: [messageService_1.default, environmentService_1.default]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof messageService_1.default !== "undefined" && messageService_1.default) === "function" && _a || Object])
    ], HelloWorldComponent);
    return HelloWorldComponent;
    var _a;
}());
exports.default = HelloWorldComponent;
//# sourceMappingURL=helloWorld.component.js.map

/***/ }),

/***/ "./src/app/invoiceReport/invoiceReport.component.html":
/***/ (function(module, exports) {

module.exports = "<main>\r\n  <header>\r\n    <span>INVOICE</span>\r\n  </header>\r\n\r\n  <section id=\"general-information\" class=\"flex-container\">\r\n\r\n    <fieldset id=\"customer-informaton\">\r\n      <legend>Customer Information:</legend>\r\n      <span class='block-span'>General Information Services, Inc.</span>\r\n      <span class='block-span'>Attn: Accounts Payable </span>\r\n      <span class='block-span'>Post Office Box 353</span>\r\n      <span class='block-span'>Chapin, South Carolina 29036</span>\r\n    </fieldset>\r\n\r\n    <fieldset id=\"reference-informaton\">\r\n      <legend>Reference Information:</legend>\r\n      <label class=\"block-label\">Date:<span>{{ currentDate | date: 'MM/dd/yyyy' }}</span></label>\r\n      <label class=\"block-label\">Invoice Number:<span>{{ invoiceNumber }}</span></label>\r\n    </fieldset>\r\n\r\n  </section>\r\n\r\n  <section id=\"report-information\">\r\n    <table>\r\n      <tr>\r\n        <th>Jurisdiction</th>\r\n        <th>Total Requests</th>\r\n        <th>Jurisdiction Total</th>\r\n      </tr>\r\n      <tbody>\r\n        <tr *ngFor=\"let jurisdictionTotal of jurisdictionTotals\">\r\n          <td>{{ jurisdictionTotal.jurisdiction }}</td>\r\n          <td>{{ jurisdictionTotal.totalRequests | number:'.0' }}</td>\r\n          <td>{{ jurisdictionTotal.jurisdictionTotal  | currency:'USD':true:'1.2-2' }}</td>\r\n        </tr>\r\n      </tbody>\r\n      <tfoot>\r\n        <tr>\r\n          <td></td>\r\n          <td>Total Request Count : {{ totalRequestCount | number:'.0' }}</td>\r\n          <td>Total Invoice Amount = {{ totalInvoiceAmount | currency:'USD':true:'1.2-2' }}</td>\r\n        </tr>\r\n      </tfoot>\r\n\r\n    </table>\r\n  </section>\r\n\r\n  <section id=\"submit-invoice-to-informaton\">\r\n\r\n    <fieldset id=\"customer-informaton\">\r\n      <legend>Remit Payment To:</legend>\r\n      <span class='block-span'>{{ invoice?.vendor.name }}</span>\r\n      <span class='block-span'>Attn: Accounts Receivable</span>\r\n      <span class='block-span'>{{ invoice?.vendor.address }}</span>\r\n      <span class='block-span'>{{ invoice?.vendor.city }}, {{ invoice?.vendor.state }}</span>\r\n      <span class='block-span'>{{ invoice?.vendor.phoneNumber }}</span>\r\n    </fieldset>\r\n\r\n  </section>\r\n\r\n</main>\r\n";

/***/ }),

/***/ "./src/app/invoiceReport/invoiceReport.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}main{font-family:Verdana,Arial,Tahoma;margin:1rem 4rem}legend{font-weight:700}header{-ms-flex-line-pack:center;align-content:center;text-align:center}header span,label{font-weight:700}table{width:100%;border-collapse:collapse}td,th{padding:.5rem 0 .5rem 1rem}td,th{border:.1rem solid #000;width:30%}tfoot td{border:initial;font-weight:700}#general-information{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}#customer-informaton{width:25rem}#reference-informaton{width:20rem}#reference-informaton span{padding-left:1rem;display:inline-block;font-weight:400}#report-information,#submit-invoice-to-informaton{margin-top:2rem}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/invoiceReport/invoiceReport.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var invoiceService_1 = __webpack_require__("./src/services/invoiceService.ts");
var index_1 = __webpack_require__("./src/services/index.ts");
var InvoiceReportComponent = (function () {
    function InvoiceReportComponent(invoiceService, msgSvc, route) {
        var _this = this;
        this.invoiceService = invoiceService;
        this.msgSvc = msgSvc;
        this.route = route;
        this.route.params.subscribe(function (params) {
            _this.startDate = params['startDate'];
            _this.endDate = params['endDate'];
            _this.invoiceNumber = params['invoiceNumber'];
        });
    }
    InvoiceReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.msgSvc.setControlKey();
        this.invoiceService.getInvoice(this.invoiceNumber, this.startDate, this.endDate)
            .subscribe(function (invoice) {
            _this.invoice = invoice;
            _this.jurisdictionTotals = invoice.jurisdictionTotals;
            _this.totalRequestCount = invoice.totalRequestCount;
            _this.totalInvoiceAmount = invoice.totalInvoiceAmount;
        });
    };
    Object.defineProperty(InvoiceReportComponent.prototype, "currentDate", {
        get: function () {
            return new Date();
        },
        enumerable: true,
        configurable: true
    });
    InvoiceReportComponent = __decorate([
        core_1.Component({
            selector: 'app-invoice-report',
            template: __webpack_require__("./src/app/invoiceReport/invoiceReport.component.html"),
            styles: [__webpack_require__("./src/app/invoiceReport/invoiceReport.component.scss")],
            providers: [invoiceService_1.default, index_1.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof invoiceService_1.default !== "undefined" && invoiceService_1.default) === "function" && _a || Object, typeof (_b = typeof index_1.MessageQueService !== "undefined" && index_1.MessageQueService) === "function" && _b || Object, typeof (_c = typeof router_1.ActivatedRoute !== "undefined" && router_1.ActivatedRoute) === "function" && _c || Object])
    ], InvoiceReportComponent);
    return InvoiceReportComponent;
    var _a, _b, _c;
}());
exports.default = InvoiceReportComponent;
//# sourceMappingURL=invoiceReport.component.js.map

/***/ }),

/***/ "./src/app/login/login.component.html":
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<form [formGroup]=\"loginForm\" (ngSubmit)=\"login()\" novalidate autocomplete=\"off\">\r\n  <div id=\"login\" *ngIf='showLogin()'>\r\n    <div id='spacerxsm'></div>\r\n    <app-login-header></app-login-header>\r\n    <div id='spacersm'></div>\r\n    <div align='center' ><img id=\"logo\" src=\"" + __webpack_require__("./src/assets/images/CRIM-Logo.gif") + "\" ></div>\r\n    <div id=\"username-group\" formGroupName=\"log\" align='center'>\r\n      <label for=\"userName\" >Username:</label>\r\n      <input id='userName' type=\"text\" formControlName=\"userName\" app-validateOnBlur\r\n        (focus)=\"setFocusById('username-sidebar')\"\r\n        (blur)=\"setBlurById('username-sidebar')\"\r\n        required><mark>*</mark>\r\n        <div id=\"username-sidebar\" class=\"username-sidebar sidebar hide-sidebar\">\r\n          <p > Username to login into the CRIM system.</p>\r\n        </div>\r\n        <div class=\"validation\"  *ngIf=\"userName.invalid && (userName.dirty || userName.touched)\">\r\n          <span *ngIf=\"userName.hasError('minlength')\">Username must be a minimum of 4 characters.</span>\r\n          <span *ngIf=\"userName.hasError('maxlength')\">Username can only be a maximum of 30 characters.</span>\r\n          <span *ngIf=\"userName.hasError('required')\">Username is required. </span>\r\n          <span *ngIf=\"userName.hasError('locked')\">Account locked. Please contact GIS Vendor Relations.</span>\r\n        </div>\r\n    </div>\r\n    <div id=\"currentPassword-group\" formGroupName=\"log\" align='center'>\r\n      <label for=\"currentPassword\" >Password:</label>\r\n      <input id='currentPassword'\r\n         type=\"password\" app-validateOnBlur\r\n         maxlength=\"60\"\r\n        (focus)=\"setFocusById('password-sidebar')\"\r\n        (blur)=\"setBlurById('password-sidebar')\"\r\n        (keyup)=\"passwordKeyup($event)\"\r\n        app-validateOnBlur\r\n        formControlName=\"currentPassword\"\r\n        required><mark>*</mark><br/>\r\n\r\n        <div id='spacerxxsm'></div>\r\n        <div id=\"password-sidebar\" class=\"password-sidebar sidebar hide-sidebar\">\r\n          <ul>\r\n            <li id=\"password-lower-case-letter\" class=\"rule-not-met\">At least <strong>1 lower case letter</strong></li>\r\n            <li id=\"password-upper-case-letter\" class=\"rule-not-met\">At least <strong>1 capital case letter</strong></li>\r\n            <li id=\"password-number-rule\" class=\"rule-not-met\">At least <strong>1 number</strong></li>\r\n            <li id=\"password-symbol-rule\" class=\"rule-not-met\">At least <strong>1 symbol</strong></li>\r\n            <li id=\"password-length-rule\"  class=\"rule-not-met\">At least <strong>8 characters</strong></li>\r\n          </ul>\r\n        </div>\r\n        <div class=\"validation\" *ngIf=\"currentPassword.invalid && (currentPassword.dirty || currentPassword.touched)\">\r\n          <span *ngIf=\"currentPassword.hasError('required')\">Password is required. </span>\r\n          <span *ngIf=\"currentPassword.hasError('maxlength')\">Password can only be a max of 60 characters.</span>\r\n          <span *ngIf=\"currentPassword.hasError('passwordRules')\">Password does not meet all validation rules.</span>\r\n        </div>\r\n      </div>\r\n      <div id='spacerxsm'></div>\r\n      <div id=\"login-group\" formGroupName=\"log\" align='center'>\r\n        <button class=\"Button button_sign\" type=\"submit\" [disabled]=\"loginForm.invalid\" >Sign On</button>\r\n        <button class=\"Button button_clear\" type=\"button\" (click)=\"clear()\">Clear</button>\r\n        <button class=\"Button button_pwd\" type=\"button\" (click)=\"changePassword()\">Change Password</button>\r\n      </div>\r\n    <div id='spacerxsm'></div>\r\n    <div align='center'><a name='ForgotPassword' routerLink='' routerLinkActive='active' (click)='forgotPassword()'><span class='retrieveTxt' >Forgot Password</span></a> </div>\r\n    <app-footer></app-footer>\r\n  </div>\r\n</form>\r\n<app-changepassword></app-changepassword>\r\n<app-forgotpassword></app-forgotpassword>\r\n\r\n";

/***/ }),

/***/ "./src/app/login/login.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}#logo{width:27rem;height:10rem}#logo,.hdr{-ms-flex-line-pack:center;align-content:center}.hdr{border:\"0\";background-color:#ccf;width:100%;margin-left:4.5rem;height:1.5rem}.hdrTxt{font-weight:700;color:#000}.retrieveTxt{font-family:Arial Narrow\\,Arial;font-size:2;text-align:center;color:#200bdd}Button{font-family:Verdana,Tahoma,Arial;background-color:#ccf}.button_sign{width:6rem;height:2rem}.button_pwd{width:13rem;height:2rem}.button_clear{width:5rem;margin:1rem;height:2rem}.footer{font-family:Arial Narrow\\,Arial;font-size:2}.lbl_headerTxt{font-weight:400;width:48rem;padding-left:34rem;text-align:left;font-size:14px}label{font-weight:bolder;display:inline-block;width:7rem;text-align:left}input,label{font-size:9pt;font-family:Verdana,Tahoma,Arial}input{margin:.2rem;height:1.35rem;width:20rem}a:link{text-decoration:underline}a:hover,a:link,a:visited{color:#00f}#spacersm{padding-top:2.5rem}#spacerxsm{padding-top:.5rem}hr{width:30rem;size:1;color:#a5a29b}.requiredTag{margin-left:50.5rem}header{-ms-flex-line-pack:center;align-content:center;text-align:center;margin-bottom:3rem}mark{color:red;background-color:inherit}small{font-size:smaller;font-weight:400;margin-left:7rem;display:inline-block}#username-group{margin-top:2rem}#currentPassword-group,#username-group{position:relative}.validation span{font-weight:400;color:red;text-align:left;display:block;font-size:8pt;padding-left:11.5rem;height:1.35rem;width:25rem}div.username-sidebar{margin-top:-.4rem;margin-left:1.7rem}div.password-sidebar,div.username-sidebar{font-size:1rem;width:auto;text-align:left;display:inline-block}div.password-sidebar{margin-top:-6.5rem;margin-left:16rem}.show-sidebar{visibility:visible;opacity:1}.hide-sidebar{visibility:hidden;opacity:0}.sidebar:before{content:\"\\25C1\";color:#dede8d;position:absolute;top:40%;left:-.6rem}.sidebar{border:.1rem solid #dede8d;padding:.3rem;background-color:lighter(beige,10%);position:absolute;margin:0}.sidebar ul{list-style-position:inside;margin:0;padding:.9rem .7rem;font-size:87%}.sidebar li:nth-of-type(n+1):nth-of-type(-n+4){margin-bottom:1.3rem}.sidebar li{list-style-type:none}.rule-not-met{color:red;padding-left:1.1rem;line-height:.8rem;background:url(\"data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg width='100%' height='100%' viewBox='0 0 31 30' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;'%3E%3Cpath d='M11.115,15.288l-10.169,-10.003c-1.097,-1.08 -1.199,-2.815 -0.236,-4.016c0.025,-0.032 0.051,-0.064 0.077,-0.096c0.53,-0.662 1.317,-1.068 2.164,-1.118c0.847,-0.05 1.675,0.261 2.28,0.856l10.315,10.147l9.282,-8.863c0.613,-0.586 1.446,-0.885 2.292,-0.822c0.846,0.062 1.626,0.48 2.147,1.149c0.027,0.035 0.054,0.07 0.081,0.105c0.946,1.215 0.818,2.949 -0.295,4.012l-9.134,8.721l7.703,7.577c1.097,1.08 1.199,2.815 0.236,4.016c-0.025,0.032 -0.051,0.064 -0.077,0.096c-0.531,0.662 -1.317,1.068 -2.164,1.118c-0.847,0.05 -1.675,-0.261 -2.28,-0.856l-7.848,-7.72l-9.112,8.7c-0.613,0.585 -1.446,0.884 -2.292,0.822c-0.846,-0.062 -1.626,-0.48 -2.147,-1.149c-0.027,-0.035 -0.054,-0.07 -0.081,-0.105c-0.946,-1.215 -0.818,-2.949 0.295,-4.012l8.963,-8.559Z' style='fill:%23e03030;stroke:%23404040;stroke-width:0.1px;'/%3E%3C/svg%3E\") no-repeat 0 50%}.rule-met{color:green;padding-left:1.1rem;line-height:.9rem;background:url(\"data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg width='100%' height='100%' viewBox='0 0 23 34' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;'%3E%3Cpath d='M0.662,23.279c-0.369,0.394 -0.359,1.009 0.022,1.391c1.655,1.654 5.881,5.881 7.872,7.871c0.237,0.237 0.577,0.34 0.906,0.273c0.328,-0.067 0.602,-0.294 0.728,-0.605c2.156,-5.322 9.812,-24.219 11.498,-28.381c0.188,-0.465 0.002,-0.999 -0.436,-1.246c-0.626,-0.353 -1.545,-0.872 -2.395,-1.351c-0.53,-0.299 -1.166,-0.341 -1.731,-0.113c-0.564,0.227 -0.994,0.699 -1.168,1.282c-1.623,5.43 -5.549,18.562 -6.993,23.393c-0.075,0.251 -0.304,0.425 -0.566,0.428c-0.262,0.004 -0.496,-0.162 -0.578,-0.411c-0.262,-0.788 -0.582,-1.752 -0.904,-2.725c-0.334,-1.004 -1.171,-1.758 -2.204,-1.985c-1.034,-0.227 -2.11,0.107 -2.833,0.879c-0.462,0.492 -0.888,0.948 -1.218,1.3Z' style='fill:%232be926;'/%3E%3C/svg%3E\") no-repeat 0 50%}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/login/login.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js"); // , Compiler
var index_1 = __webpack_require__("./src/services/index.ts"); //
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var passwordRulesValidator_1 = __webpack_require__("./src/validators/passwordRulesValidator.ts");
var index_2 = __webpack_require__("./src/models/index.ts");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var forgotPassword_component_1 = __webpack_require__("./src/app/forgotPassword/forgotPassword.component.ts");
var changePassword_component_1 = __webpack_require__("./src/app/changePassword/changePassword.component.ts");
var popupHelper_1 = __webpack_require__("./src/models/popupHelper.ts");
var alertifyPromise_1 = __webpack_require__("./src/models/alertifyPromise.ts");
var browser;
(function (browser) {
    browser["chrome"] = "Chrome";
    browser["edge"] = "Edge";
    browser["firefox"] = "Firefox";
    browser["googlebot"] = "Googlebot";
    browser["internetExplorer"] = "Internet Explorer";
    browser["opera"] = "Opera";
    browser["safari"] = "Safari";
    browser["ucBrowsers"] = "UC Browsers";
    browser["android"] = "Android";
    browser["blackberry"] = "Blackberry";
})(browser = exports.browser || (exports.browser = {}));
var environment;
(function (environment) {
    environment["any"] = "any";
    environment["galaxy"] = "Galaxy Nexus";
    environment["nexus"] = "Nexus S";
    environment["bb10"] = "BB10";
    environment["playbook"] = "PlayBook 2.1";
    environment["blackberry99"] = "9900";
    environment["androidMobile"] = "Android Mobile";
    environment["androidTablet"] = "Android Tablet";
    environment["iPhone"] = "iPhone";
    environment["iPad"] = "iPad";
    environment["mac"] = "Mac";
    environment["windows"] = "Windows";
    environment["mobile"] = "Mobile";
    environment["xbox"] = "Xbox";
    environment["explorer11"] = "explorer11";
    environment["explorer10"] = "explorer10";
    environment["explorer9"] = "explorer9";
    environment["explorer8"] = "explorer8";
    environment["explorer7"] = "explorer7";
    environment["prestoMac"] = "(Presto) Mac";
    environment["prestoWindows"] = "(Presto) Windows";
    environment["ios"] = "iOS";
    environment["iPadI0S9"] = "iPad iOS9";
    environment["iPhoneI0S9"] = "iPhone iOS9";
    environment["smartphone"] = "Smartphone";
    environment["windowsPhone"] = "Windows Phone";
    environment["os"] = "OS"; //
})(environment = exports.environment || (exports.environment = {}));
var LoginComponent = (function () {
    function LoginComponent(formBuilder, router, authenticationService, msgSvc) {
        this.formBuilder = formBuilder;
        this.router = router;
        this.authenticationService = authenticationService;
        this.msgSvc = msgSvc;
        this.supported = '';
        this.chngPass = false;
        this.logon = true;
    }
    LoginComponent.prototype.ngOnInit = function () {
        this.msgSvc.getControlKey(); // ('CacheControlKey');
        this.detectBrowser();
        this.logon = true;
        this.loginForm = this.formBuilder.group({
            log: this.formBuilder.group({
                userName: ['', forms_1.Validators.compose([
                        forms_1.Validators.minLength(4),
                        forms_1.Validators.maxLength(30),
                        forms_1.Validators.required
                    ])
                ],
                currentPassword: ['', forms_1.Validators.compose([
                        forms_1.Validators.required,
                        forms_1.Validators.maxLength(60),
                        passwordRulesValidator_1.default()
                    ])
                ],
            })
        });
    };
    LoginComponent.prototype.login = function () {
        var _this = this;
        if (this.supported === 'true') {
            var form = this.loginForm.value;
            var log = Object.assign({}, form.log, {});
            this.authenticationService.login(log.userName, log.currentPassword)
                .subscribe(function (codes) {
                var code = codes.find(function (rc) { return rc === index_2.Codes.ok; });
                if (code === index_2.Codes.ok) {
                    if (_this.authenticationService.isExpiring === 0) {
                        _this.chngPass = true;
                        popupHelper_1.default.userHelper('Your password has expired', 'error');
                    }
                    else if (_this.authenticationService.isLoggedIn) {
                        if (_this.authenticationService.isExpiring <= 7) {
                            _this.confirmExpiredPassword(_this.authenticationService.isExpiring);
                        }
                        else if (_this.authenticationService.isReset) {
                            _this.chngPass = true;
                            _this.setDirection();
                        }
                        else {
                            _this.chngPass = false;
                            _this.setDirection();
                        }
                    }
                    else if (!_this.authenticationService.isLoggedIn && (_this.authenticationService.isStatusInvalid === 401 ||
                        _this.authenticationService.isStatusInvalid === 400)) {
                        _this.invalidUser();
                    }
                }
                else {
                    for (var _i = 0, codes_1 = codes; _i < codes_1.length; _i++) {
                        var errorCode = codes_1[_i];
                        switch (errorCode) {
                            case index_2.Codes.requireUsername:
                                _this.setValidationErrorByControlName('log.userName', 'required.');
                                break;
                            case index_2.Codes.requirePassword:
                                _this.setValidationErrorByControlName('log.currentPassword', 'required');
                                break;
                            case index_2.Codes.accountLocked:
                                _this.setValidationErrorByControlName('log.userName', 'locked');
                                break;
                            default:
                                break;
                        }
                    }
                }
            });
        }
        else if (this.supported === 'false') {
            this.notSupportedBrowser();
        }
        else {
            this.networkProblems();
        }
    };
    LoginComponent.prototype.setBlurById = function (id) {
        var classListPasswordSidebar = document.getElementById(id).classList;
        classListPasswordSidebar.remove('show-sidebar');
        classListPasswordSidebar.add('hide-sidebar');
    };
    LoginComponent.prototype.setFocusById = function (id) {
        var classListPasswordSidebar = document.getElementById(id).classList;
        classListPasswordSidebar.remove('hide-sidebar');
        classListPasswordSidebar.add('show-sidebar');
    };
    LoginComponent.prototype.passwordKeyup = function (event) {
        var password = event.target.value;
        this.checkLength(password);
        this.checkRegEx(password, /[!@#$%^&*(){}[\]?~<>]/, 'password-symbol-rule');
        this.checkRegEx(password, /[A-Z]/, 'password-upper-case-letter');
        this.checkRegEx(password, /[a-z]/, 'password-lower-case-letter');
        this.checkRegEx(password, /\d/, 'password-number-rule');
    };
    LoginComponent.prototype.checkRegEx = function (s, pattern, id) {
        var isMatch = s.match(pattern);
        if (!isMatch) {
            this.showRuleNotMet(id);
        }
        else {
            this.showRuleMet(id);
        }
    };
    LoginComponent.prototype.setValidationErrorByControlName = function (controlName, validatorType) {
        var control = this.loginForm.get(controlName);
        var validator = {};
        validator[validatorType] = true;
        control.setErrors(validator);
        control.markAsTouched();
    };
    LoginComponent.prototype.checkLength = function (password) {
        var id = 'password-length-rule';
        if (password.length < 8) {
            this.showRuleNotMet(id);
        }
        else {
            this.showRuleMet(id);
        }
    };
    LoginComponent.prototype.showRuleMet = function (id) {
        var passwordLength = document.getElementById(id).classList;
        passwordLength.remove('rule-not-met');
        passwordLength.add('rule-met');
    };
    LoginComponent.prototype.showRuleNotMet = function (id) {
        var passwordLength = document.getElementById(id).classList;
        passwordLength.remove('rule-met');
        passwordLength.add('rule-not-met');
    };
    LoginComponent.prototype.clear = function () {
        this.loginForm.reset();
        // document.getElementById('userName').focus();
    };
    // Child controls
    LoginComponent.prototype.forgotPassword = function () {
        if (this.supported === 'true') {
            this.clear();
            this.fPassword.forgotPassword(true);
            this.logon = false;
        }
        else if (this.supported === 'false') {
            this.notSupportedBrowser();
        }
        else {
            this.networkProblems();
        }
    };
    LoginComponent.prototype.changePassword = function () {
        if (this.supported === 'true') {
            this.clear();
            this.cPassword.passwordChange(true);
            this.logon = false;
            if (!this.cPassword.showChange) {
                this.logon = true;
            }
        }
        else if (this.supported === 'false') {
            this.notSupportedBrowser();
        }
        else {
            this.networkProblems();
        }
    };
    LoginComponent.prototype.showLogin = function () {
        if (this.logon) {
            return true;
        }
        else {
            if (!this.cPassword.showChange && !this.fPassword.show) {
                return true;
            }
            else {
                return false;
            }
        }
    };
    LoginComponent.prototype.setDirection = function () {
        if (this.authenticationService.isLoggedIn && !this.chngPass) {
            this.router.navigate(['navigation']);
        }
        else if (this.authenticationService.isLoggedIn && this.chngPass) {
            this.changePassword();
        }
    };
    LoginComponent.prototype.confirmExpiredPassword = function (daysTillExpiration) {
        return __awaiter(this, void 0, void 0, function () {
            var message, confirmResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = "Your password is scheduled to expire in " + daysTillExpiration + " days.  Click OK to change password now.";
                        return [4 /*yield*/, popupHelper_1.default.passwordExpirationHelper(message)];
                    case 1:
                        confirmResult = _a.sent();
                        if (confirmResult === alertifyPromise_1.ConfirmResult.Ok) {
                            this.chngPass = true;
                            this.setDirection();
                        }
                        else {
                            this.chngPass = false;
                            this.setDirection();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.invalidUser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var message, alertResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = 'Invalid user and/or password.  Please try again.  Access denied';
                        return [4 /*yield*/, popupHelper_1.default.userHelper(message, 'error')];
                    case 1:
                        alertResult = _a.sent();
                        if (alertResult === alertifyPromise_1.AlertResult.Ok) {
                            this.loginForm.reset();
                            document.getElementById('userName').focus();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.notSupportedBrowser = function () {
        return __awaiter(this, void 0, void 0, function () {
            var message, alertResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = 'Unsupported browser detected. Please contact GIS Vendor Relations.';
                        return [4 /*yield*/, popupHelper_1.default.loginIssue(message)];
                    case 1:
                        alertResult = _a.sent();
                        if (alertResult === alertifyPromise_1.AlertResult.Ok) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.networkProblems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var message, alertResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = 'GIS Server Not Available';
                        return [4 /*yield*/, popupHelper_1.default.loginIssue(message)];
                    case 1:
                        alertResult = _a.sent();
                        if (alertResult === alertifyPromise_1.AlertResult.Ok) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.detectBrowser = function () {
        var _this = this;
        var env = '';
        var bwsr = '';
        // Chrome
        var _isChromeAM = (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Mobile Safari') > -1 &&
            navigator.userAgent.indexOf('Nexus 5 Build') > -1 && navigator.userAgent.indexOf('Edge') === -1 &&
            navigator.userAgent.indexOf('Android') >= 6 && navigator.userAgent.indexOf('Mac') === -1 &&
            navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
        var _isChromeAT = (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
            navigator.userAgent.indexOf('Nexus 7 Build') > -1 && navigator.userAgent.indexOf('Edge') === -1 &&
            navigator.userAgent.indexOf('Android') >= 4 && navigator.userAgent.indexOf('Mac') === -1 &&
            navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
        var _isChromeIPhone = (navigator.userAgent.indexOf('CriOS') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
            navigator.userAgent.indexOf('Mobile') > -1 && navigator.userAgent.indexOf('iPhone') > -1 &&
            navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Android') === -1 &&
            navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
        var _isChromeIPad = (navigator.userAgent.indexOf('CriOS') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
            navigator.userAgent.indexOf('Mobile') > -1 && navigator.userAgent.indexOf('iPad') > -1 &&
            navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Android') === -1 &&
            navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
        var _isChromeOS = (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
            navigator.userAgent.indexOf('CrOS') > -1 && navigator.userAgent.indexOf('Edge') === -1 &&
            navigator.userAgent.indexOf('Android') === -1 && navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
        var _isChromeMac = (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
            navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Android') === -1 &&
            navigator.userAgent.indexOf('Macintosh') > -1 && navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
        var _isChromeWindows = (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
            navigator.userAgent.indexOf('Windows NT') > -1 && navigator.userAgent.indexOf('Edge') === -1 &&
            navigator.userAgent.indexOf('Android') === -1 && navigator.userAgent.indexOf('Mac') === -1 &&
            navigator.userAgent.toLowerCase().indexOf('op') === -1) ? true : false;
        // IE
        var _isExplorer11 = ((navigator.userAgent.indexOf('Trident/7.0') > -1 && navigator.userAgent.indexOf('Windows NT 10.0') > -1) &&
            navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('WOW64') > -1) ? true : false;
        var _isExplorer10 = ((navigator.userAgent.indexOf('MSIE 10.0') > -1 && navigator.userAgent.indexOf('Windows NT 6.1') > -1) &&
            navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Trident/6.0') > -1 &&
            navigator.userAgent.indexOf('WOW64') > -1) ? true : false;
        var _isExplorer9 = ((navigator.userAgent.indexOf('MSIE 9.0') > -1 && navigator.userAgent.indexOf('Windows NT 6.1') > -1) &&
            navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Trident/5.0') > -1) ? true : false;
        var _isExplorer8 = ((navigator.userAgent.indexOf('MSIE 8.0') > -1 && navigator.userAgent.indexOf('Windows NT 6.0') > -1) &&
            navigator.userAgent.indexOf('Edge') === -1 && navigator.userAgent.indexOf('Trident/4.0') > -1) ? true : false;
        var _isExplorer7 = ((navigator.userAgent.indexOf('MSIE 7.0') > -1 && navigator.userAgent.indexOf('Windows NT 6.0') > -1) &&
            navigator.userAgent.indexOf('Edge') === -1) ? true : false;
        // Firefox
        var _isFirefoxAM = (navigator.userAgent.indexOf('Firefox') > -1 &&
            navigator.userAgent.indexOf('Mobile') > -1 && navigator.userAgent.indexOf('Android 4.4') > -1) ? true : false;
        var _isFirefoxAT = (navigator.userAgent.indexOf('Firefox') > -1 &&
            navigator.userAgent.indexOf('Tablet') > -1 && navigator.userAgent.indexOf('Android 4.4') > -1) ? true : false;
        var _isFirefoxIPhone = (navigator.userAgent.indexOf('iPhone') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
            navigator.userAgent.indexOf('FxiOS') > -1 && navigator.userAgent.indexOf('Mobile') > -1 &&
            navigator.userAgent.indexOf('iPad') === -1) ? true : false;
        var _isFirefoxIPad = (navigator.userAgent.indexOf('iPad') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
            navigator.userAgent.indexOf('FxiOS') > -1 && navigator.userAgent.indexOf('Mobile') > -1) ? true : false;
        var _isFirefoxMac = (navigator.userAgent.indexOf('Firefox') > -1 &&
            navigator.userAgent.indexOf('Macintosh') > -1) ? true : false;
        var _isFirefoxWindows = (navigator.userAgent.indexOf('Firefox') > -1 &&
            navigator.userAgent.indexOf('Windows NT 10.0') > -1) ? true : false;
        // Safari
        var _isSafariIPad = (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 &&
            navigator.userAgent.indexOf('iPad') > -1 && navigator.userAgent.indexOf('iPhone') === -1 &&
            navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1) ? true : false;
        var _isSafariIPhone = (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 &&
            navigator.userAgent.indexOf('iPhone') > -1 && navigator.userAgent.indexOf('iPad') === -1 &&
            navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1) ? true : false;
        var _isSafariMac = (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1 &&
            navigator.userAgent.indexOf('Macintosh') > -1) ? true : false;
        // Opera
        var _isOperaMac = (navigator.userAgent.toLowerCase().indexOf('op') > -1 && navigator.userAgent.indexOf('Chrome') > -1 &&
            navigator.userAgent.indexOf('Macintosh') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
            navigator.userAgent.indexOf('Intel Mac OS X 10_11_1') > -1) ? true : false;
        var _isOperaWindows = (navigator.userAgent.toLowerCase().indexOf('op') > -1 && navigator.userAgent.indexOf('Chrome') > -1 &&
            navigator.userAgent.indexOf('Windows NT 10.0') > -1 && navigator.userAgent.indexOf('Safari') > -1 &&
            navigator.userAgent.indexOf('WOW64') > -1) ? true : false;
        var _isOperaPMac = (navigator.userAgent.indexOf('Macintosh') > -1 && navigator.userAgent.indexOf('Presto') > -1 &&
            navigator.userAgent.indexOf('Intel Mac OS X 10.9.1') > -1) ? true : false;
        var _isOperaPWindows = (navigator.userAgent.indexOf('Presto') > -1 &&
            navigator.userAgent.indexOf('Windows NT 6.1') > -1) ? true : false;
        var _isOperaAM = (navigator.userAgent.indexOf('Presto') > -1 && navigator.userAgent.indexOf('Android 4.1') > -1 &&
            navigator.userAgent.indexOf('Opera Mobi') > -1) ? true : false;
        var _isOperaIos = (navigator.userAgent.indexOf('iPhone') > -1 && navigator.userAgent.indexOf('Presto') > -1 &&
            navigator.userAgent.indexOf('Opera Mini') > -1) ? true : false;
        // Edge
        var _isEdgeWindow = (navigator.userAgent.indexOf('Edge') > -1 && navigator.userAgent.indexOf('Chrome') > -1 &&
            navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Windows NT') >= 10 &&
            navigator.userAgent.indexOf('Xbox') === -1) ? true : false;
        var _isEdgeMobile = (navigator.userAgent.indexOf('Edge') > -1 && navigator.userAgent.indexOf('Chrome') > -1 &&
            navigator.userAgent.indexOf('Mobile Safari') > -1 && navigator.userAgent.indexOf('Windows Phone') >= 10) ? true : false;
        var _isEdgeXBox = (navigator.userAgent.indexOf('Edge') > -1 && navigator.userAgent.indexOf('Chrome') > -1 &&
            navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Windows NT') >= 10 &&
            navigator.userAgent.indexOf('Xbox') > -1) ? true : false;
        // Google
        var _isGooglebot = (navigator.userAgent.indexOf('Googlebot/2.1') > -1 &&
            navigator.userAgent.indexOf('Nexus 5X Build') === -1 && navigator.userAgent.indexOf('Android 6.0.1') === -1) ? true : false;
        var _isGooglebotS = (navigator.userAgent.indexOf('Googlebot/2.1') > -1 &&
            navigator.userAgent.indexOf('Nexus 5X Build') > -1 && navigator.userAgent.indexOf('Android 6.0.1') > -1) ? true : false;
        // UC
        var _isUCBAM = (navigator.userAgent.indexOf('UCBrowser') > -1 && navigator.userAgent.indexOf('Android 4.4.4') > -1 &&
            navigator.userAgent.indexOf('Mobile Safari') > -1) ? true : false;
        var _isUCBIOS = (navigator.userAgent.indexOf('UCBrowser') > -1 && navigator.userAgent.indexOf('iPad') > -1) ? true : false;
        var _isUCBWindowPhone = (navigator.userAgent.indexOf('UCBrowser') > -1 && navigator.userAgent.indexOf('Profile/MIDP') > -1 &&
            navigator.userAgent.indexOf('Mozilla') > -1) ? true : false;
        // Blackberry
        var _isBlackberryBB10 = (navigator.userAgent.indexOf('Mobile Safari') !== -1 &&
            navigator.userAgent.indexOf('BB10') !== -1) ? true : false;
        var _isBlackberryPlaybook = (navigator.userAgent.indexOf('Safari') !== -1 &&
            navigator.userAgent.indexOf('PlayBook') !== -1) ? true : false;
        var _isBlackberry9900 = (navigator.userAgent.indexOf('Mobile Safari') !== -1 &&
            navigator.userAgent.indexOf('BlackBerry') !== -1) ? true : false;
        // Android
        var _isAndroidGalaxy = (navigator.userAgent.indexOf('Android') !== -1 && navigator.userAgent.indexOf('Mobile Safari') !== -1
            && navigator.userAgent.indexOf('Galaxy Nexus') !== -1) ? true : false;
        var _isAndroidNexus = (navigator.userAgent.indexOf('Android') !== -1 && navigator.userAgent.indexOf('Mobile Safari') !== -1
            && navigator.userAgent.indexOf('Nexus S') !== -1) ? true : false;
        if (_isAndroidGalaxy) {
            env = environment.galaxy;
            bwsr = browser.android;
        }
        else if (_isAndroidNexus) {
            env = environment.nexus;
            bwsr = browser.android;
        }
        else if (_isBlackberryBB10) {
            env = environment.bb10;
            bwsr = browser.blackberry;
        }
        else if (_isBlackberryPlaybook) {
            env = environment.playbook;
            bwsr = browser.blackberry;
        }
        else if (_isBlackberry9900) {
            env = environment.blackberry99;
            bwsr = browser.blackberry;
        }
        else if (_isChromeAM) {
            env = environment.androidMobile;
            bwsr = browser.chrome;
        }
        else if (_isChromeAT) {
            env = environment.androidTablet;
            bwsr = browser.chrome;
        }
        else if (_isChromeIPhone) {
            env = environment.iPhone;
            bwsr = browser.chrome;
        }
        else if (_isChromeIPad) {
            env = environment.iPad;
            bwsr = browser.chrome;
        }
        else if (_isChromeOS) {
            env = environment.os;
            bwsr = browser.chrome;
        }
        else if (_isChromeMac) {
            env = environment.mac;
            bwsr = browser.chrome;
        }
        else if (_isChromeWindows) {
            env = environment.windows;
            bwsr = browser.chrome;
        }
        else if (_isEdgeWindow) {
            env = environment.windows;
            bwsr = browser.edge;
        }
        else if (_isEdgeMobile) {
            env = environment.mobile;
            bwsr = browser.edge;
        }
        else if (_isEdgeXBox) {
            env = environment.xbox;
            bwsr = browser.edge;
        }
        else if (_isExplorer11) {
            env = environment.explorer11;
            bwsr = browser.internetExplorer;
        }
        else if (_isExplorer10) {
            env = environment.explorer10;
            bwsr = browser.internetExplorer;
        }
        else if (_isExplorer9) {
            env = environment.explorer9;
            bwsr = browser.internetExplorer;
        }
        else if (_isExplorer8) {
            env = environment.explorer8;
            bwsr = browser.internetExplorer;
        }
        else if (_isExplorer7) {
            env = environment.explorer7;
            bwsr = browser.internetExplorer;
        }
        else if (_isGooglebot) {
            env = environment.any;
            bwsr = browser.googlebot;
        }
        else if (_isGooglebotS) {
            env = environment.smartphone;
            bwsr = browser.googlebot;
        }
        else if (_isFirefoxAM) {
            env = environment.androidMobile;
            bwsr = browser.firefox;
        }
        else if (_isFirefoxAT) {
            env = environment.androidTablet;
            bwsr = browser.firefox;
        }
        else if (_isFirefoxIPhone) {
            env = environment.iPhone;
            bwsr = browser.firefox;
        }
        else if (_isFirefoxIPad) {
            env = environment.iPad;
            bwsr = browser.firefox;
        }
        else if (_isFirefoxMac) {
            env = environment.mac;
            bwsr = browser.firefox;
        }
        else if (_isFirefoxWindows) {
            env = environment.windows;
            bwsr = browser.firefox;
        }
        else if (_isSafariIPad) {
            env = environment.iPadI0S9;
            bwsr = browser.safari;
        }
        else if (_isSafariIPhone) {
            env = environment.iPhoneI0S9;
            bwsr = browser.safari;
        }
        else if (_isSafariMac) {
            env = environment.mac;
            bwsr = browser.safari;
        }
        else if (_isUCBAM) {
            env = environment.androidMobile;
            bwsr = browser.ucBrowsers;
        }
        else if (_isUCBIOS) {
            env = environment.ios;
            bwsr = browser.ucBrowsers;
        }
        else if (_isUCBWindowPhone) {
            env = environment.windowsPhone;
            bwsr = browser.ucBrowsers;
        }
        else if (_isOperaMac) {
            env = environment.mac;
            bwsr = browser.opera;
        }
        else if (_isOperaWindows) {
            env = environment.windows;
            bwsr = browser.opera;
        }
        else if (_isOperaPMac) {
            env = environment.prestoMac;
            bwsr = browser.opera;
        }
        else if (_isOperaPWindows) {
            env = environment.prestoWindows;
            bwsr = browser.opera;
        }
        else if (_isOperaAM) {
            env = environment.androidMobile;
            bwsr = browser.opera;
        }
        else if (_isOperaIos) {
            env = environment.ios;
            bwsr = browser.opera;
        }
        try {
            if ((env !== null && env !== undefined && env !== '') && (bwsr !== null && bwsr !== undefined && bwsr !== '')) {
                this.authenticationService.checkAuthorization(env, bwsr)
                    .subscribe(function (data) {
                    _this.supported = data;
                });
            }
            else {
                this.supported = 'false';
            }
        }
        catch (e) {
            this.supported = '';
        }
    };
    Object.defineProperty(LoginComponent.prototype, "userName", {
        get: function () { return this.loginForm.get('log.userName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginComponent.prototype, "currentPassword", {
        get: function () { return this.loginForm.get('log.currentPassword'); },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.ViewChild(changePassword_component_1.ChangePasswordComponent),
        __metadata("design:type", typeof (_a = typeof changePassword_component_1.ChangePasswordComponent !== "undefined" && changePassword_component_1.ChangePasswordComponent) === "function" && _a || Object)
    ], LoginComponent.prototype, "cPassword", void 0);
    __decorate([
        core_1.ViewChild(forgotPassword_component_1.ForgotPasswordComponent),
        __metadata("design:type", typeof (_b = typeof forgotPassword_component_1.ForgotPasswordComponent !== "undefined" && forgotPassword_component_1.ForgotPasswordComponent) === "function" && _b || Object)
    ], LoginComponent.prototype, "fPassword", void 0);
    LoginComponent = __decorate([
        core_1.Component({
            template: __webpack_require__("./src/app/login/login.component.html"),
            styles: [__webpack_require__("./src/app/login/login.component.scss")],
            providers: [index_1.AuthenticationService, index_1.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_c = typeof forms_1.FormBuilder !== "undefined" && forms_1.FormBuilder) === "function" && _c || Object, typeof (_d = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _d || Object, typeof (_e = typeof index_1.AuthenticationService !== "undefined" && index_1.AuthenticationService) === "function" && _e || Object, typeof (_f = typeof index_1.MessageQueService !== "undefined" && index_1.MessageQueService) === "function" && _f || Object])
    ], LoginComponent);
    return LoginComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.LoginComponent = LoginComponent;
//# sourceMappingURL=login.component.js.map

/***/ }),

/***/ "./src/app/loginHeader/loginHeader.component.html":
/***/ (function(module, exports) {

module.exports = "<div id='spacerxsm'></div>\r\n<div class='hdr' width=95%>\r\n   <div class='row' width=95% ><span class='hdrTxt' title='Please contact GIS Vendor Relations for any questions related to CRIM'>Help</span></div>\r\n</div>\r\n<div id='spacersm'></div>\r\n\r\n";

/***/ }),

/***/ "./src/app/loginHeader/loginHeader.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}.hdr{border:\"0\";background-color:#ccf;width:95%;margin-left:3rem;margin-right:3rem;-ms-flex-line-pack:center;align-content:center;height:1.5rem}.hdrTxt{font-weight:700;color:#000}.row{float:left}#spacersm{padding-top:2.5rem}#spacerxsm{padding-top:.5rem}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/loginHeader/loginHeader.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var LoginHeaderComponent = (function () {
    function LoginHeaderComponent() {
    }
    LoginHeaderComponent = __decorate([
        core_1.Component({
            selector: 'app-login-header',
            template: __webpack_require__("./src/app/loginHeader/loginHeader.component.html"),
            styles: [__webpack_require__("./src/app/loginHeader/loginHeader.component.scss")],
        })
    ], LoginHeaderComponent);
    return LoginHeaderComponent;
}());
exports.LoginHeaderComponent = LoginHeaderComponent;
//# sourceMappingURL=loginHeader.component.js.map

/***/ }),

/***/ "./src/app/navigation/navigation.component.html":
/***/ (function(module, exports) {

module.exports = "<section>\r\n  <header>Navigation Page</header>\r\n  <h4> Welcome {{ navigation?.loggedInUser.user.firstName }} {{ navigation?.loggedInUser.user.middleName }} {{ navigation?.loggedInUser.user.lastName }}, Your last successful login was on {{navigation?.loggedInUser?.lastLoginDate | date: 'MM/dd/yyyy'}}</h4>\r\n  <h4>\r\n      Your security level authorizes you to enter the following application(s). Please select the application link to continue.\r\n  </h4>\r\n  <main>\r\n\r\n    <app-navigation-work-orders [navigation]=\"navigation\"></app-navigation-work-orders>\r\n\r\n  </main>\r\n\r\n</section>\r\n";

/***/ }),

/***/ "./src/app/navigation/navigation.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}header{background-color:#ccf;padding:.25rem 0;color:#000;font-weight:bolder;margin:0 5rem}h4{font-weight:700}section{-ms-flex-line-pack:center;align-content:center;text-align:center}section header{margin-top:1.3em}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/navigation/navigation.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js"); // Compiler
var navigationService_1 = __webpack_require__("./src/services/navigationService.ts");
var index_1 = __webpack_require__("./src/services/index.ts");
var NavigationComponent = (function () {
    function NavigationComponent(navigationService, msgSvc) {
        this.navigationService = navigationService;
        this.msgSvc = msgSvc;
    }
    NavigationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.msgSvc.setControlKey(); // ('CacheControlKey');
        this.navigationService.getJurisdictions()
            .subscribe(function (navigation) {
            _this.navigation = navigation;
        });
    };
    NavigationComponent = __decorate([
        core_1.Component({
            selector: 'app-navigation',
            template: __webpack_require__("./src/app/navigation/navigation.component.html"),
            styles: [__webpack_require__("./src/app/navigation/navigation.component.scss")],
            providers: [navigationService_1.default, index_1.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof navigationService_1.default !== "undefined" && navigationService_1.default) === "function" && _a || Object, typeof (_b = typeof index_1.MessageQueService !== "undefined" && index_1.MessageQueService) === "function" && _b || Object])
    ], NavigationComponent);
    return NavigationComponent;
    var _a, _b;
}());
exports.default = NavigationComponent;
//# sourceMappingURL=navigation.component.js.map

/***/ }),

/***/ "./src/app/navigationInternal/navigationInternal.component.html?v=001":
/***/ (function(module, exports) {

module.exports = "<head>\r\n  <meta http-equiv=\"Cache-Control\" content=\"no-cache, no-store, must-revalidate\" />\r\n  <META http-equiv=\"pragma\" CONTENT=\"no-cache\">\r\n  <META http-equiv=\"expires\" CONTENT=\"0\">\r\n</head>\r\n<section >\r\n  <div>\r\n    <label for=\"externalContractor\">External Contractor:</label>\r\n    <select id=\"externalContractor\" (change)='changeCrimAccess($event)'>\r\n        <option value='0' selected>Select from list</option>\r\n        <option value='1'>Not select from list</option>\r\n      <option *ngFor=\"let ext of contractors\" value={{ext.contractorId}} >{{ext.description}}\r\n    </select>\r\n  </div>\r\n <div>\r\n    <label for=\"groupA\">In-house group A:</label>\r\n    <select id=\"groupA\" (change)='changeCrimAccess($event)'>\r\n      <option value='0' selected>Select from list</option>\r\n      <option *ngFor=\"let grpA of groupA\" value={{grpA.groupAId}} >{{grpA.description}}\r\n    </select>\r\n  </div>\r\n  <div>\r\n    <label for=\"groupB\">In-house group B:</label>\r\n    <select id=\"groupB\" (change)='changeCrimAccess($event)'>\r\n      <option value='0' selected>Select from list</option>\r\n      <option *ngFor=\"let grpB of groupB\" value={{grpB.groupBId}}>{{grpB.description}}\r\n    </select>\r\n  </div>\r\n  <div>\r\n    <label for=\"other\">Other In-house:</label>\r\n    <select id=\"other\" (change)='changeCrimAccess($event)'>\r\n      <option value='0' selected>Select from list</option>\r\n      <option *ngFor=\"let othr of other\" value={{othr.otherId}}>{{othr.description}}\r\n    </select>\r\n  </div>\r\n  <div>\r\n    <label for=\"recordEntry\">Record Entry Queues:</label>\r\n    <select id=\"recordEntry\" (change)='changeCrimAccess($event)'>\r\n      <option value='0' selected>Select from list</option>\r\n      <option *ngFor=\"let rcd of record\" value={{rcd.recordId}} >{{rcd.description}}\r\n    </select>\r\n  </div>\r\n  <div>\r\n    <label id=\"exception\" for=\"crimException\">Crim Exceptions:</label>\r\n    <select id=\"crimException\" (change)='changeCrimAccess($event)'>\r\n      <option value='0' selected>Select from list</option>\r\n      <option value='1'>Not select from list</option>\r\n      <option *ngFor=\"let excp of exception\" value={{excp.exceptionId}} >{{excp.description}}\r\n    </select>\r\n  </div>\r\n  <div>\r\n    <label id=\"exception\" for=\"deferredException\">Crim Deferred Exceptions:</label>\r\n    <select id=\"deferredException\" (change)='changeCrimAccess($event)'>\r\n        <option value='0' selected>Select from list</option>\r\n      <option *ngFor=\"let deferred of deferredException\" value={{deferred.recordId}} >{{deferred.description}}\r\n      </select>\r\n  </div>\r\n</section>\r\n<div>\r\n    <section *ngIf=\"showInternalSection\">\r\n      <div>\r\n        <label id=\"exception\" for=\"retrieveCaseNumber\">Retrieve Work Orders By Case Number (All searches):</label>\r\n        <input id=\"retrieveCaseNumber\"><button id=\"search\">Search</button>\r\n      </div>\r\n    </section>\r\n  </div>\r\n";

/***/ }),

/***/ "./src/app/navigationInternal/navigationInternal.component.scss?v=001":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}header{background-color:#ccf;padding:.25rem 0;color:#000;font-weight:bolder;margin:0 5rem}a{display:block;margin-top:1.5rem}a:link,a:visited{color:#0066cb}em{display:block;font-style:normal}p{padding-top:3rem;font-family:Verdana,Tahoma,Arial}label{font-weight:bolder;display:inline-block}select{width:35rem;height:1.8rem;font-size:1.2rem;padding-top:.1rem}div:nth-child(2){font-family:Verdana,Arial,Tahoma}div:nth-child(2) label{margin-top:1rem;display:inline-block;width:30rem;text-align:left;vertical-align:bottom}div:nth-child(2) input{width:3.3rem;height:1.32rem}#exception{text-align:left;width:25rem}#search{background-color:#ccf;font-family:Verdana,Tahoma,Arial;margin-right:auto;margin-left:auto;width:6.2rem;margin-top:0}div section div{padding-top:.5rem;padding-left:6.5rem}div section div label{font-size:11.5px;text-align:left;width:16rem}div section div input{width:7.3rem;height:1.32rem}div section div button{background-color:#ccf;font-family:Verdana,Tahoma,Arial;margin-right:auto;margin-left:auto;width:19.2rem;padding-top:.25rem;padding-bottom:.25rem;margin-top:2rem;display:block;-webkit-transform:translate(-3.1rem);transform:translate(-3.1rem)}div section a{font-weight:bolder}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/navigationInternal/navigationInternal.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js"); // , Input
var NavigationInternalComponent = (function () {
    function NavigationInternalComponent() {
    }
    // @Input() internal: boolean;
    NavigationInternalComponent.prototype.ngOnInit = function () {
    };
    NavigationInternalComponent = __decorate([
        core_1.Component({
            selector: 'app-navigation-internal',
            template: __webpack_require__("./src/app/navigationInternal/navigationInternal.component.html?v=001"),
            styles: [__webpack_require__("./src/app/navigationInternal/navigationInternal.component.scss?v=001")],
        })
    ], NavigationInternalComponent);
    return NavigationInternalComponent;
}());
exports.NavigationInternalComponent = NavigationInternalComponent;
//# sourceMappingURL=navigationInternal.component.js.map

/***/ }),

/***/ "./src/app/navigationWorkOrders/navigationWorkOrders.component.html":
/***/ (function(module, exports) {

module.exports = "<div>\r\n  <section *ngIf=\"showInternalSection\">\r\n    <app-navigation-internal></app-navigation-internal>\r\n  </section>\r\n  <a href=\"javascript:void(0);\" (click)=\"displayRetrieveWorkOrdersSection()\">Criminal Record Information Management System</a>\r\n\r\n  <p>\r\n    <em>****IMPORTANT INFORMATION****</em>\r\n    When we receive information on an admitted criminal record, we will pass that information on to you in the \"Special Instructions\"\r\n    line located on your printed work orders. Please be advised that this information CAN NOT be seen on the screen when\r\n    you are viewing your \"Task List\" page. You must click on \"Generate Work Orders\" and allow Adobe to open up with the work\r\n    orders to view this information. You are not required to print the work order, but you can find the admitted criminal\r\n    record information here only. It is critical that you are aware of this information. Our clients expect complete information\r\n    on a record that is known to exist. If you have any questions, please contact us by clicking on \"Help\", then \"Contact\r\n    Client Services\", on the top blue line.\r\n  </p>\r\n\r\n  <section *ngIf=\"showRetrieveWorkOrdersSection\">\r\n\r\n    <header>Select Method to Retrieve Work Orders</header>\r\n\r\n    <a *ngIf=\"isExternal\" routerLink=\"/researcherTaskList/Late\">Retrieve Past Due Work Orders</a>\r\n    <a *ngIf=\"isExternal\" routerLink=\"/reports\">Reports Page</a>\r\n    <a *ngIf=\"isExternal\" routerLink=\"/researcherTaskList/New\">Retrieve New Work Orders</a>\r\n    <a *ngIf=\"!isExternal\" routerLink=\"/researcherTaskList/New\">Retrieve Work Orders By Date</a>\r\n    <a href=\"javascript:void(0)\" (click)=\"displayWorkOrdersByJurisdictionSection()\">Retrieve Work Orders By Jurisdiction</a>\r\n    <div *ngIf=\"showWorkOrdersByJurisdiction\">\r\n      <label for=\"workOrderByDate\">Select Jurisdiction:</label>\r\n      <select id=\"workOrderByDate\" #jurisdictionId>\r\n        <option [value]=\"workOrder.jurisdictionId\" *ngFor=\"let workOrder of jurisdictions\">{{workOrder.description}} - {{workOrder.count}}</option>\r\n      </select>\r\n      <button (click)=\"viewResearcherTaskListForJurisdiction(jurisdictionId.value)\" [disabled]=\"!jurisdictionId.value\">Retrieve Work Orders</button>\r\n\r\n    </div>\r\n    <a *ngIf=\"!isExternal\" routerLink=\"/researcherTaskList/New\">Retrieve Work Orders By Case Number</a>\r\n    <section *ngIf=\"showWorkOrdersByJurisdiction\">\r\n        <div *ngIf=\"showInternalSection\">\r\n            <label for=\"workOrderByDate\">Select Deferred Jurisdiction:</label>\r\n            <select id=\"workOrderByDate\" #jurisdictionId>\r\n              <option [value]=\"workOrder.jurisdictionId\" *ngFor=\"let workOrder of jurisdictions\">{{workOrder.description}} - {{workOrder.count}}</option>\r\n            </select>\r\n            <button (click)=\"viewResearcherTaskListForJurisdiction(jurisdictionId.value)\" [disabled]=\"!jurisdictionId.value\">Retrieve Work Orders</button>\r\n\r\n          </div>\r\n          </section>\r\n  </section>\r\n\r\n</div>\r\n\r\n";

/***/ }),

/***/ "./src/app/navigationWorkOrders/navigationWorkOrders.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}header{background-color:#ccf;padding:.25rem 0;color:#000;font-weight:bolder;margin:0 5rem}a{display:block;margin-top:1.5rem}a:link,a:visited{color:#0066cb}em{display:block;font-style:normal}p{padding-top:3rem;font-family:Verdana,Tahoma,Arial}label{font-weight:bolder;display:inline-block}select{width:35rem;height:1.8rem;font-size:1.2rem;padding-top:.1rem}div:nth-child(2){font-family:Verdana,Arial,Tahoma}div:nth-child(2) label{margin-top:1rem;display:inline-block;width:30rem;text-align:left;vertical-align:bottom}div:nth-child(2) input{width:3.3rem;height:1.32rem}#exception{text-align:left;width:25rem}#search{background-color:#ccf;font-family:Verdana,Tahoma,Arial;margin-right:auto;margin-left:auto;width:6.2rem;margin-top:0}div section div{padding-top:.5rem;padding-left:6.5rem}div section div label{font-size:11.5px;text-align:left;width:16rem}div section div input{width:7.3rem;height:1.32rem}div section div button{background-color:#ccf;font-family:Verdana,Tahoma,Arial;margin-right:auto;margin-left:auto;width:19.2rem;padding-top:.25rem;padding-bottom:.25rem;margin-top:2rem;display:block;-webkit-transform:translate(-3.1rem);transform:translate(-3.1rem)}div section a{font-weight:bolder}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/navigationWorkOrders/navigationWorkOrders.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var navigation_1 = __webpack_require__("./src/models/navigation.ts");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var NavigationWorkOrdersComponent = (function () {
    function NavigationWorkOrdersComponent(router) {
        this.router = router;
        this.model = {};
        this.showWorkOrdersByJurisdiction = false;
        this.showRetrieveWorkOrdersSection = false;
        this.showInternalSection = false;
        this.isExternal = true;
    }
    NavigationWorkOrdersComponent.prototype.displayWorkOrdersByJurisdictionSection = function () {
        this.showWorkOrdersByJurisdiction = true;
    };
    NavigationWorkOrdersComponent.prototype.displayRetrieveWorkOrdersSection = function () {
        this.showRetrieveWorkOrdersSection = true;
    };
    Object.defineProperty(NavigationWorkOrdersComponent.prototype, "navigation", {
        set: function (navigation) {
            if (navigation) {
                this.jurisdictions = navigation.jurisdictions;
            }
        },
        enumerable: true,
        configurable: true
    });
    NavigationWorkOrdersComponent.prototype.viewResearcherTaskListForJurisdiction = function (jurisdictionId) {
        this.router.navigate(['researcherTaskList', 'detailWork', jurisdictionId]);
    };
    NavigationWorkOrdersComponent.prototype.changeCrimAccess = function (args) {
        var result = false;
        if (args.target.value !== 0) {
            this.model.selection = args.target.value;
            this.crimException = document.getElementById('crimException');
            this.deferredException = document.getElementById('deferredException');
            this.recordEntry = document.getElementById('recordEntry');
            this.model.crimParm = (this.crimException.value === '0' && this.deferredException.value === '0') ? 'N' : 'Y';
            this.model.crimParm = (this.recordEntry.value !== '0') ? 'R' : '';
            this.navigate('CRRS', 'ChgAccess');
            result = true;
        }
        else {
            this.model.selection = '';
            this.model.crimParm = '';
            result = false;
        }
        return result;
    };
    NavigationWorkOrdersComponent.prototype.navigate = function (strSystem, task) {
        switch (strSystem) {
            case 'CRRS':
                switch (task) {
                    case 'ByDate':
                        break;
                    case 'ByCase':
                        break;
                    case 'ByCaseAll':
                        break;
                    default:
                        break;
                }
                break;
            case 'CTMS':
                break;
            default:
                break;
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", typeof (_a = typeof navigation_1.default !== "undefined" && navigation_1.default) === "function" && _a || Object),
        __metadata("design:paramtypes", [typeof (_b = typeof navigation_1.default !== "undefined" && navigation_1.default) === "function" && _b || Object])
    ], NavigationWorkOrdersComponent.prototype, "navigation", null);
    NavigationWorkOrdersComponent = __decorate([
        core_1.Component({
            selector: 'app-navigation-work-orders',
            template: __webpack_require__("./src/app/navigationWorkOrders/navigationWorkOrders.component.html"),
            styles: [__webpack_require__("./src/app/navigationWorkOrders/navigationWorkOrders.component.scss")],
        }),
        __metadata("design:paramtypes", [typeof (_c = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _c || Object])
    ], NavigationWorkOrdersComponent);
    return NavigationWorkOrdersComponent;
    var _a, _b, _c;
}());
exports.default = NavigationWorkOrdersComponent;
//# sourceMappingURL=navigationWorkOrders.component.js.map

/***/ }),

/***/ "./src/app/offense/offense.component.html":
/***/ (function(module, exports) {

module.exports = "<nav class=\"navClass\">\r\n  <ul>\r\n    <li>File\r\n      <ul class=\"sub-menu\">\r\n        <li><a (click)=\"goToNavigation()\">Return To Navigation Page</a></li>\r\n        <li><a (click)=\"exitDialog()\">Exit System</a></li>\r\n      </ul>\r\n    </li>\r\n    <li>Tools\r\n      <ul class=\"sub-menu\">\r\n        <li>\r\n          <a *ngIf=\"!offensePageForm.invalid && canWorkOrderComplete\" (click)=\"offenseSearchComponent.workOrderComplete()\">Work Order Complete</a>\r\n          <a *ngIf=\"offensePageForm.invalid || !canWorkOrderComplete\" class=\"disabled\">Work Order Complete</a>\r\n        </li>\r\n        <li>\r\n          <a *ngIf=\"!offensePageForm.invalid && !isSaving && offensePageForm.dirty\" (click)=\"onSubmit()\">Save Offense</a>\r\n          <a *ngIf=\"offensePageForm.invalid || isSaving || !offensePageForm.dirty\" class=\"disabled\">Save Offense</a>\r\n        </li>\r\n        <li>\r\n          <a *ngIf=\"!isNewRecord\" (click)=\"offenseRecordComponent.addNewRecord()\">Add New Record</a>\r\n          <a *ngIf=\"isNewRecord\" class=\"disabled\">Add New Record</a>\r\n        </li>\r\n      </ul>\r\n    </li>\r\n    <li>Help\r\n      <ul class=\"sub-menu\">\r\n        <li><a (click)=\"help()\">Page Help</a></li>\r\n        <hr>\r\n        <li><a (click)=\"support()\">Support</a></li>\r\n        <hr>\r\n        <li><a (click)=\"about()\">About</a></li>\r\n      </ul>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n\r\n<main>\r\n\r\n  <form [formGroup]=\"offensePageForm\" (ngSubmit)=\"onSubmit()\" novalidate autocomplete=\"off\">\r\n   <app-offense-search #offenseSearch\r\n                       [offenseObject]=\"offense\"\r\n                       [canWorkOrderComplete]=\"canWorkOrderComplete\"\r\n                       [offensePageForm]=\"offensePageForm\"\r\n                       [offenseSearchFormGroupObject]=\"offensePageForm.controls.offenseSearch\">\r\n   </app-offense-search>\r\n   <app-offense-record #offenseRecord\r\n                       [offenseObject]=\"offense\"\r\n                       [requestNumber]=\"requestNumber\"\r\n                       [offenseRecordFormGroupObject]=\"offensePageForm.controls.offenseRecord\"\r\n                       (updateToCurrentOffenseRecord)=\"updateToCurrentOffenseRecord($event)\"\r\n                       (updateCanDeleteCurrentOffenseRecord)=\"updateCanDeleteCurrentOffenseRecord($event)\"\r\n                       (updateToCurrentOffenseCharges)=\"updateToCurrentOffenseCharges()\">\r\n    </app-offense-record>\r\n\r\n    <section id=\"has-changes-validation-section\">\r\n      <div class=\"validation\" *ngIf=\"hasChargesValidator.invalid && (hasChargesValidator.dirty || hasChargesValidator.touched)\">\r\n        <span *ngIf=\"hasChargesValidator.hasError('hasCharges')\">\r\n            You must have at least 1 charge.\r\n        </span>\r\n      </div>\r\n      <div class=\"validation\" *ngIf=\"hasRequiredDate.invalid && (hasRequiredDate.dirty || hasRequiredDate.touched)\">\r\n        <span *ngIf=\"hasRequiredDate.hasError('hasRequiredDate')\">\r\n          Offense, Disposition or File Date is required on at least one of the COUNTS/OFFENSES.\r\n        </span>\r\n      </div>\r\n    </section>\r\n\r\n    <section id=\"button-section\">\r\n      <button type=\"submit\" [disabled]=\"offensePageForm.invalid || isSaving || !offensePageForm.dirty\">Save Record</button>\r\n      <button type=\"button\"\r\n              [disabled]=\"!canDelete\"\r\n              (click)=\"deleteRecord()\">\r\n        Delete Record\r\n      </button>\r\n    </section>\r\n  </form>\r\n</main>\r\n";

/***/ }),

/***/ "./src/app/offense/offense.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}main{margin-left:5rem;margin-right:5rem}#button-section{margin:3rem 0;-ms-flex-line-pack:center;align-content:center;text-align:center}#button-section button{background-color:#ccf;font-family:Verdana,Tahoma,Arial;margin-right:auto;margin-left:auto;width:13rem;font-size:1rem;padding-top:.5rem;padding-bottom:.5rem}.validation{-ms-flex-line-pack:center;align-content:center;text-align:center}.validation span{font-weight:400;color:red;display:block}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/offense/offense.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var offense_1 = __webpack_require__("./src/models/offense.ts");
var offenseService_1 = __webpack_require__("./src/services/offenseService.ts");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var router_2 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var isDateValidator_1 = __webpack_require__("./src/validators/isDateValidator.ts");
var formControl_1 = __webpack_require__("./src/models/formControl.ts");
var alertify = __webpack_require__("./node_modules/alertifyjs/build/alertify.js");
var httpError_1 = __webpack_require__("./src/models/httpError.ts");
var browserWindowObjectService_1 = __webpack_require__("./src/services/browserWindowObjectService.ts");
var complianceAuditLogService_1 = __webpack_require__("./src/services/complianceAuditLogService.ts");
var alertifyPromise_1 = __webpack_require__("./src/models/alertifyPromise.ts");
var popupHelper_1 = __webpack_require__("./src/models/popupHelper.ts");
var complianceAuditLog_1 = __webpack_require__("./src/models/complianceAuditLog.ts");
var index_1 = __webpack_require__("./src/services/index.ts");
var OffenseComponent = (function () {
    function OffenseComponent(offenseService, browserWindowObjectService, complianceAuditLogService, route, formBuilder, router, msgSvc, changeDetectorRef) {
        var _this = this;
        this.offenseService = offenseService;
        this.browserWindowObjectService = browserWindowObjectService;
        this.complianceAuditLogService = complianceAuditLogService;
        this.route = route;
        this.formBuilder = formBuilder;
        this.router = router;
        this.msgSvc = msgSvc;
        this.changeDetectorRef = changeDetectorRef;
        this.isSaving = false;
        this.canDelete = false;
        this.canWorkOrderComplete = false;
        this.isNewRecord = true;
        this.route.params.subscribe(function (params) {
            _this.requestNumber = params['requestNumber'];
        });
    }
    OffenseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.msgSvc.setControlKey(); // ('CacheControlKey');
        this.browserWindowObjectService.scrollToTopOfPage();
        this.offenseService.getOffense(this.requestNumber)
            .subscribe(function (object) {
            if (object instanceof offense_1.default) {
                _this.offense = object;
                _this.checkWorkOrderComplete();
            }
            else {
                var httpError = object;
                if (httpError.status === 422) {
                    _this.browserWindowObjectService.goBackOnePage();
                    // alertify.alert('Crim Error', 'You did not send a valid request');
                }
            }
        });
        this.offensePageForm = this.formBuilder.group({
            offenseSearch: this.formBuilder.group({
                admittedCrimeNotFound: ['']
            }),
            offenseRecord: this.formBuilder.group({
                sentenceLevel: [''],
                // This is just to do have a validator for identifers.
                hasIdentifier: [''],
                hasNameIdentifier: [''],
                hasDobIdentifier: [''],
                hasSsnIdentifier: [''],
                hasSinIdentifier: [''],
                hasAddressIdentifier: [''],
                hasDlnIdentifier: [''],
                isRecordLevel: [''],
                hasFaxInformation: [''],
                courtRecordedFullName: ['', [
                        forms_1.Validators.required,
                        forms_1.Validators.maxLength(60),
                    ]
                ],
                nameDiffers: [''],
                referenceNumber: ['', [
                        forms_1.Validators.required,
                        forms_1.Validators.maxLength(25),
                    ]
                ],
                courtRecordDob: ['', isDateValidator_1.default(1900)],
                dobType: [''],
                month: [''],
                day: [''],
                year: [''],
                // fullDobValidator and partialDobValidator
                // are placeholders for the validators.
                fullDobValidator: [''],
                partialDobValidator: [''],
                offenseDate: ['', isDateValidator_1.default(2000)],
                fileDate: ['', isDateValidator_1.default(2000)],
                arrestDate: ['', isDateValidator_1.default(2000)],
                dispositionDate: ['', isDateValidator_1.default(2000)],
                // This is just to do have a validator to make sure you
                // all dates are good.
                hasRequiredDate: [''],
                offenseDateGreaterThanCurrentDate: [''],
                fileDateGreaterThanCurrentDate: [''],
                arrestDateGreaterThanCurrentDate: [''],
                dispositionDateGreaterThanCurrentDate: [''],
                fileDateDateOlderThanOffenseDate: [''],
                dispositionDateOlderThanOffenseDate: [''],
                dispositionDateOlderThanFileDate: [''],
                offenseDateAtRecordAndChargeLevel: [''],
                fileDateAtRecordAndChargeLevel: [''],
                arrestDateAtRecordAndChargeLevel: [''],
                dispositionDateAtRecordAndChargeLevel: [''],
                probation: ['', forms_1.Validators.maxLength(255)],
                fines: ['', forms_1.Validators.maxLength(255)],
                courtCosts: ['', forms_1.Validators.maxLength(255)],
                jailTime: ['', forms_1.Validators.maxLength(255)],
                prisonTime: ['', forms_1.Validators.maxLength(255)],
                suspensionTime: ['', forms_1.Validators.maxLength(255)],
                nextCourtDate: ['', isDateValidator_1.default(2000)],
                comments: ['', forms_1.Validators.maxLength(3000)],
                otherSentenceNotes: ['', forms_1.Validators.maxLength(5000)],
                charge: this.formBuilder.group({
                    hasChargesValidator: ['']
                })
            })
        });
        this.formControl = new formControl_1.default(this.offensePageForm);
    };
    OffenseComponent.prototype.updateToCurrentOffenseRecord = function (offenseRecord) {
        this.currentOffenseRecord = offenseRecord;
        this.isNewRecord = this.currentOffenseRecord.isNewRecord;
        this.validateHasCharges();
        this.validateHasChargeDates();
    };
    OffenseComponent.prototype.updateCanDeleteCurrentOffenseRecord = function (canDelete) {
        this.canDelete = canDelete;
    };
    OffenseComponent.prototype.updateToCurrentOffenseCharges = function () {
        this.validateHasCharges();
        this.validateHasChargeDates();
    };
    OffenseComponent.prototype.onSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var dobInformation, save, complianceAuditLogs, offense, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dobInformation = this.getDobInformation();
                        save = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        if (!this.hasDobMismatch(dobInformation)) return [3 /*break*/, 4];
                        complianceAuditLogs = new Array();
                        complianceAuditLogs.push(new complianceAuditLog_1.default(this.requestNumber, 'DOBMISMATCH', 'OFFENCEPG', null, null));
                        return [4 /*yield*/, popupHelper_1.default.dobMismatchHelper()];
                    case 2:
                        if ((_a.sent()) === alertifyPromise_1.ConfirmResult.Cancel) {
                            complianceAuditLogs.push(new complianceAuditLog_1.default(this.requestNumber, 'DOBMISMATCH_UPDATE', 'OFFENCEPG', null, null));
                            save = false;
                            // This is a hack.
                            // For whatever reason if the time between
                            // await PopupHelper.dobMismatchHelper() === ConfirmResult.Cancel
                            // and
                            // await this.complianceAuditLogService.addComplianceAuditLogs(complianceAuditLogs);
                            // is under about 290ms, it will set focus to text box and then scroll to the bottom
                            // of page and unset focus.
                            // So telling the system to wait about 320ms before setting focus.
                            setTimeout(function () { return _this.offenseRecordComponent.setFocusForDobMismatch(); }, 320);
                        }
                        else {
                            complianceAuditLogs.push(new complianceAuditLog_1.default(this.requestNumber, 'DOBMISMATCH_PROCEED', 'OFFENCEPG', null, null));
                        }
                        return [4 /*yield*/, this.complianceAuditLogService.addComplianceAuditLogs(complianceAuditLogs)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (save) {
                            this.isSaving = true;
                            offense = this.createOffenseObject(dobInformation);
                            this.offenseService.save(offense).subscribe(function (r) {
                                if (r instanceof httpError_1.default) {
                                    if (r.status === 422) {
                                        var errorCodes = r.httpResponse.json().errorCodes;
                                        var message = "An error occurred while trying to save request with error code(s) " + errorCodes.join() + ".\n                <br>Get more information\n                <a href='https://github.geninfo.com/BackOfficeCrim/CRIM-System/wiki/Offense-API-Validation'>here</a>";
                                        alertify.alert('Crim Error', message);
                                    }
                                }
                                else {
                                    _this.isNewRecord = _this.currentOffenseRecord.isNewRecord = false;
                                    _this.offenseRecordComponent.saveCompletedSuccessfully();
                                    _this.offensePageForm.markAsPristine();
                                    _this.browserWindowObjectService.scrollToTopOfPage();
                                    _this.checkWorkOrderComplete();
                                }
                                _this.isSaving = false;
                            });
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.isSaving = false;
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    OffenseComponent.prototype.deleteRecord = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var confirmResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popupHelper_1.default.deleteRecordHelper()];
                    case 1:
                        confirmResult = _a.sent();
                        if (confirmResult === alertifyPromise_1.ConfirmResult.Ok) {
                            this.offenseService.delete(this.requestNumber, this.currentOffenseRecord.offenseNumber)
                                .subscribe(function (error) {
                                if (error === null) {
                                    var index = _this.offense.offenseRecords.indexOf(_this.currentOffenseRecord);
                                    _this.offense.offenseRecords.splice(index, 1);
                                    _this.checkWorkOrderComplete();
                                    _this.offenseRecordComponent.deleteSuccessfully();
                                }
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OffenseComponent.prototype.goToNavigation = function () {
        this.router.navigate(['navigation']);
    };
    OffenseComponent.prototype.exitDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var confirmResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popupHelper_1.default.exitSystemHelper()];
                    case 1:
                        confirmResult = _a.sent();
                        if (confirmResult === alertifyPromise_1.ConfirmResult.Ok) {
                            this.router.navigate(['exit']);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OffenseComponent.prototype.about = function () {
        popupHelper_1.default.systemVersion();
    };
    OffenseComponent.prototype.support = function () {
        popupHelper_1.default.support();
    };
    OffenseComponent.prototype.help = function () {
        this.browserWindowObjectService.openWindowInNewWindowByRoute("offenseHelp", '', 800, 900);
    };
    Object.defineProperty(OffenseComponent.prototype, "hasChargesValidator", {
        get: function () { return this.offensePageForm.get('offenseRecord.charge.hasChargesValidator'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseComponent.prototype, "hasRequiredDate", {
        get: function () { return this.offensePageForm.get('offenseRecord.hasRequiredDate'); },
        enumerable: true,
        configurable: true
    });
    OffenseComponent.prototype.validateHasCharges = function () {
        if (!this.hasCharges) {
            this.formControl.setValidationErrorByControlName('offenseRecord.charge.hasChargesValidator', 'hasCharges');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('offenseRecord.charge.hasChargesValidator', 'hasCharges');
        }
    };
    OffenseComponent.prototype.validateHasChargeDates = function () {
        if (this.hasCharges) {
            if (this.currentOffenseRecord.charges
                .some(function (c) { return c.offenseDate !== null || c.fileDate !== null || c.dispositionDate !== null; })) {
                this.formControl.clearValidatorErrorByControlName('offenseRecord.hasRequiredDate', 'hasRequiredDate');
            }
            else {
                this.formControl.setValidationErrorByControlName('offenseRecord.hasRequiredDate', 'hasRequiredDate');
            }
        }
    };
    Object.defineProperty(OffenseComponent.prototype, "hasCharges", {
        get: function () {
            return this.currentOffenseRecord !== null && this.currentOffenseRecord !== undefined
                && this.currentOffenseRecord.charges !== null && this.currentOffenseRecord.charges !== undefined
                && this.currentOffenseRecord.charges.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    OffenseComponent.prototype.checkWorkOrderComplete = function () {
        this.canWorkOrderComplete = this.offense.offenseRecords.length > 0
            && this.offense.offenseRecords.every(function (or) { return or.referenceNumber !== null
                && or.referenceNumber !== undefined && or.referenceNumber.length > 0; });
        this.changeDetectorRef.detectChanges();
    };
    OffenseComponent.prototype.hasDobMismatch = function (dobInformation) {
        var mismatch = false;
        if (dobInformation.fullDob || dobInformation.partialDob) {
            var year = this.offense.offenseSearch.dob.getFullYear();
            var month = this.offense.offenseSearch.dob.getMonth() + 1;
            var day = this.offense.offenseSearch.dob.getDate();
            var dobYear = null;
            var dobMonth = null;
            var dobDay = null;
            if (dobInformation.fullDob) {
                var dobDate = new Date(dobInformation.fullDob);
                dobYear = dobDate.getFullYear();
                dobMonth = dobDate.getMonth() + 1;
                dobDay = dobDate.getDate();
                mismatch = year !== dobYear || month !== dobMonth || day !== dobDay;
            }
            else {
                dobYear = +dobInformation.partialYear;
                dobMonth = +dobInformation.partialMonth;
                dobDay = +dobInformation.partialDay;
                mismatch = year !== dobYear || (month !== dobMonth && day !== dobDay);
            }
        }
        return mismatch;
    };
    OffenseComponent.prototype.createOffenseObject = function (dobInformation) {
        var offenseRecords = Array();
        offenseRecords.push({
            requestNbr: this.currentOffenseRecord.requestNbr,
            offenseNbr: this.currentOffenseRecord.offenseNumber,
            isCourtCaseSentencing: this.formControl.getNumberByControlName('offenseRecord.sentenceLevel') === 0 ? 'o' : null,
            offenseDt: this.formControl.getShortDateByControlName('offenseRecord.offenseDate'),
            fileDt: this.formControl.getShortDateByControlName('offenseRecord.fileDate'),
            arrestDate: this.formControl.getShortDateByControlName('offenseRecord.arrestDate'),
            dispositionDt: this.formControl.getShortDateByControlName('offenseRecord.dispositionDate'),
            courtRecordedName: this.formControl.getValueByControlName('offenseRecord.courtRecordedFullName'),
            faxInfoInd: this.formControl.getCrimBooleanByControlName('offenseRecord.hasFaxInformation'),
            identifierDOB: this.formControl.getCrimBooleanByControlName('offenseRecord.hasDobIdentifier'),
            identifierSSN: this.formControl.getCrimBooleanByControlName('offenseRecord.hasSsnIdentifier'),
            identifierName: this.formControl.getCrimBooleanByControlName('offenseRecord.hasNameIdentifier'),
            identifierAddress: this.formControl.getCrimBooleanByControlName('offenseRecord.hasAddressIdentifier'),
            identifierDLN: this.formControl.getCrimBooleanByControlName('offenseRecord.hasDlnIdentifier'),
            identifierSIN: this.formControl.getCrimBooleanByControlName('offenseRecord.hasSinIdentifier'),
            comments: this.formControl.getValueByControlName('offenseRecord.comments'),
            referenceNbr: this.formControl.getValueByControlName('offenseRecord.referenceNumber'),
            nameDiff: this.formControl.getCrimBooleanByControlName('offenseRecord.nameDiffers'),
            courtRecordDOB: dobInformation.fullDob,
            identifierPartialDOB: dobInformation.partialDob,
            partialMonth: dobInformation.partialMonth,
            partialDay: dobInformation.partialDay,
            partialYear: dobInformation.partialYear,
            identifierNoDOB: dobInformation.dobNotListed,
            nextCourtDate: this.formControl.getShortDateByControlName('offenseRecord.nextCourtDate'),
            probation: this.formControl.getValueByControlName('offenseRecord.probation'),
            jailTime: this.formControl.getValueByControlName('offenseRecord.jailTime'),
            prisonTime: this.formControl.getValueByControlName('offenseRecord.prisonTime'),
            suspensionTime: this.formControl.getValueByControlName('offenseRecord.suspensionTime'),
            fines: this.formControl.getValueByControlName('offenseRecord.fines'),
            courtCosts: this.formControl.getValueByControlName('offenseRecord.courtCosts'),
            otherSentenceNotes: this.formControl.getValueByControlName('offenseRecord.otherSentenceNotes'),
            charges: this.getCharges()
        });
        return offenseRecords;
    };
    OffenseComponent.prototype.getCharges = function () {
        var charges = Array();
        for (var _i = 0, _a = this.currentOffenseRecord.charges; _i < _a.length; _i++) {
            var charge = _a[_i];
            charges.push({
                requestNbr: charge.requestNbr,
                offenseNbr: charge.offenseNbr,
                countNbr: charge.countNbr,
                chargeLevel: charge.chargeLevel,
                charge: charge.charge,
                disposition: charge.disposition,
                chargeCd: charge.chargeCd,
                chargeDispDate: charge.chargeDispDate === null ? null : new Date(Date.UTC(charge.chargeDispDate.getFullYear(), charge.chargeDispDate.getMonth(), charge.chargeDispDate.getDate(), 0, 0, 0, 0)),
                chargeArrestDate: charge.chargeArrestDate === null ? null : new Date(Date.UTC(charge.chargeArrestDate.getFullYear(), charge.chargeArrestDate.getMonth(), charge.chargeArrestDate.getDate(), 0, 0, 0, 0)),
                chargeFileDate: charge.chargeFileDate === null ? null : new Date(Date.UTC(charge.chargeFileDate.getFullYear(), charge.chargeFileDate.getMonth(), charge.chargeFileDate.getDate(), 0, 0, 0, 0)),
                chargeOffenseDate: charge.chargeOffenseDate === null ? null : new Date(Date.UTC(charge.chargeOffenseDate.getFullYear(), charge.chargeOffenseDate.getMonth(), charge.chargeOffenseDate.getDate(), 0, 0, 0, 0)),
                noDispDateReason: charge.noDispDateReason,
                noArrestDateReason: charge.noArrestDateReason,
                noFileDateReason: charge.noFileDateReason,
                noOffenseDateReason: charge.noOffenseDateReason,
                chargeNextCourtDate: charge.chargeNextCourtDate === null ? null : new Date(Date.UTC(charge.chargeNextCourtDate.getFullYear(), charge.chargeNextCourtDate.getMonth(), charge.chargeNextCourtDate.getDate(), 0, 0, 0, 0)),
                chargeProbation: charge.chargeProbation,
                chargeJailTime: charge.chargeJailTime,
                chargePrisonTime: charge.chargePrisonTime,
                chargeSuspensionTime: charge.chargeSuspensionTime,
                chargeFines: charge.chargeFines,
                chargeCourtCosts: charge.chargeCourtCosts,
                chargeOtherSentenceNotes: charge.chargeOtherSentenceNotes,
                chargeStatute: charge.chargeStatute
            });
        }
        return charges;
    };
    OffenseComponent.prototype.getDobInformation = function () {
        var dobType = this.formControl.getValueByControlName('offenseRecord.dobType');
        var month = this.formControl.getValueByControlName('offenseRecord.month');
        var day = this.formControl.getValueByControlName('offenseRecord.day');
        var year = this.formControl.getValueByControlName('offenseRecord.year');
        var fullDob = '';
        var partialDob = '';
        var dobNotListed = '';
        if ('full-dob' === dobType) {
            fullDob = month + "/" + day + "/" + year;
            month = null;
            day = null;
            year = null;
        }
        else if ('partial-dob' === dobType) {
            partialDob = 'o';
        }
        else {
            dobNotListed = 'o';
            month = null;
            day = null;
            year = null;
        }
        return {
            fullDob: fullDob,
            partialDob: partialDob,
            dobNotListed: dobNotListed,
            partialMonth: month,
            partialDay: day,
            partialYear: year
        };
    };
    __decorate([
        core_1.ViewChild('offenseRecord'),
        __metadata("design:type", Object)
    ], OffenseComponent.prototype, "offenseRecordComponent", void 0);
    __decorate([
        core_1.ViewChild('offenseSearch'),
        __metadata("design:type", Object)
    ], OffenseComponent.prototype, "offenseSearchComponent", void 0);
    OffenseComponent = __decorate([
        core_1.Component({
            selector: 'app-offense',
            template: __webpack_require__("./src/app/offense/offense.component.html"),
            styles: [__webpack_require__("./src/app/offense/offense.component.scss")],
            providers: [offenseService_1.default, index_1.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof offenseService_1.default !== "undefined" && offenseService_1.default) === "function" && _a || Object, typeof (_b = typeof browserWindowObjectService_1.default !== "undefined" && browserWindowObjectService_1.default) === "function" && _b || Object, typeof (_c = typeof complianceAuditLogService_1.default !== "undefined" && complianceAuditLogService_1.default) === "function" && _c || Object, typeof (_d = typeof router_1.ActivatedRoute !== "undefined" && router_1.ActivatedRoute) === "function" && _d || Object, typeof (_e = typeof forms_1.FormBuilder !== "undefined" && forms_1.FormBuilder) === "function" && _e || Object, typeof (_f = typeof router_2.Router !== "undefined" && router_2.Router) === "function" && _f || Object, typeof (_g = typeof index_1.MessageQueService !== "undefined" && index_1.MessageQueService) === "function" && _g || Object, typeof (_h = typeof core_1.ChangeDetectorRef !== "undefined" && core_1.ChangeDetectorRef) === "function" && _h || Object])
    ], OffenseComponent);
    return OffenseComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h;
}());
exports.default = OffenseComponent;
//# sourceMappingURL=offense.component.js.map

/***/ }),

/***/ "./src/app/offenseCounts/offenseCounts.component.html":
/***/ (function(module, exports) {

module.exports = "<section>\r\n\r\n  <header>\r\n    <span>COUNT/OFFENSE INFORMATION</span>\r\n  </header>\r\n\r\n  <section id=\"required-fields-section\">\r\n    <div class=\"text-alert\">\r\n      <mark>*</mark>Indicates Required Entry For an Offense\r\n    </div>\r\n  </section>\r\n\r\n\r\n  <form [formGroup]=\"offenseCountsPageForm\" novalidate autocomplete=\"off\">\r\n    <section id=\"charge-information-section\" class=\"flex-container\">\r\n\r\n      <div>\r\n        <label for=\"count\"> <mark>*</mark>Count:</label>\r\n        <input type=\"text\"\r\n              id=\"count\"\r\n              (blur)=\"runValidation()\"\r\n              formControlName=\"count\"\r\n              app-validateOnBlur>\r\n      </div>\r\n\r\n      <div>\r\n        <label for=\"level\"><mark>*</mark>Level:</label>\r\n        <select id=\"level\"\r\n                (blur)=\"runValidation()\"\r\n                formControlName=\"chargeLevel\"\r\n                app-validateOnBlur>\r\n          <option value=1>Misdemeanor</option>\r\n          <option value=2>Felony</option>\r\n          <option value=4>Traffic</option>\r\n          <option value=5>Criminal Traffic</option>\r\n          <option value=7>Petty Misdemeanors</option>\r\n          <option value=9>Ordinance Violation</option>\r\n          <option value=12>Summary</option>\r\n          <option value=10>Infraction</option>\r\n          <option value=11>Other</option>\r\n          <option value=13>Minor Misdemeanor</option>\r\n        </select>\r\n      </div>\r\n\r\n      <div>\r\n        <label for=\"offense\"><mark>*</mark>Offense:</label>\r\n        <input type=\"text\"\r\n               id=\"offense\"\r\n               (blur)=\"runValidation()\"\r\n               formControlName=\"offense\"\r\n               app-validateOnBlur>\r\n      </div>\r\n\r\n      <div>\r\n        <label for=\"disposition\"><mark>*</mark>Disposition:</label>\r\n        <input type=\"text\"\r\n               id=\"disposition\"\r\n               (blur)=\"runValidation()\"\r\n               formControlName=\"disposition\"\r\n               app-validateOnBlur>\r\n      </div>\r\n\r\n      <div>\r\n        <label for=\"charge-statute\">Charge Statute:</label>\r\n        <input type=\"text\"\r\n               id=\"charge-statute\"\r\n               (blur)=\"runValidation()\"\r\n               formControlName=\"chargeStatute\"\r\n               app-validateOnBlur>\r\n      </div>\r\n\r\n    </section>\r\n\r\n    <section id=\"charge-information-validation-section\">\r\n\r\n      <div class=\"validation\" *ngIf=\"count.invalid && (count.dirty || count.touched)\">\r\n        <span *ngIf=\"count.hasError('required')\">\r\n          Count is required.\r\n        </span>\r\n        <span *ngIf=\"count.hasError('isNumber')\">\r\n          Count must be a number.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"chargeLevel.invalid && (chargeLevel.dirty || chargeLevel.touched)\">\r\n        <span *ngIf=\"chargeLevel.hasError('required')\">\r\n          Charge Level is required.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"offense.invalid && (offense.dirty || offense.touched)\">\r\n        <span *ngIf=\"offense.hasError('required')\">\r\n          Offense is required.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"disposition.invalid && (disposition.dirty || disposition.touched)\">\r\n        <span *ngIf=\"disposition.hasError('required')\">\r\n          Disposition is required.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"chargeStatute.invalid && (chargeStatute.dirty || chargeStatute.touched)\">\r\n        <span *ngIf=\"chargeStatute.hasError('maxlength')\">\r\n          Charge Statute can only be a max of 50 characters.\r\n        </span>\r\n      </div>\r\n\r\n    </section>\r\n\r\n    <section id=\"charge-result-section\" class=\"flex-container\">\r\n\r\n      <div>\r\n        <label for=\"probation\" class=\"block-label\">Probation:</label>\r\n        <input type=\"text\"\r\n               id=\"probation\"\r\n               size=\"25\"\r\n               [class]=\"isRecord ? 'gray-out' : ''\"\r\n               (blur)=\"runValidation()\"\r\n               formControlName=\"probation\"\r\n               app-validateOnBlur>\r\n      </div>\r\n\r\n      <div>\r\n        <label for=\"fines\" class=\"block-label\">Fines:</label>\r\n        <input type=\"text\"\r\n               id=\"fines\"\r\n               size=\"25\"\r\n               [class]=\"isRecord ? 'gray-out' : ''\"\r\n               (blur)=\"runValidation()\"\r\n               formControlName=\"fines\"\r\n               app-validateOnBlur>\r\n      </div>\r\n\r\n      <div>\r\n        <label for=\"court-cost\" class=\"block-label\">Court Costs:</label>\r\n        <input type=\"text\"\r\n               id=\"court-cost\"\r\n               size=\"25\"\r\n               [class]=\"isRecord ? 'gray-out' : ''\"\r\n               (blur)=\"runValidation()\"\r\n               formControlName=\"courtCosts\"\r\n               app-validateOnBlur>\r\n      </div>\r\n\r\n      <div>\r\n        <label for=\"jail-time\" class=\"block-label\">Jail Time:</label>\r\n        <input type=\"text\"\r\n               id=\"jail-time\"\r\n               size=\"25\"\r\n               [class]=\"isRecord ? 'gray-out' : ''\"\r\n               (blur)=\"runValidation()\"\r\n               formControlName=\"jailTime\"\r\n               app-validateOnBlur>\r\n      </div>\r\n\r\n      <div>\r\n        <label for=\"prison-time\" class=\"block-label\">Prison Time:</label>\r\n        <input type=\"text\"\r\n               id=\"prison-time\"\r\n               size=\"25\"\r\n               [class]=\"isRecord ? 'gray-out' : ''\"\r\n               (blur)=\"runValidation()\"\r\n               formControlName=\"prisonTime\"\r\n               app-validateOnBlur>\r\n      </div>\r\n\r\n      <div>\r\n        <label for=\"suspension-time\" class=\"block-label\">Suspension Time:</label>\r\n        <input type=\"text\"\r\n              id=\"suspension-time\"\r\n              size=\"25\"\r\n              [class]=\"isRecord ? 'gray-out' : ''\"\r\n              (blur)=\"runValidation()\"\r\n              formControlName=\"suspensionTime\"\r\n              app-validateOnBlur>\r\n      </div>\r\n\r\n      <div>\r\n        <label for=\"next-court-date\" class=\"block-label\">Next Court Date:</label>\r\n        <input type=\"text\"\r\n               id=\"next-court-date\"\r\n               size=\"25\"\r\n               [class]=\"isRecord ? 'gray-out' : ''\"\r\n               (blur)=\"runValidation()\"\r\n               (blur)=\"formatDate('nextCourtDate')\"\r\n               formControlName=\"nextCourtDate\"\r\n               app-validateOnBlur>\r\n      </div>\r\n\r\n    </section>\r\n\r\n    <section id=\"charge-result-validation-section\">\r\n\r\n      <div class=\"validation\" *ngIf=\"probation.invalid && (probation.dirty || probation.touched)\">\r\n        <span *ngIf=\"probation.hasError('maxlength')\">\r\n          Charge Statute can only be a max of 255 characters.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"fines.invalid && (fines.dirty || fines.touched)\">\r\n        <span *ngIf=\"fines.hasError('maxlength')\">\r\n          Fines can only be a max of 255 characters.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"courtCosts.invalid && (courtCosts.dirty || courtCosts.touched)\">\r\n        <span *ngIf=\"courtCosts.hasError('maxlength')\">\r\n          Court Costs can only be a max of 255 characters.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"jailTime.invalid && (jailTime.dirty || jailTime.touched)\">\r\n        <span *ngIf=\"jailTime.hasError('maxlength')\">\r\n          Jail Time can only be a max of 255 characters.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"prisonTime.invalid && (prisonTime.dirty || prisonTime.touched)\">\r\n        <span *ngIf=\"prisonTime.hasError('maxlength')\">\r\n          Prison Time can only be a max of 255 characters.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"suspensionTime.invalid && (suspensionTime.dirty || suspensionTime.touched)\">\r\n        <span *ngIf=\"suspensionTime.hasError('maxlength')\">\r\n          Suspension Time can only be a max of 255 characters.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"nextCourtDate.invalid && (nextCourtDate.dirty || nextCourtDate.touched)\">\r\n        <span *ngIf=\"nextCourtDate.hasError('isDate')\">\r\n            Next Court Date is required in format mm/dd/yy or mm/dd/yyyy.\r\n        </span>\r\n      </div>\r\n\r\n    </section>\r\n\r\n    <section id=\"charge-dates-section\" class=\"flex-container\">\r\n\r\n      <h4 class=\"text-alert\">Please include the dates listed on the public record for each COUNT/OFFENSE.</h4>\r\n      <h4 class=\"text-alert\">Disposition Date is not required for a COUNT/OFFENSE that is Pending.</h4>\r\n      <div>\r\n        <label for=\"offense-date\"><mark></mark>Offense Date:</label>\r\n        <input type=\"text\"\r\n               id=\"offense-date\"\r\n               size=\"20\"\r\n               (blur)=\"runValidation()\"\r\n               (blur)=\"formatDate('offenseDate')\"\r\n               formControlName=\"offenseDate\"\r\n               app-validateOnBlur>\r\n\r\n        <label for=\"offense-date-reason-not-provided\">Reason Not Provided:</label>\r\n        <select id=\"offense-date-reason-not-provided\"\r\n                (blur)=\"runValidation()\"\r\n                formControlName=\"noOffenseDateReason\"\r\n                app-validateOnBlur>\r\n          <option selected value=\"\"></option>\r\n          <option value=\"Not Available\">Not Available</option>\r\n          <option value=\"Not Provided\">Not Provided</option>\r\n        </select>\r\n      </div>\r\n\r\n      <div>\r\n        <label for=\"file-date\"><mark></mark>File Date:</label>\r\n        <input type=\"text\"\r\n              id=\"file-date\"\r\n              size=\"20\"\r\n              (blur)=\"runValidation()\"\r\n              (blur)=\"formatDate('fileDate')\"\r\n              formControlName=\"fileDate\"\r\n              app-validateOnBlur>\r\n\r\n        <label for=\"file-date-reason-not-provided\">Reason Not Provided:</label>\r\n        <select id=\"file-date-reason-not-provided\"\r\n                (blur)=\"runValidation()\"\r\n                formControlName=\"noFileDateReason\"\r\n                app-validateOnBlur>\r\n          <option selected value=\"\"></option>\r\n          <option value=\"Not Available\">Not Available</option>\r\n          <option value=\"Not Provided\">Not Provided</option>\r\n        </select>\r\n      </div>\r\n\r\n      <div>\r\n        <label for=\"arrest-date\">Arrest Date:</label>\r\n        <input type=\"text\"\r\n               id=\"arrest-date\"\r\n               size=\"20\"\r\n               (blur)=\"runValidation()\"\r\n               (blur)=\"formatDate('arrestDate')\"\r\n               formControlName=\"arrestDate\"\r\n               app-validateOnBlur>\r\n\r\n        <label for=\"arrest-date-reason-not-provided\">Reason Not Provided:</label>\r\n        <select id=\"arrest-date-reason-not-provided\"\r\n                (blur)=\"runValidation()\"\r\n                formControlName=\"noArrestDateReason\"\r\n                app-validateOnBlur>\r\n          <option selected value=\"\"></option>\r\n          <option value=\"Not Available\">Not Available</option>\r\n          <option value=\"Not Provided\">Not Provided</option>\r\n        </select>\r\n      </div>\r\n\r\n      <div>\r\n\r\n        <label for=\"disposition-date\"><mark></mark>Disposition Date:</label>\r\n        <input type=\"text\"\r\n               id=\"disposition-date\"\r\n               size=\"20\"\r\n               (blur)=\"runValidation()\"\r\n               (blur)=\"formatDate('dispositionDate')\"\r\n               formControlName=\"dispositionDate\"\r\n               app-validateOnBlur>\r\n\r\n        <label for=\"disposition-date-reason-not-provided\">Reason Not Provided:</label>\r\n        <select id=\"disposition-date-reason-not-provided\"\r\n                (blur)=\"runValidation()\"\r\n                formControlName=\"noDispositionReason\"\r\n                app-validateOnBlur>\r\n          <option selected value=\"\"></option>\r\n          <option value=\"Not Available\">Not Available</option>\r\n          <option value=\"Not Provided\">Not Provided</option>\r\n        </select>\r\n      </div>\r\n\r\n    </section>\r\n\r\n    <section id=\"charge-dates-validation-section\">\r\n\r\n      <div class=\"validation\" *ngIf=\"offenseDate.invalid && (offenseDate.dirty || offenseDate.touched)\">\r\n        <span *ngIf=\"offenseDate.hasError('isDate')\">\r\n            Offense Date is required in format mm/dd/yy or mm/dd/yyyy.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"fileDate.invalid && (fileDate.dirty || fileDate.touched)\">\r\n        <span *ngIf=\"fileDate.hasError('isDate')\">\r\n            File Date is required in format mm/dd/yy or mm/dd/yyyy.\r\n        </span>\r\n      </div>\r\n\r\n       <div class=\"validation\" *ngIf=\"arrestDate.invalid && (arrestDate.dirty || arrestDate.touched)\">\r\n        <span *ngIf=\"arrestDate.hasError('isDate')\">\r\n            Arrest Date is required in format mm/dd/yy or mm/dd/yyyy.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"dispositionDate.invalid && (dispositionDate.dirty || dispositionDate.touched)\">\r\n        <span *ngIf=\"dispositionDate.hasError('isDate')\">\r\n            Disposition Date is required in format mm/dd/yy or mm/dd/yyyy.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"OffenseDateGreaterThanCurrentDate.invalid && (OffenseDateGreaterThanCurrentDate.dirty || OffenseDateGreaterThanCurrentDate.touched)\">\r\n        <span *ngIf=\"OffenseDateGreaterThanCurrentDate.hasError('greaterThanCurrentDate')\">\r\n            Offense cannot be greater than current date.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"fileDateGreaterThanCurrentDate.invalid && (fileDateGreaterThanCurrentDate.dirty || fileDateGreaterThanCurrentDate.touched)\">\r\n        <span *ngIf=\"fileDateGreaterThanCurrentDate.hasError('greaterThanCurrentDate')\">\r\n            File cannot be greater than current date.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"arrestDateGreaterThanCurrentDate.invalid && (arrestDateGreaterThanCurrentDate.dirty || arrestDateGreaterThanCurrentDate.touched)\">\r\n        <span *ngIf=\"arrestDateGreaterThanCurrentDate.hasError('greaterThanCurrentDate')\">\r\n            Arrest Date cannot be greater than current date.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"dispositionDateGreaterThanCurrentDate.invalid && (dispositionDateGreaterThanCurrentDate.dirty || dispositionDateGreaterThanCurrentDate.touched)\">\r\n        <span *ngIf=\"dispositionDateGreaterThanCurrentDate.hasError('greaterThanCurrentDate')\">\r\n            Disposition cannot be greater than current date.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"fileDateDateOlderThanOffenseDate.invalid && (fileDateDateOlderThanOffenseDate.dirty || fileDateDateOlderThanOffenseDate.touched)\">\r\n        <span *ngIf=\"fileDateDateOlderThanOffenseDate.hasError('olderThan')\">\r\n            File Date cannot be older than offense date.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"dispositionDateOlderThanOffenseDate.invalid && (dispositionDateOlderThanOffenseDate.dirty || dispositionDateOlderThanOffenseDate.touched)\">\r\n        <span *ngIf=\"dispositionDateOlderThanOffenseDate.hasError('olderThan')\">\r\n            Disposition Date cannot be older than offense date.\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"validation\" *ngIf=\"dispositionDateOlderThanFileDate.invalid && (dispositionDateOlderThanFileDate.dirty || dispositionDateOlderThanFileDate.touched)\">\r\n        <span *ngIf=\"dispositionDateOlderThanFileDate.hasError('olderThan')\">\r\n            Disposition Date cannot be older than file date.\r\n        </span>\r\n      </div>\r\n\r\n    </section>\r\n\r\n    <section id=\"sentencing-notes-section\">\r\n\r\n      <div>\r\n        <label for=\"other-sentence-notes\">Other Sentence Notes:</label>\r\n        <textarea id=\"other-sentence-notes\"\r\n                  rows=\"3\"\r\n                  cols=\"80\"\r\n                  [class]=\"isRecord ? 'gray-out' : ''\"\r\n                  (blur)=\"runValidation()\"\r\n                  formControlName=\"otherSentenceNotes\"\r\n                  app-validateOnBlur>\r\n        </textarea>\r\n      </div>\r\n\r\n    </section>\r\n\r\n    <section id=\"charge-type-section\">\r\n      <button [disabled]=\"offenseCountsPageForm.invalid\" (click)=\"addCharge('C')\" type=\"button\">Convicted</button>\r\n      <button [disabled]=\"offenseCountsPageForm.invalid\" (click)=\"addCharge('N')\" type=\"button\">Other Non-Conviction</button>\r\n      <button [disabled]=\"offenseCountsPageForm.invalid\" (click)=\"addCharge('P')\" type=\"button\">Pending</button>\r\n      <button [disabled]=\"offenseCountsPageForm.invalid\" (click)=\"addCharge('CD')\" type=\"button\">Complete Deferral</button>\r\n      <button [disabled]=\"offenseCountsPageForm.invalid\" (click)=\"addCharge('AD')\" type=\"button\">Active Deferral</button>\r\n    </section>\r\n\r\n    <section id=\"charge-type-changes-section\">\r\n      <button [disabled]=\"offenseCountsPageForm.invalid || !isChargeDirty\" (click)=\"updateCharge()\" type=\"button\">Update</button>\r\n      <button [disabled]=\"offenseCountsPageForm.invalid\" (click)=\"deleteCharge()\" type=\"button\">Delete</button>\r\n      <button (click)=\"clearChargeFields()\" type=\"button\">Clear Entry Fields</button>\r\n    </section>\r\n  </form>\r\n\r\n  <section id=\"charge-type-choice-section\" class=\"flex-container\">\r\n\r\n    <div>\r\n      <label for=\"offenses-leading-to-conviction\" class=\"block-label\">Offenses LEADING to a conviction:</label>\r\n      <select id=\"offenses-leading-to-conviction\"\r\n              size=\"9\"\r\n              multiple=\"multiple\"\r\n              (click)=\"selectCharge('C', $event.target.value)\">\r\n        <option *ngFor=\"let option of convictedChargeOptions\"\r\n                [value]=\"option.index\"\r\n                [class]=\"option.selected ? option.selectedCssClass : option.cssClass\">\r\n          {{option.description}}\r\n        </option>\r\n      </select>\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"offenses-not-leading-to-conviction\" class=\"block-label\">Offenses NOT LEADING to a conviction:</label>\r\n      <select id=\"offenses-not-leading-to-conviction\"\r\n              size=\"9\"\r\n              multiple=\"multiple\"\r\n              (click)=\"selectCharge('N', $event.target.value)\">\r\n        <option *ngFor=\"let option of otherNonConvictionChargeOptions\"\r\n                [value]=\"option.index\"\r\n                [class]=\"option.selected ? option.selectedCssClass : option.cssClass\">\r\n          {{option.description}}\r\n        </option>\r\n      </select>\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"offenses-are-pending-disposition\" class=\"block-label\">Offenses that are PENDING a disposition:</label>\r\n      <select id=\"offenses-are-pending-disposition\"\r\n              size=\"9\"\r\n              multiple=\"multiple\"\r\n              (click)=\"selectCharge('P', $event.target.value)\">\r\n        <option *ngFor=\"let option of pendingChargeOptions\"\r\n                [value]=\"option.index\"\r\n                [class]=\"option.selected ? option.selectedCssClass : option.cssClass\">\r\n          {{option.description}}\r\n        </option>\r\n      </select>\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"offenses-where-deferral-is-complete\" class=\"block-label\">Offenses where Deferral is COMPLETE:</label>\r\n      <select id=\"offenses-where-deferral-is-complete\"\r\n              size=\"9\"\r\n              multiple=\"multiple\"\r\n              (click)=\"selectCharge('CD', $event.target.value)\">\r\n        <option *ngFor=\"let option of completeDeferralChargeOptions\"\r\n                [value]=\"option.index\"\r\n                [class]=\"option.selected ? option.selectedCssClass : option.cssClass\">\r\n          {{option.description}}\r\n        </option>\r\n      </select>\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"offenses-where-deferral-is-active\" class=\"block-label\">Offenses where Deferral is still ACTIVE:</label>\r\n      <select id=\"offenses-where-deferral-is-active\"\r\n              size=\"9\"\r\n              multiple=\"multiple\"\r\n              (click)=\"selectCharge('AD', $event.target.value)\">\r\n        <option *ngFor=\"let option of activeDeferralChargeOptions\"\r\n                [value]=\"option.index\"\r\n                [class]=\"option.selected ? option.selectedCssClass : option.cssClass\">\r\n          {{option.description}}\r\n        </option>\r\n      </select>\r\n    </div>\r\n\r\n\r\n  </section>\r\n\r\n</section>\r\n";

/***/ }),

/***/ "./src/app/offenseCounts/offenseCounts.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}.odd-background-charge{background-color:#ccf}.even-background-charge{background-color:#fff}.selected-charge{background-color:#00008b;color:#fff}.validation{-ms-flex-line-pack:center;align-content:center;text-align:center}.validation span{font-weight:400;color:red;display:block}*{-webkit-box-sizing:border-box;box-sizing:border-box}header{background-color:#ccf;padding:.25rem .3rem;color:#000;font-weight:bolder;margin:1.5rem 0 .4rem 0}section{margin-bottom:2rem}mark{color:red;background-color:inherit}label{font-weight:700}#charge-information-section{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}#charge-information-section div{width:45rem}#charge-information-section div:not(:first-of-type){margin-top:.5rem}#charge-information-section label{display:inline-block;width:10rem}#charge-information-section #count,#charge-information-section #level{width:15rem}#charge-information-section #charge-statute,#charge-information-section #disposition,#charge-information-section #offense{width:30rem}#charge-result-section{margin-top:-1rem}#charge-result-section div{margin-top:1rem}#charge-dates-section{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}#charge-dates-section h4.text-alert{display:block;margin-right:auto;margin-left:auto;padding:0;font-weight:400}#charge-dates-section h4.text-alert:first-of-type{margin:0}#charge-dates-section h4.text-alert:last-of-type{margin-top:.5rem}#charge-dates-section div{margin-top:.3rem}#charge-dates-section label{width:12.5rem;display:inline-block}#charge-dates-section input{margin-right:1rem}#sentencing-notes-section{margin-top:2rem;-ms-flex-line-pack:center;align-content:center;text-align:center}#sentencing-notes-section div{display:inline-block}#sentencing-notes-section label{display:block;text-align:left;margin-bottom:.5rem}#charge-type-section{margin-top:1.5rem;-ms-flex-line-pack:center;align-content:center;text-align:center}#charge-type-section button{background-color:#ccf;font-family:Verdana,Tahoma,Arial;margin-right:auto;margin-left:auto;width:13rem;font-size:1rem;padding-top:.5rem;padding-bottom:.5rem}#charge-type-changes-section{margin-top:1.5rem;-ms-flex-line-pack:center;align-content:center;text-align:center}#charge-type-changes-section button{background-color:#ccf;font-family:Verdana,Tahoma,Arial;margin-right:auto;margin-left:auto;width:13rem;font-size:1rem;padding-top:.5rem;padding-bottom:.5rem}#charge-type-choice-section{max-width:85rem;margin-right:auto;margin-left:auto;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-line-pack:initial;align-content:initial}#charge-type-choice-section div:first-of-type,#charge-type-choice-section div:nth-of-type(2),#charge-type-choice-section div:nth-of-type(4),#charge-type-choice-section div:nth-of-type(5){margin-right:5rem}#charge-type-choice-section div{margin-top:2rem}#charge-type-choice-section select{width:25rem}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/offenseCounts/offenseCounts.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var offenseRecord_1 = __webpack_require__("./src/models/offenseRecord.ts");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var formControl_1 = __webpack_require__("./src/models/formControl.ts");
var chargeLevels_1 = __webpack_require__("./src/models/chargeLevels.ts");
var charge_1 = __webpack_require__("./src/models/charge.ts");
var chargeType_1 = __webpack_require__("./src/models/chargeType.ts");
var dateHandler_1 = __webpack_require__("./src/models/dateHandler.ts");
var sentenceLevel_1 = __webpack_require__("./src/models/sentenceLevel.ts");
var isNumberValidator_1 = __webpack_require__("./src/validators/isNumberValidator.ts");
var isDateValidator_1 = __webpack_require__("./src/validators/isDateValidator.ts");
var OffenseCountsComponent = (function () {
    function OffenseCountsComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.updateOffenseDates = new core_1.EventEmitter();
        this.updateToCurrentRecordCharges = new core_1.EventEmitter();
        this.chargeIndex = 0;
        this.isRecord = false;
    }
    OffenseCountsComponent.prototype.ngOnInit = function () {
        this.offenseCountsPageForm = this.formBuilder.group({
            count: ['', [
                    forms_1.Validators.required,
                    isNumberValidator_1.default()
                ]
            ],
            chargeLevel: ['', forms_1.Validators.required],
            offense: ['', [
                    forms_1.Validators.required,
                    forms_1.Validators.maxLength(1000)
                ]
            ],
            disposition: ['', [
                    forms_1.Validators.required,
                    forms_1.Validators.maxLength(2000)
                ]
            ],
            chargeStatute: ['', forms_1.Validators.maxLength(50)],
            probation: ['', forms_1.Validators.maxLength(255)],
            fines: ['', forms_1.Validators.maxLength(255)],
            courtCosts: ['', forms_1.Validators.maxLength(255)],
            jailTime: ['', forms_1.Validators.maxLength(255)],
            prisonTime: ['', forms_1.Validators.maxLength(255)],
            suspensionTime: ['', forms_1.Validators.maxLength(255)],
            nextCourtDate: ['', isDateValidator_1.default(2000)],
            offenseDateGreaterThanCurrentDate: [''],
            fileDateGreaterThanCurrentDate: [''],
            arrestDateGreaterThanCurrentDate: [''],
            dispositionDateGreaterThanCurrentDate: [''],
            fileDateDateOlderThanOffenseDate: [''],
            dispositionDateOlderThanOffenseDate: [''],
            dispositionDateOlderThanFileDate: [''],
            offenseDate: ['', isDateValidator_1.default(2000)],
            noOffenseDateReason: [''],
            fileDate: ['', isDateValidator_1.default(2000)],
            noFileDateReason: [''],
            arrestDate: ['', isDateValidator_1.default(2000)],
            noArrestDateReason: [''],
            dispositionDate: ['', isDateValidator_1.default(2000)],
            noDispositionReason: [''],
            otherSentenceNotes: ['', forms_1.Validators.maxLength(5000)],
        });
        this.offenseCountFormControl = new formControl_1.default(this.offenseCountsPageForm);
    };
    Object.defineProperty(OffenseCountsComponent.prototype, "offenseRecordObject", {
        set: function (offenseRecord) {
            if (offenseRecord) {
                this.offenseRecord = offenseRecord;
                this.createChargeOptions();
                this.offenseCountsPageForm.reset();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "sentenceLevelObject", {
        set: function (sentenceLevel) {
            if (this.offenseCountFormControl) {
                this.isRecord = +sentenceLevel === sentenceLevel_1.SentenceLevel.Record;
                if (this.isRecord) {
                    this.offenseCountFormControl.disableControlByControlName('probation');
                    this.offenseCountFormControl.disableControlByControlName('fines');
                    this.offenseCountFormControl.disableControlByControlName('courtCosts');
                    this.offenseCountFormControl.disableControlByControlName('jailTime');
                    this.offenseCountFormControl.disableControlByControlName('prisonTime');
                    this.offenseCountFormControl.disableControlByControlName('suspensionTime');
                    this.offenseCountFormControl.disableControlByControlName('nextCourtDate');
                    this.offenseCountFormControl.disableControlByControlName('otherSentenceNotes');
                }
                else {
                    this.offenseCountFormControl.enableControlByControlName('probation');
                    this.offenseCountFormControl.enableControlByControlName('fines');
                    this.offenseCountFormControl.enableControlByControlName('courtCosts');
                    this.offenseCountFormControl.enableControlByControlName('jailTime');
                    this.offenseCountFormControl.enableControlByControlName('prisonTime');
                    this.offenseCountFormControl.enableControlByControlName('suspensionTime');
                    this.offenseCountFormControl.enableControlByControlName('nextCourtDate');
                    this.offenseCountFormControl.enableControlByControlName('otherSentenceNotes');
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    OffenseCountsComponent.prototype.runValidation = function () {
        this.validateDates();
    };
    OffenseCountsComponent.prototype.formatDate = function (controlName) {
        if (!this.offenseCountFormControl.hasErrorByControlName(controlName)) {
            var value = this.offenseCountFormControl.getValueByControlName(controlName);
            this.offenseCountFormControl.setValueByControlName(controlName, this.convertToDateFormat(value));
        }
        this.validateDates();
    };
    OffenseCountsComponent.prototype.addCharge = function (chargeType) {
        var charge = this.createChargeFromChargeUiControls(chargeType);
        if (chargeType === chargeType_1.ChargeType.Convicted) {
            this.convictedChargeOptions = this.convictedChargeOptions.concat(this.getFieldsForCharge(charge));
        }
        else if (chargeType === chargeType_1.ChargeType.OtherNonConviction) {
            this.otherNonConvictionChargeOptions = this.otherNonConvictionChargeOptions.concat(this.getFieldsForCharge(charge));
        }
        else if (chargeType === chargeType_1.ChargeType.Pending) {
            this.pendingChargeOptions = this.pendingChargeOptions.concat(this.getFieldsForCharge(charge));
        }
        else if (chargeType === chargeType_1.ChargeType.CompleteDeferral) {
            this.completeDeferralChargeOptions = this.completeDeferralChargeOptions.concat(this.getFieldsForCharge(charge));
        }
        else if (chargeType === chargeType_1.ChargeType.ActiveDeferral) {
            this.activeDeferralChargeOptions = this.activeDeferralChargeOptions.concat(this.getFieldsForCharge(charge));
        }
        this.addChargeToOffense(charge);
        this.updateOffenseDatesWithGreatestDates();
        this.offenseCountsPageForm.reset();
        this.chargesHasChanged();
    };
    OffenseCountsComponent.prototype.clearChargeFields = function () {
        this.offenseCountsPageForm.reset();
    };
    OffenseCountsComponent.prototype.updateCharge = function () {
        var newCharge = this.createChargeFromChargeUiControls();
        var fieldOptions = this.getAllChargesOptions()
            .filter(function (cf) { return cf.selected; });
        fieldOptions[0].charge.count = newCharge.count;
        fieldOptions[0].charge.chargeLevel = newCharge.chargeLevel;
        fieldOptions[0].charge.offense = newCharge.offense;
        fieldOptions[0].charge.disposition = newCharge.disposition;
        fieldOptions[0].charge.chargeStatute = newCharge.chargeStatute;
        fieldOptions[0].charge.probation = newCharge.probation;
        fieldOptions[0].charge.courtCost = newCharge.courtCost;
        fieldOptions[0].charge.jailTime = newCharge.jailTime;
        fieldOptions[0].charge.prisonTime = newCharge.prisonTime;
        fieldOptions[0].charge.suspensionTime = newCharge.suspensionTime;
        fieldOptions[0].charge.nextCourtDate = newCharge.nextCourtDate;
        fieldOptions[0].charge.offenseDate = newCharge.offenseDate;
        fieldOptions[0].charge.noOffenseDateReason = newCharge.noOffenseDateReason;
        fieldOptions[0].charge.fileDate = newCharge.fileDate;
        fieldOptions[0].charge.noFileDateReason = newCharge.noFileDateReason;
        fieldOptions[0].charge.arrestDate = newCharge.arrestDate;
        fieldOptions[0].charge.noArrestDateReason = newCharge.noArrestDateReason;
        fieldOptions[0].charge.dispositionDate = newCharge.dispositionDate;
        fieldOptions[0].charge.noDispositionReason = newCharge.noDispositionReason;
        fieldOptions[0].charge.otherSentenceNotes = newCharge.otherSentenceNotes;
        this.updateOffenseDatesWithGreatestDates();
        this.updateOptionFieldsForCharge(fieldOptions, fieldOptions[0].charge);
        this.offenseCountsPageForm.markAsPristine();
        this.chargesHasChanged();
    };
    OffenseCountsComponent.prototype.deleteCharge = function () {
        var chargeFields = this.getAllChargesOptions().filter(function (c) { return c.selected; });
        var chargeType = chargeFields[0].charge.chargeType;
        if (chargeType === chargeType_1.ChargeType.Convicted) {
            this.removeChargesByIndex(this.convictedChargeOptions, chargeFields);
        }
        else if (chargeType === chargeType_1.ChargeType.OtherNonConviction) {
            this.removeChargesByIndex(this.otherNonConvictionChargeOptions, chargeFields);
        }
        else if (chargeType === chargeType_1.ChargeType.Pending) {
            this.removeChargesByIndex(this.pendingChargeOptions, chargeFields);
        }
        else if (chargeType === chargeType_1.ChargeType.CompleteDeferral) {
            this.removeChargesByIndex(this.completeDeferralChargeOptions, chargeFields);
        }
        else if (chargeType === chargeType_1.ChargeType.ActiveDeferral) {
            this.removeChargesByIndex(this.activeDeferralChargeOptions, chargeFields);
        }
        var charge = chargeFields[0].charge;
        this.removeChargeFromOffense(charge);
        this.updateOffenseDatesWithGreatestDates();
        this.offenseCountsPageForm.reset();
        this.chargesHasChanged();
    };
    OffenseCountsComponent.prototype.selectCharge = function (chargeType, index) {
        this.offenseCountsPageForm.reset();
        var allChargeFields = this.getAllChargesOptions();
        var chargeFields = allChargeFields
            .filter(function (c) { return c.charge.chargeType === chargeType && c.index.toString() === index; });
        for (var _i = 0, allChargeFields_1 = allChargeFields; _i < allChargeFields_1.length; _i++) {
            var c = allChargeFields_1[_i];
            c.selected = false;
        }
        for (var _a = 0, chargeFields_1 = chargeFields; _a < chargeFields_1.length; _a++) {
            var c = chargeFields_1[_a];
            c.selected = true;
        }
        this.showSelectedCharge(chargeFields);
    };
    Object.defineProperty(OffenseCountsComponent.prototype, "isChargeDirty", {
        get: function () {
            return this.hasSelectedCharge &&
                (this.offenseCountFormControl.isControlNameDirty('count')
                    || this.offenseCountFormControl.isControlNameDirty('chargeLevel')
                    || this.offenseCountFormControl.isControlNameDirty('offense')
                    || this.offenseCountFormControl.isControlNameDirty('disposition')
                    || this.offenseCountFormControl.isControlNameDirty('chargeStatute')
                    || this.offenseCountFormControl.isControlNameDirty('probation')
                    || this.offenseCountFormControl.isControlNameDirty('fines')
                    || this.offenseCountFormControl.isControlNameDirty('courtCosts')
                    || this.offenseCountFormControl.isControlNameDirty('jailTime')
                    || this.offenseCountFormControl.isControlNameDirty('prisonTime')
                    || this.offenseCountFormControl.isControlNameDirty('suspensionTime')
                    || this.offenseCountFormControl.isControlNameDirty('nextCourtDate')
                    || this.offenseCountFormControl.isControlNameDirty('offenseDate')
                    || this.offenseCountFormControl.isControlNameDirty('noOffenseDateReason')
                    || this.offenseCountFormControl.isControlNameDirty('fileDate')
                    || this.offenseCountFormControl.isControlNameDirty('noFileDateReason')
                    || this.offenseCountFormControl.isControlNameDirty('arrestDate')
                    || this.offenseCountFormControl.isControlNameDirty('noArrestDateReason')
                    || this.offenseCountFormControl.isControlNameDirty('dispositionDate')
                    || this.offenseCountFormControl.isControlNameDirty('noDispositionReason')
                    || this.offenseCountFormControl.isControlNameDirty('otherSentenceNotes'));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "count", {
        get: function () { return this.offenseCountsPageForm.get('count'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "chargeLevel", {
        get: function () { return this.offenseCountsPageForm.get('chargeLevel'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "offense", {
        get: function () { return this.offenseCountsPageForm.get('offense'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "disposition", {
        get: function () { return this.offenseCountsPageForm.get('disposition'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "chargeStatute", {
        get: function () { return this.offenseCountsPageForm.get('chargeStatute'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "probation", {
        get: function () { return this.offenseCountsPageForm.get('probation'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "fines", {
        get: function () { return this.offenseCountsPageForm.get('fines'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "courtCosts", {
        get: function () { return this.offenseCountsPageForm.get('courtCosts'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "jailTime", {
        get: function () { return this.offenseCountsPageForm.get('jailTime'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "prisonTime", {
        get: function () { return this.offenseCountsPageForm.get('prisonTime'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "suspensionTime", {
        get: function () { return this.offenseCountsPageForm.get('suspensionTime'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "nextCourtDate", {
        get: function () { return this.offenseCountsPageForm.get('nextCourtDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "OffenseDateGreaterThanCurrentDate", {
        get: function () { return this.offenseCountsPageForm.get('offenseDateGreaterThanCurrentDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "fileDateGreaterThanCurrentDate", {
        get: function () { return this.offenseCountsPageForm.get('fileDateGreaterThanCurrentDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "arrestDateGreaterThanCurrentDate", {
        get: function () { return this.offenseCountsPageForm.get('arrestDateGreaterThanCurrentDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "dispositionDateGreaterThanCurrentDate", {
        get: function () { return this.offenseCountsPageForm.get('dispositionDateGreaterThanCurrentDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "fileDateDateOlderThanOffenseDate", {
        get: function () { return this.offenseCountsPageForm.get('fileDateDateOlderThanOffenseDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "dispositionDateOlderThanOffenseDate", {
        get: function () { return this.offenseCountsPageForm.get('dispositionDateOlderThanOffenseDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "dispositionDateOlderThanFileDate", {
        get: function () { return this.offenseCountsPageForm.get('dispositionDateOlderThanFileDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "offenseDate", {
        get: function () { return this.offenseCountsPageForm.get('offenseDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "noOffenseDateReason", {
        get: function () { return this.offenseCountsPageForm.get('noOffenseDateReason'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "fileDate", {
        get: function () { return this.offenseCountsPageForm.get('fileDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "noFileDateReason", {
        get: function () { return this.offenseCountsPageForm.get('noFileDateReason'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "arrestDate", {
        get: function () { return this.offenseCountsPageForm.get('arrestDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "noArrestDateReason", {
        get: function () { return this.offenseCountsPageForm.get('noArrestDateReason'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "dispositionDate", {
        get: function () { return this.offenseCountsPageForm.get('dispositionDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "noDispositionReason", {
        get: function () { return this.offenseCountsPageForm.get('noDispositionReason'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseCountsComponent.prototype, "otherSentenceNotes", {
        get: function () { return this.offenseCountsPageForm.get('otherSentenceNotes'); },
        enumerable: true,
        configurable: true
    });
    OffenseCountsComponent.prototype.chargesHasChanged = function () {
        this.updateToCurrentRecordCharges.emit();
    };
    OffenseCountsComponent.prototype.validateDates = function () {
        var offenseDate = this.offenseCountFormControl.getDateByControlName('offenseDate');
        var fileDate = this.offenseCountFormControl.getDateByControlName('fileDate');
        var arrestDate = this.offenseCountFormControl.getDateByControlName('arrestDate');
        var dispositionDate = this.offenseCountFormControl.getDateByControlName('dispositionDate');
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        if (offenseDate != null && offenseDate > today) {
            this.offenseCountFormControl.setValidationErrorByControlName('offenseDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        else {
            this.offenseCountFormControl.clearValidatorErrorByControlName('offenseDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        if (fileDate != null && fileDate > today) {
            this.offenseCountFormControl.setValidationErrorByControlName('fileDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        else {
            this.offenseCountFormControl.clearValidatorErrorByControlName('fileDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        if (fileDate != null && fileDate > today) {
            this.offenseCountFormControl.setValidationErrorByControlName('arrestDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        else {
            this.offenseCountFormControl.clearValidatorErrorByControlName('arrestDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        if (arrestDate !== null && arrestDate > today) {
            this.offenseCountFormControl.setValidationErrorByControlName('arrestDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        else {
            this.offenseCountFormControl.clearValidatorErrorByControlName('arrestDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        if (dispositionDate != null && dispositionDate > today) {
            this.offenseCountFormControl.setValidationErrorByControlName('dispositionDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        else {
            this.offenseCountFormControl.clearValidatorErrorByControlName('dispositionDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        if (offenseDate !== null && fileDate !== null && offenseDate > fileDate) {
            this.offenseCountFormControl.setValidationErrorByControlName('fileDateDateOlderThanOffenseDate', 'olderThan');
        }
        else {
            this.offenseCountFormControl.clearValidatorErrorByControlName('fileDateDateOlderThanOffenseDate', 'olderThan');
        }
        if (offenseDate !== null && dispositionDate !== null && offenseDate > dispositionDate) {
            this.offenseCountFormControl.setValidationErrorByControlName('dispositionDateOlderThanOffenseDate', 'olderThan');
        }
        else {
            this.offenseCountFormControl.clearValidatorErrorByControlName('dispositionDateOlderThanOffenseDate', 'olderThan');
        }
        if (fileDate !== null && dispositionDate !== null && fileDate > dispositionDate) {
            this.offenseCountFormControl.setValidationErrorByControlName('dispositionDateOlderThanFileDate', 'olderThan');
        }
        else {
            this.offenseCountFormControl.clearValidatorErrorByControlName('dispositionDateOlderThanFileDate', 'olderThan');
        }
    };
    Object.defineProperty(OffenseCountsComponent.prototype, "hasSelectedCharge", {
        get: function () {
            return this.getAllChargesOptions()
                .some(function (cf) { return cf.selected; });
        },
        enumerable: true,
        configurable: true
    });
    OffenseCountsComponent.prototype.createChargeFromChargeUiControls = function (chargeType) {
        if (chargeType === void 0) { chargeType = null; }
        var count = this.offenseCountFormControl.getNumberByControlName('count');
        var chargeLevel = this.offenseCountFormControl.getNumberByControlName('chargeLevel');
        var offense = this.offenseCountFormControl.getValueByControlName('offense');
        var disposition = this.offenseCountFormControl.getValueByControlName('disposition');
        var chargeStatute = this.offenseCountFormControl.getValueByControlName('chargeStatute');
        var probation = this.offenseCountFormControl.getValueByControlName('probation');
        var fines = this.offenseCountFormControl.getValueByControlName('fines');
        var courtCosts = this.offenseCountFormControl.getValueByControlName('courtCosts');
        var jailTime = this.offenseCountFormControl.getValueByControlName('jailTime');
        var prisonTime = this.offenseCountFormControl.getValueByControlName('prisonTime');
        var suspensionTime = this.offenseCountFormControl.getValueByControlName('suspensionTime');
        var nextCourtDate = this.offenseCountFormControl.getDateByControlName('nextCourtDate');
        var offenseDate = this.offenseCountFormControl.getDateByControlName('offenseDate');
        var noOffenseDateReason = this.offenseCountFormControl.getValueByControlName('noOffenseDateReason');
        var fileDate = this.offenseCountFormControl.getDateByControlName('fileDate');
        var noFileDateReason = this.offenseCountFormControl.getValueByControlName('noFileDateReason');
        var arrestDate = this.offenseCountFormControl.getDateByControlName('arrestDate');
        var noArrestDateReason = this.offenseCountFormControl.getValueByControlName('noArrestDateReason');
        var dispositionDate = this.offenseCountFormControl.getDateByControlName('dispositionDate');
        var noDispositionReason = this.offenseCountFormControl.getValueByControlName('noDispositionReason');
        var otherSentenceNotes = this.offenseCountFormControl.getValueByControlName('otherSentenceNotes');
        if (chargeType == null) {
            chargeType = this.getAllChargesOptions()
                .find(function (cf) { return cf.selected; }).charge.chargeType;
        }
        return charge_1.default.createCharge(this.offenseRecord.requestNumber, this.offenseRecord.offenseNumber, count, chargeLevel, offense, disposition, chargeStatute, probation, fines, courtCosts, jailTime, prisonTime, suspensionTime, nextCourtDate == null ? null : new Date(nextCourtDate), offenseDate == null ? null : new Date(offenseDate), noOffenseDateReason, fileDate == null ? null : new Date(fileDate), noFileDateReason, arrestDate == null ? null : new Date(arrestDate), noArrestDateReason, dispositionDate == null ? null : new Date(dispositionDate), noDispositionReason, otherSentenceNotes, chargeType);
    };
    OffenseCountsComponent.prototype.updateOffenseDatesWithGreatestDates = function () {
        var offenseDates = this.offenseRecord.charges
            .filter(function (c) { return c != null; })
            .map(function (c) { return c.offenseDate; });
        var fileDates = this.offenseRecord.charges
            .filter(function (c) { return c != null; })
            .map(function (c) { return c.fileDate; });
        var arrestDates = this.offenseRecord.charges
            .filter(function (c) { return c != null; })
            .map(function (c) { return c.arrestDate; });
        var dispositionDates = this.offenseRecord.charges
            .filter(function (c) { return c != null; })
            .map(function (c) { return c.dispositionDate; });
        var offenseDate = null;
        var fileDate = null;
        var arrestDate = null;
        var dispositionDate = null;
        if (offenseDates.length > 0) {
            offenseDate = offenseDates.reduce(function (a, b) { return a > b ? a : b; });
        }
        if (fileDates.length > 0) {
            fileDate = fileDates.reduce(function (a, b) { return a > b ? a : b; });
        }
        if (arrestDates.length > 0) {
            arrestDate = arrestDates.reduce(function (a, b) { return a > b ? a : b; });
        }
        if (dispositionDates.length > 0) {
            dispositionDate = dispositionDates.reduce(function (a, b) { return a > b ? a : b; });
        }
        this.updateOffenseDates.emit({
            offenseDate: offenseDate == null ? null : new dateHandler_1.default(offenseDate).format(),
            fileDate: fileDate == null ? null : new dateHandler_1.default(fileDate).format(),
            arrestDate: arrestDate == null ? null : new dateHandler_1.default(arrestDate).format(),
            dispositionDate: dispositionDate == null ? null : new dateHandler_1.default(dispositionDate).format()
        });
    };
    OffenseCountsComponent.prototype.removeChargesByIndex = function (chargeFields, deletedCharges) {
        var firstIndex = chargeFields.findIndex(function (cf) { return cf.index === deletedCharges[0].index; });
        var lastIndex = chargeFields.lastIndexOf(deletedCharges[deletedCharges.length - 1]);
        chargeFields.splice(firstIndex, lastIndex - firstIndex + 1);
    };
    OffenseCountsComponent.prototype.removeChargeFromOffense = function (charge) {
        if (charge) {
            var index = this.offenseRecord.charges.findIndex(function (c) { return c === charge; });
            this.offenseRecord.charges.splice(index, 1);
        }
    };
    OffenseCountsComponent.prototype.addChargeToOffense = function (charge) {
        this.offenseRecord.charges.push(charge);
    };
    OffenseCountsComponent.prototype.showSelectedCharge = function (chargeFields) {
        this.offenseCountFormControl.setValueByControlName('count', this.getFieldFromString(chargeFields[0].description));
        this.offenseCountFormControl.setValueByControlName('chargeLevel', chargeLevels_1.ChargeLevel[this.removeSpaces(this.getFieldFromString(chargeFields[1].description))]);
        this.offenseCountFormControl.setValueByControlName('offense', this.getFieldFromString(chargeFields[2].description));
        this.offenseCountFormControl.setValueByControlName('disposition', this.getFieldFromString(chargeFields[3].description));
        this.offenseCountFormControl.setValueByControlName('offenseDate', this.getFieldFromString(chargeFields[4].description));
        this.offenseCountFormControl.setValueByControlName('fileDate', this.getFieldFromString(chargeFields[5].description));
        this.offenseCountFormControl.setValueByControlName('arrestDate', this.getFieldFromString(chargeFields[6].description));
        this.offenseCountFormControl.setValueByControlName('dispositionDate', this.getFieldFromString(chargeFields[7].description));
        this.offenseCountFormControl.setValueByControlName('probation', this.getFieldFromString(chargeFields[8].description));
        this.offenseCountFormControl.setValueByControlName('fines', this.getFieldFromString(chargeFields[9].description));
        this.offenseCountFormControl.setValueByControlName('courtCosts', this.getFieldFromString(chargeFields[10].description));
        this.offenseCountFormControl.setValueByControlName('jailTime', this.getFieldFromString(chargeFields[11].description));
        this.offenseCountFormControl.setValueByControlName('prisonTime', this.getFieldFromString(chargeFields[12].description));
        this.offenseCountFormControl.setValueByControlName('suspensionTime', this.getFieldFromString(chargeFields[13].description));
        this.offenseCountFormControl.setValueByControlName('nextCourtDate', this.getFieldFromString(chargeFields[14].description));
        this.offenseCountFormControl.setValueByControlName('otherSentenceNotes', this.getFieldFromString(chargeFields[15].description));
        this.offenseCountFormControl.setValueByControlName('noDispositionReason', this.getFieldFromString(chargeFields[16].description));
        this.offenseCountFormControl.setValueByControlName('noArrestDateReason', this.getFieldFromString(chargeFields[17].description));
        this.offenseCountFormControl.setValueByControlName('noFileDateReason', this.getFieldFromString(chargeFields[18].description));
        this.offenseCountFormControl.setValueByControlName('noOffenseDateReason', this.getFieldFromString(chargeFields[19].description));
        this.offenseCountFormControl.setValueByControlName('chargeStatute', this.getFieldFromString(chargeFields[20].description));
    };
    OffenseCountsComponent.prototype.getFieldFromString = function (description) {
        return description.substring(description.indexOf(': ') + 2);
    };
    OffenseCountsComponent.prototype.camelCaseToString = function (s) {
        return s.split(/(?=[A-Z])/).join(' ');
    };
    OffenseCountsComponent.prototype.removeSpaces = function (s) {
        return s.replace(' ', '');
    };
    OffenseCountsComponent.prototype.setOddAndEventClass = function (charges) {
        var uniqueIndexes = charges.map(function (c) { return c.index; }).filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
        var odd = true;
        var _loop_1 = function (index) {
            var indexGroupCharge = charges.filter(function (c) { return c.index === index; });
            for (var _i = 0, indexGroupCharge_1 = indexGroupCharge; _i < indexGroupCharge_1.length; _i++) {
                var charge = indexGroupCharge_1[_i];
                charge.cssClass = odd ? 'odd-background-charge' : 'even-background-charge';
            }
            odd = !odd;
        };
        for (var _i = 0, uniqueIndexes_1 = uniqueIndexes; _i < uniqueIndexes_1.length; _i++) {
            var index = uniqueIndexes_1[_i];
            _loop_1(index);
        }
        return charges;
    };
    OffenseCountsComponent.prototype.createChargeOptions = function () {
        if (this.chargeIndex > 0) {
            this.chargeIndex = 0;
            this.convictedChargeOptions.length = 0;
            this.otherNonConvictionChargeOptions.length = 0;
            this.pendingChargeOptions.length = 0;
            this.completeDeferralChargeOptions.length = 0;
            this.completeDeferralChargeOptions.length = 0;
        }
        this.convictedChargeOptions = this.getChargesByChargeType(chargeType_1.ChargeType.Convicted);
        this.otherNonConvictionChargeOptions = this.getChargesByChargeType(chargeType_1.ChargeType.OtherNonConviction);
        this.pendingChargeOptions = this.getChargesByChargeType(chargeType_1.ChargeType.Pending);
        this.completeDeferralChargeOptions = this.getChargesByChargeType(chargeType_1.ChargeType.CompleteDeferral);
        this.activeDeferralChargeOptions = this.getChargesByChargeType(chargeType_1.ChargeType.ActiveDeferral);
    };
    OffenseCountsComponent.prototype.getAllChargesOptions = function () {
        var charges = this.convictedChargeOptions.concat(this.activeDeferralChargeOptions);
        charges = charges.concat(this.completeDeferralChargeOptions);
        charges = charges.concat(this.otherNonConvictionChargeOptions);
        charges = charges.concat(this.pendingChargeOptions);
        return charges;
    };
    OffenseCountsComponent.prototype.getChargesByChargeType = function (chargeType) {
        var charges = this.hasCharges
            ? this.offenseRecord.charges.filter(function (c) { return c.chargeType === chargeType; })
            : new Array();
        return this.setOddAndEventClass(this.getFieldsForCharges(charges));
    };
    OffenseCountsComponent.prototype.getFieldsForCharges = function (charges) {
        var options = new Array();
        for (var _i = 0, charges_1 = charges; _i < charges_1.length; _i++) {
            var charge = charges_1[_i];
            options = options.concat(this.getFieldsForCharge(charge));
        }
        return options;
    };
    OffenseCountsComponent.prototype.createChargeOption = function (description, charge, index) {
        return {
            class: '',
            selectedCssClass: 'selected-charge',
            selected: false,
            description: description,
            charge: charge,
            index: index
        };
    };
    Object.defineProperty(OffenseCountsComponent.prototype, "hasCharges", {
        get: function () {
            return this.offenseRecord !== null && this.offenseRecord !== undefined
                && this.offenseRecord.charges !== null && this.offenseRecord.charges !== undefined
                && this.offenseRecord.charges.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    OffenseCountsComponent.prototype.updateOptionFieldsForCharge = function (fieldOptions, charge) {
        fieldOptions[0].description = "Count: " + charge.count;
        fieldOptions[1].description = "Level: " + this.camelCaseToString(chargeLevels_1.ChargeLevel[charge.chargeLevel]);
        fieldOptions[2].description = "Offense: " + charge.offense;
        fieldOptions[3].description = "Disposition: " + charge.disposition;
        fieldOptions[4].description = "Offense Date: " + (charge.offenseDate == null ? '' : this.convertToDateFormat(charge.offenseDate));
        fieldOptions[5].description = "File Date: " + (charge.fileDate == null ? '' : this.convertToDateFormat(charge.fileDate));
        fieldOptions[6].description = "Arrest Date: " + (charge.arrestDate == null ? '' : this.convertToDateFormat(charge.arrestDate));
        fieldOptions[7].description = "Disposition Date: " + (charge.dispositionDate == null
            ? ''
            : this.convertToDateFormat(charge.dispositionDate));
        fieldOptions[8].description = "Probation: " + (charge.probation == null ? '' : charge.probation);
        fieldOptions[9].description = "Fines: " + (charge.fines == null ? '' : charge.fines);
        fieldOptions[10].description = "Court Costs: " + (charge.courtCost == null ? '' : charge.courtCost);
        fieldOptions[11].description = "Jail Time: " + (charge.jailTime == null ? '' : charge.jailTime);
        fieldOptions[12].description = "Prison Time: " + (charge.prisonTime == null ? '' : charge.prisonTime);
        fieldOptions[13].description = "Suspension Time: " + (charge.suspensionTime == null ? '' : charge.suspensionTime);
        fieldOptions[14].description = "Next Court Date: " + (charge.nextCourtDate == null ? '' : this.convertToDateFormat(charge.nextCourtDate));
        fieldOptions[15].description = "Other Sentencing Notes: " + (charge.otherSentenceNotes == null ? '' : charge.otherSentenceNotes);
        fieldOptions[16].description = "NoDispDateReason: " + (charge.noDispositionReason == null ? '' : charge.noDispositionReason);
        fieldOptions[17].description = "NoArrestDateReason: " + (charge.noFileDateReason == null ? '' : charge.noArrestDateReason);
        fieldOptions[18].description = "NoFileDateReason: " + (charge.noFileDateReason == null ? '' : charge.noFileDateReason);
        fieldOptions[19].description = "NoOffenseDateReason: " + (charge.noOffenseDateReason == null ? '' : charge.noOffenseDateReason);
        fieldOptions[20].description = "Charge Statute: " + (charge.chargeStatute == null ? '' : charge.chargeStatute);
    };
    OffenseCountsComponent.prototype.getFieldsForCharge = function (charge) {
        var options = new Array();
        var chargeIndex = this.getNewChargeIndex();
        options.push(this.createChargeOption("Count: " + charge.count, charge, chargeIndex));
        options.push(this.createChargeOption("Level: " + this.camelCaseToString(chargeLevels_1.ChargeLevel[charge.chargeLevel]), charge, chargeIndex));
        options.push(this.createChargeOption("Offense: " + charge.offense, charge, chargeIndex));
        options.push(this.createChargeOption("Disposition: " + charge.disposition, charge, chargeIndex));
        options.push(this.createChargeOption("Offense Date: " + (charge.offenseDate == null
            ? ''
            : this.convertToDateFormat(charge.offenseDate)), charge, chargeIndex));
        options.push(this.createChargeOption("File Date: " + (charge.fileDate == null
            ? ''
            : this.convertToDateFormat(charge.fileDate)), charge, chargeIndex));
        options.push(this.createChargeOption("Arrest Date: " + (charge.arrestDate == null
            ? ''
            : this.convertToDateFormat(charge.arrestDate)), charge, chargeIndex));
        options.push(this.createChargeOption("Disposition Date: " + (charge.dispositionDate == null
            ? ''
            : this.convertToDateFormat(charge.dispositionDate)), charge, chargeIndex));
        options.push(this.createChargeOption("Probation: " + (charge.probation == null ? '' : charge.probation), charge, chargeIndex));
        options.push(this.createChargeOption("Fines: " + (charge.fines == null ? '' : charge.fines), charge, chargeIndex));
        options.push(this.createChargeOption("Court Costs: " + (charge.courtCost == null ? '' : charge.courtCost), charge, chargeIndex));
        options.push(this.createChargeOption("Jail Time: " + (charge.jailTime == null ? '' : charge.jailTime), charge, chargeIndex));
        options.push(this.createChargeOption("Prison Time: " + (charge.prisonTime == null ? '' : charge.prisonTime), charge, chargeIndex));
        options.push(this.createChargeOption("Suspension Time: " + (charge.suspensionTime == null
            ? ''
            : charge.suspensionTime), charge, chargeIndex));
        options.push(this.createChargeOption("Next Court Date: " + (charge.nextCourtDate == null
            ? ''
            : this.convertToDateFormat(charge.nextCourtDate)), charge, chargeIndex));
        options.push(this.createChargeOption("Other Sentencing Notes: " + (charge.otherSentenceNotes == null
            ? ''
            : charge.otherSentenceNotes), charge, chargeIndex));
        options.push(this.createChargeOption("NoDispDateReason: " + (charge.noDispositionReason == null
            ? ''
            : charge.noDispositionReason), charge, chargeIndex));
        options.push(this.createChargeOption("NoArrestDateReason: " + (charge.noArrestDateReason == null
            ? ''
            : charge.noArrestDateReason), charge, chargeIndex));
        options.push(this.createChargeOption("NoFileDateReason: " + (charge.noFileDateReason == null
            ? ''
            : charge.noFileDateReason), charge, chargeIndex));
        options.push(this.createChargeOption("NoOffenseDateReason: " + (charge.noOffenseDateReason == null
            ? ''
            : charge.noOffenseDateReason), charge, chargeIndex));
        options.push(this.createChargeOption("Charge Statute: " + (charge.chargeStatute == null
            ? ''
            : charge.chargeStatute), charge, chargeIndex));
        return options;
    };
    OffenseCountsComponent.prototype.convertToDateFormat = function (date, baseCentury) {
        if (baseCentury === void 0) { baseCentury = 2000; }
        return new dateHandler_1.default(date, baseCentury).format();
    };
    OffenseCountsComponent.prototype.getNewChargeIndex = function () {
        return this.chargeIndex++;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", typeof (_a = typeof offenseRecord_1.default !== "undefined" && offenseRecord_1.default) === "function" && _a || Object),
        __metadata("design:paramtypes", [typeof (_b = typeof offenseRecord_1.default !== "undefined" && offenseRecord_1.default) === "function" && _b || Object])
    ], OffenseCountsComponent.prototype, "offenseRecordObject", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", typeof (_c = typeof sentenceLevel_1.SentenceLevel !== "undefined" && sentenceLevel_1.SentenceLevel) === "function" && _c || Object),
        __metadata("design:paramtypes", [typeof (_d = typeof sentenceLevel_1.SentenceLevel !== "undefined" && sentenceLevel_1.SentenceLevel) === "function" && _d || Object])
    ], OffenseCountsComponent.prototype, "sentenceLevelObject", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], OffenseCountsComponent.prototype, "updateOffenseDates", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], OffenseCountsComponent.prototype, "updateToCurrentRecordCharges", void 0);
    OffenseCountsComponent = __decorate([
        core_1.Component({
            selector: 'app-offense-counts',
            template: __webpack_require__("./src/app/offenseCounts/offenseCounts.component.html"),
            styles: [__webpack_require__("./src/app/offenseCounts/offenseCounts.component.scss")],
            providers: []
        }),
        __metadata("design:paramtypes", [typeof (_e = typeof forms_1.FormBuilder !== "undefined" && forms_1.FormBuilder) === "function" && _e || Object])
    ], OffenseCountsComponent);
    return OffenseCountsComponent;
    var _a, _b, _c, _d, _e;
}());
exports.default = OffenseCountsComponent;
//# sourceMappingURL=offenseCounts.component.js.map

/***/ }),

/***/ "./src/app/offenseHelp/offenseHelp.component.html":
/***/ (function(module, exports) {

module.exports = "<main>\r\n\r\n  <h1>Offense Entry Page Explanation</h1>\r\n\r\n  <h2>Purpose of the Offense Entry Page:</h2>\r\n  <p>\r\n    To allow entry of Offense and charge information and history as it relates to the selected Request.\r\n  </p>\r\n\r\n  <h2>Explanation of Search Information</h2>\r\n  <p>\r\n    This section displays the information that can be used for searching for background information\r\n  </p>\r\n\r\n  <h3>Jurisdiction</h3>\r\n  <p>\r\n    The country/courthouse that will be searched.\r\n  </p>\r\n\r\n  <h3>Search Dates</h3>\r\n  <p>\r\n    The date range that will be used for the search.\r\n  </p>\r\n\r\n  <h3>Name</h3>\r\n  <p>\r\n    The name to use for the search\r\n  </p>\r\n\r\n  <h3>DOB, SSN, and Address</h3>\r\n  <p>\r\n    The applicants personal information as listed on the Application/Resume for use in the background search.\r\n  </p>\r\n\r\n  <h2>Explanation of Offense Entry Section</h2>\r\n\r\n  <h3>Identifiers</h3>\r\n  <p>\r\n    Select the identifiers used in the search ... at lease one identifier must be ordered before the offense can be saved.\r\n  </p>\r\n\r\n  <h3>Additional Information being faxed</h3>\r\n  <p>\r\n    This will be selected only when additional information has been faxed to GIS pertaining to the current offense.\r\n  </p>\r\n\r\n  <h3>Name as listed in the court house</h3>\r\n  <p>\r\n    This will be the name of the individual being researched ... as listed in the Court House records.\r\n  </p>\r\n\r\n  <h3>Court Case/Ref Nbr.</h3>\r\n  <p>\r\n    The number that is noted as a Case Number or Reference Number associated with the offense being entered.\r\n  </p>\r\n\r\n  <h3>Offense Date</h3>\r\n  <p>\r\n    The date the offense occurred\r\n  </p>\r\n\r\n  <h3>File Date</h3>\r\n  <p>\r\n    The date the offense information was filed\r\n  </p>\r\n\r\n  <!-- <h3>Disposition Date</h3>\r\n  <p>\r\n    The date the offense was tried and the defendant was found guilty &lt;Convicted&gt; or not guilty &lt;Not Convicted&gt;\r\n  </p> -->\r\n\r\n  <h2>Explanation of Count/Charge Entry</h2>\r\n  <p>\r\n    This section is used to enter the convicted and non-convicted count/charge description and disposition detail information\r\n  </p>\r\n\r\n  <h3>Count/Charge</h3>\r\n  <p>\r\n    Description of the count/charge as stated in the court records\r\n  </p>\r\n\r\n  <h3>Disposition</h3>\r\n  <p>\r\n    Description of the outcome of the count/charge as stated in the court records\r\n  </p>\r\n\r\n  <h3>Additional Comments</h3>\r\n  <p>\r\n    Any comments that would need to be maintained for this offense would be entered here.\r\n  </p>\r\n\r\n  <h2>Functions available in the Count/Charge Sections </h2>\r\n\r\n  <h3>Convicted</h3>\r\n  <p>\r\n    When this is selected, it will take the Count/Charge description and Disposition and place them into the\r\n    Convicted charges associated with this offense container. *Note: A count/charge description is required\r\n    to Add a convicted item to the container.\r\n  </p>\r\n\r\n  <h3>NotConvicted</h3>\r\n  <p>\r\n    When this is selected, it will take the Count/Charge description and Disposition and place them into\r\n    the Charges not leading to a conviction associated with this offense.\r\n  </p>\r\n\r\n  <h3>Updated</h3>\r\n  <p>\r\n    A count/charge is selected from one of the containers (either the convicted or not-convicted container)\r\n    the selection will populate in the appropriate entry field. Updates are made to the data and then the\r\n    Updated push-button is selected. It will update the information and place it back into the appropriate container.\r\n  </p>\r\n\r\n  <h3>Delete</h3>\r\n  <p>\r\n    A count/charge is selected from one of the containers (either the convicted or not-convicted container) the\r\n    selection will populate in the appropriate entry field. The delete push-button is selected, a confirmation\r\n    message will appear and if OK is selected the count/charge will be deleted.\r\n  </p>\r\n\r\n  <h3>Clear Entry Field</h3>\r\n  <p>\r\n    When this is selected, any entry (or) changes in the Count/Charges description and disposition field will be cleared.\r\n    Any changes would be discarded.\r\n  </p>\r\n\r\n  <h2>Functions available on the Offense Entry Page:</h2>\r\n\r\n  <h3>Save Offense:</h3>\r\n  <p>\r\n    When selected, this will save the information that has been entered on the Offense Entry Page\r\n  </p>\r\n\r\n  <h3>Add New Offense: </h3>\r\n  <p>\r\n    When selected, this will display an empty offense page for new entry\r\n  </p>\r\n\r\n  <h3>Work Order Complete:</h3>\r\n  <p>\r\n    When selected, this will save the information currently entered on the Offense page, mark the status of the Work Order (Request)\r\n    as Complete\r\n  </p>\r\n\r\n  <h3>Communication Log:</h3>\r\n  <p>\r\n    When selected, this will display a new window that communication could be entered in ... this would be when the\r\n    external researcher has questions regarding the request that need to be reviewed by our internal staff. Our internal\r\n    staff would also save communication on this page. (i.e. a response to the external researcher)\r\n  </p>\r\n\r\n  <h3>Open Task List:</h3>\r\n  <p>\r\n   When select, this will close the current window (with a confirmation first) and then open the Work Order Task List.\r\n  </p>\r\n\r\n</main>\r\n";

/***/ }),

/***/ "./src/app/offenseHelp/offenseHelp.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}h1{-ms-flex-line-pack:center;align-content:center;text-align:center;font-size:2.2rem;font-family:Verdana,Tahoma,Arial;padding-left:1.2rem}h2{text-decoration:underline;margin-bottom:2rem}h2,h3{font-size:1.2rem;font-family:Verdana,Tahoma,Arial;padding-left:1.2rem}h3{padding-bottom:0;margin-bottom:0}p{margin-bottom:2rem;font-family:Verdana,Tahoma,Arial;padding-left:1.2rem;padding-top:0;margin-top:0}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/offenseHelp/offenseHelp.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var OffenseHelpComponent = (function () {
    function OffenseHelpComponent() {
    }
    OffenseHelpComponent = __decorate([
        core_1.Component({
            selector: 'app-offense-help',
            template: __webpack_require__("./src/app/offenseHelp/offenseHelp.component.html"),
            styles: [__webpack_require__("./src/app/offenseHelp/offenseHelp.component.scss")],
            providers: []
        })
    ], OffenseHelpComponent);
    return OffenseHelpComponent;
}());
exports.default = OffenseHelpComponent;
//# sourceMappingURL=offenseHelp.component.js.map

/***/ }),

/***/ "./src/app/offenseRecord/offenseRecord.component.html":
/***/ (function(module, exports) {

module.exports = "<section [formGroup]=\"offenseRecordFormGroup\">\r\n\r\n  <header class=\"flex-container\">\r\n    <span>RECORD INFORMATION</span>\r\n    <div>\r\n      <span>Current Record Number: {{ currentRecord }}</span>\r\n      <span>Total Records Entered and Saved for this Request: {{ totalRecords }}</span>\r\n    </div>\r\n    <div>\r\n      <a *ngIf=\"isFirstActive\" href=\"javascript:void(0)\"\r\n         (click)=\"firstOffense()\"\r\n         [ngClass]=\"{'active': isFirstActive, 'disabled': !isFirstActive}\">\r\n        First\r\n      </a>\r\n      <a *ngIf=\"!isFirstActive\" href=\"javascript:void(0)\"\r\n         [ngClass]=\"{'active': isFirstActive, 'disabled': !isFirstActive}\">\r\n        First\r\n      </a>\r\n      <a *ngIf=\"isPreviousActive\" href=\"javascript:void(0)\"\r\n          (click)=\"previousOffense()\"\r\n          [ngClass]=\"{'active': isPreviousActive, 'disabled': !isPreviousActive}\">\r\n        Previous\r\n      </a>\r\n      <a *ngIf=\"!isPreviousActive\" href=\"javascript:void(0)\"\r\n          [ngClass]=\"{'active': isPreviousActive, 'disabled': !isPreviousActive}\">\r\n        Previous\r\n      </a>\r\n      <a *ngIf=\"isNextActive\" href=\"javascript:void(0)\"\r\n          (click)=\"nextOffense()\"\r\n          [ngClass]=\"{'active': isNextActive, 'disabled': !isNextActive}\">\r\n        Next\r\n      </a>\r\n      <a *ngIf=\"!isNextActive\" href=\"javascript:void(0)\"\r\n         [ngClass]=\"{'active': isNextActive, 'disabled': !isNextActive}\">\r\n        Next\r\n      </a>\r\n      <a *ngIf=\"isLastActive\" href=\"javascript:void(0)\"\r\n          (click)=\"lastOffense()\"\r\n          [ngClass]=\"{'active': isLastActive, 'disabled': !isLastActive}\">\r\n        Last\r\n      </a>\r\n      <a *ngIf=\"!isLastActive\" href=\"javascript:void(0)\"\r\n         [ngClass]=\"{'active': isLastActive, 'disabled': !isLastActive}\">\r\n        Last\r\n      </a>\r\n      <a *ngIf=\"addNewLastActive\" href=\"javascript:void(0)\"\r\n          (click)=\"addNewRecord()\"\r\n          [ngClass]=\"{'active': addNewLastActive, 'disabled': !addNewLastActive}\">\r\n        Add New Record\r\n      </a>\r\n      <a *ngIf=\"!addNewLastActive\" href=\"javascript:void(0)\"\r\n         [ngClass]=\"{'active': addNewLastActive, 'disabled': !addNewLastActive}\">\r\n        Add New Record\r\n      </a>\r\n  </div>\r\n  </header>\r\n\r\n  <section id=\"required-fields-section\">\r\n\r\n    <label><mark>*</mark> Indicates Required Entry for a Record</label>\r\n\r\n  </section>\r\n\r\n  <section id=\"identifiers-section\" class=\"flex-container\">\r\n\r\n    <label *ngIf=\"!hasHeightenedIdentifier\"><mark>*</mark>Select Identifiers using Standard Rules:</label>\r\n    <label *ngIf=\"hasHeightenedIdentifier\"><mark>*</mark>Select Identifiers using Heightened Rules:</label>\r\n\r\n    <ul>\r\n      <li>\r\n        <input type=\"checkbox\"\r\n               for=\"name-identifier\"\r\n               formControlName=\"hasNameIdentifier\"\r\n               (change)=\"validateIdentifier()\">\r\n        <label id=\"name-identifier\">Name</label>\r\n      </li>\r\n      <li>\r\n        <input type=\"checkbox\"\r\n               for=\"dob-identifier\"\r\n               formControlName=\"hasDobIdentifier\"\r\n               (change)=\"validateIdentifier()\">\r\n        <label id=\"dob-identifier\">DOB</label>\r\n      </li>\r\n      <li>\r\n        <input type=\"checkbox\"\r\n               for=\"ssn-identifier\"\r\n               formControlName=\"hasSsnIdentifier\"\r\n               (change)=\"validateIdentifier()\">\r\n        <label id=\"ssn-identifier\">SSN</label>\r\n      </li>\r\n      <li>\r\n        <input type=\"checkbox\"\r\n               for=\"sin-identifier\"\r\n               formControlName=\"hasSinIdentifier\"\r\n               (change)=\"validateIdentifier()\">\r\n        <label id=\"sin-identifier\">SIN</label>\r\n      </li>\r\n      <li>\r\n        <input type=\"checkbox\"\r\n               for=\"address-identifier\"\r\n               formControlName=\"hasAddressIdentifier\"\r\n               (change)=\"validateIdentifier()\">\r\n        <label id=\"address-identifier\">Address</label>\r\n      </li>\r\n      <li>\r\n        <input type=\"checkbox\"\r\n               for=\"dl-identifier\"\r\n               formControlName=\"hasDlnIdentifier\"\r\n               (change)=\"validateIdentifier()\">\r\n        <label id=\"dl-identifier\">Drivers License</label>\r\n      </li>\r\n    </ul>\r\n\r\n  </section>\r\n\r\n  <section id=\"identifiers-section-validation\">\r\n\r\n    <div class=\"validation\" *ngIf=\"hasIdentifier.invalid && (hasIdentifier.dirty || hasIdentifier.touched)\">\r\n      <span *ngIf=\"hasIdentifier.hasError('hasIdentifier')\">\r\n          Select Identifiers using Standard Rules.\r\n      </span>\r\n      <span *ngIf=\"hasIdentifier.hasError('hasAdditionalIdentifier')\">\r\n        Select Identifiers using Heightened Rules.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"hasIdentifier.invalid && (hasIdentifier.dirty || hasIdentifier.touched)\">\r\n      <span *ngIf=\"hasIdentifier.hasError('dobIdentifierWithDobNotListed')\">\r\n        Cannot have DOB identifier if you choose DOB not listed on record.  You must pick either Full DOB or Partial DOB.\r\n      </span>\r\n    </div>\r\n\r\n  </section>\r\n\r\n  <section id=\"record-level-section\">\r\n\r\n    <div>\r\n      <input type=\"checkbox\" for=\"additional-informationFaxed\" formControlName=\"hasFaxInformation\">\r\n      <label id=\"additional-informationFaxed\">Additional information being faxed.</label>\r\n    </div>\r\n\r\n    <div>\r\n      <label>Sentence Info Level</label>\r\n      <input name=\"sentenceLevel\"\r\n             type=\"radio\"\r\n             value=\"0\"\r\n             (change)=\"setSentenceLevel(true, true)\"\r\n             formControlName=\"sentenceLevel\">\r\n      <label>Record / Offense</label>\r\n      <input name=\"sentenceLevel\"\r\n             type=\"radio\"\r\n             value=\"1\"\r\n             (change)=\"setSentenceLevel(true, true)\"\r\n             formControlName=\"sentenceLevel\">\r\n    </div>\r\n\r\n  </section>\r\n\r\n  <section id=\"court-metadata-section\" class=\"flex-container\">\r\n\r\n    <div>\r\n      <label><mark>*</mark>Name as Listed in the Court Records:</label>\r\n      <label for=\"court-record-full-name\" class=\"block-label\">Format: Last, First Middle</label>\r\n      <input id=\"court-record-full-name\"\r\n             type=\"text\"\r\n             size=\"50\"\r\n             formControlName=\"courtRecordedFullName\"\r\n             app-validateOnBlur\r\n             required>\r\n    </div>\r\n\r\n    <div>\r\n      <input id=\"court-record-different-than-provided-search\"\r\n            type=\"checkbox\"\r\n            formControlName=\"nameDiffers\">\r\n      <label for=\"court-record-different-than-provided-search\">\r\n        Court Recorded Name is Different than the Name Provided for Search.\r\n      </label>\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"court-case-ref-nbr\" class=\"block-label\"><mark>*</mark>CourtCase/Ref.Nbr.:</label>\r\n      <input id=\"court-case-ref-nbr\"\r\n             type=\"text\"\r\n             formControlName=\"referenceNumber\"\r\n             app-validateOnBlur>\r\n    </div>\r\n\r\n  </section>\r\n\r\n  <section id=\"court-metadata-section-validation\">\r\n\r\n    <div class=\"validation\" *ngIf=\"courtRecordedFullName.invalid && (courtRecordedFullName.dirty || courtRecordedFullName.touched)\">\r\n      <span *ngIf=\"courtRecordedFullName.hasError('required')\">\r\n          Court Name is required.\r\n      </span>\r\n      <span *ngIf=\"courtRecordedFullName.hasError('maxlength')\">\r\n         Court Name can only be a max of 60 characters.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"referenceNumber.invalid && (referenceNumber.dirty || referenceNumber.touched)\">\r\n      <span *ngIf=\"referenceNumber.hasError('required')\">\r\n          CourtCase/Ref.Nbr is required.\r\n      </span>\r\n      <span *ngIf=\"referenceNumber.hasError('maxlength')\">\r\n        CourtCase/Ref.Nbr can only be a max of 25 characters.\r\n      </span>\r\n    </div>\r\n\r\n  </section>\r\n\r\n  <section id=\"date-of-birth-section\" >\r\n\r\n    <div>\r\n      <label>DOB as Listed in Court Records:</label>\r\n      <input type=\"text\" size=\"2\"\r\n             #dobMonth\r\n             id=\"month\"\r\n             maxlength=\"2\"\r\n             (blur)=\"validateDob()\"\r\n             formControlName=\"month\">\r\n      <span>/</span>\r\n      <input type=\"text\"\r\n             id=\"day\"\r\n             size=\"2\"\r\n             maxlength=\"2\"\r\n             (blur)=\"validateDob()\"\r\n             formControlName=\"day\">\r\n      <span>/</span>\r\n      <input type=\"text\"\r\n             id=\"year\"\r\n             size=\"4\"\r\n             maxlength=\"4\"\r\n             (blur)=\"validateDob()\"\r\n             formControlName=\"year\">\r\n    </div>\r\n\r\n    <label>\r\n      <input type=\"radio\" name=\"dobType\"\r\n             formControlName=\"dobType\"\r\n             value=\"full-dob\"\r\n             (change)=\"checkIfDisableDob()\">\r\n      <span>Full DOB</span>\r\n    </label>\r\n\r\n    <label>\r\n      <input type=\"radio\"\r\n             name=\"dobType\"\r\n             formControlName=\"dobType\"\r\n             value=\"partial-dob\"\r\n             (change)=\"checkIfDisableDob()\">\r\n      <span>Partial DOB</span>\r\n    </label>\r\n\r\n    <label>\r\n      <input type=\"radio\"\r\n             name=\"dobType\"\r\n             formControlName=\"dobType\"\r\n             value=\"no-dob\"\r\n             (change)=\"checkIfDisableDob()\">\r\n      <span>DOB not listed on record</span>\r\n    </label>\r\n\r\n  </section>\r\n\r\n  <section id=\"date-of-birth-section-validation\">\r\n\r\n    <div class=\"validation\" *ngIf=\"fullDobValidator.invalid && (fullDobValidator.dirty || fullDobValidator.touched)\">\r\n      <span *ngIf=\"fullDobValidator.hasError('isFullDobDate')\">\r\n          DOB is required in format mm/dd/yy or mm/dd/yyyy.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"partialDobValidator.invalid && (partialDobValidator.dirty || partialDobValidator.touched)\">\r\n      <span *ngIf=\"partialDobValidator.hasError('isPartialDate')\">\r\n        Partial DOB must have at least a valid month day or year.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"hasIdentifier.invalid && (hasIdentifier.dirty || hasIdentifier.touched)\">\r\n      <span *ngIf=\"hasIdentifier.hasError('dobIdentifierWithDobNotListed')\">\r\n          Cannot have DOB identifier if you choose DOB not listed on record.  You must pick either Full DOB or Partial DOB.\r\n      </span>\r\n    </div>\r\n\r\n  </section>\r\n\r\n  <section id=\"charge-dates-section\" class=\"flex-container\">\r\n\r\n    <div>\r\n      <label for=\"offense-date\" class=\"block-label\">Offense Date:</label>\r\n      <input type=\"text\"\r\n             id=\"offense-date\"\r\n             formControlName=\"offenseDate\"\r\n             app-validateOnBlur\r\n             (blur)=\"formatDate('offenseDate', 2000)\">\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"file-date\" class=\"block-label\">File Date:</label>\r\n      <input type=\"text\"\r\n             id=\"file-date\"\r\n             formControlName=\"fileDate\"\r\n             app-validateOnBlur\r\n             (blur)=\"formatDate('fileDate', 2000)\">\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"arrest-date\" class=\"block-label\">Arrest Date:</label>\r\n      <input type=\"text\"\r\n             id=\"arrest-date\"\r\n             formControlName=\"arrestDate\"\r\n             app-validateOnBlur\r\n             (blur)=\"formatDate('arrestDate', 2000)\">\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"disposition-date\" class=\"block-label\">Disposition Date:</label>\r\n      <input type=\"text\"\r\n             id=\"disposition-date\"\r\n             formControlName=\"dispositionDate\"\r\n             app-validateOnBlur\r\n             (blur)=\"formatDate('dispositionDate', 2000)\">\r\n    </div>\r\n\r\n  </section>\r\n\r\n  <section id=\"charge-dates-validation\">\r\n\r\n    <div class=\"validation\" *ngIf=\"offenseDate.invalid && (offenseDate.dirty || offenseDate.touched)\">\r\n      <span *ngIf=\"offenseDate.hasError('isDate')\">\r\n          Offense Date is required in format mm/dd/yy or mm/dd/yyyy.\r\n      </span>\r\n    </div>\r\n\r\n   <div class=\"validation\" *ngIf=\"fileDate.invalid && (fileDate.dirty || fileDate.touched)\">\r\n      <span *ngIf=\"fileDate.hasError('isDate')\">\r\n          File Date is required in format mm/dd/yy or mm/dd/yyyy.\r\n      </span>\r\n    </div>\r\n\r\n     <div class=\"validation\" *ngIf=\"arrestDate.invalid && (arrestDate.dirty || arrestDate.touched)\">\r\n      <span *ngIf=\"arrestDate.hasError('isDate')\">\r\n          Arrest Date is required in format mm/dd/yy or mm/dd/yyyy.\r\n      </span>\r\n    </div>\r\n\r\n   <div class=\"validation\" *ngIf=\"dispositionDate.invalid && (dispositionDate.dirty || dispositionDate.touched)\">\r\n      <span *ngIf=\"dispositionDate.hasError('isDate')\">\r\n          Disposition Date is required in format mm/dd/yy or mm/dd/yyyy.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"hasRequiredDate.invalid && (hasRequiredDate.dirty || hasRequiredDate.touched)\">\r\n      <span *ngIf=\"hasRequiredDate.hasError('hasRequiredDate')\">\r\n          Offense, Disposition or File Date is required on at least one of the COUNTS/OFFENSES.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"offenseDateGreaterThanCurrentDate.invalid && (offenseDateGreaterThanCurrentDate.dirty || offenseDateGreaterThanCurrentDate.touched)\">\r\n      <span *ngIf=\"offenseDateGreaterThanCurrentDate.hasError('greaterThanCurrentDate')\">\r\n          Offense Date cannot be greater than current date.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"fileDateGreaterThanCurrentDate.invalid && (fileDateGreaterThanCurrentDate.dirty || fileDateGreaterThanCurrentDate.touched)\">\r\n      <span *ngIf=\"fileDateGreaterThanCurrentDate.hasError('greaterThanCurrentDate')\">\r\n          File Date cannot be greater than current date.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"arrestDateGreaterThanCurrentDate.invalid && (arrestDateGreaterThanCurrentDate.dirty || arrestDateGreaterThanCurrentDate.touched)\">\r\n      <span *ngIf=\"arrestDateGreaterThanCurrentDate.hasError('greaterThanCurrentDate')\">\r\n          Arrest Date cannot be greater than current date.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"dispositionDateGreaterThanCurrentDate.invalid && (dispositionDateGreaterThanCurrentDate.dirty || dispositionDateGreaterThanCurrentDate.touched)\">\r\n      <span *ngIf=\"dispositionDateGreaterThanCurrentDate.hasError('greaterThanCurrentDate')\">\r\n          Disposition Date cannot be greater than current date.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"dispositionDateOlderThanOffenseDate.invalid && (dispositionDateOlderThanOffenseDate.dirty || dispositionDateOlderThanOffenseDate.touched)\">\r\n      <span *ngIf=\"dispositionDateOlderThanOffenseDate.hasError('olderThan')\">\r\n          Disposition Date cannot be older than offense date.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"fileDateDateOlderThanOffenseDate.invalid && (fileDateDateOlderThanOffenseDate.dirty || fileDateDateOlderThanOffenseDate.touched)\">\r\n      <span *ngIf=\"fileDateDateOlderThanOffenseDate.hasError('olderThan')\">\r\n          File Date cannot be older than offense date.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"dispositionDateOlderThanFileDate.invalid && (dispositionDateOlderThanFileDate.dirty || dispositionDateOlderThanFileDate.touched)\">\r\n      <span *ngIf=\"dispositionDateOlderThanFileDate.hasError('olderThan')\">\r\n          Disposition Date cannot be older than file date.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"offenseDateAtRecordAndChargeLevel.invalid && (offenseDateAtRecordAndChargeLevel.dirty || offenseDateAtRecordAndChargeLevel.touched)\">\r\n      <span *ngIf=\"offenseDateAtRecordAndChargeLevel.hasError('noChargeLevel')\">\r\n          Must have Offense Date at Record Level and Charge Level.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"fileDateAtRecordAndChargeLevel.invalid && (fileDateAtRecordAndChargeLevel.dirty || fileDateAtRecordAndChargeLevel.touched)\">\r\n      <span *ngIf=\"fileDateAtRecordAndChargeLevel.hasError('noChargeLevel')\">\r\n          Must have File Date at Record Level and Charge Level.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"arrestDateAtRecordAndChargeLevel.invalid && (arrestDateAtRecordAndChargeLevel.dirty || arrestDateAtRecordAndChargeLevel.touched)\">\r\n      <span *ngIf=\"arrestDateAtRecordAndChargeLevel.hasError('noChargeLevel')\">\r\n          Must have Arrest  Date at Record Level and Charge Level.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"dispositionDateAtRecordAndChargeLevel.invalid && (dispositionDateAtRecordAndChargeLevel.dirty || dispositionDateAtRecordAndChargeLevel.touched)\">\r\n      <span *ngIf=\"dispositionDateAtRecordAndChargeLevel.hasError('noChargeLevel')\">\r\n          Must have Disposition Date at Record Level and Charge Level.\r\n      </span>\r\n    </div>\r\n\r\n  </section>\r\n\r\n  <section id=\"charge-meta-data-section\" class=\"flex-container\">\r\n\r\n    <div>\r\n      <label for=\"probation\" class=\"block-label\">Probation:</label>\r\n      <input id=\"probation\"\r\n             type=\"text\"\r\n             size=\"25\"\r\n             [class]=\"isOffense ? 'gray-out' : ''\"\r\n             (blur)=\"setSentenceLevel(true, false)\"\r\n             formControlName=\"probation\"\r\n             app-validateOnBlur>\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"fines\" class=\"block-label\">Fines:</label>\r\n      <input id=\"fines\"\r\n             type=\"text\"\r\n             size=\"25\"\r\n             [class]=\"isOffense ? 'gray-out' : ''\"\r\n             (blur)=\"setSentenceLevel(true, false)\"\r\n             formControlName=\"fines\"\r\n             app-validateOnBlur>\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"court-costs\" class=\"block-label\">Court Costs:</label>\r\n      <input id=\"court-costs\"\r\n             type=\"text\"\r\n             size=\"25\"\r\n             [class]=\"isOffense ? 'gray-out' : ''\"\r\n             (blur)=\"setSentenceLevel(true, false)\"\r\n             formControlName=\"courtCosts\"\r\n             app-validateOnBlur>\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"jail-time\" class=\"block-label\">Jail Time:</label>\r\n      <input id=\"jail-time\"\r\n             type=\"text\" size=\"25\"\r\n             [class]=\"isOffense ? 'gray-out' : ''\"\r\n             (blur)=\"setSentenceLevel(true, false)\"\r\n             formControlName=\"jailTime\"\r\n             app-validateOnBlur>\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"prison-time\" class=\"block-label\">Prison Time:</label>\r\n      <input id=\"prison-time\"\r\n             type=\"text\" size=\"25\"\r\n             [class]=\"isOffense ? 'gray-out' : ''\"\r\n             (blur)=\"setSentenceLevel(true, false)\"\r\n             formControlName=\"prisonTime\"\r\n             app-validateOnBlur>\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"suspension-time\" class=\"block-label\">Suspension Time:</label>\r\n      <input id=\"suspension-time\"\r\n              type=\"text\"\r\n              size=\"25\"\r\n              [class]=\"isOffense ? 'gray-out' : ''\"\r\n              (blur)=\"setSentenceLevel(true, false)\"\r\n              formControlName=\"suspensionTime\"\r\n              app-validateOnBlur>\r\n    </div>\r\n\r\n    <div>\r\n      <label for=\"next-court-date\" class=\"block-label\">Next Court Date:</label>\r\n      <input id=\"next-court-date\"\r\n             type=\"text\"\r\n             [class]=\"isOffense ? 'gray-out' : ''\"\r\n             (blur)=\"setSentenceLevel(true, false)\"\r\n             formControlName=\"nextCourtDate\"\r\n             (blur)=\"formatDate('nextCourtDate', 2000)\"\r\n             app-validateOnBlur>\r\n    </div>\r\n\r\n  </section>\r\n\r\n  <section>\r\n\r\n    <div class=\"validation\" *ngIf=\"probation.invalid && (probation.dirty || probation.touched)\">\r\n      <span *ngIf=\"probation.hasError('maxlength')\">\r\n          Probation can only be a max of 255 characters.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"fines.invalid && (fines.dirty || fines.touched)\">\r\n      <span *ngIf=\"fines.hasError('maxlength')\">\r\n          Fines can only be a max of 255 characters.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"courtCosts.invalid && (courtCosts.dirty || courtCosts.touched)\">\r\n      <span *ngIf=\"courtCosts.hasError('maxlength')\">\r\n          Court Costs can only be a max of 255 characters.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"jailTime.invalid && (jailTime.dirty || jailTime.touched)\">\r\n      <span *ngIf=\"jailTime.hasError('maxlength')\">\r\n          Jail Time can only be a max of 255 characters.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"prisonTime.invalid && (prisonTime.dirty || prisonTime.touched)\">\r\n      <span *ngIf=\"prisonTime.hasError('maxlength')\">\r\n          Prison Time can only be a max of 255 characters.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"suspensionTime.invalid && (suspensionTime.dirty || suspensionTime.touched)\">\r\n      <span *ngIf=\"suspensionTime.hasError('maxlength')\">\r\n          Suspension Time can only be a max of 255 characters.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"nextCourtDate.invalid && (nextCourtDate.dirty || nextCourtDate.touched)\">\r\n      <span *ngIf=\"nextCourtDate.hasError('isDate')\">\r\n        Next Court Date is required in format mm/dd/yy or mm/dd/yyyy.\r\n      </span>\r\n    </div>\r\n\r\n  </section>\r\n\r\n\r\n  <section id=\"comments-and-notes-section\" class=\"flex-container\">\r\n\r\n    <div class=\"inline-div\">\r\n      <label for=\"additional-comments\" class=\"block-label\">Additional Comments:</label>\r\n      <textarea id=\"additional-comments\" cols=\"120\" rows=\"4\" formControlName=\"comments\" app-validateOnBlur>\r\n      </textarea>\r\n    </div>\r\n\r\n    <div class=\"inline-div\">\r\n      <label for=\"other-sentence-notes\" class=\"block-label\">Other Sentence Notes:</label>\r\n      <textarea id=\"other-sentence-notes\"\r\n                cols=\"120\"\r\n                rows=\"4\"\r\n                [class]=\"isOffense ? 'gray-out' : ''\"\r\n                (blur)=\"setSentenceLevel(true, false)\"\r\n                formControlName=\"otherSentenceNotes\"\r\n                app-validateOnBlur>\r\n      </textarea>\r\n    </div>\r\n\r\n  </section>\r\n\r\n  <section>\r\n\r\n    <div class=\"validation\" *ngIf=\"comments.invalid && (comments.dirty || comments.touched)\">\r\n      <span *ngIf=\"comments.hasError('maxlength')\">\r\n        Comments can only be a max of 3000 characters.\r\n      </span>\r\n    </div>\r\n\r\n    <div class=\"validation\" *ngIf=\"otherSentenceNotes.invalid && (otherSentenceNotes.dirty || otherSentenceNotes.touched)\">\r\n      <span *ngIf=\"otherSentenceNotes.hasError('maxlength')\">\r\n          Other Sentence Notes can only be a max of 5000 characters.\r\n      </span>\r\n    </div>\r\n\r\n  </section>\r\n\r\n</section>\r\n\r\n\r\n<app-offense-counts [offenseRecordObject]=\"currentOffenseRecord\"\r\n                    [sentenceLevelObject]=\"offenseRecordFormGroup.controls.sentenceLevel.value\"\r\n                    (updateOffenseDates)=\"updateOffenseDates($event)\"\r\n                    (updateToCurrentRecordCharges)=\"updateToCurrentRecordCharges()\">\r\n</app-offense-counts>\r\n";

/***/ }),

/***/ "./src/app/offenseRecord/offenseRecord.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}section:first-child{-webkit-box-sizing:border-box;box-sizing:border-box}header{background-color:#ccf;color:#000;font-weight:bolder;padding:.5rem .3rem;margin:2rem 0 .4rem 0}header span{display:block;font-weight:400}header div>span:first-of-type{padding-bottom:.25rem}header>span:first-of-type{font-weight:inherit;margin-left:1rem}header a{padding-left:2rem}header a:last-of-type{margin-right:1rem}section{margin-bottom:3rem}a:link,a:visited{color:#0066cb;font-weight:400}mark{color:red;background-color:inherit}label,span{font-weight:700}a.disabled{pointer-events:none;cursor:default}a.active{pointer-events:auto;cursor:pointer}.validation{-ms-flex-line-pack:center;align-content:center;text-align:center}.validation span{font-weight:400;color:red;display:block}#required-fields-section{margin-bottom:.7rem}#required-fields-section label{color:red}#identifiers-section{margin-top:-1rem}#identifiers-section label{margin-top:1rem;font-weight:400}#identifiers-section ul{list-style:none;display:inline-block;text-align:center;-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0}#identifiers-section li{margin-top:1rem;display:inline-block;margin-left:6rem}#identifiers-section>label{font-weight:700}#identifiers-section input{vertical-align:bottom}#record-level-section section:last-child{margin-top:.7rem}#date-of-birth-section{margin-top:1rem}#date-of-birth-section label:first-child{display:block;margin-bottom:.5rem;margin-left:0}#date-of-birth-section div:nth-of-type(n+1){display:inline-block}#date-of-birth-section label{vertical-align:middle;margin-left:1rem}#date-of-birth-section label span{margin-right:.25rem}#charge-meta-data-section{margin-top:-1rem}#charge-meta-data-section div{margin-top:1rem}#comments-and-notes-section{-ms-flex-pack:distribute;justify-content:space-around;margin-top:-1rem}#comments-and-notes-section div,#comments-and-notes-section div:nth-of-type(2){margin-top:1rem}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/offenseRecord/offenseRecord.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var sentenceLevel_1 = __webpack_require__("./src/models/sentenceLevel.ts");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var offense_1 = __webpack_require__("./src/models/offense.ts");
var offenseRecord_1 = __webpack_require__("./src/models/offenseRecord.ts");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var dateHandler_1 = __webpack_require__("./src/models/dateHandler.ts");
var formControl_1 = __webpack_require__("./src/models/formControl.ts");
var popupHelper_1 = __webpack_require__("./src/models/popupHelper.ts");
var alertifyPromise_1 = __webpack_require__("./src/models/alertifyPromise.ts");
var OffenseRecordComponent = (function () {
    function OffenseRecordComponent() {
        this.updateToCurrentOffenseRecord = new core_1.EventEmitter();
        this.updateCanDeleteCurrentOffenseRecord = new core_1.EventEmitter();
        this.updateToCurrentOffenseCharges = new core_1.EventEmitter();
        this.currentOffenseRecordIndex = undefined;
        this.isNewRecord = false;
    }
    Object.defineProperty(OffenseRecordComponent.prototype, "offenseObject", {
        set: function (offense) {
            if (offense) {
                this.offense = offense;
                if (offense.offenseRecords.length > 0) {
                    this.firstOffense();
                }
                else {
                    this.addNewRecord();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "offenseRecordFormGroupObject", {
        set: function (offenseRecordFormGroup) {
            this.offenseRecordFormGroup = offenseRecordFormGroup;
            this.formControl = new formControl_1.default(this.offenseRecordFormGroup);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "isFirstActive", {
        get: function () {
            return this.firstButtonActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "isPreviousActive", {
        get: function () {
            return this.previousButtonActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "isNextActive", {
        get: function () {
            return this.nextButtonActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "isLastActive", {
        get: function () {
            return this.lastButtonActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "addNewLastActive", {
        get: function () {
            return this.addNewButtonActive;
        },
        enumerable: true,
        configurable: true
    });
    // tslint:disable-next-line: use-life-cycle-interface
    OffenseRecordComponent.prototype.ngOnChanges = function () {
        if (this.offense != null) {
            this.hasHeightenedIdentifier = this.offense.offenseSearch.isHeightenedIdentifier;
        }
    };
    Object.defineProperty(OffenseRecordComponent.prototype, "currentRecord", {
        get: function () {
            var currentRecord;
            if (this.isNewRecord) {
                currentRecord = 'This is a new record that has not been saved.';
            }
            else if (this.currentOffenseRecordIndex === undefined) {
                currentRecord = '0';
            }
            else {
                currentRecord = (this.currentOffenseRecordIndex + 1).toString();
            }
            return currentRecord;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "totalRecords", {
        get: function () {
            return this.hasOffenses ?
                (this.isNewRecord ? this.offense.offenseRecords.length - 1
                    : this.offense.offenseRecords.length).toString() : '0';
        },
        enumerable: true,
        configurable: true
    });
    OffenseRecordComponent.prototype.formatDate = function (controlName, baseCentury) {
        if (!this.formControl.hasErrorByControlName(controlName)) {
            var value = this.formControl.getValueByControlName(controlName);
            this.formControl.setValueByControlName(controlName, this.convertToDateFormat(value, baseCentury));
        }
        this.validateDates();
    };
    OffenseRecordComponent.prototype.firstOffense = function (ignoreMinOffenceRecord, ignoreUnsavedChanges) {
        if (ignoreMinOffenceRecord === void 0) { ignoreMinOffenceRecord = false; }
        if (ignoreUnsavedChanges === void 0) { ignoreUnsavedChanges = false; }
        return __awaiter(this, void 0, void 0, function () {
            var save, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((!this.onMinOffenseRecord || ignoreMinOffenceRecord) && this.hasOffenses)) return [3 /*break*/, 3];
                        save = true;
                        _a = !ignoreUnsavedChanges
                            && this.offenseRecordFormGroup.dirty;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, popupHelper_1.default.saveUnsavedChangesHelper()];
                    case 1:
                        _a = (_b.sent()) === alertifyPromise_1.ConfirmResult.Cancel;
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            save = false;
                        }
                        if (save) {
                            this.removeNewRecord();
                            this.currentOffenseRecordIndex = 0;
                            this.currentOffenseRecord = this.offense.offenseRecords[this.currentOffenseRecordIndex];
                            this.updateFormControls();
                            this.updateToCurrentOffenseRecord.emit(this.currentOffenseRecord);
                            this.updateCanDeleteCurrentOffenseRecord.emit(true);
                            this.offenseRecordFormGroup.markAsPristine();
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OffenseRecordComponent.prototype.previousOffense = function () {
        return __awaiter(this, void 0, void 0, function () {
            var save, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.onMinOffenseRecord && this.hasOffenses)) return [3 /*break*/, 3];
                        save = true;
                        _a = this.offenseRecordFormGroup.dirty;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, popupHelper_1.default.saveUnsavedChangesHelper()];
                    case 1:
                        _a = (_b.sent()) === alertifyPromise_1.ConfirmResult.Cancel;
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            save = false;
                        }
                        if (save) {
                            this.removeNewRecord();
                            this.currentOffenseRecordIndex--;
                            this.currentOffenseRecord = this.offense.offenseRecords[this.currentOffenseRecordIndex];
                            this.updateFormControls();
                            this.updateToCurrentOffenseRecord.emit(this.currentOffenseRecord);
                            this.updateCanDeleteCurrentOffenseRecord.emit(true);
                            this.offenseRecordFormGroup.markAsPristine();
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OffenseRecordComponent.prototype.nextOffense = function () {
        return __awaiter(this, void 0, void 0, function () {
            var save, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.onMaxOffenseRecord && this.hasOffenses)) return [3 /*break*/, 3];
                        save = true;
                        _a = this.offenseRecordFormGroup.dirty;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, popupHelper_1.default.saveUnsavedChangesHelper()];
                    case 1:
                        _a = (_b.sent()) === alertifyPromise_1.ConfirmResult.Cancel;
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            save = false;
                        }
                        if (save) {
                            this.removeNewRecord();
                            this.currentOffenseRecordIndex++;
                            this.currentOffenseRecord = this.offense.offenseRecords[this.currentOffenseRecordIndex];
                            this.updateFormControls();
                            this.updateToCurrentOffenseRecord.emit(this.currentOffenseRecord);
                            this.updateCanDeleteCurrentOffenseRecord.emit(true);
                            this.offenseRecordFormGroup.markAsPristine();
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OffenseRecordComponent.prototype.lastOffense = function () {
        return __awaiter(this, void 0, void 0, function () {
            var save, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.onMaxOffenseRecord && this.hasOffenses)) return [3 /*break*/, 3];
                        save = true;
                        _a = this.offenseRecordFormGroup.dirty;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, popupHelper_1.default.saveUnsavedChangesHelper()];
                    case 1:
                        _a = (_b.sent()) === alertifyPromise_1.ConfirmResult.Cancel;
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            save = false;
                        }
                        if (save) {
                            this.removeNewRecord();
                            this.currentOffenseRecordIndex = this.getMaxOffenseRecords();
                            this.currentOffenseRecord = this.offense.offenseRecords[this.currentOffenseRecordIndex];
                            this.updateFormControls();
                            this.updateToCurrentOffenseRecord.emit(this.currentOffenseRecord);
                            this.updateCanDeleteCurrentOffenseRecord.emit(true);
                            this.offenseRecordFormGroup.markAsPristine();
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OffenseRecordComponent.prototype.addNewRecord = function (ignoreUnsavedChanges) {
        if (ignoreUnsavedChanges === void 0) { ignoreUnsavedChanges = false; }
        return __awaiter(this, void 0, void 0, function () {
            var save, _a, maxOffenceNumber;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        save = true;
                        _a = !ignoreUnsavedChanges
                            && this.offenseRecordFormGroup.dirty;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, popupHelper_1.default.saveUnsavedChangesHelper()];
                    case 1:
                        _a = (_b.sent()) === alertifyPromise_1.ConfirmResult.Cancel;
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            save = false;
                        }
                        if (save) {
                            maxOffenceNumber = this.getNewOffenseNumber();
                            this.currentOffenseRecord = offenseRecord_1.default.createNewOffenseRecord(this.requestNumber, maxOffenceNumber);
                            this.offense.offenseRecords.push(this.currentOffenseRecord);
                            this.currentOffenseRecordIndex = this.getMaxOffenseRecords();
                            this.isNewRecord = true;
                            this.updateFormControls();
                            this.updateToCurrentOffenseRecord.emit(this.currentOffenseRecord);
                            this.updateCanDeleteCurrentOffenseRecord.emit(false);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    OffenseRecordComponent.prototype.setSentenceLevel = function (isUiCalling, changeControlState) {
        var hasProbation = this.formControl.hasValueByControlName('probation');
        var hasFines = this.formControl.hasValueByControlName('fines');
        var hasCourtCosts = this.formControl.hasValueByControlName('courtCosts');
        var hasJailTime = this.formControl.hasValueByControlName('jailTime');
        var hasPrisonTime = this.formControl.hasValueByControlName('prisonTime');
        var hasSuspensionTime = this.formControl.hasValueByControlName('suspensionTime');
        var hasNextCourtDate = this.formControl.hasValueByControlName('nextCourtDate');
        var hasOtherSentenceNotes = this.formControl.hasValueByControlName('otherSentenceNotes');
        var lockSentenceLevel = hasProbation || hasFines || hasCourtCosts || hasJailTime
            || hasPrisonTime || hasSuspensionTime || hasNextCourtDate || hasOtherSentenceNotes;
        if (!isUiCalling) {
            if (lockSentenceLevel) {
                this.formControl.setValueByControlName('sentenceLevel', sentenceLevel_1.SentenceLevel.Record.toString());
                this.isOffense = false;
            }
            else {
                this.formControl.setValueByControlName('sentenceLevel', sentenceLevel_1.SentenceLevel.Offense.toString());
                this.isOffense = true;
            }
        }
        else {
            var sentenceLevel = this.formControl.getNumberByControlName('sentenceLevel');
            this.isOffense = sentenceLevel === sentenceLevel_1.SentenceLevel.Offense;
        }
        if (changeControlState) {
            if (this.isOffense) {
                this.formControl.disableControlByControlName('probation');
                this.formControl.disableControlByControlName('fines');
                this.formControl.disableControlByControlName('courtCosts');
                this.formControl.disableControlByControlName('jailTime');
                this.formControl.disableControlByControlName('prisonTime');
                this.formControl.disableControlByControlName('suspensionTime');
                this.formControl.disableControlByControlName('nextCourtDate');
                this.formControl.disableControlByControlName('otherSentenceNotes');
                this.formControl.enableControlByControlName('sentenceLevel');
            }
            else {
                this.formControl.enableControlByControlName('probation');
                this.formControl.enableControlByControlName('fines');
                this.formControl.enableControlByControlName('courtCosts');
                this.formControl.enableControlByControlName('jailTime');
                this.formControl.enableControlByControlName('prisonTime');
                this.formControl.enableControlByControlName('suspensionTime');
                this.formControl.enableControlByControlName('nextCourtDate');
                this.formControl.enableControlByControlName('otherSentenceNotes');
            }
        }
        if (lockSentenceLevel) {
            this.formControl.disableControlByControlName('sentenceLevel');
        }
        else {
            this.formControl.enableControlByControlName('sentenceLevel');
        }
    };
    OffenseRecordComponent.prototype.updateToCurrentRecordCharges = function () {
        this.offenseRecordFormGroup.markAsDirty();
        this.updateToCurrentOffenseCharges.emit();
    };
    OffenseRecordComponent.prototype.removeNewRecord = function () {
        if (this.isNewRecord) {
            this.offense.offenseRecords.pop();
            this.isNewRecord = false;
        }
    };
    OffenseRecordComponent.prototype.handleRecordNavigationButtons = function () {
        this.firstButtonActive = true;
        this.previousButtonActive = true;
        this.nextButtonActive = true;
        this.lastButtonActive = true;
        if (this.currentOffenseRecordIndex === 0) {
            this.firstButtonActive = false;
            this.previousButtonActive = false;
        }
        if (this.offense.offenseRecords.length - 1 === this.currentOffenseRecordIndex) {
            this.nextButtonActive = false;
            this.lastButtonActive = false;
        }
        this.addNewButtonActive = !this.isNewRecord;
    };
    OffenseRecordComponent.prototype.validateDates = function () {
        var offenseDate = this.formControl.getDateByControlName('offenseDate');
        var fileDate = this.formControl.getDateByControlName('fileDate');
        var arrestDate = this.formControl.getDateByControlName('arrestDate');
        var dispositionDate = this.formControl.getDateByControlName('dispositionDate');
        var offenseChargeDates = this.currentOffenseRecord.charges
            .filter(function (c) { return c.offenseDate != null; })
            .map(function (c) { return c.offenseDate; });
        var fileChargeDates = this.currentOffenseRecord.charges
            .filter(function (c) { return c.fileDate != null; })
            .map(function (c) { return c.fileDate; });
        var arrestChargeDates = this.currentOffenseRecord.charges
            .filter(function (c) { return c.arrestDate != null; })
            .map(function (c) { return c.arrestDate; });
        var dispositionChargeDates = this.currentOffenseRecord.charges
            .filter(function (c) { return c.dispositionDate != null; })
            .map(function (c) { return c.dispositionDate; });
        var today = new Date();
        today.setHours(0, 0, 0, 0);
        if (offenseDate !== null && offenseDate > today) {
            this.formControl.setValidationErrorByControlName('offenseDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('offenseDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        if (fileDate !== null && fileDate > today) {
            this.formControl.setValidationErrorByControlName('fileDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('fileDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        if (arrestDate !== null && arrestDate > today) {
            this.formControl.setValidationErrorByControlName('arrestDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('arrestDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        if (dispositionDate !== null && dispositionDate > today) {
            this.formControl.setValidationErrorByControlName('dispositionDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('dispositionDateGreaterThanCurrentDate', 'greaterThanCurrentDate');
        }
        if (offenseDate !== null && fileDate !== null && offenseDate > fileDate) {
            this.formControl.setValidationErrorByControlName('fileDateDateOlderThanOffenseDate', 'olderThan');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('fileDateDateOlderThanOffenseDate', 'olderThan');
        }
        if (offenseDate !== null && dispositionDate !== null && offenseDate > dispositionDate) {
            this.formControl.setValidationErrorByControlName('dispositionDateOlderThanOffenseDate', 'olderThan');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('dispositionDateOlderThanOffenseDate', 'olderThan');
        }
        if (fileDate !== null && dispositionDate !== null && fileDate > dispositionDate) {
            this.formControl.setValidationErrorByControlName('dispositionDateOlderThanFileDate', 'olderThan');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('dispositionDateOlderThanFileDate', 'olderThan');
        }
        if (offenseDate !== null && !offenseChargeDates.some(function (c) { return c.getTime() === offenseDate.getTime(); })) {
            this.formControl.setValidationErrorByControlName('offenseDateAtRecordAndChargeLevel', 'noChargeLevel');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('offenseDateAtRecordAndChargeLevel', 'noChargeLevel');
        }
        if (fileDate !== null && !fileChargeDates.some(function (c) { return c.getTime() === fileDate.getTime(); })) {
            this.formControl.setValidationErrorByControlName('fileDateAtRecordAndChargeLevel', 'noChargeLevel');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('fileDateAtRecordAndChargeLevel', 'noChargeLevel');
        }
        if (arrestDate !== null && !arrestChargeDates.some(function (c) { return c.getTime() === arrestDate.getTime(); })) {
            this.formControl.setValidationErrorByControlName('arrestDateAtRecordAndChargeLevel', 'noChargeLevel');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('arrestDateAtRecordAndChargeLevel', 'noChargeLevel');
        }
        if (dispositionDate !== null && !dispositionChargeDates.some(function (c) { return c.getTime() === dispositionDate.getTime(); })) {
            this.formControl.setValidationErrorByControlName('dispositionDateAtRecordAndChargeLevel', 'noChargeLevel');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('dispositionDateAtRecordAndChargeLevel', 'noChargeLevel');
        }
    };
    OffenseRecordComponent.prototype.validateIdentifier = function () {
        var hasNameIdentifier = this.formControl.getBooleanByControlName('hasNameIdentifier');
        var hasDobIdentifier = this.formControl.getBooleanByControlName('hasDobIdentifier');
        var hasSsnIdentifier = this.formControl.getBooleanByControlName('hasSsnIdentifier');
        var hasSinIdentifier = this.formControl.getBooleanByControlName('hasSinIdentifier');
        var hasAddressIdentifier = this.formControl.getBooleanByControlName('hasAddressIdentifier');
        var hasDlnIdentifier = this.formControl.getBooleanByControlName('hasDlnIdentifier');
        var dobType = this.formControl.getValueByControlName('dobType');
        var isHeightenedIdentifier = this.offense.offenseSearch.isHeightenedIdentifier;
        var identifierCount = 0;
        if (hasNameIdentifier) {
            identifierCount++;
        }
        if (hasDobIdentifier) {
            identifierCount++;
        }
        if (hasSsnIdentifier) {
            identifierCount++;
        }
        if (hasSinIdentifier) {
            identifierCount++;
        }
        if (hasAddressIdentifier) {
            identifierCount++;
        }
        if (hasDlnIdentifier) {
            identifierCount++;
        }
        if ('no-dob' === dobType && hasDobIdentifier) {
            this.formControl.setValidationErrorByControlName('hasIdentifier', 'dobIdentifierWithDobNotListed');
        }
        else if (isHeightenedIdentifier && identifierCount < 1) {
            this.formControl.setValidationErrorByControlName('hasIdentifier', 'hasAdditionalIdentifier');
        }
        else if (!isHeightenedIdentifier && !hasNameIdentifier && !hasDobIdentifier
            && !hasSsnIdentifier && !hasSinIdentifier
            && !hasAddressIdentifier && !hasDlnIdentifier) {
            this.formControl.setValidationErrorByControlName('hasIdentifier', 'hasIdentifier');
        }
        else {
            this.formControl.clearValidatorErrorByControlName('hasIdentifier', 'hasIdentifier');
        }
    };
    OffenseRecordComponent.prototype.validateDob = function () {
        var dobType = this.formControl.getValueByControlName('dobType');
        if ('full-dob' === dobType) {
            var month = this.formControl.getValueByControlName('month');
            var day = this.formControl.getValueByControlName('day');
            var year = this.formControl.getValueByControlName('year');
            var dob = new dateHandler_1.default("" + month + day + year, 1900);
            var monthAndDay = "" + month + day;
            if (monthAndDay.length !== 4 || !dob.isValid) {
                this.formControl.setValidationErrorByControlName('fullDobValidator', 'isFullDobDate');
            }
            else {
                this.formControl.setValueByControlName('year', dob.year);
                this.formControl.clearValidatorErrorByControlName('fullDobValidator', 'isFullDobDate');
            }
        }
        else if ('partial-dob' === dobType) {
            var month = this.formControl.getValueByControlName('month');
            var day = this.formControl.getValueByControlName('day');
            var year = this.formControl.getValueByControlName('year');
            if (((month.length > 0 && !month.match(/^-?\d+$/))
                || (day.length > 0 && !day.match(/^-?\d+$/))
                || (year.length > 0 && !year.match(/^-?\d+$/)))
                || month.length === 0 && day.length === 0 && year.length === 0) {
                this.formControl.setValidationErrorByControlName('partialDobValidator', 'isPartialDate');
            }
            else {
                this.formControl.clearValidatorErrorByControlName('partialDobValidator', 'isPartialDate');
            }
        }
        this.validateIdentifier();
    };
    OffenseRecordComponent.prototype.checkIfDisableDob = function () {
        var dobType = this.formControl.getValueByControlName('dobType');
        if ('no-dob' === dobType) {
            this.formControl.setValueByControlName('month', '');
            this.formControl.setValueByControlName('day', '');
            this.formControl.setValueByControlName('year', '');
            this.formControl.getControlByControlName('month').disable();
            this.formControl.getControlByControlName('day').disable();
            this.formControl.getControlByControlName('year').disable();
            this.formControl.clearValidatorErrorByControlName('fullDobValidator', 'isFullDobDate');
            this.formControl.clearValidatorErrorByControlName('partialDobValidator', 'isPartialDate');
        }
        else if ('full-dob' === dobType) {
            this.formControl.getControlByControlName('month').enable();
            this.formControl.getControlByControlName('day').enable();
            this.formControl.getControlByControlName('year').enable();
            this.validateDob();
            this.formControl.clearValidatorErrorByControlName('partialDobValidator', 'isPartialDate');
            this.formControl.clearValidatorErrorByControlName('hasIdentifier', 'dobIdentifierWithDobNotListed');
        }
        else {
            this.formControl.getControlByControlName('month').enable();
            this.formControl.getControlByControlName('day').enable();
            this.formControl.getControlByControlName('year').enable();
            this.validateDob();
            this.formControl.clearValidatorErrorByControlName('fullDobValidator', 'isFullDobDate');
            this.formControl.clearValidatorErrorByControlName('hasIdentifier', 'dobIdentifierWithDobNotListed');
        }
        this.validateIdentifier();
    };
    OffenseRecordComponent.prototype.updateOffenseDates = function (offenseDates) {
        this.formControl.setValueByControlName('offenseDate', offenseDates.offenseDate);
        this.formControl.setValueByControlName('fileDate', offenseDates.fileDate);
        this.formControl.setValueByControlName('arrestDate', offenseDates.arrestDate);
        this.formControl.setValueByControlName('dispositionDate', offenseDates.dispositionDate);
        this.validateDates();
    };
    OffenseRecordComponent.prototype.saveCompletedSuccessfully = function () {
        this.isNewRecord = false;
        this.handleRecordNavigationButtons();
        this.updateCurrentOffense();
        this.updateCanDeleteCurrentOffenseRecord.emit(true);
    };
    OffenseRecordComponent.prototype.deleteSuccessfully = function () {
        if (this.offense.offenseRecords.length > 0) {
            this.firstOffense(true, true);
        }
        else {
            this.addNewRecord(true);
        }
    };
    OffenseRecordComponent.prototype.setFocusForDobMismatch = function () {
        this.dobMonthElement.nativeElement.focus();
    };
    OffenseRecordComponent.prototype.updateFormControls = function () {
        this.formControl.setValueByControlName('hasNameIdentifier', this.currentOffenseRecord.hasNameIdentifier);
        this.formControl.setValueByControlName('hasDobIdentifier', this.currentOffenseRecord.hasDobIdentifier);
        this.formControl.setValueByControlName('hasSsnIdentifier', this.currentOffenseRecord.hasSsnIdentifier);
        this.formControl.setValueByControlName('hasSinIdentifier', this.currentOffenseRecord.hasSinIdentifier);
        this.formControl.setValueByControlName('hasAddressIdentifier', this.currentOffenseRecord.hasAddressIdentifier);
        this.formControl.setValueByControlName('hasDlnIdentifier', this.currentOffenseRecord.hasDlnIdentifier);
        this.validateIdentifier();
        this.formControl.setValueByControlName('hasFaxInformation', this.currentOffenseRecord.hasFaxInformation);
        this.formControl.setValueByControlName('courtRecordedFullName', this.currentOffenseRecord.courtRecordFullName);
        this.formControl.setValueByControlName('nameDiffers', this.currentOffenseRecord.nameDiffers);
        this.formControl.setValueByControlName('referenceNumber', this.currentOffenseRecord.referenceNumber);
        if (this.currentOffenseRecord.hasPartialDobIdentifier) {
            this.formControl.setValueByControlName('dobType', 'partial-dob');
            this.formControl.setValueByControlName('month', this.currentOffenseRecord.partialMonth);
            this.formControl.setValueByControlName('day', this.currentOffenseRecord.partialDay);
            this.formControl.setValueByControlName('year', this.currentOffenseRecord.partialYear);
        }
        else if (this.currentOffenseRecord.hasNoDobIdentifier) {
            this.formControl.setValueByControlName('dobType', 'no-dob');
        }
        else {
            this.formControl.setValueByControlName('dobType', 'full-dob');
            var dob = new dateHandler_1.default(this.currentOffenseRecord.courtRecordDob, 1900);
            this.formControl.setValueByControlName('month', dob.month);
            this.formControl.setValueByControlName('day', dob.day);
            this.formControl.setValueByControlName('year', dob.year);
        }
        this.checkIfDisableDob();
        this.formControl.setValueByControlName('offenseDate', this.convertToDateFormat(this.currentOffenseRecord.offenseDate, 2000));
        this.formControl.setValueByControlName('fileDate', this.convertToDateFormat(this.currentOffenseRecord.fileDate, 2000));
        this.formControl.setValueByControlName('arrestDate', this.convertToDateFormat(this.currentOffenseRecord.arrestDate, 2000));
        this.formControl.setValueByControlName('dispositionDate', this.convertToDateFormat(this.currentOffenseRecord.dispositionDate, 2000));
        this.validateDates();
        this.formControl.setValueByControlName('probation', this.currentOffenseRecord.probation);
        this.formControl.setValueByControlName('fines', this.currentOffenseRecord.fines);
        this.formControl.setValueByControlName('courtCosts', this.currentOffenseRecord.courtCosts);
        this.formControl.setValueByControlName('jailTime', this.currentOffenseRecord.jailTime);
        this.formControl.setValueByControlName('prisonTime', this.currentOffenseRecord.prisonTime);
        this.formControl.setValueByControlName('suspensionTime', this.currentOffenseRecord.suspensionTime);
        this.formControl.setValueByControlName('nextCourtDate', this.convertToDateFormat(this.currentOffenseRecord.nextCourtDate, 2000));
        this.formControl.setValueByControlName('comments', this.currentOffenseRecord.comments);
        this.formControl.setValueByControlName('otherSentenceNotes', this.currentOffenseRecord.otherSentenceNotes);
        this.handleRecordNavigationButtons();
        this.setSentenceLevel(false, true);
    };
    OffenseRecordComponent.prototype.updateCurrentOffense = function () {
        if (this.currentOffenseRecordIndex !== undefined) {
            this.currentOffenseRecord.hasNameIdentifier = this.formControl.getBooleanByControlName('hasNameIdentifier');
            this.currentOffenseRecord.hasDobIdentifier = this.formControl.getBooleanByControlName('hasDobIdentifier');
            this.currentOffenseRecord.hasSsnIdentifier = this.formControl.getBooleanByControlName('hasSsnIdentifier');
            this.currentOffenseRecord.hasSinIdentifier = this.formControl.getBooleanByControlName('hasSinIdentifier');
            this.currentOffenseRecord.hasAddressIdentifier = this.formControl.getBooleanByControlName('hasAddressIdentifier');
            this.currentOffenseRecord.hasDlnIdentifier = this.formControl.getBooleanByControlName('hasDlnIdentifier');
            this.currentOffenseRecord.hasFaxInformation = this.formControl.getBooleanByControlName('hasFaxInformation');
            this.currentOffenseRecord.courtRecordFullName = this.formControl.getValueByControlName('courtRecordedFullName');
            this.currentOffenseRecord.nameDiffers = this.formControl.getBooleanByControlName('nameDiffers');
            this.currentOffenseRecord.referenceNumber = this.formControl.getValueByControlName('referenceNumber');
            var dobType = this.formControl.getValueByControlName('dobType');
            this.currentOffenseRecord.hasNoDobIdentifier = 'no-dob' === dobType;
            this.currentOffenseRecord.hasPartialDobIdentifier = 'partial-dob' === dobType;
            if ('partial-dob' === dobType || 'full-dob' === dobType) {
                var month = this.formControl.getValueByControlName('month');
                var day = this.formControl.getValueByControlName('day');
                var year = this.formControl.getValueByControlName('year');
                if (this.currentOffenseRecord.hasPartialDobIdentifier) {
                    this.currentOffenseRecord.partialMonth = month;
                    this.currentOffenseRecord.partialDay = day;
                    this.currentOffenseRecord.partialYear = year;
                }
                else {
                    this.currentOffenseRecord.courtRecordDob = new Date(month + "/" + day + "/" + year);
                }
            }
            this.currentOffenseRecord.offenseDate = new Date(this.formControl.getValueByControlName('offenseDate'));
            this.currentOffenseRecord.fileDate = new Date(this.formControl.getValueByControlName('fileDate'));
            this.currentOffenseRecord.arrestDate = new Date(this.formControl.getValueByControlName('arrestDate'));
            this.currentOffenseRecord.dispositionDate = new Date(this.formControl.getValueByControlName('dispositionDate'));
            this.currentOffenseRecord.probation = this.formControl.getValueByControlName('probation');
            this.currentOffenseRecord.fines = this.formControl.getValueByControlName('fines');
            this.currentOffenseRecord.courtCosts = this.formControl.getValueByControlName('courtCosts');
            this.currentOffenseRecord.jailTime = this.formControl.getValueByControlName('jailTime');
            this.currentOffenseRecord.prisonTime = this.formControl.getValueByControlName('prisonTime');
            this.currentOffenseRecord.suspensionTime = this.formControl.getValueByControlName('suspensionTime');
            this.currentOffenseRecord.nextCourtDate = new Date(this.formControl.getValueByControlName('nextCourtDate'));
            this.currentOffenseRecord.comments = this.formControl.getValueByControlName('comments');
            this.currentOffenseRecord.otherSentenceNotes = this.formControl.getValueByControlName('otherSentenceNotes');
        }
    };
    Object.defineProperty(OffenseRecordComponent.prototype, "onMinOffenseRecord", {
        get: function () {
            return this.hasOffenses && this.currentOffenseRecordIndex === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "onMaxOffenseRecord", {
        get: function () {
            return this.hasOffenses && this.currentOffenseRecordIndex >= this.offense.offenseRecords.length - 1;
        },
        enumerable: true,
        configurable: true
    });
    OffenseRecordComponent.prototype.getMaxOffenseRecords = function () {
        return this.hasOffenses ? this.offense.offenseRecords.length - 1 : null;
    };
    OffenseRecordComponent.prototype.getNewOffenseNumber = function () {
        var offenseNumber = 1;
        if (this.hasOffenses && this.offense.offenseRecords.length > 0) {
            offenseNumber = Math.max.apply(Math, this.offense.offenseRecords.map(function (or) { return or.offenseNumber; })) + 1;
        }
        return offenseNumber;
    };
    Object.defineProperty(OffenseRecordComponent.prototype, "hasOffenses", {
        get: function () {
            return this.offense !== null && this.offense !== undefined && this.offense !== null && this.offense.offenseRecords !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    OffenseRecordComponent.prototype.convertToDateFormat = function (date, baseCentury) {
        return new dateHandler_1.default(date, baseCentury).format();
    };
    Object.defineProperty(OffenseRecordComponent.prototype, "sentenceLevel", {
        get: function () { return this.offenseRecordFormGroup.get('sentenceLevel'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "hasIdentifier", {
        get: function () { return this.offenseRecordFormGroup.get('hasIdentifier'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "hasNameIdentifier", {
        get: function () { return this.offenseRecordFormGroup.get('hasNameIdentifier'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "hasDobIdentifier", {
        get: function () { return this.offenseRecordFormGroup.get('hasDobIdentifier'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "hasSsnIdentifier", {
        get: function () { return this.offenseRecordFormGroup.get('hasSsnIdentifier'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "hasSinIdentifier", {
        get: function () { return this.offenseRecordFormGroup.get('hasSinIdentifier'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "hasAddressIdentifier", {
        get: function () { return this.offenseRecordFormGroup.get('hasAddressIdentifier'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "hasDlnIdentifier", {
        get: function () { return this.offenseRecordFormGroup.get('hasDlnIdentifier'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "courtRecordedFullName", {
        get: function () { return this.offenseRecordFormGroup.get('courtRecordedFullName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "nameDiffers", {
        get: function () { return this.offenseRecordFormGroup.get('nameDiffers'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "referenceNumber", {
        get: function () { return this.offenseRecordFormGroup.get('referenceNumber'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "dobType", {
        get: function () { return this.offenseRecordFormGroup.get('dobType'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "month", {
        get: function () { return this.offenseRecordFormGroup.get('month'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "day", {
        get: function () { return this.offenseRecordFormGroup.get('day'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "year", {
        get: function () { return this.offenseRecordFormGroup.get('year'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "fullDobValidator", {
        get: function () { return this.offenseRecordFormGroup.get('fullDobValidator'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "partialDobValidator", {
        get: function () { return this.offenseRecordFormGroup.get('partialDobValidator'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "offenseDate", {
        get: function () { return this.offenseRecordFormGroup.get('offenseDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "fileDate", {
        get: function () { return this.offenseRecordFormGroup.get('fileDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "arrestDate", {
        get: function () { return this.offenseRecordFormGroup.get('arrestDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "dispositionDate", {
        get: function () { return this.offenseRecordFormGroup.get('dispositionDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "hasRequiredDate", {
        get: function () { return this.offenseRecordFormGroup.get('hasRequiredDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "offenseDateGreaterThanCurrentDate", {
        get: function () { return this.offenseRecordFormGroup.get('offenseDateGreaterThanCurrentDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "fileDateGreaterThanCurrentDate", {
        get: function () { return this.offenseRecordFormGroup.get('fileDateGreaterThanCurrentDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "arrestDateGreaterThanCurrentDate", {
        get: function () { return this.offenseRecordFormGroup.get('arrestDateGreaterThanCurrentDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "dispositionDateGreaterThanCurrentDate", {
        get: function () { return this.offenseRecordFormGroup.get('dispositionDateGreaterThanCurrentDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "fileDateDateOlderThanOffenseDate", {
        get: function () { return this.offenseRecordFormGroup.get('fileDateDateOlderThanOffenseDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "dispositionDateOlderThanOffenseDate", {
        get: function () { return this.offenseRecordFormGroup.get('dispositionDateOlderThanOffenseDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "dispositionDateOlderThanFileDate", {
        get: function () { return this.offenseRecordFormGroup.get('dispositionDateOlderThanFileDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "offenseDateAtRecordAndChargeLevel", {
        get: function () { return this.offenseRecordFormGroup.get('offenseDateAtRecordAndChargeLevel'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "fileDateAtRecordAndChargeLevel", {
        get: function () { return this.offenseRecordFormGroup.get('fileDateAtRecordAndChargeLevel'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "arrestDateAtRecordAndChargeLevel", {
        get: function () { return this.offenseRecordFormGroup.get('arrestDateAtRecordAndChargeLevel'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "dispositionDateAtRecordAndChargeLevel", {
        get: function () { return this.offenseRecordFormGroup.get('dispositionDateAtRecordAndChargeLevel'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "probation", {
        get: function () { return this.offenseRecordFormGroup.get('probation'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "fines", {
        get: function () { return this.offenseRecordFormGroup.get('fines'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "courtCosts", {
        get: function () { return this.offenseRecordFormGroup.get('courtCosts'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "jailTime", {
        get: function () { return this.offenseRecordFormGroup.get('jailTime'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "prisonTime", {
        get: function () { return this.offenseRecordFormGroup.get('prisonTime'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "suspensionTime", {
        get: function () { return this.offenseRecordFormGroup.get('suspensionTime'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "nextCourtDate", {
        get: function () { return this.offenseRecordFormGroup.get('nextCourtDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "comments", {
        get: function () { return this.offenseRecordFormGroup.get('comments'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecordComponent.prototype, "otherSentenceNotes", {
        get: function () { return this.offenseRecordFormGroup.get('otherSentenceNotes'); },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], OffenseRecordComponent.prototype, "updateToCurrentOffenseRecord", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], OffenseRecordComponent.prototype, "updateCanDeleteCurrentOffenseRecord", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", Object)
    ], OffenseRecordComponent.prototype, "updateToCurrentOffenseCharges", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], OffenseRecordComponent.prototype, "requestNumber", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", typeof (_a = typeof offense_1.default !== "undefined" && offense_1.default) === "function" && _a || Object),
        __metadata("design:paramtypes", [typeof (_b = typeof offense_1.default !== "undefined" && offense_1.default) === "function" && _b || Object])
    ], OffenseRecordComponent.prototype, "offenseObject", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", typeof (_c = typeof forms_1.FormGroup !== "undefined" && forms_1.FormGroup) === "function" && _c || Object),
        __metadata("design:paramtypes", [typeof (_d = typeof forms_1.FormGroup !== "undefined" && forms_1.FormGroup) === "function" && _d || Object])
    ], OffenseRecordComponent.prototype, "offenseRecordFormGroupObject", null);
    __decorate([
        core_1.ViewChild('dobMonth'),
        __metadata("design:type", typeof (_e = typeof core_1.ElementRef !== "undefined" && core_1.ElementRef) === "function" && _e || Object)
    ], OffenseRecordComponent.prototype, "dobMonthElement", void 0);
    OffenseRecordComponent = __decorate([
        core_1.Component({
            selector: 'app-offense-record',
            template: __webpack_require__("./src/app/offenseRecord/offenseRecord.component.html"),
            styles: [__webpack_require__("./src/app/offenseRecord/offenseRecord.component.scss")]
        })
    ], OffenseRecordComponent);
    return OffenseRecordComponent;
    var _a, _b, _c, _d, _e;
}());
exports.default = OffenseRecordComponent;
//# sourceMappingURL=offenseRecord.component.js.map

/***/ }),

/***/ "./src/app/offenseSearch/offenseSearch.component.html":
/***/ (function(module, exports) {

module.exports = "<section [formGroup]=\"offenseSearchFormGroup\">\r\n  <header>SEARCH INFORMATION</header>\r\n\r\n  <section id=\"first-section\">\r\n\r\n    <div>\r\n      <label>Work Order:</label>\r\n      <span> {{offense?.offenseSearch?.caseNumber}}</span>\r\n    </div>\r\n\r\n    <div>\r\n      <label>Name:</label>\r\n      <span>{{offense?.offenseSearch?.fullName}}</span>\r\n    </div>\r\n\r\n    <div>\r\n      <label>Address:</label>\r\n      <span>\r\n        {{offense?.offenseSearch?.address1}},\r\n        {{offense?.offenseSearch?.city}},\r\n        {{offense?.offenseSearch?.state}}\r\n        {{offense?.offenseSearch?.zip}}\r\n      </span>\r\n    </div>\r\n\r\n    <div>\r\n      <label>Work State:</label>\r\n      <span [class.text-alert]=\"offense?.offenseSearch?.isRestrictedState\">{{offense?.offenseSearch?.workState}}</span>\r\n      <span id=\"restricted-state\" class=\"text-alert\" *ngIf=\"offense?.offenseSearch?.isRestrictedState\"> (Restricted)</span>\r\n    </div>\r\n\r\n  </section>\r\n\r\n  <section id=\"second-section\">\r\n\r\n    <div>\r\n\r\n      <div>\r\n        <label>DOB:</label>\r\n        <span>{{offense?.offenseSearch?.dob | date: 'MM/dd/yyyy'}}</span>\r\n      </div>\r\n\r\n      <div>\r\n        <label>SSN:</label>\r\n        <span>{{offense?.offenseSearch?.socialSecurityNumber}}</span>\r\n      </div>\r\n\r\n      <div>\r\n        <label>Driver License:</label>\r\n        <span>{{offense?.offenseSearch?.licenseNumber}}</span>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <div>\r\n\r\n      <div>\r\n        <label>Jurisdiction:</label>\r\n        <span>{{offense?.offenseSearch?.jurisdiction}}</span>\r\n      </div>\r\n\r\n      <div>\r\n        <label>Search Dates:</label>\r\n        <span>{{offense?.offenseSearch?.searchFromDate}} - {{offense?.offenseSearch?.searchToDate}}</span>\r\n      </div>\r\n\r\n    </div>\r\n\r\n  </section>\r\n\r\n  <section>\r\n    <input type=\"checkbox\"\r\n      for=\"admittted-crim-not-found\"\r\n      formControlName=\"admittedCrimeNotFound\">\r\n    <label id=\"admittted-crim-not-found\">Admitted Crime Not Found</label>\r\n  </section>\r\n\r\n  <section>\r\n    <button type=\"button\"\r\n            (click)=\"workOrderComplete()\"\r\n            [disabled]=\"offensePageForm.invalid || !canWorkOrderComplete\">\r\n      Work Order Complete\r\n    </button>\r\n    <button (click)=\"goBackToTaskList()\" type=\"button\">Return to Task List</button>\r\n  </section>\r\n\r\n</section>\r\n";

/***/ }),

/***/ "./src/app/offenseSearch/offenseSearch.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}header{background-color:#ccf;padding:.25rem .3rem;color:#000;font-weight:bolder;margin:1rem 0 1rem 0}label:not(#admittted-crim-not-found){font-weight:700}button{margin-top:1.5rem;background-color:#ccf;font-family:Verdana,Tahoma,Arial;margin-right:auto;margin-left:auto;width:17rem;font-size:1rem;padding-top:.2rem;padding-bottom:.2rem}#first-section div:first-child{margin:.7rem 0}#first-section div:not(:nth-child(-n+1)){margin-top:.3rem}#second-section{margin-top:.7rem;display:table;width:70%}#second-section>div:last-of-type div{padding-top:.7rem;padding-bottom:2rem}#second-section div{display:table-row}#second-section div div{display:table-cell}#second-section div div label{width:15rem;display:inline-block}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/offenseSearch/offenseSearch.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var offense_1 = __webpack_require__("./src/models/offense.ts");
var offenseService_1 = __webpack_require__("./src/services/offenseService.ts");
var browserWindowObjectService_1 = __webpack_require__("./src/services/browserWindowObjectService.ts");
var complianceAuditLogService_1 = __webpack_require__("./src/services/complianceAuditLogService.ts");
var formControl_1 = __webpack_require__("./src/models/formControl.ts");
var complianceAuditLog_1 = __webpack_require__("./src/models/complianceAuditLog.ts");
var OffenseSearchComponent = (function () {
    function OffenseSearchComponent(offenseService, complianceAuditLogService, router, browserWindowObjectService) {
        this.offenseService = offenseService;
        this.complianceAuditLogService = complianceAuditLogService;
        this.router = router;
        this.browserWindowObjectService = browserWindowObjectService;
        this.canWorkOrderComplete = false;
    }
    OffenseSearchComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(OffenseSearchComponent.prototype, "offenseObject", {
        set: function (offense) {
            if (offense) {
                this.offense = offense;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseSearchComponent.prototype, "offenseSearchFormGroupObject", {
        set: function (offenseSearchFormGroup) {
            this.offenseSearchFormGroup = offenseSearchFormGroup;
            this.formControl = new formControl_1.default(this.offenseSearchFormGroup);
        },
        enumerable: true,
        configurable: true
    });
    OffenseSearchComponent.prototype.workOrderComplete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var admittedCrimeNotFound, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        admittedCrimeNotFound = this.formControl.getBooleanByControlName('admittedCrimeNotFound');
                        if (!admittedCrimeNotFound) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.complianceAuditLogService.addComplianceAuditLogs([
                                new complianceAuditLog_1.default(this.offense.offenseSearch.requestNumber, 'ADMTTD_CRM_NOT_FND', 'OFFENCEPG', null, null)
                            ])];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.offenseService.workOrderComplete(this.offense.offenseSearch.requestNumber, admittedCrimeNotFound)
                            .subscribe(function (object) {
                            if (object === null) {
                                _this.router.navigate(['navigation']);
                            }
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OffenseSearchComponent.prototype.goBackToTaskList = function () {
        this.browserWindowObjectService.goBackOnePage();
    };
    Object.defineProperty(OffenseSearchComponent.prototype, "admittedCrimeNotFound", {
        get: function () { return this.offenseSearchFormGroup.get('admittedCrimeNotFound'); },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", typeof (_a = typeof offense_1.default !== "undefined" && offense_1.default) === "function" && _a || Object),
        __metadata("design:paramtypes", [typeof (_b = typeof offense_1.default !== "undefined" && offense_1.default) === "function" && _b || Object])
    ], OffenseSearchComponent.prototype, "offenseObject", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", typeof (_c = typeof forms_1.FormGroup !== "undefined" && forms_1.FormGroup) === "function" && _c || Object),
        __metadata("design:paramtypes", [typeof (_d = typeof forms_1.FormGroup !== "undefined" && forms_1.FormGroup) === "function" && _d || Object])
    ], OffenseSearchComponent.prototype, "offenseSearchFormGroupObject", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], OffenseSearchComponent.prototype, "canWorkOrderComplete", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", typeof (_e = typeof forms_1.FormGroup !== "undefined" && forms_1.FormGroup) === "function" && _e || Object)
    ], OffenseSearchComponent.prototype, "offensePageForm", void 0);
    OffenseSearchComponent = __decorate([
        core_1.Component({
            selector: 'app-offense-search',
            template: __webpack_require__("./src/app/offenseSearch/offenseSearch.component.html"),
            styles: [__webpack_require__("./src/app/offenseSearch/offenseSearch.component.scss")],
            providers: []
        }),
        __metadata("design:paramtypes", [typeof (_f = typeof offenseService_1.default !== "undefined" && offenseService_1.default) === "function" && _f || Object, typeof (_g = typeof complianceAuditLogService_1.default !== "undefined" && complianceAuditLogService_1.default) === "function" && _g || Object, typeof (_h = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _h || Object, typeof (_j = typeof browserWindowObjectService_1.default !== "undefined" && browserWindowObjectService_1.default) === "function" && _j || Object])
    ], OffenseSearchComponent);
    return OffenseSearchComponent;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
}());
exports.default = OffenseSearchComponent;
//# sourceMappingURL=offenseSearch.component.js.map

/***/ }),

/***/ "./src/app/registration/registration.component.html":
/***/ (function(module, exports) {

module.exports = "<header>\r\n  <h1>\r\n    Welcome to the GIS CRIM System.\r\n  </h1>\r\n  <h3>\r\n    Please create an account with the token you were given.\r\n  </h3>\r\n</header>\r\n\r\n<main>\r\n\r\n  <form [formGroup]=\"registrationForm\" (ngSubmit)=\"onSubmit()\" novalidate autocomplete=\"off\">\r\n\r\n    <div id=\"username-group\" formGroupName=\"user\">\r\n      <label for=\"username\">Username<mark>*</mark></label>\r\n      <input id=\"username\"\r\n              (focus)=\"setFocusById('username-sidebar')\"\r\n              (blur)=\"setBlurById('username-sidebar')\"\r\n              type=\"text\"\r\n              formControlName=\"userName\"\r\n              app-validateOnBlur\r\n              required>\r\n      <div id=\"username-sidebar\" class=\"username-sidebar sidebar hide-sidebar\">\r\n        <p>\r\n          Username to login to the CRIM system.\r\n        </p>\r\n      </div>\r\n      <div class=\"validation\" *ngIf=\"userName.invalid && (userName.dirty || userName.touched)\">\r\n        <span *ngIf=\"userName.hasError('required')\">\r\n          Username is required.\r\n        </span>\r\n        <span *ngIf=\"userName.hasError('minlength')\">\r\n            Username must have a minimum of 6 characters.\r\n        </span>\r\n        <span *ngIf=\"userName.hasError('maxlength')\">\r\n            Username can only be a max of 30 characters.\r\n        </span>\r\n        <span *ngIf=\"userName.hasError('usernameAlreadyExist')\">\r\n          Username already exists.  Please choose another Username.\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <div id=\"email-address-group\" formGroupName=\"user\">\r\n      <label for=\"email-address\">Email Address<mark>*</mark></label>\r\n      <input id=\"email-address\"\r\n              (focus)=\"setFocusById('email-address-sidebar')\"\r\n              (blur)=\"setBlurById('email-address-sidebar')\"\r\n              type=\"email\"\r\n              formControlName=\"email\"\r\n              app-validateOnBlur\r\n              required>\r\n      <div id=\"email-address-sidebar\" class=\"email-address-sidebar sidebar hide-sidebar\">\r\n        <p>\r\n          Email Address will be used when sending password resets and any other type of notification.\r\n        </p>\r\n      </div>\r\n      <div class=\"validation\" *ngIf=\"email.invalid && (email.dirty || email.touched)\">\r\n        <span *ngIf=\"email.hasError('email')\">\r\n          Must be a valid Email Address.\r\n        </span>\r\n        <span *ngIf=\"email.hasError('required')\">\r\n          Email Address is required.\r\n        </span>\r\n        <span *ngIf=\"email.hasError('maxlength')\">\r\n          Email Address can only be a max of 255 characters.\r\n        </span>\r\n        <span *ngIf=\"email.hasError('compareTwoInputs')\">\r\n          Email Address and Username cannot be the same.\r\n      </span>\r\n      </div>\r\n    </div>\r\n    <div id=\"password-group\" formGroupName=\"user\">\r\n      <label for=\"password\">Password<mark>*</mark></label>\r\n      <input id=\"password\"\r\n             (focus)=\"setFocusById('password-sidebar')\"\r\n             (blur)=\"setBlurById('password-sidebar')\"\r\n             (keyup)=\"passwordKeyup($event)\"\r\n             type=\"password\"\r\n             formControlName=\"password\"\r\n             app-validateOnBlur\r\n             required>\r\n      <small>8-character minimum; case sensitive</small>\r\n      <div id=\"password-sidebar\" class=\"password-sidebar sidebar hide-sidebar\">\r\n        <ul>\r\n          <li id=\"password-lower-case-letter\" class=\"rule-not-met\">At least <strong>1 lower case letter</strong></li>\r\n          <li id=\"password-upper-case-letter\" class=\"rule-not-met\">At least <strong>1 capital case letter</strong></li>\r\n          <li id=\"password-number-rule\" class=\"rule-not-met\">At least <strong>1 number</strong></li>\r\n          <li id=\"password-symbol-rule\" class=\"rule-not-met\">At least <strong>1 symbol</strong></li>\r\n          <li id=\"password-length-rule\"  class=\"rule-not-met\">At least <strong>8 characters</strong></li>\r\n        </ul>\r\n      </div>\r\n      <div class=\"validation\" *ngIf=\"password.invalid && (password.dirty || password.touched)\">\r\n        <span *ngIf=\"password.hasError('required')\">\r\n            Password is required.\r\n        </span>\r\n        <span *ngIf=\"password.hasError('maxlength')\">\r\n          Password can only be a max of 60 characters.\r\n        </span>\r\n        <span *ngIf=\"password.hasError('passwordRules')\">\r\n            Password does not meet all validation rules.\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <div id=\"confirm-password-group\" formGroupName=\"user\">\r\n      <label for=\"confirm-password\">Confirm Password<mark>*</mark></label>\r\n      <input id=\"confirm-password\"\r\n             maxlength=\"100\"\r\n             (focus)=\"setFocusById('confirm-password-sidebar')\"\r\n             (blur)=\"setBlurById('confirm-password-sidebar')\"\r\n             type=\"password\"\r\n             formControlName=\"confirmPassword\"\r\n             app-validateOnBlur\r\n             required>\r\n      <div id=\"confirm-password-sidebar\" class=\"confirm-password-sidebar sidebar hide-sidebar\">\r\n        <p>\r\n          This needs to match the Password you entered.\r\n        </p>\r\n      </div>\r\n      <div class=\"validation\" *ngIf=\"confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)\">\r\n        <span *ngIf=\"confirmPassword.hasError('required')\">\r\n            Confirm Password is required.\r\n        </span>\r\n        <span *ngIf=\"confirmPassword.hasError('maxlength')\">\r\n            Confirm Password can only be a max of 60 characters.\r\n        </span>\r\n        <span *ngIf=\"confirmPassword.hasError('compareTwoInputs')\">\r\n            Confirm Password is not the same as Password.\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <div id=\"firstname-group\" formGroupName=\"user\">\r\n      <label for=\"firstname\">First Name<mark>*</mark></label>\r\n      <input id=\"firstname\"\r\n             type=\"text\"\r\n             formControlName=\"firstName\"\r\n             app-validateOnBlur\r\n             required>\r\n      <div class=\"validation\" *ngIf=\"firstName.invalid && (firstName.dirty || firstName.touched)\">\r\n        <span *ngIf=\"firstName.hasError('required')\">\r\n            First Name is required.\r\n        </span>\r\n        <span *ngIf=\"firstName.hasError('maxlength')\">\r\n            First Name can only be a max of 255 characters.\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <div id=\"middlename-group\" formGroupName=\"user\">\r\n      <label for=\"middlename\">Middle Name</label>\r\n      <input id=\"middlename\"\r\n             type=\"text\"\r\n             formControlName=\"middleName\"\r\n             app-validateOnBlur>\r\n      <div class=\"validation\" *ngIf=\"middleName.invalid && (middleName.dirty || middleName.touched)\">\r\n        <span *ngIf=\"middleName.hasError('maxlength')\">\r\n            Middle Name can only be a max of 255 characters.\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <div id=\"lastname-group\" formGroupName=\"user\">\r\n      <label for=\"lastname\">Last Name<mark>*</mark></label>\r\n      <input id=\"lastname\"\r\n             type=\"text\"\r\n             formControlName=\"lastName\"\r\n             app-validateOnBlur\r\n             required>\r\n      <div class=\"validation\" *ngIf=\"lastName.invalid && (lastName.dirty || lastName.touched)\">\r\n        <span *ngIf=\"lastName.hasError('required')\">\r\n            Last Name is required.\r\n        </span>\r\n        <span *ngIf=\"lastName.hasError('maxlength')\">\r\n            Last Name can only be a max of 255 characters.\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <div id=\"phone-number-group\" formGroupName=\"user\">\r\n      <label for=\"phone-number\">Phone Number</label>\r\n      <input id=\"phone-number\"\r\n             type=\"text\"\r\n             formControlName=\"phoneNumber\"\r\n             app-validateOnBlur>\r\n      <div class=\"validation\" *ngIf=\"phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)\">\r\n        <span *ngIf=\"phoneNumber.hasError('maxlength')\">\r\n            Phone Number can only be a max of 255 characters.\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <div id=\"token-group\">\r\n      <label for=\"token\">Validation Token<mark>*</mark></label>\r\n      <input id=\"token\"\r\n             (focus)=\"setFocusById('token-sidebar')\"\r\n             (blur)=\"setBlurById('token-sidebar')\"\r\n             type=\"text\"\r\n             formControlName=\"token\"\r\n             app-validateOnBlur\r\n             required>\r\n      <div id=\"token-sidebar\" class=\"token-sidebar sidebar hide-sidebar\">\r\n        <p>\r\n          This token has been provided to your orangization by GIS and is required when creating an account.\r\n        </p>\r\n      </div>\r\n      <div class=\"validation\" *ngIf=\"token.invalid && (token.dirty || token.touched)\">\r\n        <span *ngIf=\"token.hasError('required')\">\r\n          Token is required.\r\n        </span>\r\n        <span *ngIf=\"token.hasError('tokenNotValid')\">\r\n          Token is not valid.\r\n        </span>\r\n      </div>\r\n    </div>\r\n\r\n    <div id=\"create-account-group\">\r\n      <button type=\"submit\" [disabled]=\"registrationForm.invalid\">Create Account</button>\r\n    </div>\r\n\r\n    <div id=\"ledger\">\r\n      <small><mark>*</mark> are required fields</small>\r\n    </div>\r\n\r\n  </form>\r\n\r\n</main>\r\n";

/***/ }),

/***/ "./src/app/registration/registration.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}*{-webkit-box-sizing:border-box;box-sizing:border-box}header,main{margin-bottom:3rem}header{-ms-flex-line-pack:center;align-content:center;text-align:center}mark{color:red;background-color:inherit;padding-left:.2rem}div{width:35%;margin:1rem auto 0 auto}small{font-size:smaller;font-weight:400;margin-top:.4rem;display:inline-block}button{background-color:#ccf;font-family:Verdana,Tahoma,Arial;margin-right:auto;margin-left:auto;width:100%;height:2.7rem}button,label{font-weight:700}input{width:100%;height:2rem;font-size:1.25 rem;margin-top:.3rem}#username-group{margin-top:3rem}#confirm-password-group,#email-address-group,#password-group,#token-group,#username-group{position:relative}.validation{margin:0;width:100%}.validation span{font-weight:400;color:red;margin-top:.5rem;display:block}div.username-sidebar{top:-.1rem}div.email-address-sidebar,div.username-sidebar{right:-31rem;font-size:1.2rem;width:30rem;padding-left:1rem}div.email-address-sidebar{top:-.9rem}div.password-sidebar{top:-3rem;right:-24rem;font-size:1.5rem;width:auto}div.confirm-password-sidebar{top:-.7rem}div.confirm-password-sidebar,div.token-sidebar{right:-31rem;font-size:1.2rem;width:30rem;padding-left:1rem}div.token-sidebar{top:-.8rem}.show-sidebar{visibility:visible;opacity:1}.hide-sidebar{visibility:hidden;opacity:0}.sidebar:before{content:\"\\25C1\";color:#dede8d;position:absolute;top:40%;left:-.6rem}.sidebar{border:.1rem solid #dede8d;padding:.3rem;background-color:lighter(beige,10%);position:absolute;margin:0}.sidebar ul{list-style-position:inside;margin:0;padding:.9rem .7rem;font-size:87%}.sidebar li:nth-of-type(n+1):nth-of-type(-n+4){margin-bottom:1.3rem}.sidebar li{list-style-type:none}.rule-not-met{color:red;padding-left:1.1rem;line-height:.8rem;background:url(\"data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg width='100%' height='100%' viewBox='0 0 31 30' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;'%3E%3Cpath d='M11.115,15.288l-10.169,-10.003c-1.097,-1.08 -1.199,-2.815 -0.236,-4.016c0.025,-0.032 0.051,-0.064 0.077,-0.096c0.53,-0.662 1.317,-1.068 2.164,-1.118c0.847,-0.05 1.675,0.261 2.28,0.856l10.315,10.147l9.282,-8.863c0.613,-0.586 1.446,-0.885 2.292,-0.822c0.846,0.062 1.626,0.48 2.147,1.149c0.027,0.035 0.054,0.07 0.081,0.105c0.946,1.215 0.818,2.949 -0.295,4.012l-9.134,8.721l7.703,7.577c1.097,1.08 1.199,2.815 0.236,4.016c-0.025,0.032 -0.051,0.064 -0.077,0.096c-0.531,0.662 -1.317,1.068 -2.164,1.118c-0.847,0.05 -1.675,-0.261 -2.28,-0.856l-7.848,-7.72l-9.112,8.7c-0.613,0.585 -1.446,0.884 -2.292,0.822c-0.846,-0.062 -1.626,-0.48 -2.147,-1.149c-0.027,-0.035 -0.054,-0.07 -0.081,-0.105c-0.946,-1.215 -0.818,-2.949 0.295,-4.012l8.963,-8.559Z' style='fill:%23e03030;stroke:%23404040;stroke-width:0.1px;'/%3E%3C/svg%3E\") no-repeat 0 50%}.rule-met{color:green;padding-left:1.1rem;line-height:.9rem;background:url(\"data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg width='100%' height='100%' viewBox='0 0 23 34' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xml:space='preserve' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;'%3E%3Cpath d='M0.662,23.279c-0.369,0.394 -0.359,1.009 0.022,1.391c1.655,1.654 5.881,5.881 7.872,7.871c0.237,0.237 0.577,0.34 0.906,0.273c0.328,-0.067 0.602,-0.294 0.728,-0.605c2.156,-5.322 9.812,-24.219 11.498,-28.381c0.188,-0.465 0.002,-0.999 -0.436,-1.246c-0.626,-0.353 -1.545,-0.872 -2.395,-1.351c-0.53,-0.299 -1.166,-0.341 -1.731,-0.113c-0.564,0.227 -0.994,0.699 -1.168,1.282c-1.623,5.43 -5.549,18.562 -6.993,23.393c-0.075,0.251 -0.304,0.425 -0.566,0.428c-0.262,0.004 -0.496,-0.162 -0.578,-0.411c-0.262,-0.788 -0.582,-1.752 -0.904,-2.725c-0.334,-1.004 -1.171,-1.758 -2.204,-1.985c-1.034,-0.227 -2.11,0.107 -2.833,0.879c-0.462,0.492 -0.888,0.948 -1.218,1.3Z' style='fill:%232be926;'/%3E%3C/svg%3E\") no-repeat 0 50%}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/registration/registration.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var registrationCodes_1 = __webpack_require__("./src/models/registrationCodes.ts");
var registrationService_1 = __webpack_require__("./src/services/registrationService.ts");
var compareTwoInputsValidator_1 = __webpack_require__("./src/validators/compareTwoInputsValidator.ts");
var passwordRulesValidator_1 = __webpack_require__("./src/validators/passwordRulesValidator.ts");
var usernameAlreadyExistValidator_1 = __webpack_require__("./src/validators/usernameAlreadyExistValidator.ts");
var index_1 = __webpack_require__("./src/services/index.ts");
var RegistrationComponent = (function () {
    function RegistrationComponent(router, msgSvc, registrationService, formBuilder) {
        this.router = router;
        this.msgSvc = msgSvc;
        this.registrationService = registrationService;
        this.formBuilder = formBuilder;
    }
    RegistrationComponent.prototype.ngOnInit = function () {
        this.msgSvc.setControlKey();
        this.registrationForm = this.formBuilder.group({
            token: ['', forms_1.Validators.required],
            user: this.formBuilder.group({
                userName: ['', [
                        forms_1.Validators.required,
                        forms_1.Validators.minLength(6),
                        forms_1.Validators.maxLength(30),
                        usernameAlreadyExistValidator_1.default(),
                    ]
                ],
                email: ['', [
                        forms_1.Validators.required,
                        forms_1.Validators.email,
                        forms_1.Validators.maxLength(255),
                        compareTwoInputsValidator_1.default('username', false)
                    ]
                ],
                password: ['', [
                        forms_1.Validators.required,
                        forms_1.Validators.maxLength(60),
                        passwordRulesValidator_1.default()
                    ]
                ],
                confirmPassword: ['', [
                        forms_1.Validators.required,
                        forms_1.Validators.maxLength(60),
                        compareTwoInputsValidator_1.default('password')
                    ]
                ],
                firstName: ['', [
                        forms_1.Validators.required,
                        forms_1.Validators.maxLength(255),
                    ]
                ],
                middleName: ['', forms_1.Validators.maxLength(255)],
                lastName: ['', [
                        forms_1.Validators.required,
                        forms_1.Validators.maxLength(255),
                    ]
                ],
                phoneNumber: ['', forms_1.Validators.maxLength(255)],
            })
        });
    };
    RegistrationComponent.prototype.onSubmit = function () {
        var _this = this;
        var form = this.registrationForm.value;
        var user = Object.assign({}, form.user, { confirmPassword: undefined });
        this.registrationService.registerUser(user, form.token)
            .subscribe(function (registrationCodes) {
            var code = registrationCodes.find(function (rc) { return rc === registrationCodes_1.RegistrationCodes.ok; });
            if (code === registrationCodes_1.RegistrationCodes.ok) {
                _this.router.navigate(['confirmation']);
            }
            else {
                for (var _i = 0, registrationCodes_2 = registrationCodes; _i < registrationCodes_2.length; _i++) {
                    var registrationCode = registrationCodes_2[_i];
                    switch (registrationCode) {
                        case registrationCodes_1.RegistrationCodes.requireUsername:
                            _this.setValidationErrorByControlName('token', 'required');
                            break;
                        case registrationCodes_1.RegistrationCodes.tokenNotValid:
                            _this.setValidationErrorByControlName('token', 'tokenNotValid');
                            break;
                        case registrationCodes_1.RegistrationCodes.invalidUsername:
                        case registrationCodes_1.RegistrationCodes.requireUsername:
                            _this.setValidationErrorByControlName('user.userName', 'required');
                            break;
                        case registrationCodes_1.RegistrationCodes.invalidPassword:
                        case registrationCodes_1.RegistrationCodes.requirePassword:
                            _this.setValidationErrorByControlName('user.password', 'required');
                            break;
                        case registrationCodes_1.RegistrationCodes.invalidFirstName:
                            _this.setValidationErrorByControlName('user.firstName', 'required');
                            break;
                        case registrationCodes_1.RegistrationCodes.invalidLastName:
                            _this.setValidationErrorByControlName('user.lastName', 'required');
                            break;
                        case registrationCodes_1.RegistrationCodes.usernameAlreadyExist:
                            _this.setValidationErrorByControlName('user.userName', 'usernameAlreadyExist');
                            break;
                        case registrationCodes_1.RegistrationCodes.userAndEmailAreTheSame:
                            _this.setValidationErrorByControlName('user.email', 'compareTwoInputs');
                            break;
                        default:
                            break;
                    }
                }
            }
        });
    };
    RegistrationComponent.prototype.setBlurById = function (id) {
        var classListPasswordSidebar = document.getElementById(id).classList;
        classListPasswordSidebar.remove('show-sidebar');
        classListPasswordSidebar.add('hide-sidebar');
    };
    RegistrationComponent.prototype.setFocusById = function (id) {
        var classListPasswordSidebar = document.getElementById(id).classList;
        classListPasswordSidebar.remove('hide-sidebar');
        classListPasswordSidebar.add('show-sidebar');
    };
    RegistrationComponent.prototype.passwordKeyup = function (event) {
        var password = event.target.value;
        this.checkLength(password);
        this.checkRegEx(password, /[!@#$%^&*(){}[\]?~<>]/, 'password-symbol-rule');
        this.checkRegEx(password, /[A-Z]/, 'password-upper-case-letter');
        this.checkRegEx(password, /[a-z]/, 'password-lower-case-letter');
        this.checkRegEx(password, /\d/, 'password-number-rule');
    };
    RegistrationComponent.prototype.checkRegEx = function (s, pattern, id) {
        var isMatch = s.match(pattern);
        if (!isMatch) {
            this.showRuleNotMet(id);
        }
        else {
            this.showRuleMet(id);
        }
    };
    RegistrationComponent.prototype.checkLength = function (password) {
        var id = 'password-length-rule';
        if (password.length < 8) {
            this.showRuleNotMet(id);
        }
        else {
            this.showRuleMet(id);
        }
    };
    RegistrationComponent.prototype.showRuleMet = function (id) {
        var passwordLength = document.getElementById(id).classList;
        passwordLength.remove('rule-not-met');
        passwordLength.add('rule-met');
    };
    RegistrationComponent.prototype.showRuleNotMet = function (id) {
        var passwordLength = document.getElementById(id).classList;
        passwordLength.remove('rule-met');
        passwordLength.add('rule-not-met');
    };
    RegistrationComponent.prototype.setValidationErrorByControlName = function (controlName, validatorType) {
        var control = this.registrationForm.get(controlName);
        var validator = {};
        validator[validatorType] = true;
        control.setErrors(validator);
        control.markAsTouched();
    };
    Object.defineProperty(RegistrationComponent.prototype, "userName", {
        get: function () { return this.registrationForm.get('user.userName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationComponent.prototype, "email", {
        get: function () { return this.registrationForm.get('user.email'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationComponent.prototype, "password", {
        get: function () { return this.registrationForm.get('user.password'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationComponent.prototype, "confirmPassword", {
        get: function () { return this.registrationForm.get('user.confirmPassword'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationComponent.prototype, "firstName", {
        get: function () { return this.registrationForm.get('user.firstName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationComponent.prototype, "middleName", {
        get: function () { return this.registrationForm.get('user.middleName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationComponent.prototype, "lastName", {
        get: function () { return this.registrationForm.get('user.lastName'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationComponent.prototype, "phoneNumber", {
        get: function () { return this.registrationForm.get('user.phoneNumber'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RegistrationComponent.prototype, "token", {
        get: function () { return this.registrationForm.get('token'); },
        enumerable: true,
        configurable: true
    });
    RegistrationComponent = __decorate([
        core_1.Component({
            selector: 'app-registration',
            template: __webpack_require__("./src/app/registration/registration.component.html"),
            styles: [__webpack_require__("./src/app/registration/registration.component.scss")],
            providers: [registrationService_1.default, index_1.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _a || Object, typeof (_b = typeof index_1.MessageQueService !== "undefined" && index_1.MessageQueService) === "function" && _b || Object, typeof (_c = typeof registrationService_1.default !== "undefined" && registrationService_1.default) === "function" && _c || Object, typeof (_d = typeof forms_1.FormBuilder !== "undefined" && forms_1.FormBuilder) === "function" && _d || Object])
    ], RegistrationComponent);
    return RegistrationComponent;
    var _a, _b, _c, _d;
}());
exports.default = RegistrationComponent;
//# sourceMappingURL=registration.component.js.map

/***/ }),

/***/ "./src/app/reports/reports.component.html":
/***/ (function(module, exports) {

module.exports = "<nav class=\"navClass\">\r\n  <ul>\r\n    <li>File\r\n      <ul class=\"sub-menu\">\r\n        <li><a (click)=\"goToNavigation()\">Return To Navigation Page</a></li>\r\n        <li><a (click)=\"exitDialog()\">Exit System</a></li>\r\n      </ul>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n\r\n<main>\r\n\r\n  <section id=\"reports-section\">\r\n\r\n    <header>\r\n        <span>SELECT REPORT TO GENERATE</span>\r\n    </header>\r\n\r\n    <div>\r\n      <a href=\"javascript:void(0)\" (click)=\"showInvoiceReportGeneratorSection()\">Invoice</a>\r\n    </div>\r\n\r\n  </section>\r\n\r\n  <section *ngIf=\"showInvoiceReportGenerator\">\r\n\r\n    <header>\r\n      <span>SELECT THE DATES FOR THE REPORT</span>\r\n    </header>\r\n\r\n    <form [formGroup]=\"reportsPageForm\" (ngSubmit)=\"onSubmit()\" novalidate>\r\n      <div>\r\n        <label class=\"block-label\" for=\"start-date\"><mark>*</mark>Select the beginning date for the report:</label>\r\n        <input type=\"text\"\r\n               formControlName=\"startDate\"\r\n               (blur)=\"formatDate('startDate', 2000)\"\r\n               app-validateOnBlur\r\n               required>\r\n\r\n        <div class=\"validation\" *ngIf=\"startDate.invalid && (startDate.dirty || startDate.touched)\">\r\n          <span *ngIf=\"startDate.hasError('required')\" required>\r\n            Start Date is required.\r\n          </span>\r\n          <span *ngIf=\"startDate.hasError('isDate')\" required>\r\n            Start Date is required in format mm/dd/yy or mm/dd/yyyy.\r\n          </span>\r\n        </div>\r\n\r\n      </div>\r\n\r\n      <div>\r\n        <label class=\"block-label\" for=\"end-date\"><mark>*</mark>Select the ending date for the report:</label>\r\n        <input type=\"text\"\r\n               formControlName=\"endDate\"\r\n               (blur)=\"formatDate('endDate', 2000)\"\r\n               required\r\n               app-validateOnBlur>\r\n\r\n        <div class=\"validation\" *ngIf=\"endDate.invalid && (endDate.dirty || endDate.touched)\">\r\n          <span *ngIf=\"endDate.hasError('required')\" required>\r\n            End Date is required.\r\n          </span>\r\n          <span *ngIf=\"endDate.hasError('isDate')\" required>\r\n            End Date is required in format mm/dd/yy or mm/dd/yyyy.\r\n          </span>\r\n        </div>\r\n\r\n      </div>\r\n\r\n      <div>\r\n        <label class=\"block-label\" for=\"invoice-number\">Enter the Invoice Number:</label>\r\n        <input type=\"text\" formControlName=\"invoiceNumber\">\r\n      </div>\r\n\r\n      <button type=\"submit\" [disabled]=\"reportsPageForm.invalid\">Generate Report</button>\r\n      <label for=\"open-report-in-tab\"\r\n      title=\"This displays the report in a new browser tab instead of a popup window.\">\r\n        (display report in a new tab)\r\n      </label>\r\n      <input type=\"checkbox\"\r\n             id=\"open-report-in-tab\"\r\n             formControlName=\"openReportInTab\"\r\n             title=\"This displays the report in a new browser tab instead of a popup window.\">\r\n    </form>\r\n\r\n  </section>\r\n\r\n  <router-outlet name=\"invoiceReport\"></router-outlet>\r\n</main>\r\n";

/***/ }),

/***/ "./src/app/reports/reports.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}main{margin-left:5rem;padding-right:5rem}header{background-color:#ccf;color:#000;font-weight:bolder;padding:.5rem .3rem;margin:2rem 0 .4rem 0}header span{display:block;font-weight:700}mark{color:red;background-color:inherit}label{font-weight:700}input{margin-bottom:1rem}button{background-color:#ccf;font-family:Verdana,Tahoma,Arial;margin-right:auto;margin-left:auto;width:13rem;font-size:1rem;padding-top:.5rem;padding-bottom:.5rem}a:link,a:visited{color:#0066cb}#reports-section div{margin-top:3rem;-ms-flex-line-pack:center;align-content:center;text-align:center}.validation{margin:0;width:100%;margin-bottom:2rem}.validation span{font-weight:400;color:red;margin-top:.5rem;display:block}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/reports/reports.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var browserWindowObjectService_1 = __webpack_require__("./src/services/browserWindowObjectService.ts");
var isDateValidator_1 = __webpack_require__("./src/validators/isDateValidator.ts");
var formControl_1 = __webpack_require__("./src/models/formControl.ts");
var dateHandler_1 = __webpack_require__("./src/models/dateHandler.ts");
var alertifyPromise_1 = __webpack_require__("./src/models/alertifyPromise.ts");
var popupHelper_1 = __webpack_require__("./src/models/popupHelper.ts");
var index_1 = __webpack_require__("./src/services/index.ts");
var ReportsComponent = (function () {
    function ReportsComponent(browserWindowObjectService, formBuilder, msgSvc, router) {
        this.browserWindowObjectService = browserWindowObjectService;
        this.formBuilder = formBuilder;
        this.msgSvc = msgSvc;
        this.router = router;
        this.showInvoiceReportGenerator = false;
    }
    ReportsComponent.prototype.ngOnInit = function () {
        this.msgSvc.setControlKey();
        this.reportsPageForm = this.formBuilder.group({
            startDate: ['', [
                    forms_1.Validators.required,
                    isDateValidator_1.default(2000)
                ]
            ],
            endDate: ['', [
                    forms_1.Validators.required,
                    isDateValidator_1.default(2000)
                ]
            ],
            invoiceNumber: [''],
            openReportInTab: ['']
        });
        this.formControl = new formControl_1.default(this.reportsPageForm);
    };
    ReportsComponent.prototype.showInvoiceReportGeneratorSection = function () {
        this.showInvoiceReportGenerator = true;
    };
    ReportsComponent.prototype.onSubmit = function () {
        var form = this.reportsPageForm.value;
        var startDate = this.convertDateToString(form.startDate, 2000, 'MM-DD-YYYY');
        var endDate = this.convertDateToString(form.endDate, 2000, 'MM-DD-YYYY');
        var route = "invoiceReport/" + startDate + "/" + endDate + "/" + form.invoiceNumber;
        if (form.openReportInTab) {
            this.browserWindowObjectService.openWindowITabByRoute(route, form.invoice);
        }
        else {
            this.browserWindowObjectService.openWindowInNewWindowByRoute(route, form.invoice, 1000, 900);
        }
    };
    ReportsComponent.prototype.formatDate = function (controlName, baseCentury) {
        if (!this.formControl.hasErrorByControlName(controlName)) {
            var value = this.formControl.getValueByControlName(controlName);
            this.formControl.setValueByControlName(controlName, this.convertDateToString(value, baseCentury));
        }
    };
    ReportsComponent.prototype.goToNavigation = function () {
        this.router.navigate(['navigation']);
    };
    ReportsComponent.prototype.exitDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var confirmResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popupHelper_1.default.exitSystemHelper()];
                    case 1:
                        confirmResult = _a.sent();
                        if (confirmResult === alertifyPromise_1.ConfirmResult.Ok) {
                            this.router.navigate(['exit']);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ReportsComponent.prototype.convertDateToString = function (date, baseCentury, mask) {
        if (mask === void 0) { mask = null; }
        return new dateHandler_1.default(date, baseCentury).format(mask);
    };
    Object.defineProperty(ReportsComponent.prototype, "startDate", {
        get: function () { return this.reportsPageForm.get('startDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportsComponent.prototype, "endDate", {
        get: function () { return this.reportsPageForm.get('endDate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportsComponent.prototype, "invoiceNumber", {
        get: function () { return this.reportsPageForm.get('invoiceNumber'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportsComponent.prototype, "openReportInTab", {
        get: function () { return this.reportsPageForm.get('openReportInTab'); },
        enumerable: true,
        configurable: true
    });
    ReportsComponent = __decorate([
        core_1.Component({
            selector: 'app-reports',
            template: __webpack_require__("./src/app/reports/reports.component.html"),
            styles: [__webpack_require__("./src/app/reports/reports.component.scss")],
            providers: [index_1.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof browserWindowObjectService_1.default !== "undefined" && browserWindowObjectService_1.default) === "function" && _a || Object, typeof (_b = typeof forms_1.FormBuilder !== "undefined" && forms_1.FormBuilder) === "function" && _b || Object, typeof (_c = typeof index_1.MessageQueService !== "undefined" && index_1.MessageQueService) === "function" && _c || Object, typeof (_d = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _d || Object])
    ], ReportsComponent);
    return ReportsComponent;
    var _a, _b, _c, _d;
}());
exports.default = ReportsComponent;
//# sourceMappingURL=reports.component.js.map

/***/ }),

/***/ "./src/app/researcherTaskComment/researcherTaskComment.component.html":
/***/ (function(module, exports) {

module.exports = "<nav class='navClass'>\r\n  <ul>\r\n    <li>Tools\r\n      <ul class='sub-menu'>\r\n        <li>\r\n          <a (click)='doSubmit(\"Save\")'>Save</a>\r\n        </li>\r\n        <li>\r\n          <a (click)='doSubmit(\"Cancel\")'>Cancel</a>\r\n        </li>\r\n        <li>\r\n          <a (click)='doSubmit(\"Delete\")'>Delete</a>\r\n        </li>\r\n      </ul>\r\n    </li>\r\n    <li>Help\r\n      <ul class=\"sub-menu\">\r\n        <li><a (click)=\"support()\">Support</a></li>\r\n        <hr>\r\n        <li><a (click)=\"about()\">About</a></li>\r\n      </ul>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n<div id=\"spacerxsm\"></div>\r\n<form name=\"form\" #f=\"ngForm\" novalidate>\r\n  <div id=\"woHeader\">\r\n    <div id=\"woHeader-left\">\r\n      <b>TASK COMMENTS</b>\r\n    </div>\r\n  </div>\r\n  <br/>\r\n  <div id=\"woMain\">\r\n    <div id=\"woComment-left\">Comments:</div>\r\n  </div>\r\n  <div id=\"spacerxxsm\"></div>\r\n  <div class=\"form-group\" align='center'>\r\n    <div id=\"woMain\">\r\n      <div id=\"woComment-left\">\r\n        <div id=\"woComment-text\">\r\n          <textarea id=\"\" cols=\"30\" rows=\"10\" datatype='text' ROWS='15' cols='145' [(ngModel)]=\"model.comment\" #comment=\"ngModel\" name=\"comment\"\r\n            [disabled]=isEnabled() (change)=\"commentChanged()\"></textarea>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div id=\"spacerxxsm\"></div>\r\n  <div id=\"woButton\">\r\n    <button class='Button' name='btnSave' (click)='doSubmit(\"Save\")' title=''>Save</button>\r\n    <button class='Button' name='btnCancel' (click)='doSubmit(\"Cancel\")' title=''>Cancel</button>\r\n  </div>\r\n</form>\r\n";

/***/ }),

/***/ "./src/app/researcherTaskComment/researcherTaskComment.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(__webpack_require__("./node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!./node_modules/postcss-loader/lib/index.js?{\"ident\":\"postcss\",\"plugins\":[null,null,{\"version\":\"5.2.18\",\"plugins\":[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],\"postcssPlugin\":\"cssnano\",\"postcssVersion\":\"5.2.18\"}]}!./node_modules/alertifyjs/build/css/alertify.css"), "");

// module
exports.push([module.i, ".flex-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}label.block-label{display:block;margin-bottom:.5rem}div.inline-div{display:inline-block}.gray-out{background-color:grey}.red{color:red}a.disabled{color:gray;cursor:not-allowed;text-decoration:none}a.router-link-menu{color:#000;text-decoration:none}span.block-span{display:block;margin-bottom:.5rem}.text-alert{color:red}.screen-disable{width:100%;height:100%;top:0;left:0;padding:0;margin:0;background:rgba(0,0,0,.7);display:none;position:fixed;z-index:100;display:block}.dbo-title{font-size:20px;text-align:center}.dob-mismatch-container{position:relative;padding-left:50px;font-size:14px}.dob-mismatch-message{line-height:1.4;font-family:arial,helvetica,sans-serif;font-weight:700;font-size:16px}.dob-mismatch-container:before{display:block;position:absolute;left:0;top:0;content:\"!\";border-radius:50%;border:1px solid red;width:2rem;height:2rem;line-height:22px;text-align:center;color:red;font-weight:400}.highlight{font-weight:700}.navClass{border:.5;padding-left:1rem;padding-right:1rem}.navClass>ul{cursor:pointer;font-family:Tahoma,Verdana,Arial;font-weight:400;font-size:Verdana,Tahoma,Arial;background-color:#ccf;width:100%;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b;padding-left:.25rem}.navClass>ul>li{display:inline-block;padding:.425rem .5rem;position:relative}.navClass>ul>li:hover{background-color:#5050f0}ul.sub-menu{cursor:pointer;position:absolute;background-color:#ccf;list-style-type:none;width:16rem;margin-left:-.5rem;padding-left:.5rem;padding-top:.5rem;display:none;border-left:.2rem solid #9e9e9e;border-top:.2rem solid #9e9e9e;border-bottom:.2rem solid #4b4b4b;border-right:.2rem solid #4b4b4b}ul.sub-menu li{padding-left:.5em;padding-bottom:.4em}.navClass li:hover ul.sub-menu{display:block}.navClass ul.sub-menu li:hover{background-color:#5050f0;color:#fff}.loader,.loader:after,.loader:before{background:#f66733;-webkit-animation:load1 1s infinite ease-in-out;animation:load1 1s infinite ease-in-out;width:1em;height:4em}.loader{color:#522d80;text-indent:-9999em;left:50%;top:50%;position:fixed;z-index:1000;font-size:11px;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation-delay:-.16s;animation-delay:-.16s}.loader:after,.loader:before{position:fixed;z-index:1000;content:\"\"}.loader:before{left:-1.5em;-webkit-animation-delay:-.32s;animation-delay:-.32s}.loader:after{left:1.5em}@-webkit-keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}@keyframes load1{0%,80%,to{-webkit-box-shadow:0 0;box-shadow:0 0;height:4em}40%{-webkit-box-shadow:0 -2em;box-shadow:0 -2em;height:5em}}label{font-weight:400;display:block;padding:2px 0 32px}#spacerxxsm{padding-top:.5rem}#spacerxsm{padding-top:1.5rem}#woHeader{margin:0 auto;border:0;background-color:#ccf;padding-left:3.5rem}#woHeader-left{width:77rem;vertical-align:left;text-align:left;float:left}#woHeader-main{padding:1rem;width:19rem;text-align:right}.Button{font-family:Verdana,Tahoma,Arial;background-color:#ccf}#woMain{margin:2.9rem 3rem;border:0;background-color:beige;width:150rem;padding-left:.6rem}#woHeader div{padding:1rem;float:left;background-color:#ccf}#woComment-left{font-weight:700;width:67rem}#woComment-left,#woComment-text{vertical-align:left;text-align:left;float:left}textarea{resize:none}#woButton{margin:13rem -45rem;width:45rem;vertical-align:left;text-align:left;float:left;padding-left:10rem}.btnClass>ul>li{list-style-type:none;display:inline-block;padding:5rem 10rem}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/researcherTaskComment/researcherTaskComment.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var index_1 = __webpack_require__("./src/services/index.ts");
var popupHelper_1 = __webpack_require__("./src/models/popupHelper.ts");
var alertifyPromise_1 = __webpack_require__("./src/models/alertifyPromise.ts");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var ResearcherTaskCommentComponent = (function () {
    function ResearcherTaskCommentComponent(router, msgSvc, researcherService) {
        var _this = this;
        this.router = router;
        this.msgSvc = msgSvc;
        this.researcherService = researcherService;
        this.model = {};
        this.model.status = JSON.parse(localStorage.getItem('status'));
        this.model.requestNbr = (localStorage.getItem('requests'));
        localStorage.removeItem('status');
        this.researcherService.getResearchTaskComment(this.model.requestNbr)
            .subscribe(function (data) {
            _this.model.comment = data;
        });
    }
    ResearcherTaskCommentComponent.prototype.ngOnInit = function () {
        this.msgSvc.setControlKey();
    };
    ResearcherTaskCommentComponent.prototype.submit = function () {
        var _this = this;
        this.researcherService.saveResearcherTaskComments(this.model.requestNbr, this.model.comment)
            .subscribe(function (data) {
            if (data === 200) {
                window.close();
            }
            else if (data === 401) {
                window.close();
                _this.router.navigate(['login']);
            }
        });
    };
    ResearcherTaskCommentComponent.prototype.deleteComment = function () {
        if (this.model.comment != null) {
            this.researcherService.deleteResearcherTaskComments(this.model.requestNbr)
                .subscribe(function (data) {
                if (data === 200) {
                    window.close();
                }
                else if (data === 401) {
                    window.close();
                }
            });
        }
        else {
            window.close();
        }
    };
    ResearcherTaskCommentComponent.prototype.doSubmit = function (type) {
        if (type === 'Save') {
            if (this.model.change === false) {
                type = 'Cancel';
                this.submit();
            }
            else {
                this.saveAlertBox();
            }
        }
        else if (type === 'Cancel') {
            window.close();
        }
        else if (type === 'Delete') {
            this.deleteComment();
        }
    };
    ResearcherTaskCommentComponent.prototype.checkStatus = function () {
        if (this.model.status === 'W' || this.model.status === 'C' || this.model.status === 'U') {
            return false;
        }
        else {
            return true;
        }
    };
    ResearcherTaskCommentComponent.prototype.isEnabled = function () {
        if (this.model.status === 'W' || this.model.status === 'C' || this.model.status === 'U') {
            return true;
        }
        else {
            return false;
        }
    };
    ResearcherTaskCommentComponent.prototype.commentChanged = function () {
        this.model.change = true;
    };
    ResearcherTaskCommentComponent.prototype.saveAlertBox = function () {
        return __awaiter(this, void 0, void 0, function () {
            var message, alertResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = "During times of heavy system activity, Task Comments may\n    take up to 5-10 minutes to post. This is expected behavior.\n    Thank you for your understanding";
                        return [4 /*yield*/, popupHelper_1.default.saveComment(message)];
                    case 1:
                        alertResult = _a.sent();
                        if (alertResult === alertifyPromise_1.AlertResult.Ok) {
                            this.submit();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ResearcherTaskCommentComponent.prototype.about = function () {
        popupHelper_1.default.systemVersion();
    };
    ResearcherTaskCommentComponent.prototype.support = function () {
        popupHelper_1.default.support();
    };
    ResearcherTaskCommentComponent = __decorate([
        core_1.Component({
            selector: 'app-tasklist-comments',
            template: __webpack_require__("./src/app/researcherTaskComment/researcherTaskComment.component.html"),
            styles: [__webpack_require__("./src/app/researcherTaskComment/researcherTaskComment.component.scss")],
            providers: [index_1.ResearcherService, index_1.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _a || Object, typeof (_b = typeof index_1.MessageQueService !== "undefined" && index_1.MessageQueService) === "function" && _b || Object, typeof (_c = typeof index_1.ResearcherService !== "undefined" && index_1.ResearcherService) === "function" && _c || Object])
    ], ResearcherTaskCommentComponent);
    return ResearcherTaskCommentComponent;
    var _a, _b, _c;
}());
exports.ResearcherTaskCommentComponent = ResearcherTaskCommentComponent;
//# sourceMappingURL=researcherTaskComment.component.js.map

/***/ }),

/***/ "./src/app/researcherTaskList/ResearcherTaskList.component.html":
/***/ (function(module, exports) {

module.exports = "<nav class = 'navClass'>\r\n  <ul>\r\n    <li>File\r\n      <ul class='sub-menu'>\r\n        <li><a (click)='goToNavigation()'>Return To Navigation Page</a></li>\r\n        <li><a (click)='submitTaskList()'>Submit Updates</a></li>\r\n        <li><a (click)='exitDialog()'>Exit System</a></li>\r\n      </ul>\r\n    </li>\r\n    <li>Tools\r\n      <ul class='sub-menu'>\r\n        <li><a (click)='sortWorkOrderList()'>Sort Task List</a></li>\r\n        <li><a (click)='selectAll()'>Select All Work Orders</a></li>\r\n        <li><a (click)='removeAllSelection()'>Remove All Work Orders Selected</a></li>\r\n        <li><a (click)='displayReport(\"Report\")'>Generate Work Orders</a></li>\r\n        <li><a routerLink=\"/reports\" class=\"router-link-menu\">Reports</a></li>\r\n      </ul>\r\n    </li>\r\n    <li>Help\r\n      <ul class=\"sub-menu\">\r\n        <li><a (click)=\"help()\">Page Help</a></li>\r\n        <hr>\r\n        <li><a (click)=\"support()\">Support</a></li>\r\n        <hr>\r\n        <li><a (click)=\"about()\">About</a></li>\r\n      </ul>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n<div id=\"wrapper\">\r\n  <div id=\"woHeader\">\r\n    <div id=\"woHeader-left\"><b>Work Order List For {{taskList.gisUserName}}</b></div>\r\n    <div id=\"woHeader-main\"><b>Assigned Workorders: {{taskList.requestTotal}}</b></div>\r\n    <div id=\"woHeader-rightmain\"><b>New Workorders: {{taskList.newTotal}}</b></div>\r\n    <div id=\"woHeader-rightmain\"><b>Late Workorders: {{taskList.lateTotal}}</b></div>\r\n    <div id=\"woHeader-right\"><b>Effective: {{taskList.currentSysDt}}</b></div>\r\n  </div>\r\n</div>\r\n<div id=\"spacer\"></div>\r\n<div id=\"Wrapper\">\r\n  <div id=\"woMain\">\r\n    <div id=\"woButton-main\"><button class='Button'  tabindex='1' name='btnReceived' (click)='displayReport(\"Received\")' title='Selecting this will mark the items checked as Received'>Mark Requests Received</button></div>\r\n    <div id=\"woButton-left\"><input tabindex='2' type='button' class='Button' name='btnReport'  (click)='displayReport(\"Report\")' title='Selecting this will open a PDF report formatted for printing.  This report will contain all selected Work Orders.' value='Generate Work Orders' /></div>\r\n    <div id=\"woLinkSelect\"><a  tabindex='3' name=\"SelectAll\"  href=\"javascript:void(0)\" (click)='selectAll()' title=\"Select to check all work orders\">Select All</a></div>\r\n    <div id=\"woLinkClear\"><a tabindex='4' name='ClearSelections' href=\"javascript:void(0)\" (click)='removeAllSelection()' title=\"Select to clear all Work Order Selections\">Clear All</a></div>\r\n    <div id=\"woButton-rightmain\"><input tabindex='5' type='button' class='Button' name='btnFilter' title='Select this option to sort the Work Orders displayed in the task list.' (click)='sortWorkOrderList()' value='Sort task list' /></div>\r\n    <div id=\"woButton-right\"><input tabindex='6' type='button' class='Button' name='btnSubmit' title='Select this option to Submit Updates.' [disabled]='submitTaskListDisabled()' (click)='submitTaskList()' value='Submit Updates' /></div>\r\n  </div>\r\n</div>\r\n<div id=\"spacer\"></div>\r\n  <div id=\"woMain\">\r\n    <div id=\"woJuris-left\">Requests Displayed are {{taskList.min}} - {{totalWorkOrdersOnPage}} of {{totalWorkOrders}}</div>\r\n    <div  *ngIf='isJurisVisible()'>Filter By Jurisdiction:\r\n    </div>\r\n  </div>\r\n\r\n<div id=\"spacerxsm\"></div>\r\n\r\n  <div id=\"woMain\" *ngIf='isJurisVisible()'>\r\n    <div id=\"woJuris-right\" >\r\n        <select id='JurisdictionFilter' [(ngModel)]=\"model.selectedValue\" #selectedValue=\"ngModel\">\r\n          <option value='0' selected>Not Selected</option>\r\n          <option *ngFor='let flter of jurFilters'\r\n            value={{flter.jurisdictionId}} >{{flter.description}}\r\n        </select>\r\n    </div>\r\n    <br/>\r\n    <br/>\r\n    <div id=\"woJuris\" >\r\n        <input tabindex='5' type='button' class='Button' name='btnFilter' (click)='filterWorkOrderList()' value='Filter task list' />\r\n    </div>\r\n  </div>\r\n\r\n<br />\r\n<br />\r\n<table class='tblWO' align='center'>\r\n  <tr>\r\n    <th class='first' bgcolor='#ccccff' title='Checking this box will select this Work Order for viewing on the PDF report.'>Select</th>\r\n    <th class='second' bgcolor='#ccccff' title='GIS reference number'>Work Order</th>\r\n    <th class='third' bgcolor='#ccccff' title='The jurisdication this Work Order belongs in.'>Jurisdiction</th>\r\n    <th class='fourth' bgcolor='#ccccff' title='Name, SSN, and DOB as listed on the application'>Reference Name/SSN/DOB/Res. Add</th>\r\n    <th class='fifth' bgcolor='#ccccff' title='The date this work order is due to be completed.'>Request Date</th>\r\n    <th class='sixth' bgcolor='#ccccff' title='Select the appropriate action to take on the Request.'>Result/Action</th>\r\n  </tr>\r\n  <tr *ngFor=\"let item of wo | orderBy: '+' \">\r\n    <td class='first'>\r\n      <input type='checkbox' name='Select' [checked] = 'item.checked' [(ngModel)]='item.checked' value={{item.requestNbr}} />\r\n     </td>\r\n  <td class='second'>\r\n    <font color={{item.colorValue}}>{{item.caseNbr}}</font>\r\n    <div *ngIf='!showLink()'><font color={{item.colorValue}} size=1>{{item.woValue}}</font></div>\r\n    <font color={{item.colorValue}} size=1>{{item.reportAllText}}</font>\r\n    <div class={{item.showInstruction}} size=1><a id='specialInstructionName' routerLinkActive='active'  href=\"javascript:void(0)\" (click)=\"specialInstruction(item.requestNbr)\"><font font-size=4 ><br /> *Special Research Instructions</font></a>\r\n    </div>\r\n    <br />\r\n  </td>\r\n  <td class='third'>\r\n    <font color={{item.colorValue}}>{{item.woSourceName}} <br />{{item.jurisdiction}} <br /><div *ngIf='isVisible(item.sourceType, item.hrefCif)'><a id='watson' routerLinkActive='active'  href=\"javascript:void(0)\" (click)=\"watsonShowGuideline(item.hrefCif)\">{{item.hrefCif}}</a> <br/></div><div *ngIf='isVisible(item.sourceType, item.woPhone)'> {{item.woPhone}}<br /></div> Search Dates: {{item.searchFromDt}} - {{item.searchToDt}}</font>\r\n  </td>\r\n  <td class='third'><font  color={{item.colorValue}}>{{item.refName}}<br />{{item.ssnDisplay}} <br />{{item.dobDisplay}}<br />{{item.refAddr1}}, {{item.refCity}}, {{item.refState}}, {{item.refZip}}</font></td>\r\n  <td class='first'><font  color={{item.colorValue}}>{{item.dis_RequestDt}}</font></td>\r\n\r\n  <td class='third'>\r\n  <div class={{item.woNoHitsDisplay}}><input type=\"checkbox\" id={{item.woNoHitsName}} value= {{item.requestNbr}} [checked] = 'item.woNoHitsChecked' [disabled]='item.woNoHitsDisable' (click)='completeWorkOrder(item.requestNbr, item.caseNbr, item.refName)'/> No Record\r\n  <br /></div>\r\n  <div class={{item.woManualDisplay}}><input type='checkbox' id={{item.woManualName}} value= {{item.requestNbr}} [checked] = 'item.woManualChecked'> Handle Manually\r\n  <br /></div>\r\n  <div class={{item.woPendingDisplay}}><input type='checkbox' id={{item.woPendingName}} value= {{item.requestNbr}}  [checked] = 'item.woPendingChecked' [disabled]='woPendingDisable' (click)='pendingWorkOrder(\"\", item.requestNbr, item.caseNbr, item.refName, item.status)'/>\r\n  <a class={{item.woPendingLinkDisplay}} routerLinkActive='active' href=\"javascript:void(0)\" (click)=\"pendingWorkOrder('Link', item.requestNbr, item.caseNbr, item.refName, item.status)\"> Pending</a>\r\n  <br /></div>\r\n  <div class={{item.woRecordDisplay}}><a id='recordFound' [class.disabled]= \"( item.woRecordFoundDisable) ? true : false\"  routerLinkActive='active' href=\"javascript:void(0)\"  (click)=\"openWindow('Edit', item.caseNbr, item.requestNbr)\"><font color={{item.linkColor}}>Record Found</font></a>\r\n  <br /></div>\r\n  <div class={{item.woCommentsDisplay}}><a id='comment'  routerLinkActive='active' href=\"javascript:void(0)\" (click)=\"showComment(item.requestNbr, item.status)\"> Comments</a>\r\n  <br /></div>\r\n  <div class={{item.woSearchDisplay}}><a id='searchCapture' routerLinkActive='active' href=\"javascript:void(0)\" (click)='searchCapture(1188, item.requestNbr)'> Search/Capture</a>\r\n  <br /></div>\r\n  <div class={{item.woDeferredDisplay}}><input type='checkbox' value= {{item.requestNbr}} [checked] = 'item.woDeferredChecked' id={{item.woDeferredName}} (click)=\"pendingWorkOrder('item.RequestNbr', 'item.caseNbr', 'item.refName')\"> Deferred\r\n  <br /></div>\r\n  <div class={{item.woAdmittedDisplay}}><input type='checkbox' id={{item.woAdmittedName}} value= {{item.requestNbr}} [checked] = 'item.woAdmittedChecked'  [(ngModel)]='item.woAdmittedChecked' (click)='getAdmittedChecked(item.requestNbr)'> Admitted Not Found\r\n  </div>\r\n  <div id='spacers'></div>\r\n  </table>\r\n  <div id='spacers'></div>\r\n  <div id='center'>\r\n      <a href=\"#top\">Click here to go to the top.</a>\r\n  </div>\r\n  <div id='spacers'></div>\r\n";

/***/ }),

/***/ "./src/app/researcherTaskList/researcherTaskList.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, ".Hide{DISPLAY:none}label{font-weight:400;display:block;padding:2px 0 32px}.hdrClass{font-size:8pt;font-family:Verdana,Tahoma,Arial;background-color:#ccf}#spacer{padding-top:1.6em}#spacersm{padding-top:3.5em}#spacerxsm{padding-top:.5em}#spacers{padding-top:2.5em}#wrapper{background-color:#ccf;margin:22px}#Wrapper{background-color:beige}#woHeader{margin:0 auto;border:.5;width:100%;padding-left:.5rem}#woHeader,#woHeader div{background-color:#ccf;display:inline-block}#woHeader div{padding:.7rem}#woHeader-left{width:38.5rem;vertical-align:left;text-align:left;display:fixed}#woHeader-main{width:15rem;text-align:right;display:fixed}#woHeader-rightmain{width:20.4rem;text-align:right;display:fixed}#woHeader-right{text-align:right;float:right}.Button{font-family:Verdana,Tahoma,Arial;background-color:#ccf}#woMain{margin:0 auto;font-size:8pt;background-color:beige;border:.5;width:100%;padding-left:4rem;padding-right:4rem;display:inline-block}#woButton-main{width:21rem}#woButton-left,#woButton-main{vertical-align:left;text-align:left;float:left}#woButton-left{width:15.2rem}#woLinkSelect{width:10rem}#woLinkClear,#woLinkSelect{vertical-align:left;text-align:left;float:left}#woLinkClear{width:41.5rem}#woButton-rightmain{width:24.3em;vertical-align:left;text-align:left;float:left}#woButton-right{text-align:right;float:left}#center{text-align:center}#woJuris-left{width:100.8em;vertical-align:left;text-align:left;float:left}#woJuris-right{width:122em}#woJuris,#woJuris-right{text-align:right;float:left}#woJuris{width:109.5em}#JurisdictionFilter{width:225px}.tblJuris{border:0;-webkit-column-span:2;column-span:2;width:95%}.tblJuris .first{vertical-align:\"left\";width:\"70%\"}.tblJuris .second{vertical-align:\"left\";width:\"25%\"}.tblWO{border:.5;-webkit-column-span:6;column-span:6;width:100%;padding-left:4rem;padding-right:4rem}.tblWO .first{width:3%;font-size:8pt;-ms-flex-line-pack:center;align-content:center}.tblWO .second{word-wrap:break-word}.tblWO .second,.tblWO .third{width:35rem;text-align:left;font-size:8pt}.tblWO .fourth{width:32rem}.tblWO .fifth,.tblWO .fourth{font-size:8pt;text-align:left}.tblWO .fifth{width:20rem}.tblWO .sixth{width:10%;vertical-align:\"left\";font-size:8pt;text-align:left}.btnClass>ul>li{list-style-type:none;display:inline-block;padding:5px 10px}.link{FONT-FAMILY:Verdana,Tahoma,Arial;font-size:10px;width:95px}.DisplayLate{color:tomato}.Display,.DisplayLate{border-right:medium none;border-top:medium none;font-size:8pt;border-left:medium none;border-bottom:medium none;font-family:Verdana,Tahoma,Arial;background-color:beige}.Disable{pointer-events:none;cursor:default;color:gray}.Invisible{display:none}div{overflow:hidden}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/researcherTaskList/researcherTaskList.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var index_1 = __webpack_require__("./src/models/index.ts");
var index_2 = __webpack_require__("./src/services/index.ts");
var browserWindowObjectService_1 = __webpack_require__("./src/services/browserWindowObjectService.ts");
var alertifyPromise_1 = __webpack_require__("./src/models/alertifyPromise.ts");
var popupHelper_1 = __webpack_require__("./src/models/popupHelper.ts");
var complianceAuditLog_1 = __webpack_require__("./src/models/complianceAuditLog.ts");
var complianceAuditLogService_1 = __webpack_require__("./src/services/complianceAuditLogService.ts");
var woc;
(function (woc) {
    woc["removePending"] = "RP";
    woc["noHits"] = "NH";
    woc["removeNoHits"] = "RH";
    woc["pendingRequest"] = "PR";
})(woc = exports.woc || (exports.woc = {}));
var ResearcherTaskListComponent = (function () {
    function ResearcherTaskListComponent(router, researcherService, route, bwObjectService, msgSvc, complianceAuditLogService) {
        var _this = this;
        this.router = router;
        this.researcherService = researcherService;
        this.route = route;
        this.bwObjectService = bwObjectService;
        this.msgSvc = msgSvc;
        this.complianceAuditLogService = complianceAuditLogService;
        this.totalWorkOrdersOnPage = 0;
        this.totalWorkOrders = 0;
        this.submitTaskDialog = [];
        this.submitTask = [];
        this.filter = [];
        this.defaultStr = 'Not Selected';
        this.wo = [];
        this.stateData = [];
        this.jurFilters = [];
        this.originalAdmitted = [];
        this.admittedAll = [];
        this.requestNbrs = [];
        this.model = {};
        this.headerRP = 0;
        this.headerNH = 0;
        this.headerRH = 0;
        this.headerPR = 0;
        this.model.jurisdictionId = 0;
        this.woComplete = new index_1.WorkOrderComplete;
        this.submitList = new index_1.SubmitTask;
        this.model.viewAsLink = false;
        this.route.params.subscribe(function (params) {
            _this.model.requestType = params['status'];
            _this.model.type = localStorage.getItem('sortType');
            _this.model.jurisdictionId = (params['jurisdictionId'] === undefined) ? 0 : params['jurisdictionId'];
            _this.model.selectedValue = 0;
        });
    }
    ResearcherTaskListComponent.prototype.ngOnInit = function () {
        this.msgSvc.setControlKey(); // ('CacheControlKey');
        if (this.model.type === 'sorting') {
            this.model.selectedValue = JSON.parse(localStorage.getItem('selection'));
            this.totalWorkOrdersOnPage = this.wo.length;
            this.totalWorkOrders = this.wo.length;
            if (this.model.selectedValue !== 'ns') {
                this.filterWorkOrderList();
            }
            else {
                this.getResearcherTaskData();
            }
            this.removeSortingArray();
        }
        else {
            this.setDefaultOrder();
            this.getResearcherTaskData();
        }
        this.model.isSubmitDisabled = false;
    };
    ResearcherTaskListComponent.prototype.getJurisdiction = function () {
        for (var _i = 0, _a = JSON.parse(localStorage.getItem('jurisdictions')); _i < _a.length; _i++) {
            var item = _a[_i];
            this.juris = {
                jurisdictionId: item.jurisdictionId,
                description: item.description,
                count: 0
            };
            this.jurFilters.push(this.juris);
        }
    };
    ResearcherTaskListComponent.prototype.getResearcherTaskData = function () {
        var _this = this;
        var i = 0;
        this.taskList = new index_1.ResearcherTaskList;
        this.woData = new index_1.WorkOrder;
        this.wo.length = 0;
        this.jurFilters.length = 0;
        this.stateData.length = 0;
        this.researcherService.getResearchTaskList(this.model.requestType, this.model.jurisdictionId)
            .subscribe(function (data) {
            _this.totalWorkOrdersOnPage = data.length;
            _this.totalWorkOrders = data.length;
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var item = data_1[_i];
                for (0; i < 1; i++) {
                    _this.taskList = {
                        calculatedValue: (item.sourceType === 'EX') ? _this.getExTotal(item) : _this.getIntTotal(item),
                        currentSysDt: item.iso_SysDt, crrsrCount: 17, dataType1: 'string', dataType2: 'number',
                        dataType3: 'number', detailWork: _this.model.requestType,
                        displayNumber: (item.sourceType === 'EX') ? _this.getExDisplayNumber(item) : _this.getIntDisplayNumber(item),
                        emailAddress: item.emailAddress, errorDescription: '', filterText: '', filterTotal: 1, fullName: item.sourceName,
                        gisUserName: item.gisUserName, lateTotal: item.lateTotal, max: 100, min: 1,
                        newTotal: item.newTotal, numbers: (item.newTotal > item.max) ? item.max : item.newTotal,
                        requestTotal: item.requestTotal, sortOne: 'jurisdiction', sortTwo: 'dis_RequestDt',
                        sortThree: 'refName', sortOrder1: 'ascending', sortOrder2: 'descending', sortOrder3: 'ascending',
                        sourceName: item.sourceName, sourceType: item.sourceType, sysID: '', totalDisplayRequest: 1
                    };
                }
                _this.woData = {
                    admissionInfo: '',
                    admittedCrimeNotFound: item.admittedCrimeNotFound,
                    caseNbr: item.caseNbr,
                    checked: false,
                    crrsrCount: 200,
                    custId: item.custId,
                    deferred: item.deferred,
                    dis_DueDt: item.dis_DueDt,
                    dis_RequestDt: item.dis_RequestDt,
                    dis_RequestDt_sort: new Date(item.dis_RequestDt),
                    dob: item.dob,
                    dobDisplay: (item.dob !== '') ? item.dob : 'No DOB On File',
                    driversLicense: '',
                    emailAddress: item.emailAddress,
                    filterText: item.filterText,
                    filterTotal: 100,
                    hrefAttachDoc: item.hrefAttachDoc,
                    hrefCif: item.hrefCif,
                    gisUserName: item.gisUserName,
                    isLate: _this.getLateStatus(_this.model.requestType, item.dis_DueDt, item.iso_SysDt),
                    iso_DueDt: item.iso_DueDt,
                    iso_SysDt: item.iso_SysDt,
                    jurisdiction: item.jurisdiction,
                    jurisdictionId: item.jurisdictionId,
                    lateTotal: item.lateTotal,
                    linkColor: _this.getLinkColor(item),
                    manualInd: item.manualInd,
                    max: 100,
                    min: 1,
                    nameRefNbr: item.nameRefNbr,
                    newTotal: item.newTotal,
                    ociIndicator: item.ociIndicator,
                    pendingComments: item.pendingComments,
                    phone: '',
                    position: '',
                    printInd: item.printInd,
                    recordFound: item.recordFound,
                    refAddr1: item.refAddr1,
                    refCity: item.refCity,
                    refName: item.refName,
                    refState: item.refState,
                    refZip: item.refZip,
                    requestNbr: item.requestNbr,
                    requestTotal: item.requestTotal,
                    reportAll: item.reportAll,
                    reportAllText: _this.getReportAllText(item),
                    searchFromDt: item.searchFromDt,
                    searchToDt: item.searchToDt,
                    signedRelInd: item.signedRelInd,
                    sourceName: item.sourceName,
                    sourceType: item.sourceType,
                    specialInstr: item.specialInstr,
                    showInstruction: (item.specialInstr === 'Y') ? 'Display' : 'Invisible',
                    ssn: item.ssn,
                    ssnDisplay: (item.ssn.length > 0) ? 'XXX-XX-' + item.ssn.substr(5) : 'No Social Security Nbr On File',
                    status: item.status,
                    strWork: '',
                    totalInstruction: (item.specialInstr === 'Y') ? 1 : 0,
                    url: '',
                    woPhone: (_this.validatePhone(item.sourceType, item.phone)) ? item.phone : '',
                    woSourceName: (_this.model.requestType === 'ByCaseAll') ? item.sourceName : '',
                    woURL: (_this.validateUrl(item.sourceType, item.url)) ? item.url : '',
                    woValue: _this.getCaseStatus(item),
                    woNoHitsDisable: _this.setDisabled(item, 'NoHits'),
                    woPendingDisable: _this.setDisabled(item, 'Pending'),
                    woNoHitsDisplay: _this.display(item, 'NoHits'),
                    woManualDisplay: _this.display(item, 'Manual'),
                    woPendingDisplay: _this.display(item, 'Pending'),
                    woPendingLinkDisplay: _this.display(item, 'PendingLink'),
                    woRecordDisplay: _this.display(item, 'RecordFound'),
                    woCommentsDisplay: _this.display(item, 'Comments'),
                    woSearchDisplay: _this.display(item, 'SearchCapture'),
                    woDeferredDisplay: _this.display(item, 'Deferred'),
                    woAdmittedDisplay: '',
                    woNoHitsChecked: _this.setCheckbox(item, 'NoHits'),
                    woManualChecked: _this.setCheckbox(item, 'Manual'),
                    woPendingChecked: _this.setCheckbox(item, 'Pending'),
                    woDeferredChecked: _this.setCheckbox(item, 'Deferred'),
                    woAdmittedChecked: _this.setCheckbox(item, 'Admitted'),
                    woNoHitsName: 'cbNoHits' + item.requestNbr,
                    woManualName: 'cbManual' + item.requestNbr,
                    woPendingName: 'cbPending' + item.requestNbr,
                    woDeferredName: 'cbDeferred' + item.requestNbr,
                    woAdmittedName: 'cbAdmitted' + item.requestNbr,
                    licenseNumber: item.licenseNumber,
                    isHeightenedIdentifier: item.isHeightenedIdentifier,
                    colorValue: _this.getColorValue(item.status, item.dis_DueDt, item.iso_SysDt),
                };
                _this.wo.push(_this.woData);
            }
            for (var _a = 0, _b = JSON.parse(localStorage.getItem('jurisdictions')); _a < _b.length; _a++) {
                var item = _b[_a];
                _this.juris = {
                    jurisdictionId: item.jurisdictionId,
                    description: item.description,
                    count: 0
                };
                _this.jurFilters.push(_this.juris);
            }
        });
        this.stateData = this.wo;
        this.isJurisVisible();
    };
    ResearcherTaskListComponent.prototype.isJurisVisible = function () {
        if (this.taskList.sourceType === 'EX') {
            if (this.taskList.detailWork === 'New' || this.taskList.detailWork === 'Late' || this.taskList.detailWork === 'Filter') {
                return true;
            }
            else {
                return false;
            }
        }
        else if (this.taskList.sourceType === undefined) {
            return true;
        }
        else {
            return false;
        }
    };
    ResearcherTaskListComponent.prototype.isVisible = function (type, validate) {
        if (type === 'IH') {
            return (validate !== '') ? true : false;
        }
        else {
            return false;
        }
    };
    ResearcherTaskListComponent.prototype.getCaseStatus = function (item) {
        var status;
        if (item.sourceType === 'IH') {
            if (item.custId !== '') {
                status = "<a routerLinkActive='active' href=\"" + item.hrefCif + "custID= " + item.custId + "\" target=\"_blank\">{{item.custId}}</a>";
            }
        }
        if (item.printInd === 'Y') {
            status = 'Has Been Printed';
            this.model.viewAsLink = false;
        }
        if (item.signedRelInd === 'Y') {
            status = 'Release Required';
            this.model.viewAsLink = false;
        }
        if (item.status === 'W' || item.status === 'C' || item.status === 'U' || item.status === 'E' || item.signedRelInd === 'Y' || item.ociIndicator === 'Y') {
            status = item.custId;
            this.model.viewAsLink = false;
        }
        return status;
    };
    ResearcherTaskListComponent.prototype.getReportAllText = function (item) {
        var status;
        if (item.reportAllText !== '' && item.reportAllText !== null && item.reportAllText !== undefined) {
            status = item.reportAllText;
        }
        else {
            status = '';
        }
        return status;
    };
    ResearcherTaskListComponent.prototype.getExDisplayNumber = function (item) {
        if (this.model.requestType === 'New') {
            var number = (item.newTotal > item.max) ? item.max : item.newTotal;
            return (number > item.newTotal) ? item.newTotal : number;
        }
        else if (this.model.requestType === 'Late') {
            return (item.lateTotal > item.max) ? item.max : item.lateTotal;
        }
        else if (this.taskList.filterText !== '') {
            return (item.filterTotal > item.max) ? item.max : item.filterTotal;
        }
        else if (this.model.requestType === 'Filter') {
            return (item.filterTotal > item.max) ? item.filterTotal : item.max;
        }
        else {
            return (this.taskList.totalDisplayRequest > item.max) ? item.max : this.taskList.totalDisplayRequest;
        }
    };
    ResearcherTaskListComponent.prototype.getExTotal = function (item) {
        if (this.model.requestType === 'New') {
            return item.newTotal;
        }
        else if (this.model.requestType === 'Late') {
            return item.lateTotal;
        }
        else if ((item.filterText !== '') || (this.model.requestType === 'Filter')) {
            return item.filterTotal;
        }
        else {
            return this.taskList.totalDisplayRequest;
        }
    };
    ResearcherTaskListComponent.prototype.getIntDisplayNumber = function (item) {
        if (this.model.requestType === 'New') {
            return (this.taskList.totalDisplayRequest > item.newTotal) ? item.newTotal : this.taskList.totalDisplayRequest;
        }
        else if (this.model.requestType === 'Late') {
            return (this.taskList.totalDisplayRequest > item.lateTotal) ? item.lateTotal : this.taskList.totalDisplayRequest;
        }
        else {
            return (item.max > this.taskList.totalDisplayRequest) ? this.taskList.totalDisplayRequest : item.max;
        }
    };
    ResearcherTaskListComponent.prototype.getIntTotal = function (item) {
        if (this.model.requestType === 'New') {
            return item.newTotal;
        }
        else if (this.model.requestType === 'Late') {
            return item.lateTotal;
        }
        else {
            return this.taskList.totalDisplayRequest;
        }
    };
    ResearcherTaskListComponent.prototype.validateUrl = function (sourceType, url) {
        if (sourceType === 'IH') {
            return (url !== '') ? true : false;
        }
        else {
            return false;
        }
    };
    ResearcherTaskListComponent.prototype.getColorValue = function (status, disDueDt, isoSysDt) {
        var color;
        if (status === 'C' || status === 'W' || status === 'U') {
            color = 'Green';
        }
        else if (status === 'I' || status === 'L' || status === 'Q') {
            color = (this.parseDate(disDueDt, isoSysDt)) ? 'Red' : 'Black';
        }
        else {
            color = (this.getLateStatus(this.model.requestType, disDueDt, isoSysDt)) ? 'Red' : 'Black';
        }
        return color;
    };
    ResearcherTaskListComponent.prototype.getLateStatus = function (detailWork, disDueDt, isoSysDt) {
        if (detailWork === 'Late') {
            return true;
        }
        else {
            return (this.parseDate(disDueDt, isoSysDt)) ? true : false;
        }
    };
    ResearcherTaskListComponent.prototype.parseDate = function (disDueDt, isoSysDt) {
        return (new Date(disDueDt) < new Date(isoSysDt)) ? true : false;
    };
    ResearcherTaskListComponent.prototype.validatePhone = function (sourceType, phone) {
        if (sourceType === 'IH') {
            return (phone !== '') ? true : false;
        }
        else {
            return false;
        }
    };
    ResearcherTaskListComponent.prototype.display = function (item, type) {
        var display = '';
        switch (type) {
            case 'NoHits': {
                display = 'Display';
                break;
            }
            case 'Manual': {
                if (item.ociIndicator === 'Y') {
                    display = 'Display';
                }
                else {
                    display = 'Invisible';
                }
                break;
            }
            case 'Pending': {
                display = 'Display';
                break;
            }
            case 'PendingLink': {
                if (item.status === 'C' || item.status === 'W' || item.status === 'U') {
                    display = 'Disable';
                }
                else {
                    display = 'Display';
                }
                break;
            }
            case 'Deferred': {
                if (item.status === 'Q') {
                    display = 'Display';
                }
                else {
                    display = 'Invisible';
                }
                break;
            }
            case 'SearchCapture': {
                if (item.status !== 'C' && item.status !== 'W' && item.status !== 'U') {
                    if (this.taskList.sourceType !== 'EX') {
                        display = 'Display';
                    }
                    else {
                        display = 'Invisible';
                    }
                }
                else {
                    display = 'Invisible';
                }
                break;
            }
            case 'RecordFound': {
                if (item.status === 'C' || item.status === 'W' || item.status === 'U') {
                    if (item.recordFound === 'Y') {
                        if (item.status !== 'W') {
                            if (item.specialInstr === 'Y') {
                                display = 'Disable';
                            }
                            else {
                                display = 'Display';
                            }
                        }
                        else if (item.status === 'W') {
                            if (item.specialInstr === 'Y') {
                                display = 'Disable';
                            }
                            else {
                                display = 'Display';
                            }
                        }
                    }
                }
                else {
                    if (item.specialInstr === 'Y') {
                        display = 'Disable';
                    }
                    else {
                        display = 'Display';
                    }
                }
                break;
            }
            default: {
                display = 'Display';
            }
        }
        return display;
    };
    ResearcherTaskListComponent.prototype.getLinkColor = function (item) {
        if (item.specialInstr === 'Y') {
            return 'Gray';
        }
        else {
            return 'Blue';
        }
    };
    ResearcherTaskListComponent.prototype.setCheckbox = function (item, type) {
        var checked = false;
        switch (type) {
            case 'NoHits': {
                if (item.status === 'C' || item.status === 'W' || item.status === 'U') {
                    if (item.recordFound === 'Y') {
                        checked = true;
                        item.woNoHitsDisable = true;
                    }
                }
                else {
                    if (item.specialInstr === 'Y') {
                        item.woNoHitsDisable = true;
                    }
                    checked = false;
                }
                break;
            }
            case 'Manual': {
                if (item.ociIndicator === 'Y') {
                    if (item.manualInd === 'Y') {
                        checked = true;
                    }
                    else {
                        checked = false;
                    }
                }
                break;
            }
            case 'Pending': {
                if (item.status === 'P') {
                    checked = true;
                }
                else {
                    checked = false;
                }
                break;
            }
            case 'Deferred': {
                if (item.status === 'Q') {
                    if (item.deferred === 'o') {
                        checked = true;
                    }
                    else {
                        checked = false;
                    }
                }
                break;
            }
            case 'Admitted': {
                if (item.admittedCrimeNotFound === true) {
                    checked = true;
                    this.originalAdmitted.push(item.requestNbr);
                }
                else {
                    checked = false;
                }
                break;
            }
            default: {
                checked = false;
            }
        }
        return checked;
    };
    ResearcherTaskListComponent.prototype.setDisabled = function (item, type) {
        var disable = false;
        switch (type) {
            case 'NoHits': {
                if (item.status === 'C' || item.status === 'W' || item.status === 'U') {
                    if (item.recordFound === 'Y' || (item.specialInstr === 'Y')) {
                        disable = true;
                    }
                    else if (item.recordFound === 'N' || (item.specialInstr === 'Y')) {
                        disable = true;
                    }
                }
                else {
                    if (item.specialInstr === 'Y') {
                        disable = true;
                    }
                }
                break;
            }
            case 'Pending': {
                if (item.status === 'C' || item.status === 'W' || item.status === 'U') {
                    disable = true;
                }
                else {
                    disable = false;
                }
                break;
            }
            default: {
                disable = false;
            }
        }
        return disable;
    };
    ResearcherTaskListComponent.prototype.pendingWorkOrder = function (objValue, requestNbr, caseNbr, refName, status) {
        this.getOriginalState(requestNbr);
        for (var _i = 0, _a = this.wo; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.requestNbr === +requestNbr) {
                this.woComplete.pendingComments = item.pendingComments;
                break;
            }
        }
        this.woComplete.requestNbr = requestNbr;
        this.woComplete.caseNbr = caseNbr;
        this.woComplete.refName = refName;
        this.woComplete.currentStatus = status;
        this.noHits = document.getElementById('cbNoHits' + requestNbr);
        this.pending = document.getElementById('cbPending' + requestNbr);
        if (objValue === 'Link') {
            if (!this.pending.checked) {
                this.woComplete.pendingComments = null;
                this.pendingWOHelper('Pending comment not checked.');
            }
            else if (this.woComplete.pendingComments === null || this.woComplete.pendingComments === '') {
                this.pendingWOHelper('There are no pending comments for this request.');
                this.pending.checked = false;
            }
            else {
                var holdComment = this.woComplete.pendingComments;
                if (this.woComplete.pendingComments === undefined) {
                    this.woComplete.pendingComments = window.prompt('Please enter an explanation for placing this Work Order into a Pending Status.', '');
                }
                else {
                    this.woComplete.pendingComments = window.prompt('Please enter an explanation for placing this Work Order into a Pending Status.', this.woComplete.pendingComments);
                }
                // canceled
                if (this.woComplete.pendingComments === null) {
                    this.woComplete.pendingComments = holdComment;
                    if (holdComment === '' || holdComment === undefined || holdComment === null) {
                        this.pending.checked = false;
                    }
                    else {
                        this.pending.checked = true;
                    }
                }
                for (var _b = 0, _c = this.wo; _b < _c.length; _b++) {
                    var item = _c[_b];
                    if (item.requestNbr === +requestNbr) {
                        if (this.pending.checked === true && (this.woComplete.pendingComments !== null || this.woComplete.pendingComments !== undefined)) {
                            item.pendingComments = this.woComplete.pendingComments;
                            break;
                        }
                        else if (this.pending.checked === false || this.woComplete.pendingComments === undefined) {
                            item.pendingComments = null;
                            break;
                        }
                    }
                }
                if (this.pending.checked === true) {
                    this.woComplete.currentStatus = 'P';
                    this.populateList(this.woComplete.requestNbr, this.woComplete.pendingComments, this.woComplete.currentStatus);
                }
            }
            return;
        }
        if (this.pending.checked === true) {
            if (this.woComplete.pendingComments === undefined || this.woComplete.pendingComments === null || this.woComplete.pendingComments === '') {
                this.woComplete.pendingComments = '';
            }
            this.woComplete.pendingComments = this.woComplete.pendingComments;
            this.woComplete.pendingComments = window.prompt('Please enter an explanation for placing this Work Order into a Pending Status.', this.woComplete.pendingComments);
            if (this.woComplete.pendingComments === undefined || this.woComplete.pendingComments === '' || this.woComplete.pendingComments === null) {
                this.pending.checked = false;
                if (this.noHits.checked === true) {
                    this.noHits.checked = true;
                }
                this.pendingWOHelper('A comment must be entered when a Work Order is placed in Pending Status.');
            }
            if (this.woComplete.currentStatus === 'C') {
                this.woComplete.removeNoHit = "No longer marked as No Record - Reference Name: " + this.woComplete.refName + " Work Order Nbr: " + this.woComplete.caseNbr + '\n\n';
                this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.removeNoHit, this.woComplete.removeNoHitsMsg, woc.removeNoHits);
                this.noHits.checked = false;
                this.woComplete.currentStatus = 'P';
                this.woComplete.pendingRequests = "Set To Pending - Reference Name: " + this.woComplete.refName + "  Work Order Nbr: " + this.woComplete.caseNbr + '\n\n';
                this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.pendingRequests, this.woComplete.pendingRqstMsg, woc.pendingRequest);
            }
            else if (this.pending.checked === true) {
                this.woComplete.currentStatus = 'P';
                this.noHits.checked = false;
                this.woComplete.pendingRequests = "Set To Pending - Reference Name: " + this.woComplete.refName + " Work Order Nbr: " + this.woComplete.caseNbr + '\n\n';
                this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.pendingRequests, this.woComplete.pendingRqstMsg, woc.pendingRequest);
            }
            else {
                this.woComplete.currentStatus = 'I';
                if (this.noHits.checked === true) {
                    this.noHits.checked = true;
                }
                else {
                    this.noHits.checked = false;
                }
            }
        }
        else {
            if (this.woComplete.currentStatus === 'P') {
                this.woComplete.removePending = "No longer marked as Pending - Reference Name: " + this.woComplete.refName + " Work Order Nbr: " + this.woComplete.caseNbr + '\n\n';
                this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.removePending, this.woComplete.removePendingMsg, woc.removePending);
                this.pending.checked = false;
                this.woComplete.currentStatus = 'I';
            }
            else {
                this.woComplete.currentStatus = 'I';
                this.woComplete.removePending = '\n' + ("No longer marked as Pending - Reference Name: " + this.woComplete.refName + " Work Order Nbr: " + this.woComplete.caseNbr) + '\n\n';
                this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.removePending, this.woComplete.removePendingMsg, woc.removePending);
            }
        }
        for (var _d = 0, _e = this.wo; _d < _e.length; _d++) {
            var item = _e[_d];
            if (item.requestNbr === +requestNbr) {
                if (this.woComplete.pendingComments !== '') {
                    item.pendingComments = this.woComplete.pendingComments;
                    break;
                }
            }
        }
        this.populateList(this.woComplete.requestNbr, this.woComplete.pendingComments, this.woComplete.currentStatus);
    };
    ResearcherTaskListComponent.prototype.completeWorkOrder = function (requestNbr, caseNbr, refName) {
        this.woComplete.requestNbr = requestNbr;
        this.woComplete.caseNbr = caseNbr;
        this.woComplete.refName = refName;
        this.noHits = document.getElementById('cbNoHits' + requestNbr);
        this.pending = document.getElementById('cbPending' + requestNbr);
        if (this.noHits.checked === true) {
            if (this.pending.checked === true) {
                this.pending.checked = false;
            }
            this.noHitsConfirmation("You have selected No Record Found. Select OK to confirm or Cancel to remove selection.", requestNbr, true);
        }
        else {
            this.noHitsConfirmation("You have removed the selection of No Record Found. Select OK to confirm or Cancel to keep No Record selected.", requestNbr, false);
        }
    };
    ResearcherTaskListComponent.prototype.populateList = function (requestNbr, comment, status) {
        if (!this.checkList(requestNbr)) {
            this.populateTaskList(requestNbr, comment, status, false);
        }
        else {
            this.submitTask = this.submitTask.filter(function (item) { return item.RequestNbr !== requestNbr; });
            this.populateTaskList(requestNbr, comment, status, false);
        }
    };
    ResearcherTaskListComponent.prototype.checkList = function (requestNbr) {
        var exists = false;
        for (var _i = 0, _a = this.submitTask; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.RequestNbr === requestNbr) {
                exists = true;
                break;
            }
        }
        return exists;
    };
    ResearcherTaskListComponent.prototype.openWindow = function (type, caseNbr, requestNbr) {
        switch (type) {
            case 'Edit': {
                this.confirmEditVerifications(requestNbr, caseNbr);
                break;
            }
            default: {
            }
        }
    };
    ResearcherTaskListComponent.prototype.specialInstruction = function (requestNbr) {
        this.noHits = document.getElementById('cbNoHits' + requestNbr);
        for (var _i = 0, _a = this.wo; _i < _a.length; _i++) {
            var item = _a[_i];
            if (this.noHits.defaultValue === item.requestNbr.toString()) {
                item.woNoHitsDisable = false;
                item.woRecordDisplay = 'Display';
                item.linkColor = 'Blue';
                break;
            }
        }
        this.msgSvc.saveRequestNbrs(JSON.stringify(requestNbr));
        this.bwObjectService.openInNewWindowByRoute('specialInstruction', 'SIWin', '', 800, 520);
    };
    ResearcherTaskListComponent.prototype.confirmEditVerifications = function (requestNbr, refNbr) {
        this.noHits = document.getElementById('cbNoHits' + requestNbr);
        this.pending = document.getElementById('cbPending' + requestNbr);
        this.woComplete.submit = 'true';
        var state = (this.noHits.checked === true || this.pending.checked === true) ? 1 : 0;
        var msg = '';
        if (this.noHits.checked === true) {
            msg = 'Selecting Ok will remove the selection of No Record.  Would you like to continue?';
            this.confirmRemovingNoRecordStatus(msg, refNbr, requestNbr, state);
        }
        else if (this.pending.checked === true) {
            msg = 'Would you like to remove the Pending Status on this request?  Select OK to remove it and Cancel to keep it.';
            this.confirmRemovingPendingStatus(msg, refNbr, requestNbr, state);
        }
        else if (this.submitTaskDialog.length > 0) {
            this.confirmWorkOrderStatus('OffenseEntry', true, 'R', requestNbr, state);
        }
        else {
            this.router.navigate(['offense', requestNbr]);
        }
    };
    ResearcherTaskListComponent.prototype.confirmWorkOrderStatus = function (objFrom, valid, type, requestNbr, state) {
        this.woComplete.submit = 'true';
        this.sortTaskDialog();
        this.woComplete.alertMsg = undefined;
        for (var _i = 0, _a = this.submitTaskDialog; _i < _a.length; _i++) {
            var item = _a[_i];
            switch (item.type) {
                case 'PR':
                    if (this.headerPR === 0) {
                        if (this.woComplete.alertMsg === undefined) {
                            this.woComplete.alertMsg = this.woComplete.msgLine + " " + item.header + " \n  " + item.comments + " " + this.woComplete.breakLine;
                        }
                        else {
                            this.woComplete.alertMsg = this.woComplete.alertMsg + " " + this.woComplete.msgLine + " " + item.header + " \n " + item.comments + " " + this.woComplete.breakLine;
                        }
                        this.headerPR = 1;
                    }
                    else {
                        if (this.woComplete.alertMsg === undefined) {
                            this.woComplete.alertMsg = item.comments + " " + this.woComplete.breakLine;
                        }
                        else {
                            this.woComplete.alertMsg = this.woComplete.alertMsg + " " + item.comments + " " + this.woComplete.breakLine;
                        }
                    }
                    break;
                case 'RH': {
                    if (this.headerRH === 0) {
                        if (this.woComplete.alertMsg === undefined) {
                            this.woComplete.alertMsg = this.woComplete.msgLine + " " + item.header + " \n " + item.comments + " " + this.woComplete.breakLine;
                        }
                        else {
                            this.woComplete.alertMsg = this.woComplete.alertMsg + " " + this.woComplete.msgLine + " " + item.header + " \n  " + item.comments + " " + this.woComplete.breakLine;
                        }
                        this.headerRH = 1;
                    }
                    else {
                        if (this.woComplete.alertMsg === undefined) {
                            this.woComplete.alertMsg = item.comments + " " + this.woComplete.breakLine;
                        }
                        else {
                            this.woComplete.alertMsg = this.woComplete.alertMsg + " " + item.comments + " " + this.woComplete.breakLine;
                        }
                    }
                    break;
                }
                case 'RP': {
                    if (this.headerRP === 0) {
                        if (this.woComplete.alertMsg === undefined) {
                            this.woComplete.alertMsg = this.woComplete.msgLine + " " + item.header + " \n " + item.comments + " " + this.woComplete.breakLine;
                        }
                        else {
                            this.woComplete.alertMsg = this.woComplete.alertMsg + " " + this.woComplete.msgLine + " " + item.header + " \n " + item.comments + " " + this.woComplete.breakLine;
                        }
                        this.headerRP = 1;
                    }
                    else {
                        if (this.woComplete.alertMsg === undefined) {
                            this.woComplete.alertMsg = item.comments + " " + this.woComplete.breakLine;
                        }
                        else {
                            this.woComplete.alertMsg = this.woComplete.alertMsg + " " + item.comments + " " + this.woComplete.breakLine;
                        }
                    }
                    break;
                }
                case 'NH': {
                    if (this.headerNH === 0) {
                        if (this.woComplete.alertMsg === undefined) {
                            this.woComplete.alertMsg = this.woComplete.msgLine + " " + item.header + " \n  " + item.comments + " " + this.woComplete.breakLine;
                        }
                        else {
                            this.woComplete.alertMsg = this.woComplete.alertMsg + " " + this.woComplete.msgLine + " " + item.header + " \n " + item.comments + " " + this.woComplete.breakLine;
                        }
                        this.headerNH = 1;
                    }
                    else {
                        if (this.woComplete.alertMsg === undefined) {
                            this.woComplete.alertMsg = item.comments + " " + this.woComplete.breakLine;
                        }
                        else {
                            this.woComplete.alertMsg = this.woComplete.alertMsg + " " + item.comments + " " + this.woComplete.breakLine;
                        }
                    }
                    break;
                }
                default:
                    break;
            }
        }
        if (type === 'S') {
            this.woComplete.alertMsgS = this.woComplete.alertMsg;
        }
        else if (type === 'R') {
            this.woComplete.alertMsgR = this.woComplete.alertMsg;
        }
        if (valid) {
            var msg = '';
            if (this.woComplete.alertMsg !== undefined) {
                this.woComplete.alertMsg = undefined;
                if (this.woComplete.alertMsgS !== undefined && type === 'S') {
                    msg = this.woComplete.alertMsgS + " " + this.woComplete.confirmationMsg;
                }
                else if (this.woComplete.alertMsgR !== undefined && type === 'R') {
                    msg = this.woComplete.alertMsgR + " " + this.woComplete.confirmationMsg;
                }
                this.confirmSubmit(msg, type, requestNbr);
            }
            else if (objFrom === 'Submit' && this.woComplete.alertMsgS === undefined && this.admittedCrimeCheckboxesChanged()) {
                this.getAllRequestsNotPreviouslyMarkedAdmittedCrimeNotFound();
                this.logComplianceLogs();
                this.submit();
                this.woComplete.submit = 'true';
                this.router.navigate(['navigation']);
            }
            else {
                if (objFrom === 'OffenseEntry') {
                    if (this.woComplete.alertMsgR === '' || this.woComplete.alertMsgR === undefined || this.woComplete.alertMsgR === null) {
                        this.woComplete.submit = 'noChange';
                        this.router.navigate(['offense', requestNbr]);
                    }
                }
                if (objFrom === 'Submit') {
                    if (this.submitTask.length > 0) {
                        this.getAllRequestsNotPreviouslyMarkedAdmittedCrimeNotFound();
                        this.logComplianceLogs();
                        this.submit();
                        this.woComplete.submit = 'true';
                        this.router.navigate(['navigation']);
                    }
                    else if (this.woComplete.alertMsgS === undefined && !this.admittedCrimeCheckboxesChanged()) {
                        this.noChangeHelper();
                        this.woComplete.submit = 'noChange';
                    }
                }
            }
        }
        else {
            if (objFrom === 'OffenseEntry' && state === 0) {
                this.router.navigate(['offense', requestNbr]);
            }
            else {
                this.woComplete.submit = '';
                if (requestNbr !== '') {
                    for (var _b = 0, _c = this.wo; _b < _c.length; _b++) {
                        var item = _c[_b];
                        if (requestNbr === item.requestNbr.toString()) {
                            item.woNoHitsDisable = false;
                            item.woRecordDisplay = 'Display';
                            break;
                        }
                    }
                }
            }
        }
    };
    ResearcherTaskListComponent.prototype.filterWorkOrderList = function () {
        if (this.model.selectedValue !== 'ns') {
            if (localStorage.getItem('jurisdictionId') !== '0' && localStorage.getItem('jurisdictionId') !== null) {
                this.model.jurisdictionId = JSON.parse(localStorage.getItem('jurisdictionId'));
                localStorage.removeItem('jurisdictionId');
            }
            else {
                this.model.jurisdictionId = this.model.selectedValue;
            }
            this.getResearcherTaskData();
        }
    };
    ResearcherTaskListComponent.prototype.submitTaskListDisabled = function () {
        return (this.model.isSubmitDisabled) ? true : false;
    };
    ResearcherTaskListComponent.prototype.submitTaskList = function () {
        this.model.isSubmitDisabled = true;
        this.confirmWorkOrderStatus('Submit', true, 'S', '', 1);
        if (this.woComplete.submit === 'noChange') {
            this.model.isSubmitDisabled = false;
            return;
        }
    };
    ResearcherTaskListComponent.prototype.submit = function () {
        var _this = this;
        this.researcherService.submitTaskListData(this.submitTask)
            .subscribe(function (data) {
            if (data === 200) {
                _this.woComplete = new index_1.WorkOrderComplete;
            }
            else {
                popupHelper_1.default.userHelper('Unable to submit updates', 'error');
            }
            _this.model.isSubmitDisabled = false;
        });
    };
    ResearcherTaskListComponent.prototype.selectAll = function () {
        this.wo.forEach(function (item) {
            item.checked = true;
        });
    };
    ResearcherTaskListComponent.prototype.removeAllSelection = function () {
        this.wo.forEach(function (item) {
            item.checked = false;
        });
    };
    ResearcherTaskListComponent.prototype.getAllAdmitted = function () {
        var _this = this;
        this.admittedAll.length = 0;
        this.wo.forEach(function (item) {
            if (item.woAdmittedChecked) {
                _this.admittedAll.push(item.requestNbr);
            }
        });
    };
    ResearcherTaskListComponent.prototype.getAdmittedChecked = function (requestNbr) {
        var _this = this;
        this.anf = document.getElementById('cbAdmitted' + requestNbr);
        if (!this.anf.checked) {
            this.wo.forEach(function (item) {
                if (item.requestNbr === +requestNbr && item.woAdmittedChecked === true) {
                    item.woAdmittedChecked = false;
                    _this.filterList(requestNbr);
                    _this.submitTask = _this.submitTask.filter(function (x) { return x.RequestNbr !== requestNbr; });
                    _this.populateTaskList(requestNbr, '', 'ANF', false);
                }
            });
        }
        else if (this.anf.checked) {
            this.wo.forEach(function (item) {
                if (item.requestNbr === +requestNbr && item.woAdmittedChecked === false) {
                    item.woAdmittedChecked = true;
                    _this.filterList(requestNbr);
                    _this.populateTaskList(requestNbr, '', 'ANF', true);
                }
            });
        }
    };
    ResearcherTaskListComponent.prototype.admittedCrimeCheckboxesChanged = function () {
        var inArray = false;
        this.getAllAdmitted();
        for (var _i = 0, _a = this.admittedAll; _i < _a.length; _i++) {
            var allRqsts = _a[_i];
            if (this.checkedChange(this.originalAdmitted, allRqsts)) {
                inArray = false;
            }
            else {
                inArray = true;
                break;
            }
        }
        return inArray;
    };
    ResearcherTaskListComponent.prototype.getAllRequestsNotPreviouslyMarkedAdmittedCrimeNotFound = function () {
        this.getAllAdmitted();
        for (var _i = 0, _a = this.admittedAll; _i < _a.length; _i++) {
            var allRqsts = _a[_i];
            if (!this.checkedChange(this.originalAdmitted, allRqsts)) {
                this.filterList(allRqsts);
                this.populateTaskList(allRqsts, '', 'ANF', true);
            }
        }
    };
    ResearcherTaskListComponent.prototype.logComplianceLogs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, allRqsts, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.getAllAdmitted();
                        _i = 0, _a = this.admittedAll;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 6];
                        allRqsts = _a[_i];
                        if (!!this.checkedChange(this.originalAdmitted, allRqsts)) return [3 /*break*/, 5];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.complianceAuditLogService.addComplianceAuditLogs([
                                new complianceAuditLog_1.default(allRqsts, 'ADMTTD_CRM_NOT_FND', 'ResearcherTaskList', null, null)
                            ])];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _b.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ResearcherTaskListComponent.prototype.checkedChange = function (arr, test) {
        return arr.some(function (arrVal) {
            return test === arrVal;
        });
    };
    ResearcherTaskListComponent.prototype.populateTaskList = function (requestNbr, comment, status, checked) {
        this.submitList = {
            RequestNbr: requestNbr,
            PendingComments: comment,
            Type: status,
            AdmittedCrimeNotFound: checked,
        };
        this.submitTask.push(this.submitList);
    };
    ResearcherTaskListComponent.prototype.goToNavigation = function () {
        this.router.navigate(['navigation']);
    };
    ResearcherTaskListComponent.prototype.gotoTop = function () {
        window.scrollTo(0, 0);
    };
    ResearcherTaskListComponent.prototype.displayReport = function (rptType) {
        var _this = this;
        for (var _i = 0, _a = this.wo; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.checked === true) {
                this.requestNbrs.push({ requestNbr: item.requestNbr });
            }
        }
        if (this.requestNbrs.length <= 0) {
            if (rptType === 'Received') {
                this.receivedDialog();
            }
            else if (rptType === 'Report') {
                this.reportDialog();
            }
        }
        else {
            if (rptType === 'Received') {
                this.researcherService.markRequestReceived(this.requestNbrs)
                    .subscribe(function () {
                    if (_this.researcherService.successful) {
                        _this.goToNavigation();
                    }
                });
            }
            else if (rptType === 'Report') {
                this.msgSvc.saveRequestNbrs(JSON.stringify(this.requestNbrs));
                this.bwObjectService.openInNewWindowByRoute('workOrderReport', 'WOWin', '', 920, 430);
                this.goToNavigation();
            }
        }
    };
    ResearcherTaskListComponent.prototype.createDateTime = function () {
        var today = new Date();
        var year = this.takeYear(today);
        var month = this.leadingZero(today.getMonth() + 1);
        var day = this.leadingZero(today.getDate());
        var minutes = this.leadingZero(today.getMinutes());
        var seconds = this.leadingZero(today.getSeconds());
        var hours = today.getHours();
        var ampm = 'am';
        if (hours === 0) {
            hours = 12;
        }
        else if (hours > 11) {
            ampm = 'pm';
        }
        else if (hours > 12) {
            hours -= 12;
        }
        hours = this.leadingZero(hours);
        return (month + '/' + day + '/' + year + ' ' + hours + ':' + minutes + ':' + seconds + ' ' + ampm);
    };
    ResearcherTaskListComponent.prototype.takeYear = function (dte) {
        return ((dte.getYear() % 100) < 38) ? 2000 : 1900;
    };
    ResearcherTaskListComponent.prototype.leadingZero = function (nbr) {
        if (nbr < 10) {
            nbr = '0' + nbr;
        }
        return nbr;
    };
    ResearcherTaskListComponent.prototype.showComment = function (requestNbr, status) {
        this.msgSvc.saveRequestNbrs(JSON.stringify(requestNbr));
        this.msgSvc.saveStatus(JSON.stringify(status));
        this.bwObjectService.openInNewWindowByRoute('comment', 'SIWin', '', 1005, 375);
    };
    ResearcherTaskListComponent.prototype.searchCapture = function (userID, requestNbr) {
        this.bwObjectService.searchCaptureOpen("http://dev2paperlesscrim.geninfo.com/IncomingUser.aspx?su=" + userID + "|" + requestNbr);
    };
    ResearcherTaskListComponent.prototype.watsonShowGuideline = function (route) {
        var address = route.substr(8);
        this.bwObjectService.watsonShowGuideline("http://dev2watson.geninfo.com/" + address);
    };
    ResearcherTaskListComponent.prototype.showLink = function () {
        if (this.model.viewAsLink === true) {
            return true;
        }
        else {
            return false;
        }
    };
    ResearcherTaskListComponent.prototype.help = function () {
        this.bwObjectService.openWindowInNewWindowByRoute("researcherHelp", '', 800, 900);
    };
    // ALERTS
    ResearcherTaskListComponent.prototype.receivedDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var alertResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popupHelper_1.default.userHelper('You have not selected any items to mark as received.', 'crim')];
                    case 1:
                        alertResult = _a.sent();
                        if (alertResult === alertifyPromise_1.AlertResult.Ok) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ResearcherTaskListComponent.prototype.reportDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var alertResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popupHelper_1.default.userHelper('You have not selected any items to print.', 'crim')];
                    case 1:
                        alertResult = _a.sent();
                        if (alertResult === alertifyPromise_1.AlertResult.Ok) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ResearcherTaskListComponent.prototype.exitDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var confirmResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popupHelper_1.default.exitSystemHelper()];
                    case 1:
                        confirmResult = _a.sent();
                        if (confirmResult === alertifyPromise_1.ConfirmResult.Ok) {
                            this.router.navigate(['exit']);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ResearcherTaskListComponent.prototype.confirmRemovingNoRecordStatus = function (message, refNbr, requestNbr, state) {
        return __awaiter(this, void 0, void 0, function () {
            var oHits, confirmResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        oHits = false;
                        return [4 /*yield*/, popupHelper_1.default.confirmSubmitHelper(message)];
                    case 1:
                        confirmResult = _a.sent();
                        if (confirmResult === alertifyPromise_1.ConfirmResult.Ok) {
                            this.woComplete.removeNoHit = "\n No longer marked as No Record - Work Order Nbr: " + refNbr + " Request Nbr: " + requestNbr;
                            this.populateSubmitComments(requestNbr, refNbr, this.woComplete.removeNoHit, this.woComplete.removeNoHitsMsg, woc.removeNoHits);
                            this.noHits.checked = false;
                            this.woComplete.persist = 'I';
                            this.woComplete.closeDt = '';
                            this.woComplete.newStatus = 'I';
                            this.populateList(requestNbr, '', this.woComplete.newStatus);
                        }
                        else {
                            this.noHits.checked = true;
                            oHits = this.noHits.checked;
                            this.populateList(requestNbr, '', this.woComplete.newStatus);
                        }
                        this.woComplete.submit = '';
                        this.confirmWorkOrderStatus('OffenseEntry', (oHits || this.pending.checked) ? true : false, 'R', this.noHits.defaultValue, state);
                        return [2 /*return*/];
                }
            });
        });
    };
    ResearcherTaskListComponent.prototype.confirmRemovingPendingStatus = function (message, refNbr, requestNbr, state) {
        return __awaiter(this, void 0, void 0, function () {
            var oPending, confirmResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        oPending = false;
                        return [4 /*yield*/, popupHelper_1.default.confirmSubmitHelper(message)];
                    case 1:
                        confirmResult = _a.sent();
                        if (confirmResult === alertifyPromise_1.ConfirmResult.Ok) {
                            this.woComplete.removePending = "\n No longer marked as Pending - Work Order Nbr: " + refNbr + " Request Nbr: " + requestNbr;
                            this.populateSubmitComments(requestNbr, refNbr, this.woComplete.removePending, this.woComplete.removePendingMsg, woc.removePending);
                            oPending = this.pending.checked;
                            this.pending.checked = false;
                            this.woComplete.persist = 'I';
                            this.woComplete.closeDt = '';
                            this.woComplete.newStatus = 'I';
                            this.populateList(requestNbr, '', this.woComplete.newStatus);
                        }
                        else {
                            this.pending.checked = true;
                            oPending = this.pending.checked;
                        }
                        this.woComplete.submit = '';
                        this.confirmWorkOrderStatus('OffenseEntry', (this.noHits.checked || oPending) ? true : false, 'R', this.noHits.defaultValue, state);
                        return [2 /*return*/];
                }
            });
        });
    };
    ResearcherTaskListComponent.prototype.confirmSubmit = function (message, type, requestNbr) {
        return __awaiter(this, void 0, void 0, function () {
            var confirmResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popupHelper_1.default.confirmSubmitHelper(message)];
                    case 1:
                        confirmResult = _a.sent();
                        if (confirmResult === alertifyPromise_1.ConfirmResult.Ok) {
                            if (type === 'S') {
                                this.getAllRequestsNotPreviouslyMarkedAdmittedCrimeNotFound();
                                this.logComplianceLogs();
                                this.submit();
                                this.woComplete.submit = 'true';
                                this.router.navigate(['navigation']);
                            }
                            else if (type === 'R') {
                                if (this.woComplete.submit === 'noChange') {
                                    this.woComplete.work = 'Retrieve';
                                    this.woComplete.detailWork = 'Add';
                                    this.router.navigate(['offense', requestNbr]);
                                }
                                if (this.woComplete.submit === 'true') {
                                    if (this.submitTask.length !== 0) {
                                        this.submit();
                                    }
                                    else {
                                        this.populateList(requestNbr, '', this.woComplete.newStatus);
                                        this.submit();
                                    }
                                    this.woComplete.work = 'PersistFirst';
                                    this.router.navigate(['offense', requestNbr]);
                                }
                            }
                        }
                        else {
                            if (type === 'S') {
                                this.model.isSubmitDisabled = false;
                                this.woComplete.submit = 'false';
                                this.woComplete.alertMsg = '';
                                popupHelper_1.default.userHelper('You have chosen to cancel the submit, your changes have not been saved.', 'crim');
                            }
                            else if (type === 'R') {
                                this.woComplete.submit = 'false';
                                popupHelper_1.default.userHelper('You have selected not to continue to the offense page.', 'crim');
                            }
                            this.headerNH = 0;
                            this.headerPR = 0;
                            this.headerRP = 0;
                            this.headerRH = 0;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ResearcherTaskListComponent.prototype.getOriginalState = function (requestNbr) {
        for (var _i = 0, _a = this.stateData; _i < _a.length; _i++) {
            var item = _a[_i];
            if (requestNbr === item.requestNbr) {
                this.originalStatus = item.status;
                return;
            }
        }
    };
    ResearcherTaskListComponent.prototype.support = function () {
        popupHelper_1.default.support();
    };
    ResearcherTaskListComponent.prototype.about = function () {
        popupHelper_1.default.systemVersion();
    };
    ResearcherTaskListComponent.prototype.crimAlert = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var alertResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popupHelper_1.default.userHelper(message, 'prompt')];
                    case 1:
                        alertResult = _a.sent();
                        if (alertResult === alertifyPromise_1.AlertResult.Ok) {
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ResearcherTaskListComponent.prototype.sortWorkOrderList = function () {
        this.msgSvc.selectedValue(JSON.stringify(this.model.selectedValue));
        this.msgSvc.selectedJurisdiction(JSON.stringify(this.model.jurisdictionId));
        this.router.navigate(['sortTaskList', this.model.requestType]);
    };
    ResearcherTaskListComponent.prototype.removeSortingArray = function () {
        localStorage.removeItem('sortType');
    };
    ResearcherTaskListComponent.prototype.setDefaultOrder = function () {
        this.config = ['+jurisdiction'];
        this.config.push("-dis_RequestDt_sort");
        this.config.push("+refName");
        this.config.push("+caseNbr");
        this.msgSvc.saveSortOrder(JSON.stringify(this.config));
    };
    ResearcherTaskListComponent.prototype.pendingWOHelper = function (alertMsg) {
        return __awaiter(this, void 0, void 0, function () {
            var message, alertResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = alertMsg;
                        return [4 /*yield*/, popupHelper_1.default.pendingWOHelper(message)];
                    case 1:
                        alertResult = _a.sent();
                        if (alertResult === alertifyPromise_1.AlertResult.Ok) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ResearcherTaskListComponent.prototype.noChangeHelper = function () {
        return __awaiter(this, void 0, void 0, function () {
            var alertResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popupHelper_1.default.noChangesToTaskList()];
                    case 1:
                        alertResult = _a.sent();
                        if (alertResult === alertifyPromise_1.AlertResult.Ok) {
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ResearcherTaskListComponent.prototype.noHitsConfirmation = function (alertMsg, requestNbr, checked) {
        return __awaiter(this, void 0, void 0, function () {
            var message, confirmResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = alertMsg;
                        return [4 /*yield*/, popupHelper_1.default.noHitsConfirmation(message)];
                    case 1:
                        confirmResult = _a.sent();
                        if (confirmResult === alertifyPromise_1.ConfirmResult.Ok) {
                            if (checked) {
                                if (this.pending.checked === true) {
                                    this.woComplete.removePending = "No longer marked as Pending -   Reference Name: " + this.woComplete.refName + "  Work Order Nbr: " + this.woComplete.caseNbr + " \n\n ";
                                    this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.removePending, this.woComplete.removePendingMsg, woc.removePending);
                                }
                                this.woComplete.noHitRequests = "Marked Complete - Reference Name: " + this.woComplete.refName + " Work Order Nbr: " + this.woComplete.caseNbr + " \n\n";
                                this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.noHitRequests, this.woComplete.noHitsMsg, woc.noHits);
                                this.woComplete.currentDte = this.createDateTime();
                                this.woComplete.newStatus = 'C';
                            }
                            else {
                                this.woComplete.removeNoHit = "No longer marked as No Record -  Reference Name: " + this.woComplete.refName + " Work Order Nbr: " + this.woComplete.caseNbr + " \n\n";
                                this.populateSubmitComments(requestNbr, this.woComplete.caseNbr, this.woComplete.removeNoHit, this.woComplete.removeNoHitsMsg, woc.removeNoHits);
                                if (this.woComplete.newStatus === 'C') {
                                    this.woComplete.newStatus = 'I';
                                }
                            }
                            this.populateList(this.woComplete.requestNbr, '', this.woComplete.newStatus);
                        }
                        else {
                            if (checked) {
                                this.noHits.checked = false;
                            }
                            else {
                                this.noHits.checked = true;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ResearcherTaskListComponent.prototype.populateSubmitComments = function (requestNbr, caseNbr, comment, header, type) {
        this.submitTaskDialog = this.submitTaskDialog.filter(function (item) { return item.requestNbr !== requestNbr; });
        var records = new index_1.SubmitTaskDialog;
        records.requestNbr = requestNbr;
        records.caseNbr = caseNbr;
        records.comments = comment;
        records.header = header;
        records.type = type;
        this.submitTaskDialog.push(records);
    };
    ResearcherTaskListComponent.prototype.sortTaskDialog = function () {
        this.submitTaskDialog.sort(function (a, b) {
            if (a.type < b.type) {
                return -1;
            }
            else if (a.type > b.type) {
                return 1;
            }
            else {
                return 0;
            }
        });
    };
    ResearcherTaskListComponent.prototype.filterList = function (requestNbr) {
        this.filter = this.submitTask.filter(function (x) { return x.RequestNbr === requestNbr; });
        this.filter = this.filter.filter(function (x) { return x.Type !== 'ANF'; });
        this.submitTask = this.submitTask.filter(function (x) { return x.RequestNbr !== requestNbr; });
        for (var _i = 0, _a = this.filter; _i < _a.length; _i++) {
            var ftr = _a[_i];
            this.populateTaskList(ftr.RequestNbr, ftr.PendingComments, ftr.Type, ftr.AdmittedCrimeNotFound);
        }
    };
    ResearcherTaskListComponent = __decorate([
        core_1.Component({
            template: __webpack_require__("./src/app/researcherTaskList/ResearcherTaskList.component.html"),
            styles: [__webpack_require__("./src/app/researcherTaskList/researcherTaskList.component.scss")],
            providers: [index_2.ResearcherService, browserWindowObjectService_1.default, index_2.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _a || Object, typeof (_b = typeof index_2.ResearcherService !== "undefined" && index_2.ResearcherService) === "function" && _b || Object, typeof (_c = typeof router_1.ActivatedRoute !== "undefined" && router_1.ActivatedRoute) === "function" && _c || Object, typeof (_d = typeof browserWindowObjectService_1.default !== "undefined" && browserWindowObjectService_1.default) === "function" && _d || Object, typeof (_e = typeof index_2.MessageQueService !== "undefined" && index_2.MessageQueService) === "function" && _e || Object, typeof (_f = typeof complianceAuditLogService_1.default !== "undefined" && complianceAuditLogService_1.default) === "function" && _f || Object])
    ], ResearcherTaskListComponent);
    return ResearcherTaskListComponent;
    var _a, _b, _c, _d, _e, _f;
}());
exports.ResearcherTaskListComponent = ResearcherTaskListComponent;
//# sourceMappingURL=researcherTaskList.component.js.map

/***/ }),

/***/ "./src/app/researcherTaskListHelp/researcherTaskListHelp.component.html":
/***/ (function(module, exports) {

module.exports = "  <title>Help Screen for Researcher Task list </title>\r\n\r\n  <h2>Task List Page Explanation</h2>\r\n  <div id=\"xsmspacer\"></div>\r\n  <h3>Purpose of Task List Page:</h3>\r\n  <p>\r\n    To display a list of all outstanding Work Orders that have been assigned to the individual logged into the Researcher System.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <h3>Explanation of Columns in the task list:</h3>\r\n  <div id='header'>Select</div>\r\n  <p>\r\n    The Select column contains a check box that, when checked, will select the associated Work Order for display within a Work Order Report.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Work Order</div>\r\n  <p>\r\n    The Work Order column contains the number that has been assigned to this task by GIS.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Jurisdiction</div>\r\n  <p>\r\n    The Jurisdiction column contains the name of the courthouse or county that would be applicable for the associated Work Order.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Reference Name</div>\r\n  <p>\r\n    The name of the applicant as listed on the application.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>DOB</div>\r\n  <p>\r\n    The DOB column contains the applicants' date of birth as listed on the application.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>SSN</div>\r\n  <p>\r\n    The SSN column contains the social security number of the applicant as listed on the application.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Due Date</div>\r\n  <p>\r\n    The Due Date column contains the date the Work Order has to be Completed.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Result</div>\r\n  <p>\r\n    The Result column is used for Quick Entry of the Work Orders that were researched and no hit was received.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Status</div>\r\n  <p>\r\n    The Status column contains 2 possible selections.<br>\r\n    1. Complete:  This will be selected when all research has been completed and documented for the Work Order.  This will remove the\r\n    Work Order from the Researcher Task list.<br>\r\n    2. Pending:  The item can be placed in Pending status when there is something outside of your control that is holding up completion\r\n    of the background check.  When selecting the Pending Status, you will be required to enter an explanation of\r\n    why the Work Order has been placed in pending status.<br>\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n   <h3>Functions available on the Task List Page:</h3>\r\n  <div id='header'>Select All Work Orders:</div>\r\n  <p>\r\n      When checked, all Work Orders will be selected.  This is used to choose the items\r\n      to display when opening the Work Order Report in PDF format.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Clear Work Order Selections:</div>\r\n  <p>\r\n    When checked, this will de-select all Work Orders that were previously selected for viewing in the Work Order Report.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Open selected Work Orders in PDF for Print:</div>\r\n  <p>\r\n    When pressed, this will display a report of all selected Work Orders. The report will be in PDF format, this will\r\n    enable printing of the Work Order Report.  The Work Order items will print one item per page. To select a Work Order,\r\n    click the checkbox located in the 'Select' column of the Work Order list.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Filter Page:</div>\r\n  <p>\r\n    When pressed, a pop-up screen will display. This screen will contain all available options for filtering the Researcher Task list.  When the OK button is selected\r\n    the Work Order list will be refreshed with items that match the filtering criteria. When the Cancel button is selected, the Researcher Task List will display with the\r\n    as it was before going to this screen.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Sort Task List: </div>\r\n  <p>\r\n    This drop-down contains all columns that can be used for sorting.  To change the sorting of the page, make a selection\r\n    from this drop-down.  When a new selection is made, the Task List will refresh in the new sort order. The default sorting of\r\n    the Work Order list is Jurisdiction and then Due Date within that Jurisdiction.\r\n  </p>\r\n";

/***/ }),

/***/ "./src/app/researcherTaskListHelp/researcherTaskListHelp.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "h2{text-align:center}h3{text-decoration:underline}#header,h3{font-weight:700;padding-left:1.5rem;font-family:Verdana,Tahoma,Arial}#header{font-size:10pt}h4{font-weight:700;text-decoration:underline}h4,p{padding-left:1.5rem;font-family:Verdana,Tahoma,Arial}p{font-size:10pt}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/researcherTaskListHelp/researcherTaskListHelp.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var ResearcherTaskListHelpComponent = (function () {
    function ResearcherTaskListHelpComponent() {
    }
    ResearcherTaskListHelpComponent = __decorate([
        core_1.Component({
            template: __webpack_require__("./src/app/researcherTaskListHelp/researcherTaskListHelp.component.html"),
            styles: [__webpack_require__("./src/app/researcherTaskListHelp/researcherTaskListHelp.component.scss")]
        })
    ], ResearcherTaskListHelpComponent);
    return ResearcherTaskListHelpComponent;
}());
exports.ResearcherTaskListHelpComponent = ResearcherTaskListHelpComponent;
//# sourceMappingURL=researcherTaskListHelp.component.js.map

/***/ }),

/***/ "./src/app/sortTaskList/sortTaskList.component.html":
/***/ (function(module, exports) {

module.exports = "<nav class='navClass'>\r\n  <ul>\r\n    <li>File\r\n      <ul class='sub-menu'>\r\n        <li>\r\n          <a (click)='goToNavigation()'>Return To Navigation Page</a>\r\n        </li>\r\n        <li>\r\n          <a (click)='exitDialog()'>Exit System</a>\r\n        </li>\r\n      </ul>\r\n    </li>\r\n    <li>Tools\r\n      <ul class='sub-menu'>\r\n        <li>\r\n          <a (click)='displaySortedTaskList()'>Display Sorted Task List</a>\r\n        </li>\r\n      </ul>\r\n    </li>\r\n    <li>Help\r\n      <ul class=\"sub-menu\">\r\n        <li>\r\n          <a (click)=\"help()\">Page Help</a>\r\n        </li>\r\n        <hr>\r\n        <li>\r\n          <a (click)=\"support()\">Client Support</a>\r\n        </li>\r\n        <hr>\r\n        <li>\r\n          <a (click)=\"about()\">About</a>\r\n        </li>\r\n      </ul>\r\n    </li>\r\n  </ul>\r\n</nav>\r\n<div id=\"wrapper\">\r\n  <div id=\"woHeader\">\r\n    <div>SORT TASK LIST</div>\r\n  </div>\r\n</div>\r\n<div id=\"spacer\"></div>\r\n<div id=\"column\">\r\n  <label for=\"selection1\">Sort Column 1:</label>\r\n  <select id='selection1' [(ngModel)]=\"model.defaultSort1\" #defaultSort1=\"ngModel\">\r\n    <option value='0' selected>Jurisdiction - Default</option>\r\n    <option value='1' selected>Request Date</option>\r\n    <option value='2' selected>Status</option>\r\n    <option value='3' selected>Reference Name</option>\r\n  </select>\r\n  <label for=\"selection2\">Sort Column 2:</label>\r\n  <select id='selection2' [(ngModel)]=\"model.defaultSort2\" #defaultSort2=\"ngModel\">\r\n    <option value='0' selected>Jurisdiction</option>\r\n    <option value='1' selected>Request Date - Default</option>\r\n    <option value='2' selected>Status</option>\r\n    <option value='3' selected>Reference Name</option>\r\n  </select>\r\n  <label for=\"selection3\">Sort Column 3:</label>\r\n  <select id='selection3' [(ngModel)]=\"model.defaultSort3\" #defaultSort3=\"ngModel\">\r\n    <option value='0' selected>Jurisdiction</option>\r\n    <option value='1' selected>Request Date</option>\r\n    <option value='2' selected>Status</option>\r\n    <option value='3' selected>Reference Name</option>\r\n  </select>\r\n</div>\r\n\r\n<div id=\"column2\">\r\n  <label for=\"selection1\">Sort Order for Column 1:</label>\r\n  <select id='selection1' [(ngModel)]=\"model.defaultOrder1\" #defaultOrder1=\"ngModel\">\r\n    <option value='0' selected>Ascending - Default</option>\r\n    <option value='1' selected>Descending</option>\r\n  </select>\r\n  <label for=\"selection2\">Sort Order for Column 2:</label>\r\n  <select id='selection2' [(ngModel)]=\"model.defaultOrder2\" #defaultOrder2=\"ngModel\">\r\n    <option value='0' selected>Ascending - Default</option>\r\n    <option value='1' selected>Descending</option>\r\n  </select>\r\n  <label for=\"selection3\">Sort Order for Column 3:</label>\r\n  <select id='selection3' [(ngModel)]=\"model.defaultOrder3\" #defaultOrder3=\"ngModel\">\r\n    <option value='0' selected>Ascending - Default</option>\r\n    <option value='1' selected>Descending</option>\r\n  </select>\r\n</div>\r\n<div id=\"spacer\"></div>\r\n<div id=\"column\">\r\n  <button class=\"Button\" type=\"button\"  (click)=\"displaySortedTaskList()\">Display Sorted Task List</button>\r\n</div>\r\n";

/***/ }),

/***/ "./src/app/sortTaskList/sortTaskList.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "label{font-weight:700;display:block;padding:.5rem}select{padding-left:.5rem;width:15rem}#column{width:30em;float:left;padding-left:40rem}#column,#selection2-group,#selection3-group{text-align:left}#spacer{padding-top:1.6em}#wrapper{background-color:#ccf;margin:22px}#woHeader{margin:0 auto;border:.5;width:100%;padding-left:.5rem;font-weight:700}#woHeader,#woHeader div{background-color:#ccf;display:inline-block}#woHeader div{padding:.1rem}.Button{font-family:Verdana,Tahoma,Arial;background-color:#ccf}div{overflow:hidden}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/sortTaskList/sortTaskList.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var popupHelper_1 = __webpack_require__("./src/models/popupHelper.ts");
var browserWindowObjectService_1 = __webpack_require__("./src/services/browserWindowObjectService.ts");
var alertifyPromise_1 = __webpack_require__("./src/models/alertifyPromise.ts");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var index_1 = __webpack_require__("./src/models/index.ts");
var index_2 = __webpack_require__("./src/services/index.ts");
var list;
(function (list) {
    list["jurisdiction"] = "jurisdiction";
    list["requestDt"] = "dis_RequestDt_sort";
    list["status"] = "isLate";
    list["referenceName"] = "refName";
    list["ascending"] = "+";
    list["descending"] = "-";
})(list = exports.list || (exports.list = {}));
var SortTaskListComponent = (function () {
    function SortTaskListComponent(router, route, bwObjectService, msgSvc) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.bwObjectService = bwObjectService;
        this.msgSvc = msgSvc;
        this.model = {};
        this.model.defaultSort1 = '0';
        this.model.defaultSort2 = '1';
        this.model.defaultSort3 = '3';
        this.model.defaultOrder1 = '0';
        this.model.defaultOrder2 = '0';
        this.model.defaultOrder3 = '0';
        this.sortList = new index_1.SortList;
        this.route.params.subscribe(function (params) {
            _this.model.requestType = params['status'];
        });
    }
    SortTaskListComponent.prototype.displaySortedTaskList = function () {
        this.config = [this.getSortOrder(this.model.defaultOrder1) + this.getSortValue(this.model.defaultSort1)];
        this.config.push(this.getSortOrder(this.model.defaultOrder2) + this.getSortValue(this.model.defaultSort2));
        this.config.push(this.getSortOrder(this.model.defaultOrder3) + this.getSortValue(this.model.defaultSort3));
        this.config.push("+caseNbr");
        this.msgSvc.saveSortOrder(JSON.stringify(this.config));
        this.msgSvc.saveSortType('sorting');
        this.router.navigate(['researcherTaskList', this.model.requestType]);
    };
    SortTaskListComponent.prototype.goToNavigation = function () {
        this.router.navigate(['navigation']);
    };
    SortTaskListComponent.prototype.exitDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var confirmResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, popupHelper_1.default.exitSystemHelper()];
                    case 1:
                        confirmResult = _a.sent();
                        if (confirmResult === alertifyPromise_1.ConfirmResult.Ok) {
                            this.router.navigate(['exit']);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SortTaskListComponent.prototype.getSortValue = function (value) {
        switch (value) {
            case '0': {
                this.result = list.jurisdiction;
                break;
            }
            case '1': {
                this.result = list.requestDt;
                break;
            }
            case '2': {
                this.result = list.status;
                break;
            }
            case '3': {
                this.result = list.referenceName;
                break;
            }
            default: {
            }
        }
        return this.result;
    };
    SortTaskListComponent.prototype.getSortOrder = function (order) {
        switch (order) {
            case '0': {
                this.result = list.ascending;
                break;
            }
            case '1': {
                this.result = list.descending;
                break;
            }
            default: {
            }
        }
        return this.result;
    };
    SortTaskListComponent.prototype.support = function () {
        popupHelper_1.default.support();
    };
    SortTaskListComponent.prototype.about = function () {
        popupHelper_1.default.systemVersion();
    };
    SortTaskListComponent.prototype.help = function () {
        this.bwObjectService.openWindowInNewWindowByRoute("sortTaskListHelp", '', 800, 500);
    };
    SortTaskListComponent = __decorate([
        core_1.Component({
            template: __webpack_require__("./src/app/sortTaskList/sortTaskList.component.html"),
            styles: [__webpack_require__("./src/app/sortTaskList/sortTaskList.component.scss")],
            providers: [index_2.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _a || Object, typeof (_b = typeof router_1.ActivatedRoute !== "undefined" && router_1.ActivatedRoute) === "function" && _b || Object, typeof (_c = typeof browserWindowObjectService_1.default !== "undefined" && browserWindowObjectService_1.default) === "function" && _c || Object, typeof (_d = typeof index_2.MessageQueService !== "undefined" && index_2.MessageQueService) === "function" && _d || Object])
    ], SortTaskListComponent);
    return SortTaskListComponent;
    var _a, _b, _c, _d;
}());
exports.SortTaskListComponent = SortTaskListComponent;
//# sourceMappingURL=sortTaskList.component.js.map

/***/ }),

/***/ "./src/app/sortTaskListHelp/sortTaskListHelp.component.html":
/***/ (function(module, exports) {

module.exports = "  <title>Help Screen for Researcher Task Sort/Filter </title>\r\n\r\n  <h2>Sort/Filter Page Explanation</h2>\r\n  <div id=\"xsmspacer\"></div>\r\n  <h3>Purpose of Sort/Filter Page:</h3>\r\n  <p>\r\n    To allow the end user to Sort or Filter the task list based on his/her preference.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <h3>Explanation of Sort Task List Section</h3>\r\n  <p>\r\n    This section allows the user to Sort based on a primary and also a secondary column. (i.e. The default sort is first based on Jurisdiction in Ascending order and then within that sorting it is sort based on Order date in Ascending order).\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Sort Column 1</div>\r\n  <p>\r\n    This will be the primary sort column.  The default is set to be Jurisdiction.  The available options are Jurisdiction, Order Date, Past Due\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Sort Order for Columnn 1</div>\r\n  <p>\r\n    This determines if the order will be in ascending or descending order.  The default is set to Ascending.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Sort Column 2</div>\r\n  <p>\r\n    This determines the secondary sort column.  The default is set to be Order Date.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Sort Order for Column 2</div>\r\n  <p>\r\n    This determines if the order will be in ascending or descending order.  The default is set to Ascending.\r\n  </p>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id=\"xsmspacer\"></div>\r\n  <h3>Functions available in the Sort Task List Section</h3>\r\n  <div id=\"xsmspacer\"></div>\r\n  <div id='header'>Display Sorted Task List</div>\r\n  <p>\r\n    When this is selected, it will display the task list sorted in the order as noted in the Sort Column 1 and Sort Column 2.\r\n  </p>\r\n";

/***/ }),

/***/ "./src/app/sortTaskListHelp/sortTaskListHelp.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "h2{text-align:center}h3{text-decoration:underline}#header,h3{font-weight:700;padding-left:1.5rem;font-family:Verdana,Tahoma,Arial}#header{font-size:10pt}h4{font-weight:700;text-decoration:underline}h4,p{padding-left:1.5rem;font-family:Verdana,Tahoma,Arial}p{font-size:10pt}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/sortTaskListHelp/sortTaskListHelp.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SortTaskListHelpComponent = (function () {
    function SortTaskListHelpComponent() {
    }
    SortTaskListHelpComponent = __decorate([
        core_1.Component({
            template: __webpack_require__("./src/app/sortTaskListHelp/sortTaskListHelp.component.html"),
            styles: [__webpack_require__("./src/app/sortTaskListHelp/sortTaskListHelp.component.scss")]
        })
    ], SortTaskListHelpComponent);
    return SortTaskListHelpComponent;
}());
exports.SortTaskListHelpComponent = SortTaskListHelpComponent;
//# sourceMappingURL=sortTaskListHelp.component.js.map

/***/ }),

/***/ "./src/app/specialAdmitted/specialAdmitted.component.html":
/***/ (function(module, exports) {

module.exports = "<section >\r\n  <form name=\"form\" #f=\"ngForm\" novalidate>\r\n    <div class=\"form-group\" align='center'>\r\n      <div  id=\"general\">\r\n        <div id=\"general-left\">\r\n          <div id=\"instruction-text\">\r\n            <textarea id=\"admission\" datatype='text' Rows='13' cols='104' readonly autofocus> {{admission}}\r\n            </textarea>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</section>\r\n";

/***/ }),

/***/ "./src/app/specialAdmitted/specialAdmitted.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "#general{margin:2rem 3rem;border:0;background-color:#70706e;padding-left:.6rem}#general-left{vertical-align:left;text-align:left;float:left;font-weight:700;width:67rem}#instruction{margin:17.5rem 3rem;border:0;background-color:#70706e;padding-left:.6rem}#instruction-text{vertical-align:left;text-align:left;float:left}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/specialAdmitted/specialAdmitted.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SpecialAdmittedComponent = (function () {
    function SpecialAdmittedComponent() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SpecialAdmittedComponent.prototype, "admission", void 0);
    SpecialAdmittedComponent = __decorate([
        core_1.Component({
            selector: 'app-special-admitted',
            template: __webpack_require__("./src/app/specialAdmitted/specialAdmitted.component.html"),
            styles: [__webpack_require__("./src/app/specialAdmitted/specialAdmitted.component.scss")],
        }),
        __metadata("design:paramtypes", [])
    ], SpecialAdmittedComponent);
    return SpecialAdmittedComponent;
}());
exports.SpecialAdmittedComponent = SpecialAdmittedComponent;
//# sourceMappingURL=specialAdmitted.component.js.map

/***/ }),

/***/ "./src/app/specialInstruction/specialInstruction.component.html":
/***/ (function(module, exports) {

module.exports = "<head>\r\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\r\n  <meta http-equiv=\"Cache-Control\" content=\"no-cache, no-store, must-revalidate\" />\r\n  <META http-equiv=\"pragma\" CONTENT=\"no-cache\">\r\n  <META http-equiv=\"expires\" CONTENT=\"0\">\r\n</head>\r\n<div id=\"spacerxsm\"></div>\r\n<form name=\"form\" #f=\"ngForm\" novalidate>\r\n  <div id=\"instrHeader\">\r\n    <div id=\"instrHeader-left\">\r\n      <b>Special Research Instruction</b>\r\n    </div>\r\n  </div>\r\n  <div id=\"spacerxsm\"></div>\r\n  <section *ngIf=\"showAdmissionSection\">\r\n    <app-special-admitted [admission]=admission> </app-special-admitted>\r\n  </section>\r\n  <section *ngIf=\"showResearchSection\">\r\n    <app-special-research [researchInstruction]=researchInstruction></app-special-research>\r\n  </section>\r\n  <div id=\"Wrapper\">\r\n    <div id=\"woButton\">\r\n      <button class='Button' name='btnOk' (click)=close() title=''>OK</button>\r\n    </div>\r\n  </div>\r\n";

/***/ }),

/***/ "./src/app/specialInstruction/specialInstruction.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "#spacerxsm{padding-top:1.5rem}#instrHeader{margin:0 auto;border:0;background-color:grey;padding-left:3.5rem}#instrHeader div{padding:.5rem;float:left;background-color:grey}#instrHeader-left{width:56rem;vertical-align:left;text-align:center;font-size:14pt;float:left}#woHeader div{padding:1rem;float:left;background-color:grey}#siAdmission{margin:2rem 3rem;border:0;background-color:#70706e;padding-left:.6rem}#siAdmission-left{vertical-align:left;text-align:left;float:left;font-weight:700;width:67rem}#siInstruction{margin:17.5rem 3rem;border:0;background-color:#70706e;padding-left:.6rem}#instruction-text{vertical-align:left;text-align:left;float:left}.Button{font-family:Verdana,Tahoma,Arial;width:6rem}#woButton{margin:16rem -45rem;vertical-align:left;text-align:left;float:left;padding-left:10rem}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/specialInstruction/specialInstruction.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var index_1 = __webpack_require__("./src/services/index.ts");
var SpecialInstructionComponent = (function () {
    function SpecialInstructionComponent(researcherService, msgSvc) {
        this.researcherService = researcherService;
        this.msgSvc = msgSvc;
        this.requestNumber = localStorage.getItem('requests');
    }
    SpecialInstructionComponent.prototype.ngOnInit = function () {
        this.msgSvc.setControlKey();
        this.getInstructionData();
    };
    SpecialInstructionComponent.prototype.getInstructionData = function () {
        var _this = this;
        this.showAdmissionSection = true;
        this.researcherService.getSpecialInstructions(this.requestNumber)
            .subscribe(function (data) {
            _this.admission = data.admission;
            _this.researchInstruction = data.researchInstruction;
            if (_this.admission === '' || _this.admission === undefined || _this.admission === null) {
                if (_this.researchInstruction !== '' || _this.researchInstruction !== undefined || _this.researchInstruction !== null) {
                    _this.admission = data.researchInstruction;
                    _this.researchInstruction = '';
                    _this.showResearchSection = false;
                }
                else {
                    _this.showResearchSection = true;
                }
            }
            else {
                if (_this.researchInstruction !== null) {
                    _this.showResearchSection = true;
                }
                else {
                    _this.showResearchSection = false;
                }
            }
        });
    };
    SpecialInstructionComponent.prototype.close = function () {
        window.close();
    };
    SpecialInstructionComponent = __decorate([
        core_1.Component({
            selector: 'app-special-instruction',
            template: __webpack_require__("./src/app/specialInstruction/specialInstruction.component.html"),
            styles: [__webpack_require__("./src/app/specialInstruction/specialInstruction.component.scss")],
            providers: [index_1.ResearcherService, index_1.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof index_1.ResearcherService !== "undefined" && index_1.ResearcherService) === "function" && _a || Object, typeof (_b = typeof index_1.MessageQueService !== "undefined" && index_1.MessageQueService) === "function" && _b || Object])
    ], SpecialInstructionComponent);
    return SpecialInstructionComponent;
    var _a, _b;
}());
exports.SpecialInstructionComponent = SpecialInstructionComponent;
//# sourceMappingURL=specialInstruction.component.js.map

/***/ }),

/***/ "./src/app/specialResearch/specialResearch.component.html":
/***/ (function(module, exports) {

module.exports = "<form name=\"form\" #f=\"ngForm\" novalidate>\r\n  <div class=\"form-group\" align='center' >\r\n    <div id=\"instruction\">\r\n      <div id=\"instruction-text\">\r\n        <textarea id=\"specialInstruction\"  datatype='text' ROWS='13' cols='104' readonly>{{researchInstruction}}</textarea>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n";

/***/ }),

/***/ "./src/app/specialResearch/specialResearch.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "#general{margin:2rem 3rem;border:0;background-color:#70706e;padding-left:.6rem}#general-left{vertical-align:left;text-align:left;float:left;font-weight:700;width:67rem}#instruction{margin:17.5rem 3rem;border:0;background-color:#70706e;padding-left:.6rem}#instruction-text{vertical-align:left;text-align:left;float:left}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/specialResearch/specialResearch.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var SpecialResearchComponent = (function () {
    function SpecialResearchComponent() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SpecialResearchComponent.prototype, "researchInstruction", void 0);
    SpecialResearchComponent = __decorate([
        core_1.Component({
            selector: 'app-special-research',
            template: __webpack_require__("./src/app/specialResearch/specialResearch.component.html"),
            styles: [__webpack_require__("./src/app/specialResearch/specialResearch.component.scss")],
        }),
        __metadata("design:paramtypes", [])
    ], SpecialResearchComponent);
    return SpecialResearchComponent;
}());
exports.SpecialResearchComponent = SpecialResearchComponent;
//# sourceMappingURL=specialResearch.component.js.map

/***/ }),

/***/ "./src/app/workOrderAdmissions/WorkOrderAdmissions.component.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"woMain\" >\r\n  <div id=\"xsmspacer\"></div>\r\n  <pre>{{admission}} </pre>\r\n</div>\r\n";

/***/ }),

/***/ "./src/app/workOrderAdmissions/WorkOrderAdmissions.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "#xsmspacer{padding-top:.5em}#woMain{margin:5px 3em;border:0;width:60em}#woRpt{width:29.2em;vertical-align:left;text-align:left;float:left}span{font-weight:700}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/workOrderAdmissions/workOrderAdmissions.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var WorkOrderAdmissionsComponent = (function () {
    function WorkOrderAdmissionsComponent() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], WorkOrderAdmissionsComponent.prototype, "admission", void 0);
    WorkOrderAdmissionsComponent = __decorate([
        core_1.Component({
            selector: 'app-wo-admissions',
            template: __webpack_require__("./src/app/workOrderAdmissions/WorkOrderAdmissions.component.html"),
            styles: [__webpack_require__("./src/app/workOrderAdmissions/WorkOrderAdmissions.component.scss")]
        }),
        __metadata("design:paramtypes", [])
    ], WorkOrderAdmissionsComponent);
    return WorkOrderAdmissionsComponent;
}());
exports.WorkOrderAdmissionsComponent = WorkOrderAdmissionsComponent;
//# sourceMappingURL=workOrderAdmissions.component.js.map

/***/ }),

/***/ "./src/app/workOrderIdentifiers/WorkOrderIdentifiers.component.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"xsmspacer\"></div>\r\n<div id=\"woMain\">\r\n  <div id=\"woIdentifier-left\">\r\n    <input type='checkbox'>Name</div>\r\n  <div id=\"woIdentifier-left\">\r\n    <input type='checkbox'>DOB</div>\r\n  <div id=\"woIdentifier-left\">\r\n    <input type='checkbox'>SSN</div>\r\n  <div id=\"woIdentifier-middle\">\r\n    <input type='checkbox'>Address</div>\r\n  <div id=\"woIdentifier-left\">\r\n    <input type='checkbox'>DLN</div>\r\n</div>\r\n<div id=\"xsmspacer\"></div>\r\n<hr>\r\n";

/***/ }),

/***/ "./src/app/workOrderIdentifiers/WorkOrderIdentifiers.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "#woIdentifier-left{width:7.2em}#woIdentifier-left,#woIdentifier-middle{vertical-align:left;text-align:left;float:left}#woIdentifier-middle{width:6.5em}#woRpt-left{width:15.2em;vertical-align:left;text-align:left;float:left}#xsmspacer{padding-top:1.5em}#woMain{margin:5px 3em;border:0;width:60em}span{font-weight:700}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/workOrderIdentifiers/workOrderIdentifiers.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var WorkOrderIdentifiersComponent = (function () {
    function WorkOrderIdentifiersComponent() {
    }
    WorkOrderIdentifiersComponent = __decorate([
        core_1.Component({
            selector: 'app-wo-identifiers',
            template: __webpack_require__("./src/app/workOrderIdentifiers/WorkOrderIdentifiers.component.html"),
            styles: [__webpack_require__("./src/app/workOrderIdentifiers/WorkOrderIdentifiers.component.scss")]
        })
    ], WorkOrderIdentifiersComponent);
    return WorkOrderIdentifiersComponent;
}());
exports.WorkOrderIdentifiersComponent = WorkOrderIdentifiersComponent;
//# sourceMappingURL=workOrderIdentifiers.component.js.map

/***/ }),

/***/ "./src/app/workOrderReport/WorkOrderReport.component.html":
/***/ (function(module, exports) {

module.exports = "\r\n<div *ngFor=\"let item of rpt  | orderBy: '+' \">\r\n  <div *ngIf='notEndOfFile(item.jurisdiction)'>\r\n    <div class=\"page-break\"></div>\r\n  </div>\r\n  <div id=\"woMain\">\r\n    <div id=\"woHeader\">\r\n      <h2>{{item.jurisdiction}}</h2>\r\n    </div>\r\n  </div>\r\n  <div id=\"spacer\"></div>\r\n  <div id=\"woMain\">\r\n    <div id=\"woRpt\">\r\n      <span>Request Nbr:</span> {{item.caseNbr}}</div>\r\n    <div id=\"woRpt-left\">\r\n      <input type='checkbox'>Has Record </div>\r\n  </div>\r\n  <div id=\"spacer\"></div>\r\n  <div id=\"woMain\">\r\n    <div id=\"woRpt-long\">\r\n      <span>Name:</span> {{item.refName}}</div>\r\n  </div>\r\n  <div id=\"smspacer\"></div>\r\n  <div id=\"woMain\">\r\n    <div id=\"woRpt-long\">\r\n      <span>Address: </span>{{item.refAddr1}} {{item.refCity}}, {{item.refState}} {{item.refZip}}</div>\r\n  </div>\r\n  <div id=\"smspacer\"></div>\r\n  <div id=\"woMain\">\r\n    <div id=\"woRpt\">\r\n      <span>Search Dates:</span> {{item.searchFromDt}} - {{item.searchToDt}}</div>\r\n    <div id=\"woRpt-left\">\r\n      <span>DOB: </span>{{item.dob}}</div>\r\n    <div id=\"woRpt-left\">\r\n      <span>SSN: </span>{{item.ssn}}</div>\r\n  </div>\r\n  <div id=\"smspacer\"></div>\r\n  <div id=\"woMain\">\r\n    <div id=\"woRpt\">\r\n      <span>Special Instruction: </span>\r\n    </div>\r\n    <div id=\"woRpt\">\r\n      <span>Driver's License: </span>{{item.licenseNumber}}\r\n    </div>\r\n  </div>\r\n  <div id=\"xsmspacer\"></div>\r\n  <section class={{researchDisplay}}>\r\n    <app-wo-special-instructions [researchInstructions]=item.researchInstructions></app-wo-special-instructions>\r\n  </section>\r\n  <div id=\"spacer\"></div>\r\n  <div id=\"woMain\">\r\n    <div id=\"woRpt\">\r\n        <span>Admission Info:</span>\r\n    </div>\r\n  </div>\r\n  <section *ngIf=item.display>\r\n      <br>\r\n  </section>\r\n  <section class={{item.admissionDisplay}}>\r\n    <app-wo-admissions [admission]=item.admission></app-wo-admissions>\r\n  </section>\r\n\r\n  <div id=\"woMain\">\r\n      <div id=\"woRpt\">\r\n        <span>Identifiers Used:</span>\r\n      </div>\r\n  </div>\r\n  <section>\r\n    <app-wo-identifiers></app-wo-identifiers>\r\n  </section>\r\n  <br>\r\n</div>\r\n";

/***/ }),

/***/ "./src/app/workOrderReport/WorkOrderReport.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "#spacer{padding-top:4.5em}textarea{line-height:200%;padding-left:0}#woAdmissionInfo,textarea{border:0 none #fff;overflow:hidden;outline:none;background-color:transparent;font-family:Verdana,Arial,Tahoma}#woAdmissionInfo{white-space:pre-line}#spacer{padding-top:2.5em}#smspacer{padding-top:2em}#xsmspacer{padding-top:1.5em}#xxsmspacer{padding-top:.5em}#woMain{margin:5px 3em;border:0;width:60em}#woRpt{width:29.2em}#woRpt,#woSI{vertical-align:left;text-align:left;float:left}#woSI{width:90%;padding-bottom:5px}span{font-weight:700}#woRpt-long{width:65.2em}#woRpt-left,#woRpt-long{vertical-align:left;text-align:left;float:left}#woRpt-left{width:15.2em}#woRpt-full{width:100%}#woHeader,#woRpt-full{vertical-align:left;text-align:left;float:left}#woHeader{width:50.2em;font-weight:700}hr{float:left;width:67rem;margin:5px 3em}@media print{.page-break{display:block;page-break-before:always}}section.hidden{display:none}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/workOrderReport/workOrderReport.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var index_1 = __webpack_require__("./src/models/index.ts");
var index_2 = __webpack_require__("./src/services/index.ts");
var WorkOrderReportComponent = (function () {
    function WorkOrderReportComponent(researcherService, msgSvc) {
        this.researcherService = researcherService;
        this.msgSvc = msgSvc;
        this.rpt = [];
        this.requestNbr = JSON.parse(localStorage.getItem('requests'));
    }
    WorkOrderReportComponent.prototype.ngOnInit = function () {
        this.msgSvc.setControlKey();
        this.getReportData(this.requestNbr);
    };
    WorkOrderReportComponent.prototype.getReportData = function (requestNbrs) {
        var _this = this;
        this.rpt.length = 0;
        this.researcherService.getWorkOrders(requestNbrs)
            .subscribe(function (data) {
            _this.rpt = index_1.Report.getWorkOrderReport(data);
        });
    };
    WorkOrderReportComponent.prototype.notEndOfFile = function (value) {
        if (this.jurisdiction === '' || this.jurisdiction === undefined || this.jurisdiction === null) {
            this.jurisdiction = value;
        }
        if (this.jurisdiction !== value) {
            this.jurisdiction = value;
            this.isPageBreak = true;
        }
        else {
            this.isPageBreak = false;
        }
        if (this.endOfFile !== 0) {
            this.endOfFile = this.endOfFile - 1;
        }
        return this.isPageBreak;
    };
    WorkOrderReportComponent.prototype.showJurisdiction = function (value) {
        var show = localStorage.getItem('jurisdication');
        if (show !== null && show !== undefined && show !== '') {
            if (show === value) {
                this.showJuris = false;
            }
            else {
                this.showJuris = true;
            }
        }
        else {
            this.showJuris = true;
        }
        localStorage.setItem('jurisdiction', value);
        return this.showJuris;
    };
    WorkOrderReportComponent = __decorate([
        core_1.Component({
            selector: 'app-wo-report',
            template: __webpack_require__("./src/app/workOrderReport/WorkOrderReport.component.html"),
            styles: [__webpack_require__("./src/app/workOrderReport/WorkOrderReport.component.scss")],
            providers: [index_2.ResearcherService, index_2.MessageQueService]
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof index_2.ResearcherService !== "undefined" && index_2.ResearcherService) === "function" && _a || Object, typeof (_b = typeof index_2.MessageQueService !== "undefined" && index_2.MessageQueService) === "function" && _b || Object])
    ], WorkOrderReportComponent);
    return WorkOrderReportComponent;
    var _a, _b;
}());
exports.WorkOrderReportComponent = WorkOrderReportComponent;
//# sourceMappingURL=workOrderReport.component.js.map

/***/ }),

/***/ "./src/app/workOrderSpecialInstructions/WorkOrderSpecialInstructions.component.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"woMain\" >\r\n  <div  id=\"woSI\">{{researchInstructions}}</div>\r\n</div>\r\n";

/***/ }),

/***/ "./src/app/workOrderSpecialInstructions/WorkOrderSpecialInstructions.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.i, "#woMain{margin:5px 3em;border:0;width:60em}#woSI{width:90%;vertical-align:left;text-align:left;float:left;padding-bottom:5px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();

/***/ }),

/***/ "./src/app/workOrderSpecialInstructions/workOrderSpecialInstructions.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var WorkOrderSpecialInstructionsComponent = (function () {
    function WorkOrderSpecialInstructionsComponent() {
    }
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], WorkOrderSpecialInstructionsComponent.prototype, "researchInstructions", void 0);
    WorkOrderSpecialInstructionsComponent = __decorate([
        core_1.Component({
            selector: 'app-wo-special-instructions',
            template: __webpack_require__("./src/app/workOrderSpecialInstructions/WorkOrderSpecialInstructions.component.html"),
            styles: [__webpack_require__("./src/app/workOrderSpecialInstructions/WorkOrderSpecialInstructions.component.scss")]
        }),
        __metadata("design:paramtypes", [])
    ], WorkOrderSpecialInstructionsComponent);
    return WorkOrderSpecialInstructionsComponent;
}());
exports.WorkOrderSpecialInstructionsComponent = WorkOrderSpecialInstructionsComponent;
//# sourceMappingURL=workOrderSpecialInstructions.component.js.map

/***/ }),

/***/ "./src/assets/images/CRIM-Logo.gif":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/CRIM-Logo.381482a1bebe45fd6ead916f278d2008.gif";

/***/ }),

/***/ "./src/directives/validateOnblur.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var forms_1 = __webpack_require__("./node_modules/@angular/forms/esm5/forms.js");
var ValidationOnBlurDirective = (function () {
    function ValidationOnBlurDirective(formControl) {
        this.formControl = formControl;
    }
    ValidationOnBlurDirective.prototype.onFocus = function () {
        this.wasChanged = false;
        this.validators = this.formControl.control.validator;
        this.asyncValidators = this.formControl.control.asyncValidator;
        this.formControl.control.clearAsyncValidators();
        this.formControl.control.clearValidators();
    };
    ValidationOnBlurDirective.prototype.onKeyup = function () {
        this.wasChanged = true; // keyboard change
    };
    ValidationOnBlurDirective.prototype.onChange = function () {
        this.wasChanged = true; // copypaste change
    };
    ValidationOnBlurDirective.prototype.onNgModelChange = function () {
        this.wasChanged = true; // ng-value change
    };
    ValidationOnBlurDirective.prototype.onBlur = function () {
        this.formControl.control.setAsyncValidators(this.asyncValidators);
        this.formControl.control.setValidators(this.validators);
        if (this.wasChanged) {
            this.formControl.control.updateValueAndValidity();
        }
    };
    ValidationOnBlurDirective = __decorate([
        core_1.Directive({
            selector: '[app-validateOnBlur]',
            host: {
                '(focus)': 'onFocus($event)',
                '(blur)': 'onBlur($event)',
                '(keyup)': 'onKeyup($event)',
                '(change)': 'onChange($event)',
                '(ngModelChange)': 'onNgModelChange($event)'
            }
        }),
        __metadata("design:paramtypes", [typeof (_a = typeof forms_1.NgControl !== "undefined" && forms_1.NgControl) === "function" && _a || Object])
    ], ValidationOnBlurDirective);
    return ValidationOnBlurDirective;
    var _a;
}());
exports.default = ValidationOnBlurDirective;
//# sourceMappingURL=validateOnblur.directive.js.map

/***/ }),

/***/ "./src/globals.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var env = "PRODUCTION";
exports.environmentName = env;
//# sourceMappingURL=globals.js.map

/***/ }),

/***/ "./src/guards/authenticationGuard.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var authenticationService_1 = __webpack_require__("./src/services/authenticationService.ts");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var AuthenticationGuard = (function () {
    function AuthenticationGuard(authenticationService, router) {
        this.authenticationService = authenticationService;
        this.router = router;
    }
    AuthenticationGuard.prototype.canActivate = function () {
        var isLoggedIn = this.isLoggedIn();
        if (!isLoggedIn) {
            this.router.navigate(['login']);
        }
        return isLoggedIn;
    };
    AuthenticationGuard.prototype.isLoggedIn = function () {
        var isLoggedIn = this.authenticationService && this.authenticationService.isLoggedIn;
        if (!isLoggedIn) {
            isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
        }
        return isLoggedIn;
    };
    AuthenticationGuard = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof authenticationService_1.AuthenticationService !== "undefined" && authenticationService_1.AuthenticationService) === "function" && _a || Object, typeof (_b = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _b || Object])
    ], AuthenticationGuard);
    return AuthenticationGuard;
    var _a, _b;
}());
exports.default = AuthenticationGuard;
//# sourceMappingURL=authenticationGuard.js.map

/***/ }),

/***/ "./src/main.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var platform_browser_dynamic_1 = __webpack_require__("./node_modules/@angular/platform-browser-dynamic/esm5/platform-browser-dynamic.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var app_module_1 = __webpack_require__("./src/app/app.module.ts");
var globals_1 = __webpack_require__("./src/globals.ts");
if (globals_1.environmentName === 'PRODUCTION') {
    core_1.enableProdMode();
}
platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);
//# sourceMappingURL=main.js.map

/***/ }),

/***/ "./src/models/Admission.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Admission = (function () {
    function Admission(admissionLevel, admissionType, admissionYear, countyName, description, federal, firstLevelOffender, probationCompleted, probationStatus, prohibited, prohibitedState, question, stateCode, type) {
        this.admissionLevel = admissionLevel;
        this.admissionType = admissionType;
        this.admissionYear = admissionYear;
        this.countyName = countyName;
        this.description = description;
        this.federal = federal;
        this.firstLevelOffender = firstLevelOffender;
        this.probationCompleted = probationCompleted;
        this.probationStatus = probationStatus;
        this.prohibited = prohibited;
        this.prohibitedState = prohibitedState;
        this.question = question;
        this.stateCode = stateCode;
        this.type = type;
    }
    Admission.getAdmissions = function (specialInstruction) {
        var admission = '';
        for (var _i = 0, specialInstruction_1 = specialInstruction; _i < specialInstruction_1.length; _i++) {
            var admissions = specialInstruction_1[_i];
            if (admissions.applicantAdmissions.length > 0) {
                for (var _a = 0, _b = admissions.applicantAdmissions; _a < _b.length; _a++) {
                    var item = _b[_a];
                    if (item.admissionType !== undefined && item.admissionType !== null && item.admissionType !== '') {
                        admission += "\n Admission Type = " + item.admissionType + " \n";
                        if (item.question !== '' && item.question !== undefined && item.question !== null) {
                            admission += "  Question = " + item.question + " \n";
                        }
                        if (item.federal !== '' && item.federal !== undefined && item.federal !== null) {
                            admission += "  Federal = " + item.federal + " \n";
                        }
                        if (item.admissionYear !== '' && item.admissionYear !== undefined && item.admissionYear !== null) {
                            admission += "  Admission Year = " + item.admissionYear + " \n";
                        }
                        if (item.stateCode !== '' && item.stateCode !== undefined && item.stateCode !== null) {
                            admission += "  State Code = " + item.stateCode + " \n";
                        }
                        if (item.countyName !== '' && item.countyName !== undefined && item.countyName !== null) {
                            admission += "  County Name = " + item.countyName + " \n";
                        }
                        if (item.description !== '' && item.description !== undefined && item.description !== null) {
                            admission += "  Description = " + item.description + " \n";
                        }
                        if (item.type !== '' && item.type !== undefined && item.type !== null) {
                            admission += "  Type = " + item.type + " \n";
                        }
                        if (item.firstLevelOffender !== '' && item.firstLevelOffender !== undefined && item.firstLevelOffender !== null) {
                            admission += "  First Level Offender = " + item.firstLevelOffender + " \n";
                        }
                        if (item.admissionLevel !== '' && item.admissionLevel !== undefined && item.admissionLevel !== null) {
                            admission += "  Admission Level = " + item.admissionLevel + " \n";
                        }
                        if (item.probationStatus !== '' && item.probationStatus !== undefined && item.probationStatus !== null) {
                            admission += "  Probation Status = " + item.probationStatus + " \n";
                        }
                        if (item.probationCompleted !== '' && item.probationCompleted !== undefined && item.probationCompleted !== null) {
                            admission += "  Probation Completed = " + item.probationCompleted + " \n";
                        }
                        if (item.prohibited !== '' && item.prohibited !== undefined && item.prohibited !== null) {
                            admission += "  Prohibited = " + item.prohibited + " \n";
                        }
                        if (item.prohibitedState !== '' && item.prohibitedState !== undefined && item.prohibitedState !== null) {
                            admission += "  Prohibited State = " + item.prohibitedState + " \n";
                        }
                    }
                }
            }
            else {
                admission = '';
            }
        }
        return admission;
    };
    return Admission;
}());
exports.Admission = Admission;
//# sourceMappingURL=Admission.js.map

/***/ }),

/***/ "./src/models/ResearchInstruction.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ResearchInstruction = (function () {
    function ResearchInstruction(researchInstruction) {
        this.researchInstruction = researchInstruction;
    }
    ResearchInstruction.getResearchInstruction = function (specialInstruction) {
        var result = null;
        for (var _i = 0, specialInstruction_1 = specialInstruction; _i < specialInstruction_1.length; _i++) {
            var item = specialInstruction_1[_i];
            if (item.researchInstructions.length > 0) {
                for (var _a = 0, _b = item.researchInstructions; _a < _b.length; _a++) {
                    var research = _b[_a];
                    result = research.researchInstructions;
                }
            }
        }
        return result;
    };
    return ResearchInstruction;
}());
exports.ResearchInstruction = ResearchInstruction;
//# sourceMappingURL=ResearchInstruction.js.map

/***/ }),

/***/ "./src/models/alertifyPromise.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var alertify = __webpack_require__("./node_modules/alertifyjs/build/alertify.js");
var AlertResult;
(function (AlertResult) {
    AlertResult[AlertResult["Ok"] = 1] = "Ok";
})(AlertResult = exports.AlertResult || (exports.AlertResult = {}));
var ConfirmResult;
(function (ConfirmResult) {
    ConfirmResult[ConfirmResult["Ok"] = 1] = "Ok";
    ConfirmResult[ConfirmResult["Cancel"] = 2] = "Cancel";
})(ConfirmResult = exports.ConfirmResult || (exports.ConfirmResult = {}));
function promisifyAlert(title, message, options) {
    if (options === void 0) { options = {
        labels: {
            ok: 'OK'
        }
    }; }
    return new Promise(function (resolve) {
        alertify.alert(title, message, function () { return resolve(AlertResult.Ok); }).set(Object.assign({}, {
            closableByDimmer: false,
            defaultFocus: 'ok',
            frameless: false,
            closable: false
        }, options));
    });
}
exports.promisifyAlert = promisifyAlert;
function promisifyConfirm(title, message, options) {
    if (options === void 0) { options = {
        labels: {
            ok: 'OK',
            cancel: 'CANCEL'
        }
    }; }
    return new Promise(function (resolve) {
        alertify.confirm(title, message, function () { return resolve(ConfirmResult.Ok); }, function () { return resolve(ConfirmResult.Cancel); }).set(Object.assign({}, {
            closableByDimmer: false,
            defaultFocus: 'cancel',
            frameless: false,
            closable: false
        }, options));
    });
}
exports.promisifyConfirm = promisifyConfirm;
//# sourceMappingURL=alertifyPromise.js.map

/***/ }),

/***/ "./src/models/charge.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Charge = (function () {
    function Charge(requestNbr, offenseNbr, chargeNbr, countNbr, chargeLevel, charge, disposition, chargeStatute, chargeProbation, chargeFines, chargeCourtCosts, chargeJailTime, chargePrisonTime, chargeSuspensionTime, chargeNextCourtDate, chargeOffenseDate, noOffenseDateReason, chargeFileDate, noFileDateReason, chargeArrestDate, noArrestDateReason, chargeDispDate, noDispDateReason, chargeOtherSentenceNotes, chargeCd) {
        this.requestNbr = requestNbr;
        this.offenseNbr = offenseNbr;
        this.chargeNbr = chargeNbr;
        this.countNbr = countNbr;
        this.chargeLevel = chargeLevel;
        this.charge = charge;
        this.disposition = disposition;
        this.chargeStatute = chargeStatute;
        this.chargeProbation = chargeProbation;
        this.chargeFines = chargeFines;
        this.chargeCourtCosts = chargeCourtCosts;
        this.chargeJailTime = chargeJailTime;
        this.chargePrisonTime = chargePrisonTime;
        this.chargeSuspensionTime = chargeSuspensionTime;
        this.chargeNextCourtDate = chargeNextCourtDate;
        this.chargeOffenseDate = chargeOffenseDate;
        this.noOffenseDateReason = noOffenseDateReason;
        this.chargeFileDate = chargeFileDate;
        this.noFileDateReason = noFileDateReason;
        this.chargeArrestDate = chargeArrestDate;
        this.noArrestDateReason = noArrestDateReason;
        this.chargeDispDate = chargeDispDate;
        this.noDispDateReason = noDispDateReason;
        this.chargeOtherSentenceNotes = chargeOtherSentenceNotes;
        this.chargeCd = chargeCd;
        if (this.chargeNextCourtDate !== null) {
            this.chargeNextCourtDate.setHours(0, 0, 0, 0);
        }
        if (this.chargeOffenseDate !== null) {
            this.chargeOffenseDate.setHours(0, 0, 0, 0);
        }
        if (this.chargeFileDate !== null) {
            this.chargeFileDate.setHours(0, 0, 0, 0);
        }
        if (this.chargeArrestDate !== null) {
            this.chargeArrestDate.setHours(0, 0, 0, 0);
        }
        if (this.chargeDispDate !== null) {
            this.chargeDispDate.setHours(0, 0, 0, 0);
        }
    }
    Object.defineProperty(Charge.prototype, "offenseNumber", {
        get: function () {
            return this.offenseNbr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "chargeNumber", {
        get: function () {
            return this.chargeNbr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "count", {
        get: function () {
            return this.countNbr;
        },
        set: function (count) {
            this.countNbr = count;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "offense", {
        get: function () {
            return this.charge;
        },
        set: function (offense) {
            this.charge = offense;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "probation", {
        get: function () {
            return this.chargeProbation;
        },
        set: function (probation) {
            this.chargeProbation = probation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "fines", {
        get: function () {
            return this.chargeFines;
        },
        set: function (fines) {
            this.chargeFines = fines;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "courtCost", {
        get: function () {
            return this.chargeCourtCosts;
        },
        set: function (courtCost) {
            this.chargeCourtCosts = courtCost;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "jailTime", {
        get: function () {
            return this.chargeJailTime;
        },
        set: function (jailTime) {
            this.chargeJailTime = jailTime;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "prisonTime", {
        get: function () {
            return this.chargePrisonTime;
        },
        set: function (prisonTime) {
            this.chargePrisonTime = prisonTime;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "suspensionTime", {
        get: function () {
            return this.chargeSuspensionTime;
        },
        set: function (suspensionTime) {
            this.chargeSuspensionTime = suspensionTime;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "nextCourtDate", {
        get: function () {
            return this.chargeNextCourtDate;
        },
        set: function (nextCourtDate) {
            if (nextCourtDate !== null) {
                nextCourtDate.setHours(0, 0, 0, 0);
            }
            this.chargeNextCourtDate = nextCourtDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "offenseDate", {
        get: function () {
            return this.chargeOffenseDate;
        },
        set: function (offenseDate) {
            if (offenseDate !== null) {
                offenseDate.setHours(0, 0, 0, 0);
            }
            this.chargeOffenseDate = offenseDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "fileDate", {
        get: function () {
            return this.chargeFileDate;
        },
        set: function (fileDate) {
            if (fileDate !== null) {
                fileDate.setHours(0, 0, 0, 0);
            }
            this.chargeFileDate = fileDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "arrestDate", {
        get: function () {
            return this.chargeArrestDate;
        },
        set: function (arrestDate) {
            if (arrestDate !== null) {
                arrestDate.setHours(0, 0, 0, 0);
            }
            this.chargeArrestDate = arrestDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "dispositionDate", {
        get: function () {
            return this.chargeDispDate;
        },
        set: function (dispositionDate) {
            if (dispositionDate !== null) {
                dispositionDate.setHours(0, 0, 0, 0);
            }
            this.chargeDispDate = dispositionDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "noDispositionReason", {
        get: function () {
            return this.noDispDateReason;
        },
        set: function (noDispositionReason) {
            this.noDispDateReason = noDispositionReason;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "otherSentenceNotes", {
        get: function () {
            return this.chargeOtherSentenceNotes;
        },
        set: function (otherSentenceNotes) {
            this.chargeOtherSentenceNotes = otherSentenceNotes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Charge.prototype, "chargeType", {
        get: function () {
            return this.chargeCd;
        },
        set: function (chargeType) {
            this.chargeCd = chargeType;
        },
        enumerable: true,
        configurable: true
    });
    Charge.createCharge = function (requestNumber, offenseNumber, count, chargeLevel, offense, disposition, chargeStatute, probation, fines, courtCosts, jailTime, prisonTime, suspensionTime, nextCourtDate, offenseDate, noOffenseDateReason, fileDate, noFileDateReason, arrestDate, noArrestDateReason, dispositionDate, noDispositionReason, otherSentenceNotes, chargeType) {
        return new Charge(requestNumber, offenseNumber, null, count, chargeLevel, offense, disposition, chargeStatute, probation, fines, courtCosts, jailTime, prisonTime, suspensionTime, nextCourtDate, offenseDate, noOffenseDateReason, fileDate, noFileDateReason, arrestDate, noArrestDateReason, dispositionDate, noDispositionReason, otherSentenceNotes, chargeType);
    };
    Charge.createFromRequest = function (charges) {
        if (charges == null) {
            return null;
        }
        var internalCharges = new Array();
        for (var _i = 0, charges_1 = charges; _i < charges_1.length; _i++) {
            var chargeBackup = charges_1[_i];
            internalCharges.push(new Charge(chargeBackup.requestNbr, chargeBackup.offenseNbr, chargeBackup.chargeNbr, chargeBackup.countNbr, chargeBackup.chargeLevel, chargeBackup.charge, chargeBackup.disposition, chargeBackup.chargeStatute, chargeBackup.chargeProbation, chargeBackup.chargeFines, chargeBackup.chargeCourtCosts, chargeBackup.chargeJailTime, chargeBackup.chargePrisonTime, chargeBackup.chargeSuspensionTime, chargeBackup.chargeNextCourtDate === null ? null : new Date(chargeBackup.chargeNextCourtDate), chargeBackup.chargeOffenseDate === null ? null : new Date(chargeBackup.chargeOffenseDate), chargeBackup.noOffenseDateReason, chargeBackup.chargeFileDate === null ? null : new Date(chargeBackup.chargeFileDate), chargeBackup.noFileDateReason, chargeBackup.chargeArrestDate === null ? null : new Date(chargeBackup.chargeArrestDate), chargeBackup.noArrestDateReason, chargeBackup.chargeDispDate === null ? null : new Date(chargeBackup.chargeDispDate), chargeBackup.noDispDateReason, chargeBackup.chargeOtherSentenceNotes, chargeBackup.chargeCd));
        }
        return internalCharges;
    };
    return Charge;
}());
exports.default = Charge;
//# sourceMappingURL=charge.js.map

/***/ }),

/***/ "./src/models/chargeLevels.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ChargeLevel;
(function (ChargeLevel) {
    ChargeLevel[ChargeLevel["Misdemeanor"] = 1] = "Misdemeanor";
    ChargeLevel[ChargeLevel["Felony"] = 2] = "Felony";
    ChargeLevel[ChargeLevel["Traffic"] = 4] = "Traffic";
    ChargeLevel[ChargeLevel["CriminalTraffic"] = 5] = "CriminalTraffic";
    ChargeLevel[ChargeLevel["PettyMisdemeanors"] = 7] = "PettyMisdemeanors";
    ChargeLevel[ChargeLevel["OrdinanceViolation"] = 9] = "OrdinanceViolation";
    ChargeLevel[ChargeLevel["Infraction"] = 10] = "Infraction";
    ChargeLevel[ChargeLevel["Other"] = 11] = "Other";
    ChargeLevel[ChargeLevel["Summary"] = 12] = "Summary";
    ChargeLevel[ChargeLevel["MinorMisdemeanor"] = 13] = "MinorMisdemeanor";
})(ChargeLevel = exports.ChargeLevel || (exports.ChargeLevel = {}));
//# sourceMappingURL=chargeLevels.js.map

/***/ }),

/***/ "./src/models/chargeType.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ChargeType;
(function (ChargeType) {
    ChargeType["Convicted"] = "C";
    ChargeType["ActiveDeferral"] = "AD";
    ChargeType["CompleteDeferral"] = "CD";
    ChargeType["OtherNonConviction"] = "N";
    ChargeType["Pending"] = "P";
})(ChargeType = exports.ChargeType || (exports.ChargeType = {}));
//# sourceMappingURL=chargeType.js.map

/***/ }),

/***/ "./src/models/codes.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Codes;
(function (Codes) {
    Codes[Codes["ok"] = 200] = "ok";
    Codes[Codes["requireUsername"] = 460] = "requireUsername";
    Codes[Codes["requirePassword"] = 461] = "requirePassword";
    Codes[Codes["requiredNewPassword"] = 464] = "requiredNewPassword";
    Codes[Codes["invalidPassword"] = 453] = "invalidPassword";
    Codes[Codes["userNamePasswordNotExist"] = 454] = "userNamePasswordNotExist";
    Codes[Codes["passwordAlreadyExist"] = 455] = "passwordAlreadyExist";
    Codes[Codes["passwordMatch"] = 456] = "passwordMatch";
    Codes[Codes["requiredEmail"] = 464] = "requiredEmail";
    Codes[Codes["accountLocked"] = 458] = "accountLocked";
})(Codes = exports.Codes || (exports.Codes = {}));
//# sourceMappingURL=codes.js.map

/***/ }),

/***/ "./src/models/complianceAuditLog.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ComplianceAuditLog = (function () {
    function ComplianceAuditLog(requestNbr, event, page, description, comment) {
        this.requestNbr = requestNbr;
        this.event = event;
        this.page = page;
        this.description = description;
        this.comment = comment;
    }
    return ComplianceAuditLog;
}());
exports.default = ComplianceAuditLog;
//# sourceMappingURL=complianceAuditLog.js.map

/***/ }),

/***/ "./src/models/dateHandler.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__("./node_modules/moment/moment.js");
var DateHandler = (function () {
    function DateHandler(date, baseCentury) {
        if (baseCentury === void 0) { baseCentury = 2000; }
        this.baseCentury = baseCentury;
        this.date = null;
        this.mask = 'MM/DD/YYYY';
        this.dayMask = 'DD';
        this.monthMask = 'MM';
        this.yearMask = 'YYYY';
        if (date instanceof Date) {
            this.date = moment(date).format(this.mask);
        }
        else {
            this.date = date ? date.trim() : date;
        }
    }
    Object.defineProperty(DateHandler.prototype, "isValid", {
        get: function () {
            var date = this.formatDate(this.date, this.mask);
            return date !== null && moment(date, this.mask).isValid();
        },
        enumerable: true,
        configurable: true
    });
    DateHandler.prototype.format = function (mask) {
        if (mask === void 0) { mask = null; }
        return this.date === null ? '' : this.internalFormat(mask === null || mask === undefined ? this.mask : mask);
    };
    Object.defineProperty(DateHandler.prototype, "month", {
        get: function () {
            return this.date === null ? '' : this.internalFormat(this.monthMask);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateHandler.prototype, "day", {
        get: function () {
            return this.date === null ? '' : this.internalFormat(this.dayMask);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DateHandler.prototype, "year", {
        get: function () {
            return this.date === null ? '' : this.internalFormat(this.yearMask);
        },
        enumerable: true,
        configurable: true
    });
    DateHandler.prototype.internalFormat = function (mask) {
        var date = null;
        if (!this.isValid) {
            date = this.formatDate(this.date, this.mask);
        }
        else {
            date = this.date;
        }
        return date === null || date.trim() === '' ? '' : moment(date, this.mask).format(mask);
    };
    DateHandler.prototype.formatDate = function (date, mask) {
        var dateNoDelimiters = date.replace(/\/|-/g, '');
        var maskNoDelimiters = mask.replace(/\/|-/g, '');
        var length = maskNoDelimiters.length - dateNoDelimiters.length;
        if (length < 0 || (length !== 2 && length !== 0)) {
            return null;
        }
        if (length === 2) {
            var year = parseInt(dateNoDelimiters.slice(-2), 10);
            date = "" + date.slice(0, -2) + (year + this.baseCentury);
        }
        return date;
    };
    return DateHandler;
}());
exports.default = DateHandler;
//# sourceMappingURL=dateHandler.js.map

/***/ }),

/***/ "./src/models/formControl.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dateHandler_1 = __webpack_require__("./src/models/dateHandler.ts");
var FormControl = (function () {
    function FormControl(formGroup) {
        this.formGroup = formGroup;
    }
    FormControl.prototype.setValidationErrorByControlName = function (controlName, validatorType) {
        var control = this.formGroup.get(controlName);
        var validator = {};
        validator[validatorType] = true;
        control.setErrors(validator);
        control.markAsTouched();
    };
    FormControl.prototype.clearValidatorErrorByControlName = function (controlName, validatorType) {
        var control = this.formGroup.get(controlName);
        var validator = {};
        validator[validatorType] = false;
        control.setErrors(validator);
        control.updateValueAndValidity();
    };
    FormControl.prototype.setValueByControlName = function (controlName, value) {
        this.formGroup.get(controlName).setValue(value === null ? '' : value);
    };
    FormControl.prototype.getValueByControlName = function (controlName) {
        return this.formGroup.get(controlName).value;
    };
    FormControl.prototype.getNumberByControlName = function (controlName) {
        return +this.formGroup.get(controlName).value;
    };
    FormControl.prototype.getBooleanByControlName = function (controlName) {
        var value = this.getValueByControlName(controlName);
        return value === null || value.length === 0 ? false : Boolean(value);
    };
    FormControl.prototype.getCrimBooleanByControlName = function (controlName) {
        var value = this.getValueByControlName(controlName);
        var boolean = value === null || value.length === 0 ? 'false' : Boolean(value);
        return boolean ? 'o' : '';
    };
    FormControl.prototype.getDateByControlName = function (controlName, baseCentury) {
        if (baseCentury === void 0) { baseCentury = 2000; }
        var value = this.getValueByControlName(controlName);
        var date = new dateHandler_1.default(value, baseCentury);
        return value === null || value.length === 0 || !date.isValid ? null : new Date(date.format());
    };
    FormControl.prototype.getShortDateByControlName = function (controlName, baseCentury) {
        if (baseCentury === void 0) { baseCentury = 2000; }
        var value = this.getValueByControlName(controlName);
        var date = new dateHandler_1.default(value, baseCentury);
        return value === null || value.length === 0 || !date.isValid ? null : new Date(Date.UTC(new Date(date.format()).getFullYear(), new Date(date.format()).getMonth(), new Date(date.format()).getDate(), 0, 0, 0, 0));
    };
    FormControl.prototype.getControlByControlName = function (controlName) {
        return this.formGroup.get(controlName);
    };
    FormControl.prototype.hasErrorByControlName = function (controlName) {
        return this.formGroup.get(controlName).invalid;
    };
    FormControl.prototype.isControlNameDirty = function (controlName) {
        return this.formGroup.get(controlName).dirty;
    };
    FormControl.prototype.disableControlByControlName = function (controlName) {
        return this.formGroup.get(controlName).disable();
    };
    FormControl.prototype.enableControlByControlName = function (controlName) {
        return this.formGroup.get(controlName).enable();
    };
    FormControl.prototype.hasValueByControlName = function (controlName) {
        var value = this.getValueByControlName(controlName);
        return value !== null && value !== undefined && value !== '';
    };
    return FormControl;
}());
exports.default = FormControl;
//# sourceMappingURL=formControl.js.map

/***/ }),

/***/ "./src/models/httpBase.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = __webpack_require__("./node_modules/@angular/http/esm5/http.js");
var Rx_1 = __webpack_require__("./node_modules/rxjs/Rx.js");
var alertify = __webpack_require__("./node_modules/alertifyjs/build/alertify.js");
var HttpBase = (function () {
    function HttpBase(http, router) {
        this.http = http;
        this.router = router;
    }
    HttpBase.prototype.httpPost = function (url, object, showPopupOnError, redirectToLoginIfNotAuthorized) {
        var _this = this;
        if (showPopupOnError === void 0) { showPopupOnError = true; }
        if (redirectToLoginIfNotAuthorized === void 0) { redirectToLoginIfNotAuthorized = true; }
        this.putLoader();
        var headers = new http_1.Headers();
        headers.append('Content-Type', 'application/json');
        var options = new http_1.RequestOptions({
            headers: headers,
            withCredentials: true
        });
        return this.http.post(url, JSON.stringify(object), options)
            .map(function (r) { return r; })
            .catch(function (r) {
            if (r.status === 401 && redirectToLoginIfNotAuthorized) {
                _this.goToLoginPage();
            }
            else if (r.status !== 401 && r.status !== 422 && showPopupOnError) {
                alertify.alert('Crim Error', 'Your request cannot be processed at this time.  Please try again later.');
            }
            return Rx_1.Observable.of(r);
        })
            .finally(function () {
            _this.removeLoader();
        });
    };
    HttpBase.prototype.httpDelete = function (url, showPopupOnError, redirectToLoginIfNotAuthorized) {
        var _this = this;
        if (showPopupOnError === void 0) { showPopupOnError = true; }
        if (redirectToLoginIfNotAuthorized === void 0) { redirectToLoginIfNotAuthorized = true; }
        this.putLoader();
        var headers = new http_1.Headers();
        headers.append('Content-Type', 'application/json');
        var options = new http_1.RequestOptions({
            headers: headers,
            withCredentials: true
        });
        return this.http.delete(url, options)
            .map(function (r) { return r; })
            .catch(function (r) {
            if (r.status === 401 && redirectToLoginIfNotAuthorized) {
                _this.goToLoginPage();
            }
            else if (r.status !== 401 && r.status !== 422 && showPopupOnError) {
                alertify.alert('Crim Error', 'Your request cannot be processed at this time.  Please try again later.');
            }
            return Rx_1.Observable.of(r);
        })
            .finally(function () {
            _this.removeLoader();
        });
    };
    HttpBase.prototype.httpGet = function (url, showPopupOnError, redirectToLoginIfNotAuthorized) {
        var _this = this;
        if (showPopupOnError === void 0) { showPopupOnError = true; }
        if (redirectToLoginIfNotAuthorized === void 0) { redirectToLoginIfNotAuthorized = true; }
        this.putLoader();
        return this.http.get(url, { withCredentials: true })
            .map(function (r) { return r; })
            .catch(function (r) {
            if (r.status === 401 && redirectToLoginIfNotAuthorized) {
                _this.goToLoginPage();
            }
            else if (r.status !== 401 && r.status !== 422 && showPopupOnError) {
                alertify.alert('Crim Error', 'Your request cannot be processed at this time.  Please try again later.');
            }
            return Rx_1.Observable.of(r);
        })
            .finally(function () {
            _this.removeLoader();
        });
    };
    HttpBase.prototype.goToLoginPage = function () {
        this.router.navigate(['login']);
    };
    HttpBase.prototype.putLoader = function () {
        var loaderElement = document.getElementById('loader');
        loaderElement.className = 'loader';
        var screenDisableElement = document.getElementById('screen-disable');
        screenDisableElement.className = 'screen-disable';
    };
    HttpBase.prototype.removeLoader = function () {
        var loaderElement = document.getElementById('loader');
        loaderElement.className = '';
        var screenDisableElement = document.getElementById('screen-disable');
        screenDisableElement.className = '';
    };
    return HttpBase;
}());
exports.default = HttpBase;
//# sourceMappingURL=httpBase.js.map

/***/ }),

/***/ "./src/models/httpError.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HttpError = (function () {
    function HttpError(response, urlUsed) {
        this.response = response;
        this.urlUsed = urlUsed;
    }
    Object.defineProperty(HttpError.prototype, "status", {
        get: function () {
            return this.response.status;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HttpError.prototype, "statusText", {
        get: function () {
            return this.response.statusText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HttpError.prototype, "url", {
        get: function () {
            return this.response.url || this.urlUsed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HttpError.prototype, "httpResponse", {
        get: function () {
            return this.response;
        },
        enumerable: true,
        configurable: true
    });
    return HttpError;
}());
exports.default = HttpError;
//# sourceMappingURL=httpError.js.map

/***/ }),

/***/ "./src/models/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/models/httpError.ts"));
__export(__webpack_require__("./src/models/researcherTaskList.ts"));
__export(__webpack_require__("./src/models/workOrder.ts"));
__export(__webpack_require__("./src/models/workOrderComplete.ts"));
__export(__webpack_require__("./src/models/report.ts"));
__export(__webpack_require__("./src/models/specialInstruction.ts"));
__export(__webpack_require__("./src/models/submitTask.ts"));
__export(__webpack_require__("./src/models/submitTaskDialog.ts"));
__export(__webpack_require__("./src/models/codes.ts"));
__export(__webpack_require__("./src/models/params.ts"));
__export(__webpack_require__("./src/models/sortList.ts"));
__export(__webpack_require__("./src/models/jurisdictions.ts"));
__export(__webpack_require__("./src/models/jurisdictionResults.ts"));
__export(__webpack_require__("./src/models/orderBy.ts"));
__export(__webpack_require__("./src/models/Admission.ts"));
__export(__webpack_require__("./src/models/ResearchInstruction.ts"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./src/models/invoice.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var jurisdictionTotal_1 = __webpack_require__("./src/models/jurisdictionTotal.ts");
var vendor_1 = __webpack_require__("./src/models/vendor.ts");
var Invoice = (function () {
    function Invoice(vendor, jurisdictionTotals, totalRequestCount, totalInvoiceAmount) {
        this.vendor = vendor;
        this.jurisdictionTotals = jurisdictionTotals;
        this.totalRequestCount = totalRequestCount;
        this.totalInvoiceAmount = totalInvoiceAmount;
    }
    Invoice.createFromRequest = function (request) {
        var vendor = vendor_1.default.createFromRequest(request);
        var jurisdictionTotals = new Array();
        for (var _i = 0, _a = request.jurisdictions; _i < _a.length; _i++) {
            var jurisdictionTotal = _a[_i];
            jurisdictionTotals.push(jurisdictionTotal_1.default.createFromRequest(jurisdictionTotal));
        }
        return new Invoice(vendor, jurisdictionTotals, request.source.totalRequests, request.source.totalInvoiceAmount);
    };
    return Invoice;
}());
exports.default = Invoice;
//# sourceMappingURL=invoice.js.map

/***/ }),

/***/ "./src/models/jurisdiction.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Jurisdiction = (function () {
    function Jurisdiction(jurisdictionId, description, count) {
        this.jurisdictionId = jurisdictionId;
        this.description = description;
        this.count = count;
    }
    Jurisdiction.createFromRequest = function (request) {
        return new Jurisdiction(request.jurisdictionId, request.description, request.count);
    };
    return Jurisdiction;
}());
exports.default = Jurisdiction;
//# sourceMappingURL=jurisdiction.js.map

/***/ }),

/***/ "./src/models/jurisdictionResults.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var JurisdicationResults = (function () {
    function JurisdicationResults(jurisdictionId, jState, jurisdiction, requestTotal) {
        this.jurisdictionId = jurisdictionId;
        this.jState = jState;
        this.jurisdiction = jurisdiction;
        this.requestTotal = requestTotal;
    }
    JurisdicationResults.createFromRequest = function (results) {
        return results == null
            ? null
            : new JurisdicationResults(results.jurisdicationId, results.jState, results.jurisdiction, results.requestTotal);
    };
    return JurisdicationResults;
}());
exports.JurisdicationResults = JurisdicationResults;
//# sourceMappingURL=jurisdictionResults.js.map

/***/ }),

/***/ "./src/models/jurisdictionTotal.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var JurisdictionTotal = (function () {
    function JurisdictionTotal(jurisdiction, totalRequests, jurisdictionTotal) {
        this.jurisdiction = jurisdiction;
        this.totalRequests = totalRequests;
        this.jurisdictionTotal = jurisdictionTotal;
    }
    JurisdictionTotal.createFromRequest = function (request) {
        return new JurisdictionTotal(request.jurisdiction, request.totalRequests, request.jurisdictionTotal);
    };
    return JurisdictionTotal;
}());
exports.default = JurisdictionTotal;
//# sourceMappingURL=jurisdictionTotal.js.map

/***/ }),

/***/ "./src/models/jurisdictions.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Jurisdictions = (function () {
    function Jurisdictions(sourceId, sourceType, sourceSubType, sourceName, status, statusReason, addresss, state, zipCode, phoneNbr, faxPhoneNbr, altPhoneNbr, altFaxNumber, emailAddress, webAddress, pfdSendMethod, pfdRecvMethod, workOrderFormat, comments, contact, systemOwnerId) {
        this.sourceId = sourceId;
        this.sourceType = sourceType;
        this.sourceSubType = sourceSubType;
        this.sourceName = sourceName;
        this.status = status;
        this.statusReason = statusReason;
        this.addresss = addresss;
        this.state = state;
        this.zipCode = zipCode;
        this.phoneNbr = phoneNbr;
        this.faxPhoneNbr = faxPhoneNbr;
        this.altPhoneNbr = altPhoneNbr;
        this.altFaxNumber = altFaxNumber;
        this.emailAddress = emailAddress;
        this.webAddress = webAddress;
        this.pfdSendMethod = pfdSendMethod;
        this.pfdRecvMethod = pfdRecvMethod;
        this.workOrderFormat = workOrderFormat;
        this.comments = comments;
        this.contact = contact;
        this.systemOwnerId = systemOwnerId;
    }
    Jurisdictions.createFromRequest = function (juris) {
        return juris == null
            ? null
            : new Jurisdictions(juris.sourceId, juris.sourceType, juris.sourceSubType, juris.sourceName, juris.status, juris.statusReason, juris.address, juris.state, juris.zipCode, juris.phoneNbr, juris.altPhoneNbr, juris.faxPhoneNbr, juris.altFaxNumber, juris.emailAddress, juris.webAddress, juris.pfdSendMethod, juris.pfdRecvMethod, juris.workOrderFormat, juris.comments, juris.contact, juris.systemOwnerId);
    };
    return Jurisdictions;
}());
exports.Jurisdictions = Jurisdictions;
//# sourceMappingURL=jurisdictions.js.map

/***/ }),

/***/ "./src/models/loggedInUser.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var user_1 = __webpack_require__("./src/models/user.ts");
var LoggedInUser = (function () {
    function LoggedInUser(lastLoginDate, user) {
        this.lastLoginDate = lastLoginDate;
        this.user = user;
    }
    LoggedInUser.createFromRequest = function (request) {
        var lastLoginDate = request.lastLoginDate;
        return new LoggedInUser(lastLoginDate, user_1.default.createFromRequest(request.user));
    };
    return LoggedInUser;
}());
exports.default = LoggedInUser;
//# sourceMappingURL=loggedInUser.js.map

/***/ }),

/***/ "./src/models/navigation.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var jurisdiction_1 = __webpack_require__("./src/models/jurisdiction.ts");
var loggedInUser_1 = __webpack_require__("./src/models/loggedInUser.ts");
var vendor_1 = __webpack_require__("./src/models/vendor.ts");
var Navigation = (function () {
    function Navigation(loggedInUser, jurisdictions, vendors) {
        this.loggedInUser = loggedInUser;
        this.jurisdictions = jurisdictions;
        this.vendors = vendors;
    }
    Navigation.createFromRequest = function (request) {
        var jurisdictions = new Array();
        var vendors = new Array();
        var loggedInUser = loggedInUser_1.default.createFromRequest(request.loggedInUser);
        for (var _i = 0, _a = request.jurisdictions; _i < _a.length; _i++) {
            var jurisdiction = _a[_i];
            jurisdictions.push(jurisdiction_1.default.createFromRequest(jurisdiction));
        }
        for (var _b = 0, _c = request.vendors; _b < _c.length; _b++) {
            var vendor = _c[_b];
            vendors.push(vendor_1.default.createFromRequest(vendor));
        }
        return new Navigation(loggedInUser, jurisdictions, vendors);
    };
    return Navigation;
}());
exports.default = Navigation;
//# sourceMappingURL=navigation.js.map

/***/ }),

/***/ "./src/models/offense.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Offense = (function () {
    function Offense(offenseSearch, offenseRecords) {
        this.offenseSearch = offenseSearch;
        this.offenseRecords = offenseRecords;
    }
    return Offense;
}());
exports.default = Offense;
//# sourceMappingURL=offense.js.map

/***/ }),

/***/ "./src/models/offenseCodes.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Using bitwise operator I can
// pass back multiple codes.
var OffenseCodes;
(function (OffenseCodes) {
    OffenseCodes[OffenseCodes["ok"] = 0] = "ok";
})(OffenseCodes = exports.OffenseCodes || (exports.OffenseCodes = {}));
//# sourceMappingURL=offenseCodes.js.map

/***/ }),

/***/ "./src/models/offenseRecord.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var charge_1 = __webpack_require__("./src/models/charge.ts");
var OffenseRecord = (function () {
    function OffenseRecord(requestNbr, offenseNbr, offenseDt, fileDt, dispositionDt, gradingResult, courtRecordedName, faxInfoInd, identifierDOB, identifierSSN, identifierName, identifierAddress, identifierDLN, classification, comments, referenceNbr, nameDiff, identifierSIN, courtRecordDOB, identifierPartialDOB, partialMonth, partialDay, partialYear, identifierNoDOB, nextCourtDate, probation, jailTime, prisonTime, suspensionTime, fines, courtCosts, otherSentenceNotes, arrestDate, results, suppressed, deleted, deferred, isCourtCaseSentencing, verifiedDOBFull, verifiedDOBPartial, verifiedAddress, verifiedSSN, verifiedSIN, verifiedDL, verifiedName, isVerified, verifiedUserId, charges, isNewRecord) {
        if (isNewRecord === void 0) { isNewRecord = false; }
        this.requestNbr = requestNbr;
        this.offenseNbr = offenseNbr;
        this.offenseDt = offenseDt;
        this.fileDt = fileDt;
        this.dispositionDt = dispositionDt;
        this.gradingResult = gradingResult;
        this.courtRecordedName = courtRecordedName;
        this.faxInfoInd = faxInfoInd;
        this.identifierDOB = identifierDOB;
        this.identifierSSN = identifierSSN;
        this.identifierName = identifierName;
        this.identifierAddress = identifierAddress;
        this.identifierDLN = identifierDLN;
        this.classification = classification;
        this.comments = comments;
        this.referenceNbr = referenceNbr;
        this.nameDiff = nameDiff;
        this.identifierSIN = identifierSIN;
        this.courtRecordDOB = courtRecordDOB;
        this.identifierPartialDOB = identifierPartialDOB;
        this.partialMonth = partialMonth;
        this.partialDay = partialDay;
        this.partialYear = partialYear;
        this.identifierNoDOB = identifierNoDOB;
        this.nextCourtDate = nextCourtDate;
        this.probation = probation;
        this.jailTime = jailTime;
        this.prisonTime = prisonTime;
        this.suspensionTime = suspensionTime;
        this.fines = fines;
        this.courtCosts = courtCosts;
        this.otherSentenceNotes = otherSentenceNotes;
        this.arrestDate = arrestDate;
        this.results = results;
        this.suppressed = suppressed;
        this.deleted = deleted;
        this.deferred = deferred;
        this.isCourtCaseSentencing = isCourtCaseSentencing;
        this.verifiedDOBFull = verifiedDOBFull;
        this.verifiedDOBPartial = verifiedDOBPartial;
        this.verifiedAddress = verifiedAddress;
        this.verifiedSSN = verifiedSSN;
        this.verifiedSIN = verifiedSIN;
        this.verifiedDL = verifiedDL;
        this.verifiedName = verifiedName;
        this.isVerified = isVerified;
        this.verifiedUserId = verifiedUserId;
        this.charges = charges;
        this.isNewRecord = isNewRecord;
        if (courtRecordDOB != null) {
            this.courtRecordDOB.setHours(0, 0, 0, 0);
        }
        if (nextCourtDate != null) {
            this.nextCourtDate.setHours(0, 0, 0, 0);
        }
        if (nextCourtDate != null) {
            this.nextCourtDate.setHours(0, 0, 0, 0);
        }
        if (fileDt != null) {
            this.fileDt.setHours(0, 0, 0, 0);
        }
        if (dispositionDt != null) {
            this.dispositionDt.setHours(0, 0, 0, 0);
        }
    }
    Object.defineProperty(OffenseRecord.prototype, "requestNumber", {
        get: function () {
            return this.requestNbr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "offenseNumber", {
        get: function () {
            return this.offenseNbr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "offenseDate", {
        get: function () {
            return this.offenseDt;
        },
        set: function (offenseDate) {
            if (offenseDate != null) {
                offenseDate.setHours(0, 0, 0, 0);
            }
            this.offenseDt = offenseDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "fileDate", {
        get: function () {
            return this.fileDt;
        },
        set: function (fileDate) {
            if (fileDate != null) {
                fileDate.setHours(0, 0, 0, 0);
            }
            this.fileDt = fileDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "dispositionDate", {
        get: function () {
            return this.dispositionDt;
        },
        set: function (dispositionDate) {
            if (dispositionDate != null) {
                dispositionDate.setHours(0, 0, 0, 0);
            }
            this.dispositionDt = dispositionDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "courtRecordFullName", {
        get: function () {
            return this.courtRecordedName;
        },
        set: function (courtRecordFullName) {
            this.courtRecordedName = courtRecordFullName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "hasFaxInformation", {
        get: function () {
            return this.faxInfoInd === 'o';
        },
        set: function (hasFaxInformation) {
            this.faxInfoInd = hasFaxInformation ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "hasDobIdentifier", {
        get: function () {
            return this.identifierDOB === 'o';
        },
        set: function (hasDobIdentifier) {
            this.identifierDOB = hasDobIdentifier ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "hasSsnIdentifier", {
        get: function () {
            return this.identifierSSN === 'o';
        },
        set: function (hasSsnIdentifier) {
            this.identifierSSN = hasSsnIdentifier ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "hasNameIdentifier", {
        get: function () {
            return this.identifierName === 'o';
        },
        set: function (hasNameIdentifier) {
            this.identifierName = hasNameIdentifier ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "hasAddressIdentifier", {
        get: function () {
            return this.identifierAddress === 'o';
        },
        set: function (hasAddressIdentifier) {
            this.identifierAddress = hasAddressIdentifier ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "hasDlnIdentifier", {
        get: function () {
            return this.identifierDLN === 'o';
        },
        set: function (hasDlnIdentifier) {
            this.identifierDLN = hasDlnIdentifier ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "hasSinIdentifier", {
        get: function () {
            return this.identifierSIN === 'o';
        },
        set: function (hasSinIdentifier) {
            this.identifierSIN = hasSinIdentifier ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "hasPartialDobIdentifier", {
        get: function () {
            return this.identifierPartialDOB === 'o';
        },
        set: function (hasPartialDobIdentifier) {
            this.identifierPartialDOB = hasPartialDobIdentifier ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "hasNoDobIdentifier", {
        get: function () {
            return this.identifierNoDOB === 'o';
        },
        set: function (hasNoDobIdentifier) {
            this.identifierNoDOB = hasNoDobIdentifier ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "referenceNumber", {
        get: function () {
            return this.referenceNbr;
        },
        set: function (referenceNumber) {
            this.referenceNbr = referenceNumber;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "nameDiffers", {
        get: function () {
            return this.nameDiff === 'o';
        },
        set: function (nameDiffers) {
            this.nameDiff = nameDiffers ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "courtRecordDob", {
        get: function () {
            return this.courtRecordDOB;
        },
        set: function (courtRecordDob) {
            if (courtRecordDob != null) {
                courtRecordDob.setHours(0, 0, 0, 0);
            }
            this.courtRecordDOB = courtRecordDob;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "isSuppressed", {
        get: function () {
            return this.suppressed === 'o';
        },
        set: function (isSuppressed) {
            this.suppressed = isSuppressed ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "isDeleted", {
        get: function () {
            return this.deleted === 'o';
        },
        set: function (isDeleted) {
            this.deleted = isDeleted ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "isDeferred", {
        get: function () {
            return this.deferred === 'o';
        },
        set: function (isDeferred) {
            this.deferred = isDeferred ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "isCourtCaseSentence", {
        get: function () {
            return this.isCourtCaseSentencing === 'o';
        },
        set: function (isCourtCaseSentence) {
            this.isCourtCaseSentencing = isCourtCaseSentence ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "isVerifiedDobFull", {
        get: function () {
            return this.verifiedDOBFull === 'o';
        },
        set: function (isVerifiedDobFull) {
            this.verifiedDOBFull = isVerifiedDobFull ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "isVerifiedDobPartial", {
        get: function () {
            return this.verifiedDOBPartial === 'o';
        },
        set: function (isVerifiedDobPartial) {
            this.verifiedDOBPartial = isVerifiedDobPartial ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "isVerifiedAddress", {
        get: function () {
            return this.verifiedAddress === 'o';
        },
        set: function (isVerifiedAddress) {
            this.verifiedAddress = isVerifiedAddress ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "isVerifiedSsn", {
        get: function () {
            return this.verifiedSSN === 'o';
        },
        set: function (isVerifiedSsn) {
            this.verifiedSSN = isVerifiedSsn ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "isVerifiedSin", {
        get: function () {
            return this.verifiedSIN === 'o';
        },
        set: function (isVerifiedSin) {
            this.verifiedSIN = isVerifiedSin ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "isVerifiedDl", {
        get: function () {
            return this.verifiedDL === 'o';
        },
        set: function (isVerifiedDl) {
            this.verifiedDL = isVerifiedDl ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "isVerifiedName", {
        get: function () {
            return this.verifiedName === 'o';
        },
        set: function (isVerifiedName) {
            this.verifiedName = isVerifiedName ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseRecord.prototype, "isOffenseVerified", {
        get: function () {
            return this.isVerified === 'o';
        },
        set: function (isOffenseVerified) {
            this.isVerified = isOffenseVerified ? 'o' : '';
        },
        enumerable: true,
        configurable: true
    });
    OffenseRecord.getFromRequest = function (offenseRecords) {
        if (offenseRecords == null) {
            return null;
        }
        var records = new Array();
        if (offenseRecords.length > 0) {
            for (var _i = 0, offenseRecords_1 = offenseRecords; _i < offenseRecords_1.length; _i++) {
                var offenseRecord = offenseRecords_1[_i];
                records.push(new OffenseRecord(offenseRecord.requestNbr, offenseRecord.offenseNbr, offenseRecord.offenseDt === null ? null : new Date(offenseRecord.offenseDt), offenseRecord.fileDt === null ? null : new Date(offenseRecord.fileDt), offenseRecord.dispositionDt === null ? null : new Date(offenseRecord.dispositionDt), offenseRecord.gradingResult, offenseRecord.courtRecordedName, offenseRecord.faxInfoInd, offenseRecord.identifierDOB, offenseRecord.identifierSSN, offenseRecord.identifierName, offenseRecord.identifierAddress, offenseRecord.identifierDLN, offenseRecord.classification, offenseRecord.comments, offenseRecord.referenceNbr, offenseRecord.nameDiff, offenseRecord.identifierSIN, offenseRecord.courtRecordDOB === null ? null : new Date(offenseRecord.courtRecordDOB), offenseRecord.identifierPartialDOB, offenseRecord.partialMonth, offenseRecord.partialDay, offenseRecord.partialYear, offenseRecord.identifierNoDOB, offenseRecord.nextCourtDate === null ? null : new Date(offenseRecord.nextCourtDate), offenseRecord.probation, offenseRecord.jailTime, offenseRecord.prisonTime, offenseRecord.suspensionTime, offenseRecord.fines, offenseRecord.courtCosts, offenseRecord.otherSentenceNotes, offenseRecord.arrestDate === null ? null : new Date(offenseRecord.arrestDate), offenseRecord.results, offenseRecord.suppressed, offenseRecord.deleted, offenseRecord.deferred, offenseRecord.isCourtCaseSentencing, offenseRecord.verifiedDOBFull, offenseRecord.verifiedDOBPartial, offenseRecord.verifiedAddress, offenseRecord.verifiedSSN, offenseRecord.verifiedSIN, offenseRecord.verifiedDL, offenseRecord.verifiedName, offenseRecord.isVerified, offenseRecord.verifiedUserId, charge_1.default.createFromRequest(offenseRecord.charges)));
            }
        }
        return records;
    };
    OffenseRecord.createNewOffenseRecord = function (requestNumber, offenceNumber) {
        return new OffenseRecord(requestNumber, offenceNumber, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, new Array(), true);
    };
    return OffenseRecord;
}());
exports.default = OffenseRecord;
//# sourceMappingURL=offenseRecord.js.map

/***/ }),

/***/ "./src/models/offenseSearch.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OffenseSearch = (function () {
    function OffenseSearch(requestNbr, caseNbr, refName, refAddr1, refCity, refState, refZip, workState, restrictedState, dob, jurisdiction, jurisdictionId, ssn, searchFromDt, searchToDt, admittedCrimNotFound, status, sourceName, sourceType, licenseNumber, isHeightenedIdentifier) {
        this.requestNbr = requestNbr;
        this.caseNbr = caseNbr;
        this.refName = refName;
        this.refAddr1 = refAddr1;
        this.refCity = refCity;
        this.refState = refState;
        this.refZip = refZip;
        this.workState = workState;
        this.restrictedState = restrictedState;
        this.dob = dob;
        this.jurisdiction = jurisdiction;
        this.jurisdictionId = jurisdictionId;
        this.ssn = ssn;
        this.searchFromDt = searchFromDt;
        this.searchToDt = searchToDt;
        this.admittedCrimNotFound = admittedCrimNotFound;
        this.status = status;
        this.sourceName = sourceName;
        this.sourceType = sourceType;
        this.licenseNumber = licenseNumber;
        this.isHeightenedIdentifier = isHeightenedIdentifier;
    }
    Object.defineProperty(OffenseSearch.prototype, "requestNumber", {
        get: function () {
            return this.requestNbr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseSearch.prototype, "caseNumber", {
        get: function () {
            return this.caseNbr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseSearch.prototype, "fullName", {
        get: function () {
            return this.refName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseSearch.prototype, "address1", {
        get: function () {
            return this.refAddr1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseSearch.prototype, "city", {
        get: function () {
            return this.refCity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseSearch.prototype, "state", {
        get: function () {
            return this.refState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseSearch.prototype, "zip", {
        get: function () {
            return this.refZip;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseSearch.prototype, "isRestrictedState", {
        get: function () {
            return this.restrictedState === 'Y';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseSearch.prototype, "socialSecurityNumber", {
        get: function () {
            return this.ssn === null || this.ssn === undefined || this.ssn.length !== 9
                ? this.ssn
                : this.ssn.slice(0, 3) + "-" + this.ssn.slice(3, 5) + "-" + this.ssn.slice(5);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseSearch.prototype, "searchFromDate", {
        get: function () {
            return this.searchFromDt;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OffenseSearch.prototype, "searchToDate", {
        get: function () {
            return this.searchToDt;
        },
        enumerable: true,
        configurable: true
    });
    OffenseSearch.createFromRequest = function (offenseSearch) {
        return offenseSearch == null
            ? null
            : new OffenseSearch(offenseSearch.requestNbr, offenseSearch.caseNbr, offenseSearch.refName, offenseSearch.refAddr1, offenseSearch.refCity, offenseSearch.refState, offenseSearch.refZip, offenseSearch.workState, offenseSearch.restrictedState, new Date(offenseSearch.dob), offenseSearch.jurisdiction, offenseSearch.jurisdictionId, offenseSearch.ssn, offenseSearch.searchFromDt, offenseSearch.searchToDt, offenseSearch.admittedCrimNotFound, offenseSearch.status, offenseSearch.sourceName, offenseSearch.sourceType, offenseSearch.licenseNumber, offenseSearch.isHeightenedIdentifier);
    };
    return OffenseSearch;
}());
exports.default = OffenseSearch;
//# sourceMappingURL=offenseSearch.js.map

/***/ }),

/***/ "./src/models/orderBy.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var OrderBy = (function () {
    function OrderBy() {
        this.value = [];
    }
    OrderBy_1 = OrderBy;
    OrderBy._orderByComparator = function (a, b) {
        if (a === null || a === undefined) {
            a = 0;
        }
        if (b === null || b === undefined) {
            b = 0;
        }
        if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
            if (!isNaN(Date.parse(a)) || !isNaN(Date.parse(b))) {
                if (a < b) {
                    return -1;
                }
                if (a > b) {
                    return 1;
                }
            }
            else {
                a = a.toString();
                b = b.toString();
                if (a.toLowerCase() < b.toLowerCase()) {
                    return -1;
                }
                if (a.toLowerCase() > b.toLowerCase()) {
                    return 1;
                }
            }
        }
        else {
            if (parseFloat(a) < parseFloat(b)) {
                return -1;
            }
            if (parseFloat(a) > parseFloat(b)) {
                return 1;
            }
        }
        return 0; // equal each other
    };
    OrderBy.prototype.transform = function (input, config) {
        if (config === void 0) { config = '+'; }
        config = JSON.parse(localStorage.getItem('sortOrder'));
        if (!input) {
            return input;
        }
        var value = input.slice();
        if (!Array.isArray(value)) {
            return value;
        }
        return value.sort(function (a, b) {
            for (var i = 0; i < config.length; i++) {
                var desc = config[i].substr(0, 1) === '-';
                var property = config[i].substr(0, 1) === '+' || config[i].substr(0, 1) === '-'
                    ? config[i].substr(1) : config[i];
                var aValue = a[property];
                var bValue = b[property];
                var propertySplit = property.split('.');
                if (aValue === undefined && bValue === undefined && propertySplit.length > 1) {
                    aValue = a;
                    bValue = b;
                    for (var j = 0; j < propertySplit.length; j++) {
                        aValue = aValue[propertySplit[j]];
                        bValue = bValue[propertySplit[j]];
                    }
                }
                var comparison = !desc ? OrderBy_1._orderByComparator(aValue, bValue)
                    : -OrderBy_1._orderByComparator(aValue, bValue);
                if (comparison !== 0) {
                    return comparison;
                }
            }
            return 0; // equal each other
        });
    };
    OrderBy = OrderBy_1 = __decorate([
        core_1.Pipe({ name: 'orderBy', pure: false })
    ], OrderBy);
    return OrderBy;
    var OrderBy_1;
}());
exports.OrderBy = OrderBy;
//# sourceMappingURL=orderBy.js.map

/***/ }),

/***/ "./src/models/params.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Params = (function () {
    function Params() {
    }
    return Params;
}());
exports.Params = Params;
//# sourceMappingURL=params.js.map

/***/ }),

/***/ "./src/models/popupHelper.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var alertifyPromise_1 = __webpack_require__("./src/models/alertifyPromise.ts");
var alertify = __webpack_require__("./node_modules/alertifyjs/build/alertify.js");
var PopupHelper = (function () {
    function PopupHelper() {
    }
    PopupHelper.dobMismatchHelper = function () {
        var message = "\n    <div class=\"dob-mismatch-container\">\n      <div class=\"dob-mismatch-message\">The applicant DOB does not match the court DOB.</div>\n      <div>Select <span class=\"highlight\">Proceed</span> to continue without editing the DOB.</div>\n      <div>Select <span class=\"highlight\">Update</span> to edit the DOB.</div>\n    </div>\n    ";
        return alertifyPromise_1.promisifyConfirm('<div class="red dbo-title">***WARNING*** DOB MISMATCH</div>', message, {
            labels: {
                ok: 'Proceed',
                cancel: 'Update'
            }
        });
    };
    PopupHelper.saveUnsavedChangesHelper = function () {
        var message = "You made changes to the current record.\n    <br><br>If you would like these changes to be saved, please select <b>Cancel</b> and Save Record.\n    Select <span class=\"highlight\">OK</span> to proceed without saving these changes";
        return alertifyPromise_1.promisifyConfirm('<span class="highlight">Unsaved changes</span>', message);
    };
    PopupHelper.exitSystemHelper = function () {
        var message = "You have chosen to Exit the Criminal Research System. If you\n    have made any changes that you have not saved, please select\n    the <span class=\"highlight\">CANCEL</span> push-button to save those changes. To continue\n    logging off of the system, select the <span class=\"highlight\">OK</span> push-button.";
        return alertifyPromise_1.promisifyConfirm('<span class="highlight">System Exit</span>', message);
    };
    PopupHelper.confirmSubmitHelper = function (message) {
        return alertifyPromise_1.promisifyConfirm('<span class="highlight">Confirm Submit</span>', message);
    };
    PopupHelper.pendingWOHelper = function (message) {
        return alertifyPromise_1.promisifyAlert('<span class="highlight">Crim System</span>', message);
    };
    PopupHelper.passwordExpirationHelper = function (message) {
        return alertifyPromise_1.promisifyConfirm('<span class="highlight">Crim Error</span>', message);
    };
    PopupHelper.saveComment = function (message) {
        return alertifyPromise_1.promisifyAlert('<span class="highlight">Notice</span>', message);
    };
    PopupHelper.loginIssue = function (message) {
        return alertifyPromise_1.promisifyAlert('<span class="highlight">CrimSystem</span>', message);
    };
    PopupHelper.userHelperConfirm = function (message) {
        return alertifyPromise_1.promisifyConfirm('<span class="highlight">Crim System</span>', message);
    };
    PopupHelper.userHelper = function (message, type) {
        if (type === 'error') {
            return alertifyPromise_1.promisifyAlert('<span class="highlight">Crim Error</span>', message);
        }
        else if (type === 'crim') {
            return alertifyPromise_1.promisifyAlert('<span class="highlight">Crim System</span>', message);
        }
        else {
            return alertifyPromise_1.promisifyAlert('<span class="highlight">Forgot Password</span>', message);
        }
    };
    PopupHelper.deleteRecordHelper = function () {
        var message = "Are you sure you want to delete this record?";
        return alertifyPromise_1.promisifyConfirm('<span class="highlight">Record Delete</span>', message);
    };
    PopupHelper.systemVersion = function () {
        alertify.alert('Crim System', "Criminal Record Information Management Version 2.0");
    };
    PopupHelper.support = function () {
        alertify.alert('Crim System', "Please contact GIS Vendor Relations for any questions related to CRIM.");
    };
    PopupHelper.submitHelper = function (message) {
        alertify.alert('Crim System', message);
    };
    PopupHelper.noChangesToTaskList = function () {
        return alertifyPromise_1.promisifyAlert('<span class="highlight">Crim System</span>', "No Changes have been made to the Task List.");
    };
    PopupHelper.noHitsConfirmation = function (message) {
        return alertifyPromise_1.promisifyConfirm('<span class="highlight">Crim System</span>', message);
    };
    PopupHelper.developerEasterEgg = function () {
        alertify.alert('Easter Egg Found!!!', "\n      <div style=\"align-content: center; text-align: center;\">\n        <h1 style=\"font-size: 1rem; margin-bottom: 1rem;\">Here are the members of the CRIM team in late 2017</h1>\n        <h1 style=\"font-size: 1rem;\">Director</h1>\n        <div>Kristin Schaefer</div>\n\n        <h1 style=\"font-size: 1rem;\">Manager</h1>\n        <div style=\"margin-bottom: 1rem;\">Steve Amodio</div>\n\n        <h1 style=\"font-size: 1rem;\">Product Owner</h1>\n        <div>Todd Francis</div>\n\n        <h1 style=\"font-size: 1rem;\">Qa Team</h1>\n        <div>Kavitha Jayaseelan</div>\n        <div>Lindsey Fletcher</div>\n        <div>Mohana Katukuti</div>\n\n        <h1 style=\"font-size: 1rem;\">Front-end Developers</h1>\n        <div>Tracy Carter-Romey</div>\n        <div>Michael Astrauckas(Best Developer Ever!!!)</div>\n\n        <h1 style=\"font-size: 1rem;\">Back-end Developers</h1>\n        <div>Rob Segal</div>\n        <div style=\"margin-bottom: 3rem;\">Michael Baffey</div>\n        <div style=\"font-size: 0.001rem;\">\n          01000011 01110010 01101001 01101101\n          00100000 01101001 01110011 00100000\n          01101110 01101111 01110100 00100000\n          01100001 00100000 01010011 01110100\n          01110010 01100001 01110100 01110101\n          01110011 00100000 01110000 01110010\n          01101111 01101010 01100101 01100011\n          01110100 00100001\n        </div>\n      </div>\n      ");
    };
    return PopupHelper;
}());
exports.default = PopupHelper;
//# sourceMappingURL=popupHelper.js.map

/***/ }),

/***/ "./src/models/registrationCodes.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Using bitwise operator I can
// pass back multiple codes.
var RegistrationCodes;
(function (RegistrationCodes) {
    RegistrationCodes[RegistrationCodes["ok"] = 0] = "ok";
    RegistrationCodes[RegistrationCodes["requireToken"] = 450] = "requireToken";
    RegistrationCodes[RegistrationCodes["usernameAlreadyExist"] = 451] = "usernameAlreadyExist";
    RegistrationCodes[RegistrationCodes["invalidUsername"] = 452] = "invalidUsername";
    RegistrationCodes[RegistrationCodes["requireUsername"] = 460] = "requireUsername";
    RegistrationCodes[RegistrationCodes["requirePassword"] = 461] = "requirePassword";
    RegistrationCodes[RegistrationCodes["tokenNotValid"] = 450] = "tokenNotValid";
    RegistrationCodes[RegistrationCodes["invalidPassword"] = 453] = "invalidPassword";
    RegistrationCodes[RegistrationCodes["invalidFirstName"] = 462] = "invalidFirstName";
    RegistrationCodes[RegistrationCodes["invalidLastName"] = 463] = "invalidLastName";
    RegistrationCodes[RegistrationCodes["emailAddress"] = 464] = "emailAddress";
    RegistrationCodes[RegistrationCodes["userAndEmailAreTheSame"] = 472] = "userAndEmailAreTheSame";
})(RegistrationCodes = exports.RegistrationCodes || (exports.RegistrationCodes = {}));
//# sourceMappingURL=registrationCodes.js.map

/***/ }),

/***/ "./src/models/report.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Admission_1 = __webpack_require__("./src/models/Admission.ts");
var Report = (function () {
    function Report(admissionInfo, caseNbr, dis_RequestDt_sort, dob, refAddr1, refCity, refName, refState, reportAllText, refZip, requestNbr, researchInstructions, researchDisplay, searchFromDt, searchToDt, specialInstr, // flag
        ssn, jurisdiction, licenseNumber, specialInstructions, admission, admissionDisplay, display, applicantAdmissions) {
        if (specialInstructions === void 0) { specialInstructions = {}; }
        if (applicantAdmissions === void 0) { applicantAdmissions = {}; }
        this.admissionInfo = admissionInfo;
        this.caseNbr = caseNbr;
        this.dis_RequestDt_sort = dis_RequestDt_sort;
        this.dob = dob;
        this.refAddr1 = refAddr1;
        this.refCity = refCity;
        this.refName = refName;
        this.refState = refState;
        this.reportAllText = reportAllText;
        this.refZip = refZip;
        this.requestNbr = requestNbr;
        this.researchInstructions = researchInstructions;
        this.researchDisplay = researchDisplay;
        this.searchFromDt = searchFromDt;
        this.searchToDt = searchToDt;
        this.specialInstr = specialInstr;
        this.ssn = ssn;
        this.jurisdiction = jurisdiction;
        this.licenseNumber = licenseNumber;
        this.specialInstructions = specialInstructions;
        this.admission = admission;
        this.admissionDisplay = admissionDisplay;
        this.display = display;
        this.applicantAdmissions = applicantAdmissions;
    }
    Report.getWorkOrderReport = function (data) {
        var rpt = new Array();
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var item = data_1[_i];
            rpt.push(new Report(item.admissionInfo, item.caseNbr, item.dis_RequestDt_sort === null ? null : new Date(item.dis_RequestDt_sort), item.dob !== '' ? item.dob : '', item.refAddr1, item.refCity, item.refName, item.refState, item.reportAllText, item.refZip, item.requestNbr, item.researchInstructions === null ? null : this.getSpecialInstruction(item.specialInstructions, item.reportAllText), item.researchDisplay = this.displaySections(item.researchInstructions), item.searchFromDt, item.searchToDt, item.specialInstr, item.ssn, item.jurisdiction, item.licenseNumber, item.specialInstructions, item.admission = Admission_1.Admission.getAdmissions(item.specialInstructions), item.admissionDisplay = this.displaySections(item.admission), item.display = this.display(item.admissionDisplay), item.applicantAdmissions));
        }
        return rpt;
    };
    Report.getSpecialInstruction = function (specialInstructions, reportAllText) {
        var instruction = '';
        for (var _i = 0, specialInstructions_1 = specialInstructions; _i < specialInstructions_1.length; _i++) {
            var item = specialInstructions_1[_i];
            var researchInstructions = '';
            if (item.researchInstructions.length > 0) {
                for (var _a = 0, _b = item.researchInstructions; _a < _b.length; _a++) {
                    var x = _b[_a];
                    researchInstructions = x.researchInstructions;
                }
            }
            if (reportAllText !== '' && reportAllText !== undefined && reportAllText !== null) {
                if (researchInstructions !== '' && researchInstructions !== undefined && researchInstructions !== null) {
                    instruction = reportAllText + ".  " + researchInstructions;
                }
                else {
                    instruction = reportAllText + ".";
                }
            }
            else {
                if (researchInstructions !== '' && researchInstructions !== undefined && researchInstructions !== null) {
                    instruction = "" + researchInstructions;
                }
            }
        }
        return instruction;
    };
    Report.displaySections = function (value) {
        var display = null;
        if (value === '' || value === undefined || value === null) {
            display = 'hidden';
        }
        return display;
    };
    Report.display = function (value) {
        if (value === 'hidden') {
            return true;
        }
        else {
            return false;
        }
    };
    return Report;
}());
exports.Report = Report;
//# sourceMappingURL=report.js.map

/***/ }),

/***/ "./src/models/researcherTaskList.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ResearcherTaskList = (function () {
    function ResearcherTaskList() {
    }
    return ResearcherTaskList;
}());
exports.ResearcherTaskList = ResearcherTaskList;
//# sourceMappingURL=researcherTaskList.js.map

/***/ }),

/***/ "./src/models/sentenceLevel.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SentenceLevel;
(function (SentenceLevel) {
    SentenceLevel[SentenceLevel["Record"] = 0] = "Record";
    SentenceLevel[SentenceLevel["Offense"] = 1] = "Offense";
})(SentenceLevel = exports.SentenceLevel || (exports.SentenceLevel = {}));
//# sourceMappingURL=sentenceLevel.js.map

/***/ }),

/***/ "./src/models/sortList.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SortList = (function () {
    function SortList() {
    }
    return SortList;
}());
exports.SortList = SortList;
//# sourceMappingURL=sortList.js.map

/***/ }),

/***/ "./src/models/specialInstruction.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SpecialInstruction = (function () {
    function SpecialInstruction(researchInstruction, admission) {
        this.researchInstruction = researchInstruction;
        this.admission = admission;
    }
    return SpecialInstruction;
}());
exports.SpecialInstruction = SpecialInstruction;
//# sourceMappingURL=specialInstruction.js.map

/***/ }),

/***/ "./src/models/submitTask.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubmitTask = (function () {
    function SubmitTask() {
    }
    return SubmitTask;
}());
exports.SubmitTask = SubmitTask;
//# sourceMappingURL=submitTask.js.map

/***/ }),

/***/ "./src/models/submitTaskDialog.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SubmitTaskDialog = (function () {
    function SubmitTaskDialog() {
    }
    return SubmitTaskDialog;
}());
exports.SubmitTaskDialog = SubmitTaskDialog;
//# sourceMappingURL=submitTaskDialog.js.map

/***/ }),

/***/ "./src/models/user.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var User = (function () {
    function User(userName, firstName, middleName, lastName, email, phoneNumber) {
        this.userName = userName;
        this.firstName = firstName;
        this.middleName = middleName;
        this.lastName = lastName;
        this.email = email;
        this.phoneNumber = phoneNumber;
    }
    User.createFromRequest = function (request) {
        var userName = request.userName, firstName = request.firstName, middleName = request.middleName, lastName = request.lastName, email = request.email, phoneNumber = request.phoneNumber;
        return new User(userName, firstName, middleName, lastName, email, phoneNumber);
    };
    return User;
}());
exports.default = User;
//# sourceMappingURL=user.js.map

/***/ }),

/***/ "./src/models/vendor.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Vendor = (function () {
    function Vendor(id, name, address, city, state, zipCode, phoneNumber) {
        if (name === void 0) { name = null; }
        if (address === void 0) { address = null; }
        if (city === void 0) { city = null; }
        if (state === void 0) { state = null; }
        if (zipCode === void 0) { zipCode = null; }
        if (phoneNumber === void 0) { phoneNumber = null; }
        this.id = id;
        this.name = name;
        this.address = address;
        this.city = city;
        this.state = state;
        this.zipCode = zipCode;
        this.phoneNumber = phoneNumber;
    }
    Vendor.createFromRequest = function (request) {
        if (request.source !== null && request.source !== undefined) {
            var _a = request.source, sourceName = _a.sourceName, address = _a.address, city = _a.city, state = _a.state, zipCode = _a.zipCode, phoneNbr = _a.phoneNbr;
            return new Vendor(null, sourceName, address, city, state, zipCode, phoneNbr);
        }
        else if (request.vendorId === null || request.vendorId === undefined) {
            return new Vendor(request.vendorId);
        }
        return null;
    };
    return Vendor;
}());
exports.default = Vendor;
//# sourceMappingURL=vendor.js.map

/***/ }),

/***/ "./src/models/workOrder.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WorkOrder = (function () {
    function WorkOrder() {
    }
    return WorkOrder;
}());
exports.WorkOrder = WorkOrder;
//# sourceMappingURL=workOrder.js.map

/***/ }),

/***/ "./src/models/workOrderComplete.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WorkOrderComplete = (function () {
    function WorkOrderComplete() {
        this.confirmationMsg = '<br>' + 'Select OK if you would like to continue with this action. ' + '<br>' + '<br>';
        this.msgLine = '______________________________________________________________' + '<br>' + '<br>';
        this.breakLine = '<br>' + '<br>';
        this.pendingRqstMsg = "The following will be placed in Pending Status." + '<br>' + '<br>';
        this.removePendingMsg = 'The following will no longer be marked as Pending. ' + '<br>' + '<br>';
        this.noHitsMsg = 'The following will be marked Completed. ' + '<br>' + '<br>';
        this.removeNoHitsMsg = 'The following will no longer be marked as Completed. ' + '<br>' + '<br>';
    }
    return WorkOrderComplete;
}());
exports.WorkOrderComplete = WorkOrderComplete;
//# sourceMappingURL=workOrderComplete.js.map

/***/ }),

/***/ "./src/services/MessageQueService.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var environmentService_1 = __webpack_require__("./src/services/environmentService.ts");
var httpBase_1 = __webpack_require__("./src/models/httpBase.ts");
var http_1 = __webpack_require__("./node_modules/@angular/http/esm5/http.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var MessageQueService = (function (_super) {
    __extends(MessageQueService, _super);
    function MessageQueService(http, router, environmentService, runtime) {
        var _this = _super.call(this, http, router) || this;
        _this.environmentService = environmentService;
        _this.runtime = runtime;
        return _this;
    }
    MessageQueService.prototype.saveRequestNbrs = function (requestNbrs) {
        this.rqstNbrs = requestNbrs;
        localStorage.setItem('requests', this.rqstNbrs);
    };
    MessageQueService.prototype.saveStateData = function (stateData) {
        localStorage.setItem('stateData', stateData);
    };
    MessageQueService.prototype.saveTaskListData = function (taskList) {
        localStorage.setItem('taskList', taskList);
    };
    MessageQueService.prototype.saveOriginalAdmitted = function (admitted) {
        localStorage.setItem('admitted', admitted);
    };
    MessageQueService.prototype.selectedValue = function (selection) {
        localStorage.setItem('selection', selection);
    };
    MessageQueService.prototype.selectedJurisdiction = function (jurisdictionId) {
        localStorage.setItem('jurisdictionId', jurisdictionId);
    };
    MessageQueService.prototype.saveWOData = function (woData) {
        localStorage.setItem('workOrder', woData);
    };
    MessageQueService.prototype.savejurisdictionFilter = function (filter) {
        localStorage.setItem('jFilter', filter);
    };
    MessageQueService.prototype.saveSortOrder = function (sortList) {
        localStorage.setItem('sortOrder', sortList);
    };
    MessageQueService.prototype.saveSortType = function (sorting) {
        localStorage.setItem('sortType', sorting);
    };
    MessageQueService.prototype.saveStatus = function (status) {
        this.status = status;
        localStorage.setItem('status', this.status);
    };
    MessageQueService.prototype.saveComment = function (comment) {
        this.comment = comment;
        localStorage.setItem('comment', this.comment);
    };
    // shared methods
    MessageQueService.prototype.formatDob = function (dob) {
        dob = new Date(dob).toISOString();
        var date = new Date(dob);
        var day = date.getDate();
        var month = this.getMonth(date);
        var year = date.getFullYear();
        var formattedDt = month + '/' + day + '/' + year;
        return formattedDt;
    };
    MessageQueService.prototype.setControlKey = function () {
        // this.cacheControlKey = this.getSwitchValue();
        // if (this.cacheControlKey === undefined || this.cacheControlKey === null) {
        //   this.getControlKey(configName) ;
        // } else {
        //   if (this.cacheControlKey === 1) {
        this.runtime.clearCache();
        //   }
        // }
    };
    MessageQueService.prototype.getSwitchValue = function () {
        var value = localStorage.getItem('cacheControlKey').toLowerCase().trim();
        switch (value) {
            case '1':
                return 1;
            case '0':
                return 0;
            default: return 0;
        }
    };
    MessageQueService.prototype.getControlKey = function () {
        // this.getCacheControlKey(configName)
        //   .subscribe(
        //     (data) => {
        //       localStorage.setItem('cacheControlKey', data.toString());
        //       if (data === 1) {
        this.runtime.clearCache();
        //       }
        //     });
        // return this.cacheControlKey;
    };
    MessageQueService.prototype.getCacheControlKey = function (configName) {
        return this.httpGet(this.environmentService.cacheControlKeyUrl + "configName=" + configName, false)
            .map(function (r) {
            return r.json();
        });
    };
    MessageQueService.prototype.getMonth = function (date) {
        var month = date.getMonth() + 1;
        return month < 10 ? '0' + month : month;
    };
    MessageQueService.prototype.getDay = function (date) {
        var day = date.getDay() + 1;
        return day < 10 ? '0' + day : day;
    };
    MessageQueService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof http_1.Http !== "undefined" && http_1.Http) === "function" && _a || Object, typeof (_b = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _b || Object, typeof (_c = typeof environmentService_1.default !== "undefined" && environmentService_1.default) === "function" && _c || Object, typeof (_d = typeof core_1.Compiler !== "undefined" && core_1.Compiler) === "function" && _d || Object])
    ], MessageQueService);
    return MessageQueService;
    var _a, _b, _c, _d;
}(httpBase_1.default));
exports.MessageQueService = MessageQueService;
//# sourceMappingURL=MessageQueService.js.map

/***/ }),

/***/ "./src/services/authenticationService.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var environmentService_1 = __webpack_require__("./src/services/environmentService.ts");
var index_1 = __webpack_require__("./src/models/index.ts");
var httpBase_1 = __webpack_require__("./src/models/httpBase.ts");
var http_1 = __webpack_require__("./node_modules/@angular/http/esm5/http.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
__webpack_require__("./node_modules/rxjs/add/operator/map.js");
var popupHelper_1 = __webpack_require__("./src/models/popupHelper.ts");
var AuthenticationService = (function (_super) {
    __extends(AuthenticationService, _super);
    function AuthenticationService(http, router, environmentService) {
        var _this = _super.call(this, http, router) || this;
        _this.environmentService = environmentService;
        _this.loggedIn = false;
        _this.chngPass = false;
        _this.reset = false;
        return _this;
    }
    AuthenticationService.prototype.login = function (username, password) {
        var _this = this;
        this.deleteLocalStorage();
        this.chngPass = false;
        return this.httpPost(this.environmentService.loginUrl, {
            userName: username,
            password: password
        }, true, false)
            .map(function (r) {
            if (r.status === 401 || r.status === 400) {
                _this.statusCd = r.status;
            }
            else {
                if (r.status === 200) {
                    _this.reset = (r.json()).resetPassword;
                    var expirationDt = (r.json()).passwordExpirationDate;
                    _this.loggedIn = r.status === 200;
                    _this.daysTillExpiration = _this.isExpired(expirationDt);
                }
                else if (r.status === 422) {
                    return r.json().errorCodes;
                }
                _this.statusCd = r.status;
            }
            var okCode = [index_1.Codes.ok];
            _this.setLocalStorage();
            return okCode;
        });
    };
    AuthenticationService.prototype.checkAuthorization = function (environment, browser) {
        return this.httpGet(this.environmentService.checkAuthorizationtUrl + "browser=" + browser + "&environment=" + environment, false)
            .map(function (r) {
            return r.json();
        });
    };
    AuthenticationService.prototype.logout = function () {
        this.loggedIn = false;
        this.chngPass = false;
        sessionStorage.setItem('isLoggedIn', this.loggedIn.toString());
        sessionStorage.setItem('isChanged', this.chngPass.toString());
        return this.httpPost(this.environmentService.logoutUrl, {}, false);
    };
    AuthenticationService.prototype.isExpired = function (expirationDt) {
        var duration = 0;
        var expireDt = new Date(expirationDt);
        var currentDt = new Date();
        if (this.expiredDate(expireDt, currentDt)) {
            var diff = Math.abs(expireDt.getTime() - currentDt.getTime());
            duration = Math.ceil(diff / (1000 * 3600 * 24));
        }
        else {
            duration = 0;
        }
        return duration;
    };
    AuthenticationService.prototype.expiredDate = function (expireDt, currentDt) {
        if (expireDt > currentDt) {
            return true;
        }
        else {
            return false;
        }
    };
    AuthenticationService.prototype.setLocalStorage = function () {
        if (this.isLoggedIn !== undefined && this.isLoggedIn !== null) {
            sessionStorage.setItem('isLoggedIn', this.isLoggedIn.toString());
        }
        if (this.chngPass !== undefined && this.chngPass !== null) {
            sessionStorage.setItem('isChanged', this.chngPass.toString());
        }
        if (this.reset !== undefined && this.reset !== null) {
            sessionStorage.setItem('isReset', this.reset.toString());
        }
        if (this.daysTillExpiration !== undefined && this.daysTillExpiration !== null) {
            sessionStorage.setItem('isExpiring', this.daysTillExpiration.toString());
        }
        if (this.statusCd !== undefined && this.statusCd !== null) {
            sessionStorage.setItem('isStatusInvalid', this.statusCd.toString());
        }
    };
    AuthenticationService.prototype.deleteLocalStorage = function () {
        sessionStorage.clear();
    };
    Object.defineProperty(AuthenticationService.prototype, "isLoggedIn", {
        get: function () {
            return this.loggedIn;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "isChanged", {
        get: function () {
            return this.chngPass;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "isReset", {
        get: function () {
            return this.reset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "isExpiring", {
        get: function () {
            return this.daysTillExpiration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "isStatusInvalid", {
        get: function () {
            return this.statusCd;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationService.prototype.changePassword = function (userName, password, newPassword) {
        return this.httpPost(this.environmentService.changePasswordUrl, {
            UserName: userName,
            Password: password,
            NewPassword: newPassword
        }, true)
            .map(function (r) {
            if (r.status === 401 || r.status === 400) {
                popupHelper_1.default.userHelper('Invalid user and/or password.  Please try again.  Access denied', 'error');
            }
            else if (r.status === 422) {
                return r.json().errorCodes;
            }
            var okCode = [index_1.Codes.ok];
            return okCode;
        });
    };
    AuthenticationService.prototype.resetPassword = function (userName, email) {
        var _this = this;
        return this.httpPost(this.environmentService.resetUrl, {
            UserName: userName,
            Email: email
        }, true)
            .map(function (r) {
            _this.statusCd = r.status;
            if (r.status === 422) {
                return r.json().errorCodes;
            }
            _this.setLocalStorage();
            var okCode = [index_1.Codes.ok];
            return okCode;
        });
    };
    AuthenticationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof http_1.Http !== "undefined" && http_1.Http) === "function" && _a || Object, typeof (_b = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _b || Object, typeof (_c = typeof environmentService_1.default !== "undefined" && environmentService_1.default) === "function" && _c || Object])
    ], AuthenticationService);
    return AuthenticationService;
    var _a, _b, _c;
}(httpBase_1.default));
exports.AuthenticationService = AuthenticationService;
//# sourceMappingURL=authenticationService.js.map

/***/ }),

/***/ "./src/services/browserWindowObjectService.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var BrowserWindowObjectService = (function () {
    function BrowserWindowObjectService() {
    }
    BrowserWindowObjectService.prototype.getNativeWindow = function () {
        return window;
    };
    BrowserWindowObjectService.prototype.searchCaptureOpen = function (route) {
        window.open("" + route, '_blank', "menubar=1,  scrollbars=1, resizeable");
    };
    BrowserWindowObjectService.prototype.watsonShowGuideline = function (route) {
        window.open("" + route, '_blank', "menubar=1,  scrollbars=1, resizeable");
    };
    BrowserWindowObjectService.prototype.openWindowInNewWindowByRoute = function (route, title, width, height) {
        window.open("#" + route, 'NewWin', "menubar=1, width=" + width + ", height= " + height + ", scrollbars=1, resizeable, titlebar=" + title);
    };
    BrowserWindowObjectService.prototype.openInNewWindowByRoute = function (route, name, title, width, height) {
        var wComment = window.open("#" + route, "" + name, '', true);
        wComment.close();
        window.open("#" + route, "" + name, "menubar=1, width=" + width + ", height= " + height + ", scrollbars=1, resizeable, titlebar=" + title, true);
    };
    BrowserWindowObjectService.prototype.openWindowITabByRoute = function (route, title) {
        window.open("#" + route, "titlebar=" + title);
    };
    BrowserWindowObjectService.prototype.scrollToTopOfPage = function () {
        window.scrollTo(0, 0);
    };
    BrowserWindowObjectService.prototype.goBackOnePage = function () {
        window.history.back();
    };
    BrowserWindowObjectService = __decorate([
        core_1.Injectable()
    ], BrowserWindowObjectService);
    return BrowserWindowObjectService;
}());
exports.default = BrowserWindowObjectService;
//# sourceMappingURL=browserWindowObjectService.js.map

/***/ }),

/***/ "./src/services/complianceAuditLogService.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/http/esm5/http.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var httpBase_1 = __webpack_require__("./src/models/httpBase.ts");
var environmentService_1 = __webpack_require__("./src/services/environmentService.ts");
var ComplianceAuditLogService = (function (_super) {
    __extends(ComplianceAuditLogService, _super);
    function ComplianceAuditLogService(http, router, environmentService) {
        var _this = _super.call(this, http, router) || this;
        _this.environmentService = environmentService;
        return _this;
    }
    ComplianceAuditLogService.prototype.addComplianceAuditLogs = function (complianceAuditLogs) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.httpPost(_this.environmentService.complianceAuditLogs, complianceAuditLogs)
                .subscribe(function (r) {
                if (r.status === 200) {
                    resolve(true);
                }
                else {
                    reject(false);
                }
            });
        });
    };
    ComplianceAuditLogService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof http_1.Http !== "undefined" && http_1.Http) === "function" && _a || Object, typeof (_b = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _b || Object, typeof (_c = typeof environmentService_1.default !== "undefined" && environmentService_1.default) === "function" && _c || Object])
    ], ComplianceAuditLogService);
    return ComplianceAuditLogService;
    var _a, _b, _c;
}(httpBase_1.default));
exports.default = ComplianceAuditLogService;
//# sourceMappingURL=complianceAuditLogService.js.map

/***/ }),

/***/ "./src/services/environmentService.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var globals_1 = __webpack_require__("./src/globals.ts");
var EnvironmentService = (function () {
    function EnvironmentService() {
        this.environmentName = globals_1.environmentName;
        this.hostname = window.location.hostname;
        this.port = this.isDevelopment ? ':5001' : '';
        this.crimWebVirtualDirectoryName = this.isDevelopment ? '' : '/crimwebapi';
        this.protocol = window.location.protocol;
    }
    Object.defineProperty(EnvironmentService.prototype, "webApiUrl", {
        get: function () {
            return this.protocol + "//" + this.hostname + this.port + this.crimWebVirtualDirectoryName + "/api/";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "loginUrl", {
        get: function () {
            return this.webApiUrl + "account/login";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "cacheControlKeyUrl", {
        get: function () {
            return this.webApiUrl + "ConfigurationKey/SwitchStatus?";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "resetUrl", {
        get: function () {
            return this.webApiUrl + "account/Forgot";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "logoutUrl", {
        get: function () {
            return this.webApiUrl + "account/logout";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "changePasswordUrl", {
        get: function () {
            return this.webApiUrl + "account/Change";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "registerUrl", {
        get: function () {
            return this.webApiUrl + "account/create";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "helloWorldUrl", {
        get: function () {
            return this.webApiUrl + "helloworld/1";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "navigationUrl", {
        get: function () {
            return this.webApiUrl + "NavigationPage ";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "taskListUrl", {
        get: function () {
            return this.webApiUrl + "Requests?";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "jurisdictionUrl", {
        get: function () {
            return this.webApiUrl + "Jurisdictions";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "markRequestReceivedUrl", {
        get: function () {
            return this.webApiUrl + "Requests/MarkReceived";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "GetWorkOrdersUrl", {
        get: function () {
            return this.webApiUrl + "Requests/GetWorkOrders";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "getResearchTaskCommentUrl", {
        get: function () {
            return this.webApiUrl + "RequestComments?";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "checkAuthorizationtUrl", {
        get: function () {
            return this.webApiUrl + "BrowserSecurity/CheckAuthorization?";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "getSubmitTasklUrl", {
        get: function () {
            return this.webApiUrl + "Requests/SubmitChanges";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "SpecialInstructionUrl", {
        get: function () {
            return this.webApiUrl + "SpecialInstructions?";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "saveResearchTaskCommentUrl", {
        get: function () {
            return this.webApiUrl + "RequestComments/AddComment";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "deleteResearchTaskCommentUrl", {
        get: function () {
            return this.webApiUrl + "RequestComments/DeleteComment";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "getOffenses", {
        get: function () {
            return this.webApiUrl + "request";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "deleteOffense", {
        get: function () {
            return this.webApiUrl + "request/delete";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "saveOffenses", {
        get: function () {
            return this.webApiUrl + "offenses/save";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "workOrderComplete", {
        get: function () {
            return this.webApiUrl + "Request/workOrderComplete";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "invoiceUrl", {
        get: function () {
            return this.webApiUrl + "invoice";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "complianceAuditLogs", {
        get: function () {
            return this.webApiUrl + "ComplianceAuditLog/add";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "isDevelopment", {
        get: function () {
            return this.environmentName === 'DEVELOPMENT';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EnvironmentService.prototype, "isProduction", {
        get: function () {
            return this.environmentName === 'PRODUCTION';
        },
        enumerable: true,
        configurable: true
    });
    EnvironmentService = __decorate([
        core_1.Injectable()
    ], EnvironmentService);
    return EnvironmentService;
}());
exports.default = EnvironmentService;
//# sourceMappingURL=environmentService.js.map

/***/ }),

/***/ "./src/services/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/services/authenticationService.ts"));
__export(__webpack_require__("./src/services/messageService.ts"));
__export(__webpack_require__("./src/services/researcherService.ts"));
__export(__webpack_require__("./src/services/MessageQueService.ts"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./src/services/invoiceService.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/http/esm5/http.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var httpBase_1 = __webpack_require__("./src/models/httpBase.ts");
var environmentService_1 = __webpack_require__("./src/services/environmentService.ts");
var invoice_1 = __webpack_require__("./src/models/invoice.ts");
var InvoiceService = (function (_super) {
    __extends(InvoiceService, _super);
    function InvoiceService(http, router, environmentService) {
        var _this = _super.call(this, http, router) || this;
        _this.environmentService = environmentService;
        return _this;
    }
    InvoiceService.prototype.getInvoice = function (invoiceNumber, startDate, endDate) {
        var queryString = "invoiceNumber=" + invoiceNumber + "&startDate=" + startDate + "&endDate=" + endDate;
        return this.httpGet(this.environmentService.invoiceUrl + "?" + queryString)
            .map(function (r) {
            return invoice_1.default.createFromRequest(r.json());
        });
    };
    InvoiceService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof http_1.Http !== "undefined" && http_1.Http) === "function" && _a || Object, typeof (_b = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _b || Object, typeof (_c = typeof environmentService_1.default !== "undefined" && environmentService_1.default) === "function" && _c || Object])
    ], InvoiceService);
    return InvoiceService;
    var _a, _b, _c;
}(httpBase_1.default));
exports.default = InvoiceService;
//# sourceMappingURL=invoiceService.js.map

/***/ }),

/***/ "./src/services/messageService.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__("./node_modules/rxjs/add/operator/toPromise.js");
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var environmentService_1 = __webpack_require__("./src/services/environmentService.ts");
var http_1 = __webpack_require__("./node_modules/@angular/http/esm5/http.js");
var httpError_1 = __webpack_require__("./src/models/httpError.ts");
var MessageService = (function () {
    function MessageService(http, environmentService) {
        this.http = http;
        this.environmentService = environmentService;
    }
    MessageService.prototype.getMessage = function () {
        var _this = this;
        return this.http.get(this.environmentService.helloWorldUrl, { withCredentials: true })
            .toPromise()
            .then(function (r) { return r.json(); })
            .catch(function (e) {
            throw new httpError_1.default(e, _this.environmentService.helloWorldUrl);
        });
    };
    MessageService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof http_1.Http !== "undefined" && http_1.Http) === "function" && _a || Object, typeof (_b = typeof environmentService_1.default !== "undefined" && environmentService_1.default) === "function" && _b || Object])
    ], MessageService);
    return MessageService;
    var _a, _b;
}());
exports.default = MessageService;
//# sourceMappingURL=messageService.js.map

/***/ }),

/***/ "./src/services/navigationService.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/http/esm5/http.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var httpBase_1 = __webpack_require__("./src/models/httpBase.ts");
var environmentService_1 = __webpack_require__("./src/services/environmentService.ts");
var navigation_1 = __webpack_require__("./src/models/navigation.ts");
var NavigationService = (function (_super) {
    __extends(NavigationService, _super);
    function NavigationService(http, router, environmentService) {
        var _this = _super.call(this, http, router) || this;
        _this.environmentService = environmentService;
        return _this;
    }
    NavigationService.prototype.getJurisdictions = function () {
        return this.httpGet(this.environmentService.navigationUrl)
            .map(function (r) {
            return navigation_1.default.createFromRequest(r.json());
        });
    };
    NavigationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof http_1.Http !== "undefined" && http_1.Http) === "function" && _a || Object, typeof (_b = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _b || Object, typeof (_c = typeof environmentService_1.default !== "undefined" && environmentService_1.default) === "function" && _c || Object])
    ], NavigationService);
    return NavigationService;
    var _a, _b, _c;
}(httpBase_1.default));
exports.default = NavigationService;
//# sourceMappingURL=navigationService.js.map

/***/ }),

/***/ "./src/services/offenseService.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var http_1 = __webpack_require__("./node_modules/@angular/http/esm5/http.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var offenseCodes_1 = __webpack_require__("./src/models/offenseCodes.ts");
var httpBase_1 = __webpack_require__("./src/models/httpBase.ts");
var environmentService_1 = __webpack_require__("./src/services/environmentService.ts");
var offense_1 = __webpack_require__("./src/models/offense.ts");
var offenseSearch_1 = __webpack_require__("./src/models/offenseSearch.ts");
var offenseRecord_1 = __webpack_require__("./src/models/offenseRecord.ts");
var httpError_1 = __webpack_require__("./src/models/httpError.ts");
var OffenseService = (function (_super) {
    __extends(OffenseService, _super);
    function OffenseService(http, router, environmentService) {
        var _this = _super.call(this, http, router) || this;
        _this.environmentService = environmentService;
        return _this;
    }
    OffenseService.prototype.getOffense = function (requestNbr) {
        var _this = this;
        return this.httpGet(this.environmentService.getOffenses + "\\?requestNbr=" + requestNbr)
            .map(function (r) {
            if (r.status === 200) {
                return new offense_1.default(offenseSearch_1.default.createFromRequest(r.json().request), r.json().request.offenses === null ? null : offenseRecord_1.default.getFromRequest(r.json().request.offenses));
            }
            return new httpError_1.default(r, _this.environmentService.getOffenses);
        });
    };
    OffenseService.prototype.save = function (offenseRecords) {
        return this.httpPost(this.environmentService.saveOffenses, offenseRecords)
            .map(function (r) {
            if (r.status !== 200) {
            }
            return offenseCodes_1.OffenseCodes.ok;
        });
    };
    OffenseService.prototype.delete = function (requestNumber, offenceNumber) {
        var _this = this;
        return this.httpDelete(this.environmentService.deleteOffense + "\\" + requestNumber + "\\" + offenceNumber)
            .map(function (r) {
            if (r.status !== 200) {
                return new httpError_1.default(r, _this.environmentService.saveOffenses);
            }
            return null;
        });
    };
    OffenseService.prototype.workOrderComplete = function (requestNumber, admittedCrimeNotFound) {
        var _this = this;
        return this.httpPost("" + this.environmentService.workOrderComplete, { RequestNbr: requestNumber, admittedCrimeNotFound: admittedCrimeNotFound })
            .map(function (r) {
            if (r.status !== 200) {
                return new httpError_1.default(r, _this.environmentService.workOrderComplete);
            }
            return null;
        });
    };
    OffenseService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof http_1.Http !== "undefined" && http_1.Http) === "function" && _a || Object, typeof (_b = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _b || Object, typeof (_c = typeof environmentService_1.default !== "undefined" && environmentService_1.default) === "function" && _c || Object])
    ], OffenseService);
    return OffenseService;
    var _a, _b, _c;
}(httpBase_1.default));
exports.default = OffenseService;
//# sourceMappingURL=offenseService.js.map

/***/ }),

/***/ "./src/services/registrationService.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var environmentService_1 = __webpack_require__("./src/services/environmentService.ts");
var httpBase_1 = __webpack_require__("./src/models/httpBase.ts");
var http_1 = __webpack_require__("./node_modules/@angular/http/esm5/http.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
var registrationCodes_1 = __webpack_require__("./src/models/registrationCodes.ts");
__webpack_require__("./node_modules/rxjs/add/operator/map.js");
var RegistrationService = (function (_super) {
    __extends(RegistrationService, _super);
    function RegistrationService(http, router, environmentService) {
        var _this = _super.call(this, http, router) || this;
        _this.environmentService = environmentService;
        return _this;
    }
    RegistrationService.prototype.registerUser = function (user, token) {
        return this.httpPost(this.environmentService.registerUrl, {
            user: user,
            token: token
        }, true)
            .map(function (r) {
            if (r.status === 422) {
                return r.json().errorCodes;
            }
            var okCode = [registrationCodes_1.RegistrationCodes.ok];
            // return Array<RegistrationCodes>(RegistrationCodes.ok);
            return okCode;
        });
    };
    RegistrationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof http_1.Http !== "undefined" && http_1.Http) === "function" && _a || Object, typeof (_b = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _b || Object, typeof (_c = typeof environmentService_1.default !== "undefined" && environmentService_1.default) === "function" && _c || Object])
    ], RegistrationService);
    return RegistrationService;
    var _a, _b, _c;
}(httpBase_1.default));
exports.default = RegistrationService;
//# sourceMappingURL=registrationService.js.map

/***/ }),

/***/ "./src/services/researcherService.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
var httpBase_1 = __webpack_require__("./src/models/httpBase.ts");
var http_1 = __webpack_require__("./node_modules/@angular/http/esm5/http.js");
var router_1 = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
__webpack_require__("./node_modules/rxjs/add/operator/map.js");
var index_1 = __webpack_require__("./src/models/index.ts");
var environmentService_1 = __webpack_require__("./src/services/environmentService.ts");
var httpError_1 = __webpack_require__("./src/models/httpError.ts");
var ResearcherService = (function (_super) {
    __extends(ResearcherService, _super);
    function ResearcherService(http, router, environmentService) {
        var _this = _super.call(this, http, router) || this;
        _this.environmentService = environmentService;
        _this.isSuccessful = false;
        return _this;
    }
    // Get Task List
    ResearcherService.prototype.getResearchTaskList = function (requestType, jurisdictionId) {
        var _this = this;
        return this.httpGet(this.environmentService.taskListUrl + "requestType=" + requestType + "&jurisdictionId=" + jurisdictionId, false)
            .map(function (r) {
            if (r.status === 401 || r.status === 422) {
                _this.router.navigate(['login']);
            }
            else {
                if (r.status === 200) {
                    localStorage.setItem('jurisdictions', JSON.stringify((r.json()).jurisdictions));
                    var wo = (r.json()).requests;
                    return wo;
                }
            }
        });
    };
    // Submit Update
    ResearcherService.prototype.submitTaskListData = function (submitTask) {
        return this.httpPost(this.environmentService.getSubmitTasklUrl, submitTask, false)
            .map(function (r) {
            return r.status;
        });
    };
    // Mark Request Received
    ResearcherService.prototype.markRequestReceived = function (requestNbr) {
        var _this = this;
        return this.httpPost(this.environmentService.markRequestReceivedUrl, requestNbr, false)
            .map(function (r) {
            if (r.status === 401) {
                window.close();
                _this.router.navigate(['login']);
            }
            else {
                if (r.status === 200) {
                    _this.isSuccessful = r.status === 200;
                }
            }
        });
    };
    // Generate Work Order
    ResearcherService.prototype.getWorkOrders = function (requestNbr) {
        var _this = this;
        return this.httpPost(this.environmentService.GetWorkOrdersUrl, requestNbr, false)
            .map(function (r) {
            if (r.status === 401) {
                window.close();
                _this.router.navigate(['login']);
            }
            else {
                if (r.status === 200) {
                    var rpt = (r.json()).requests;
                    return rpt;
                }
            }
        });
    };
    ResearcherService.prototype.getSpecialInstructions = function (requestNbr) {
        var _this = this;
        return this.httpGet(this.environmentService.SpecialInstructionUrl + "requestNbr=" + requestNbr)
            .map(function (r) {
            if (r.status === 200) {
                return new index_1.SpecialInstruction(index_1.ResearchInstruction.getResearchInstruction(r.json().specialInstructions), r.json().specialInstructions.admissions === null ? null : index_1.Admission.getAdmissions(r.json().specialInstructions));
            }
            else if (r.status === 401) {
                window.close();
            }
            return new httpError_1.default(r, _this.environmentService.SpecialInstructionUrl);
        });
    };
    // Get Comments
    ResearcherService.prototype.getResearchTaskComment = function (requestNbr) {
        var _this = this;
        return this.httpGet(this.environmentService.getResearchTaskCommentUrl + "requestNbr=" + requestNbr)
            .map(function (r) {
            if (r.status === 401) {
                window.close();
                _this.router.navigate(['login']);
            }
            else {
                if (r.status === 200) {
                    return (r.json().requestComments.comment);
                }
            }
        });
    };
    // Delete Comments
    ResearcherService.prototype.deleteResearcherTaskComments = function (requestNbr) {
        var _this = this;
        return this.httpPost(this.environmentService.deleteResearchTaskCommentUrl, {
            RequestNbr: requestNbr
        }, true)
            .map(function (r) {
            if (r.status === 401) {
                window.close();
                _this.router.navigate(['login']);
            }
            return r.status;
        });
    };
    // Save Comments
    ResearcherService.prototype.saveResearcherTaskComments = function (requestNbr, comment) {
        return this.httpPost(this.environmentService.saveResearchTaskCommentUrl, {
            RequestNbr: requestNbr,
            Comment: comment
        }, true)
            .map(function (r) {
            if (r.status === 401) {
                window.close();
            }
            return r.status;
        });
    };
    Object.defineProperty(ResearcherService.prototype, "successful", {
        get: function () {
            return this.isSuccessful;
        },
        enumerable: true,
        configurable: true
    });
    ResearcherService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [typeof (_a = typeof http_1.Http !== "undefined" && http_1.Http) === "function" && _a || Object, typeof (_b = typeof router_1.Router !== "undefined" && router_1.Router) === "function" && _b || Object, typeof (_c = typeof environmentService_1.default !== "undefined" && environmentService_1.default) === "function" && _c || Object])
    ], ResearcherService);
    return ResearcherService;
    var _a, _b, _c;
}(httpBase_1.default));
exports.ResearcherService = ResearcherService;
//# sourceMappingURL=researcherService.js.map

/***/ }),

/***/ "./src/validators/compareTwoInputsValidator.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function compareTwoInputsValidator(compareInputId, same) {
    if (same === void 0) { same = true; }
    return function (control) {
        var input = document.getElementById(compareInputId);
        return !input || !control || (same ? control.value === input.value : control.value !== input.value) ? null : { compareTwoInputs: true };
    };
}
exports.default = compareTwoInputsValidator;
//# sourceMappingURL=compareTwoInputsValidator.js.map

/***/ }),

/***/ "./src/validators/isDateValidator.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dateHandler_1 = __webpack_require__("./src/models/dateHandler.ts");
function isDateValidator(baseCentury) {
    return function (control) {
        var date = new dateHandler_1.default(control.value, baseCentury);
        return control.value === null || control.value.length === 0 || date.isValid ? null : { isDate: true };
    };
}
exports.default = isDateValidator;
//# sourceMappingURL=isDateValidator.js.map

/***/ }),

/***/ "./src/validators/isNumberValidator.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function isNumberValidator() {
    return function (control) {
        return control.value !== null && control.value.length !== 0 && !isNaN(control.value) ? null : { isNumber: true };
    };
}
exports.default = isNumberValidator;
//# sourceMappingURL=isNumberValidator.js.map

/***/ }),

/***/ "./src/validators/passwordRulesValidator.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function passwordRulesValidator() {
    return function (control) {
        if (control.value != null) {
            var password = control.value;
            return password.match(/[!@#$%^&*(){}[\]?~<>]/)
                && password.match(/[A-Z]/)
                && password.match(/[a-z]/)
                && password.match(/\d/)
                && password.length >= 8
                ? null
                : { passwordRules: true };
        }
        else {
            return null;
        }
    };
}
exports.default = passwordRulesValidator;
//# sourceMappingURL=passwordRulesValidator.js.map

/***/ }),

/***/ "./src/validators/passwordValidation.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PasswordValidation = (function () {
    function PasswordValidation() {
    }
    PasswordValidation.MatchPassword = function (AC) {
        var password = AC.get('newPassword').value;
        var confirmPassword = AC.get('confirmPassword').value;
        if (password !== confirmPassword) {
            AC.get('confirmPassword').setErrors({ MatchPassword: true });
        }
        else {
            return null;
        }
    };
    return PasswordValidation;
}());
exports.PasswordValidation = PasswordValidation;
//# sourceMappingURL=passwordValidation.js.map

/***/ }),

/***/ "./src/validators/usernameAlreadyExistValidator.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function usernameAlreadyExistValidator() {
    return function () {
        // Always return true.  This is so if the api tells me a username already exist, I can show this error.
        return null;
    };
}
exports.default = usernameAlreadyExistValidator;
//# sourceMappingURL=usernameAlreadyExistValidator.js.map

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./src/main.ts");


/***/ })

},[0]);


// WEBPACK FOOTER //
// js/app.bundle.a6cc317d.min.js